'use strict';

require('core-js/modules/es.symbol.js');
require('core-js/modules/es.symbol.description.js');
require('core-js/modules/es.array.concat.js');
var React = require('react');
var classnames = require('classnames');
require('core-js/modules/es.object.assign.js');
require('core-js/modules/es.string.small.js');
require('core-js/modules/es.array.map.js');
require('core-js/modules/es.array.slice.js');
require('core-js/modules/es.date.to-string.js');
require('core-js/modules/es.object.to-string.js');
require('core-js/modules/es.regexp.to-string.js');
require('core-js/modules/es.array.includes.js');
require('core-js/modules/es.array.iterator.js');
require('core-js/modules/es.function.name.js');
require('core-js/modules/es.string.includes.js');
require('core-js/modules/web.dom-collections.iterator.js');
require('core-js/modules/es.regexp.exec.js');
require('core-js/modules/es.string.replace.js');
require('core-js/modules/es.promise.js');
require('core-js/modules/es.string.anchor.js');
require('core-js/modules/es.string.bold.js');
require('core-js/modules/es.string.link.js');
var ReactDOM = require('react-dom');
require('core-js/modules/web.timers.js');
require('core-js/modules/es.date.now.js');
var FocusTrap = require('focus-trap-react');
require('core-js/modules/es.array.from.js');
require('core-js/modules/es.array.join.js');
require('core-js/modules/es.string.iterator.js');
require('core-js/modules/web.url.js');
require('core-js/modules/web.url.to-json.js');
require('core-js/modules/web.url-search-params.js');
require('core-js/modules/es.array.is-array.js');
require('core-js/modules/es.array.index-of.js');
require('core-js/modules/es.array.reduce.js');
var Select$1 = require('react-select');
require('core-js/modules/es.regexp.constructor.js');
require('core-js/modules/es.string.match.js');
var OutsideClickHandler = require('@graffer-inc/react-outside-click-handler');
require('core-js/modules/es.array.filter.js');
require('core-js/modules/es.string.trim.js');
var dayjs = require('dayjs');
var ja = require('dayjs/locale/ja');
require('core-js/modules/es.array.every.js');
require('core-js/modules/es.array.flat-map.js');
require('core-js/modules/es.array.unscopables.flat-map.js');
require('core-js/modules/es.array.some.js');
var ja$1 = require('date-fns/locale/ja');
var ReactDatePicker = require('react-datepicker');
require('core-js/modules/es.number.constructor.js');
require('core-js/modules/es.string.ends-with.js');
require('core-js/modules/es.string.starts-with.js');
require('core-js/modules/es.array.last-index-of.js');
require('core-js/modules/es.string.split.js');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n.default = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);
var classnames__default = /*#__PURE__*/_interopDefault(classnames);
var ReactDOM__default = /*#__PURE__*/_interopDefault(ReactDOM);
var FocusTrap__default = /*#__PURE__*/_interopDefault(FocusTrap);
var Select__default = /*#__PURE__*/_interopDefault(Select$1);
var OutsideClickHandler__default = /*#__PURE__*/_interopDefault(OutsideClickHandler);
var dayjs__default = /*#__PURE__*/_interopDefault(dayjs);
var ja__default = /*#__PURE__*/_interopDefault(ja);
var ja__default$1 = /*#__PURE__*/_interopDefault(ja$1);
var ReactDatePicker__default = /*#__PURE__*/_interopDefault(ReactDatePicker);

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;
  if (!css || typeof document === 'undefined') {
    return;
  }
  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';
  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$U = ":root {\n  /* font */\n  /* color */\n  /* shadow */\n  /* 余白 */\n  /* border-radius */\n}\n\n/*共通ファイル*/\n\n/*bulmaの.inputを上書き*/\n\n/*consoleのinputをどうデザインするか未定なので、コメントアウトしておく*/\n\n/*.input {*/\n\n/*  font: var(--bodyLight);*/\n\n/*  padding: var(--medium) calc(var(--small) + 4px);*/\n\n/*  border: 2px solid var(--N400);*/\n\n/*}*/\n\n/*.input:focus,*/\n\n/*.input[type]:focus {*/\n\n/*  outline: 0;*/\n\n/*  box-shadow: none;*/\n\n/*  border: 2px solid var(--B500);*/\n\n/*  background-color: var(--Wh);*/\n\n/*  filter: drop-shadow(0px 0px 4px rgba(57, 68, 179, 0.6));*/\n\n/*}*/\n\n/*.input:hover {*/\n\n/*  border-color: #e8e5e4;*/\n\n/*}*/\n\n/* buttonのブラウザ標準のスタイルは使用しない */\n\nbutton {\n  background-color: transparent;\n  border: none;\n  cursor: pointer;\n  outline: none;\n  padding: 0;\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n}\n\n/*フォント周りの共通設定、変数*/\n\nbody {\n  color: #1d1c1a;\n}\n";
styleInject(css_248z$U);

function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function () {
    return !!t;
  })();
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectDestructuringEmpty(t) {
  if (null == t) throw new TypeError("Cannot destructure " + t);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function (t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function (t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(typeof e + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function (e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function () {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function (e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function (t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function (t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    catch: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw Error("illegal catch attempt");
    },
    delegateYield: function (e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}

var css_248z$T = ":root {\n  /* Color styles */\n\n  /* Text-size styles */\n\n  /* Effect styles */\n  /* border-radius */\n}\n\n.banner-module_information__1kcnn {\n  background-color: #e8e9f9;\n  color: #353ebd;\n}\n\n.banner-module_warning__3d8zY {\n  background-color: #fdfce6;\n  color: #82480a;\n}\n\n.banner-module_success__2Bh9y {\n  background-color: #e1f2f0;\n  color: #154a3c;\n}\n\n.banner-module_banner__3lTB5 {\n  padding: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 16px;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n}\n\n.banner-module_contents__1LIIP {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  margin: 0px auto;\n}\n\n.banner-module_iconWrapper__rToc0 {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n}\n\n.banner-module_icon__2Q4MX {\n  display: inline-flex;\n  align-items: center;\n}\n\n.banner-module_messageWrapper__3LlOc,\n.banner-module_messages__2MONr {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.banner-module_messageWrapper__3LlOc {\n  justify-content: space-between;\n}\n\n.banner-module_message__3kA6v {\n  font-weight: 300;\n}\n\n.banner-module_description__15OnA {\n  color: #262b38;\n  font-weight: 300;\n  font-size: 13px;\n  line-height: 18px;\n}\n\n.banner-module_closeButtonArea__himWQ {\n  margin-left: auto;\n  margin-right: 4px;\n}\n\n.banner-module_closeButton__tuOyE {\n  font: 300 16px/24px Meiryo, Arial, system-ui, sans-serif;\n  color: #ffffff;\n  padding: 4px;\n  border-radius: 4px;\n  white-space: nowrap;\n}\n";
var styles$S = {"information":"banner-module_information__1kcnn","warning":"banner-module_warning__3d8zY","success":"banner-module_success__2Bh9y","banner":"banner-module_banner__3lTB5","contents":"banner-module_contents__1LIIP","iconWrapper":"banner-module_iconWrapper__rToc0","icon":"banner-module_icon__2Q4MX","messageWrapper":"banner-module_messageWrapper__3LlOc","messages":"banner-module_messages__2MONr","message":"banner-module_message__3kA6v","description":"banner-module_description__15OnA","closeButtonArea":"banner-module_closeButtonArea__himWQ","closeButton":"banner-module_closeButton__tuOyE"};
styleInject(css_248z$T);

var SvgIcon$1S = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M20 3c9.37 0 17 7.63 17 17 0 9.37-7.63 17-17 17-9.37 0-17-7.63-17-17 0-9.37 7.63-17 17-17Zm0-2C9.51 1 1 9.51 1 20s8.51 19 19 19 19-8.51 19-19S30.49 1 20 1Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M17.71 27.48c-.24-.03-.54-.11-.72-.31l-6.45-6.77a.996.996 0 1 1 1.44-1.38l5.73 6.01 11.18-11.59a.996.996 0 1 1 1.44 1.38l-11.9 12.34c-.19.21-.45.32-.72.32Z",
    fill: "currentColor"
  }));
};
var CheckCircleIcon = function CheckCircleIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$1S, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$1R = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M20 3c9.37 0 17 7.63 17 17 0 9.37-7.63 17-17 17-9.37 0-17-7.63-17-17 0-9.37 7.63-17 17-17Zm0-2C9.51 1 1 9.51 1 20s8.51 19 19 19 19-8.51 19-19S30.49 1 20 1Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M19.84 12.54a2.14 2.14 0 1 0 0-4.28 2.14 2.14 0 0 0 0 4.28ZM19.84 32.42c-.83 0-1.5-.67-1.5-1.5V16.88c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v14.04c0 .83-.67 1.5-1.5 1.5Z",
    fill: "currentColor"
  }));
};
var InfoCircleIcon = function InfoCircleIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$1R, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$1Q = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("g", {
    clipPath: "url(#warning_svg__a)",
    fill: "currentColor"
  }, /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M20.14 3c1.5 0 2.83.79 3.56 2.1l13.79 25.08c.7 1.27.67 2.77-.06 4.02a4.012 4.012 0 0 1-3.49 1.99H6.07c-1.46 0-2.77-.75-3.5-2.01a4.024 4.024 0 0 1-.04-4.04L16.6 5.07C17.33 3.77 18.65 3 20.14 3Zm0-2c-2.06 0-4.12 1.03-5.28 3.09L.78 29.17c-2.27 4.04.65 9.02 5.28 9.02h27.87c4.61 0 7.53-4.94 5.31-8.98L25.45 4.14C24.3 2.05 22.22 1 20.14 1Z"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M20.1 31.17a2.14 2.14 0 1 0 0-4.28 2.14 2.14 0 0 0 0 4.28ZM22.09 13.51l-.99 11.04a1.004 1.004 0 0 1-2 0l-.98-11.04a1.993 1.993 0 1 1 3.97 0Z"
  })), /*#__PURE__*/React__namespace.default.createElement("defs", null, /*#__PURE__*/React__namespace.default.createElement("clipPath", {
    id: "warning_svg__a"
  }, /*#__PURE__*/React__namespace.default.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  }))));
};
var WarningIcon$1 = function WarningIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$1Q, _objectSpread2({
    focusable: "false"
  }, props));
};

var IconSizes = {
  small: 16,
  medium: 24,
  large: 32,
  extraLarge: 40
};

var SvgIcon$1P = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "m21.41 20 13.3-13.29A.996.996 0 1 0 33.3 5.3L20 18.59 6.71 5.29A.996.996 0 1 0 5.3 6.7L18.59 20 5.29 33.29a.996.996 0 0 0 0 1.41c.2.2.45.3.71.3.26 0 .51-.1.71-.29L20 21.41 33.29 34.7c.2.2.45.3.71.3.26 0 .51-.1.71-.29a.996.996 0 0 0 0-1.41L21.41 20Z",
    fill: "currentColor"
  }));
};
var CloseIcon = function CloseIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$1P, _objectSpread2({
    focusable: "false"
  }, props));
};

var css_248z$S = ":root {\n  /* Color styles */\n\n  /* Text-size styles */\n\n  /* Effect styles */\n  /* border-radius */\n}\n\n.close-module_closeButton__3rA_0 {\n  color: #262b38;\n  border-radius: 50%;\n  white-space: nowrap;\n  width: 28px;\n  height: 28px;\n}\n\n.close-module_closeButton__3rA_0:default {\n  outline: unset;\n}\n\n.close-module_closeButton__3rA_0.close-module_default__2-gTy:focus {\n  border: 1px solid #353ebd;\n  color: #353ebd;\n  box-shadow: 0px 0px 5px rgba(53, 62, 189, 1);\n}\n\n.close-module_closeButton__3rA_0.close-module_warn__2q5R9:focus {\n  border: 1px solid #82480a;\n  color: #82480a;\n  box-shadow: 0px 0px 5px #dcab7e;\n}\n\n.close-module_closeButton__3rA_0.close-module_success__272qy:focus {\n  border: 1px solid #258675;\n  color: #258675;\n  box-shadow: 0px 0px 5px #3aa393;\n}\n\n.close-module_closeButton__3rA_0.close-module_error__2J30A:focus {\n  border: 1px solid #de3226;\n  color: #de3226;\n  box-shadow: 0px 0px 5px rgba(222, 50, 38, 0.7);\n}\n\n@media (hover: hover) {\n  .close-module_closeButton__3rA_0:hover {\n    cursor: pointer;\n  }\n  .close-module_closeButton__3rA_0.close-module_default__2-gTy:hover {\n    color: #353ebd;\n  }\n  .close-module_closeButton__3rA_0.close-module_warn__2q5R9:hover {\n    color: #82480a;\n  }\n  .close-module_closeButton__3rA_0.close-module_success__272qy:hover {\n    color: #258675;\n  }\n  .close-module_closeButton__3rA_0.close-module_error__2J30A:hover {\n    color: #b1110c;\n  }\n}\n";
var styles$R = {"closeButton":"close-module_closeButton__3rA_0","default":"close-module_default__2-gTy","warn":"close-module_warn__2q5R9","success":"close-module_success__272qy","error":"close-module_error__2J30A"};
styleInject(css_248z$S);

var ColorMap = {
  "default": styles$R["default"],
  warn: styles$R.warn,
  success: styles$R.success,
  error: styles$R.error
};
var CloseButton = function CloseButton(_ref) {
  var onClose = _ref.onClose,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? "default" : _ref$color;
  return /*#__PURE__*/React__namespace.default.createElement("button", {
    className: classnames__default.default(styles$R.closeButton, ColorMap[color]),
    onClick: onClose
  }, /*#__PURE__*/React__namespace.default.createElement(CloseIcon, {
    size: IconSizes.medium
  }));
};

var _excluded$g = ["message", "description"],
  _excluded2$4 = ["message", "description"],
  _excluded3$2 = ["message", "description"];
var BaseBanner = function BaseBanner(_ref) {
  var className = _ref.className,
    icon = _ref.icon,
    message = _ref.message,
    description = _ref.description,
    color = _ref.color,
    onClose = _ref.onClose;
  return /*#__PURE__*/React__namespace.createElement("div", {
    className: "".concat(styles$S.banner, " ").concat(className)
  }, /*#__PURE__*/React__namespace.createElement("div", {
    className: styles$S.contents
  }, /*#__PURE__*/React__namespace.createElement("div", {
    className: styles$S.messageWrapper
  }, /*#__PURE__*/React__namespace.createElement("div", {
    className: styles$S.messages
  }, /*#__PURE__*/React__namespace.createElement("span", {
    className: styles$S.icon
  }, icon), /*#__PURE__*/React__namespace.createElement("span", {
    className: styles$S.message
  }, message)), !!onClose && (/*#__PURE__*/React__namespace.createElement("div", {
    className: styles$S.iconWrapper
  }, /*#__PURE__*/React__namespace.createElement(CloseButton, {
    onClose: onClose,
    color: color
  })))), /*#__PURE__*/React__namespace.createElement("div", {
    className: styles$S.description
  }, description)));
};
var InformationBanner = function InformationBanner(_ref2) {
  var message = _ref2.message,
    description = _ref2.description,
    props = _objectWithoutProperties(_ref2, _excluded$g);
  return /*#__PURE__*/React__namespace.createElement(BaseBanner, _objectSpread2({
    className: styles$S.information,
    icon: /*#__PURE__*/React__namespace.createElement(InfoCircleIcon, {
      size: IconSizes.medium
    }),
    message: message,
    description: description,
    color: "default"
  }, props));
};
var SuccessBanner = function SuccessBanner(_ref3) {
  var message = _ref3.message,
    description = _ref3.description,
    props = _objectWithoutProperties(_ref3, _excluded2$4);
  return /*#__PURE__*/React__namespace.createElement(BaseBanner, _objectSpread2({
    className: styles$S.success,
    icon: /*#__PURE__*/React__namespace.createElement(CheckCircleIcon, {
      size: IconSizes.medium
    }),
    message: message,
    description: description,
    color: "success"
  }, props));
};
var WarningBanner = function WarningBanner(_ref4) {
  var message = _ref4.message,
    description = _ref4.description,
    props = _objectWithoutProperties(_ref4, _excluded3$2);
  return /*#__PURE__*/React__namespace.createElement(BaseBanner, _objectSpread2({
    className: styles$S.warning,
    icon: /*#__PURE__*/React__namespace.createElement(WarningIcon$1, {
      size: IconSizes.medium
    }),
    message: message,
    description: description,
    color: "warn"
  }, props));
};

var css_248z$R = ":root {\n  /* Color styles */\n\n  /* Text-size styles */\n\n  /* Effect styles */\n  /* border-radius */\n}\n\n@media screen and (max-width: 800px) {\n  .button-module_primary__3rx99,\n  .button-module_secondary__gEQ3n,\n  .button-module_danger__1bWv0,\n  .button-module_dangerSecondary__3piko {\n    width: 100%;\n  }\n}\n\n/* common */\n\n.button-module_button__pOXX9 {\n  font: 600 14px/18px Meiryo, Arial, system-ui, sans-serif;\n  text-align: center;\n  border-radius: 4px;\n  box-sizing: border-box;\n  padding: 12px 20px;\n}\n\n.button-module_secondary__gEQ3n.button-module_button__pOXX9.button-module_kebab__3Q04_ {\n  padding: 8px;\n}\n\n.button-module_loader___iCKA {\n  margin-right: 8px;\n}\n\n/* primary */\n\n.button-module_primary__3rx99 {\n  color: #ffffff;\n  background-color: #353ebd;\n  border: 1px solid #353ebd;\n  fill: #353ebd;\n}\n\n.button-module_primary__3rx99:focus:not(:active) {\n  background: #0f1192;\n  color: #ffffff;\n  box-shadow: 0px 0px 5px rgba(53, 62, 189, 1);\n  fill: #0f1192;\n}\n\n.button-module_primary__3rx99:active {\n  border: 1px solid #030962;\n  background: #030962;\n  color: #ffffff;\n  fill: #030962;\n}\n\n/* secondary */\n\n.button-module_secondary__gEQ3n {\n  color: #353ebd;\n  background-color: #ffffff;\n  border: 1px solid #353ebd;\n  fill: #353ebd;\n}\n\n.button-module_secondary__gEQ3n:focus:not(:active) {\n  background: #ffffff;\n  color: #0f1192;\n  border: 1px solid #0f1192;\n  box-shadow: 0px 0px 5px rgba(53, 62, 189, 1);\n  fill: #0f1192;\n}\n\n.button-module_secondary__gEQ3n:active {\n  border: 1px solid #030962;\n  background: #ffffff;\n  color: #030962;\n  fill: #030962;\n}\n\n.button-module_secondary__gEQ3n .button-module_loader___iCKA {\n  border-top: 2px solid #353ebd;\n  border-right: 2px solid #353ebd;\n  border-bottom: 2px solid rgba(0, 0, 0, 0.1);\n  border-left: 2px solid #353ebd;\n}\n\n/* danger */\n\n.button-module_danger__1bWv0 {\n  color: #ffffff;\n  border: 1px solid #de3226;\n  background-color: #de3226;\n  fill: #de3226;\n}\n\n.button-module_danger__1bWv0:focus:not(:active) {\n  background: #b1110c;\n  border-color: #b1110c;\n  color: #ffffff;\n  box-shadow: 0px 0px 5px rgba(222, 50, 38, 0.7);\n  fill: #b1110c;\n}\n\n.button-module_danger__1bWv0:active {\n  border: 1px solid #920400;\n  background: #920400;\n  color: #ffffff;\n  fill: #920400;\n}\n\n/* dangerSecondary */\n\n.button-module_dangerSecondary__3piko {\n  color: #de3226;\n  background-color: #ffffff;\n  border: 1px solid #de3226;\n  fill: #de3226;\n}\n\n.button-module_dangerSecondary__3piko:focus:not(:active) {\n  background: #ffffff;\n  color: #b1110c;\n  border: 1px solid #b1110c;\n  box-shadow: 0px 0px 5px rgba(222, 50, 38, 0.7);\n  fill: #b1110c;\n}\n\n.button-module_dangerSecondary__3piko:active {\n  border: 1px solid #920400;\n  background: #ffffff;\n  color: #920400;\n  fill: #920400;\n}\n\n.button-module_dangerSecondary__3piko .button-module_loader___iCKA {\n  border-top: 2px solid #de3226;\n  border-right: 2px solid #de3226;\n  border-bottom: 2px solid rgba(0, 0, 0, 0.1);\n  border-left: 2px solid #de3226;\n}\n\n/* disabled */\n\n.button-module_primary__3rx99:disabled {\n  background: #cfd4e0;\n  color: #ffffff;\n  border: 1px solid #cfd4e0;\n  fill: #cfd4e0;\n}\n\n.button-module_danger__1bWv0:disabled {\n  background: #cfd4e0;\n  color: #ffffff;\n  border: 1px solid #cfd4e0;\n  fill: #cfd4e0;\n}\n\n.button-module_secondary__gEQ3n:disabled {\n  background: #ffffff;\n  color: #cfd4e0;\n  border: 1px solid #cfd4e0;\n  fill: #cfd4e0;\n}\n\n.button-module_dangerSecondary__3piko:disabled {\n  background: #ffffff;\n  color: #cfd4e0;\n  border: 1px solid #cfd4e0;\n  fill: #cfd4e0;\n}\n\n.button-module_small__VIe4U {\n  font: 600 12px/12px Meiryo, Arial, system-ui, sans-serif;\n  padding: 8px 16px;\n}\n\n/* textButton */\n\n.button-module_textButton__vk9Ls {\n  font: 300 14px/20px Meiryo, Arial, system-ui, sans-serif;\n  border-radius: 4px;\n  padding: 4px 2px;\n}\n\n.button-module_textButton__vk9Ls.button-module_textButtonDanger__3syOl {\n  color: #de3226;\n  fill: #de3226;\n}\n\n.button-module_textButton__vk9Ls.button-module_textButtonDanger__3syOl:focus {\n  color: #de3226;\n  fill: #de3226;\n  background-color: #f1f2f7;\n}\n\n.button-module_textButton__vk9Ls.button-module_textButtonDanger__3syOl:active {\n  color: #b1110c;\n  fill: #b1110c;\n}\n\n@media (hover: hover) {\n  .button-module_textButton__vk9Ls.button-module_textButtonDanger__3syOl:hover:not(:disabled) {\n    color: #b1110c;\n    fill: #b1110c;\n  }\n}\n\n/* textButton disabled */\n\n.button-module_textButton__vk9Ls:disabled {\n  color: #cfd4e0;\n  fill: #cfd4e0;\n  cursor: not-allowed;\n}\n\n/* textButton clear */\n\n.button-module_clear__1iz5H {\n  color: #353ebd;\n  fill: #353ebd;\n  cursor: pointer;\n}\n\n.button-module_clear__1iz5H:focus {\n  color: #353ebd;\n  fill: #353ebd;\n  background-color: #f1f2f7;\n}\n\n.button-module_clear__1iz5H:active {\n  color: #030962;\n  fill: #030962;\n}\n\n/* icon */\n\n.button-module_icon__3TGyd {\n  display: inline-flex;\n  align-items: center;\n}\n\n.button-module_button__pOXX9:not(.button-module_kebab__3Q04_) .button-module_iconLeft__2Wa9S {\n  margin-right: 10px;\n}\n\n.button-module_iconRight__JI0Pd {\n  margin-left: 10px;\n}\n\n.button-module_textButtonIcon__2bN0H {\n  margin-right: 8px;\n  display: inline-flex;\n  align-items: center;\n}\n\n@media (hover: hover) {\n  .button-module_primary__3rx99:hover:not(:disabled) {\n    border: 1px solid #0f1192;\n    background: #0f1192;\n    color: #ffffff;\n    fill: #0f1192;\n  }\n  .button-module_secondary__gEQ3n:hover:not(:disabled) {\n    border: 1px solid #0f1192;\n    background: #ffffff;\n    color: #0f1192;\n    fill: #0f1192;\n  }\n  .button-module_danger__1bWv0:hover:not(:disabled) {\n    border: 1px solid #b1110c;\n    background: #b1110c;\n    color: #ffffff;\n    fill: #b1110c;\n  }\n  .button-module_dangerSecondary__3piko:hover:not(:disabled) {\n    background: #ffffff;\n    border: 1px solid #b1110c;\n    color: #b1110c;\n    fill: #b1110c;\n  }\n  .button-module_clear__1iz5H:hover:not(:disabled) {\n    color: #0f1192;\n    fill: #0f1192;\n  }\n}\n";
var styles$Q = {"primary":"button-module_primary__3rx99","secondary":"button-module_secondary__gEQ3n","danger":"button-module_danger__1bWv0","dangerSecondary":"button-module_dangerSecondary__3piko","button":"button-module_button__pOXX9","kebab":"button-module_kebab__3Q04_","loader":"button-module_loader___iCKA","small":"button-module_small__VIe4U","textButton":"button-module_textButton__vk9Ls","textButtonDanger":"button-module_textButtonDanger__3syOl","clear":"button-module_clear__1iz5H","icon":"button-module_icon__3TGyd","iconLeft":"button-module_iconLeft__2Wa9S","iconRight":"button-module_iconRight__JI0Pd","textButtonIcon":"button-module_textButtonIcon__2bN0H"};
styleInject(css_248z$R);

var SvgIcon$1O = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M38 21.77a1 1 0 0 1-.66-.25L19.87 6 2.67 21.51a1 1 0 1 1-1.34-1.48L19.19 3.92a1 1 0 0 1 1.34 0l18.14 16.11a1 1 0 0 1 .08 1.41.999.999 0 0 1-.75.33Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M33.03 36.66h-8.82a1 1 0 0 1-1-1v-10.6h-6.42v10.6a1 1 0 0 1-1 1H6.98a1 1 0 0 1-1-1V16.61a1 1 0 0 1 2 0v18.05h6.81v-10.6a1 1 0 0 1 1-1h8.42a1 1 0 0 1 1 1v10.6h6.82V16.61a1 1 0 0 1 2 0v19.05a1 1 0 0 1-1 1Z",
    fill: "currentColor"
  }));
};
var AddressIcon = function AddressIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$1O, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$1N = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "m37.916 24.246-3.385-7.172a4.99 4.99 0 0 0 1.663-2.294 4.965 4.965 0 0 0-.2-3.793 4.897 4.897 0 0 0-5.604-2.686L26.746.575a1.01 1.01 0 0 0-.737-.563c-.328-.05-.647.06-.876.292l-14.276 15.02-6.251 3.007c-1.444.765-3.704 3.169-1.992 6.81l1.763 3.733c.03.06.06.11.09.16.706.977 2.319 2.415 4.26 2.415.219 0 .448-.02.667-.06l3.793 8.038c.17.362.528.573.896.573.14 0 .289-.03.428-.1l4.092-1.972a.992.992 0 0 0 .507-.574c.09-.251.07-.523-.04-.764l-3.723-7.897 1.484-.715 20.288-2.293a1 1 0 0 0 .757-.513c.15-.282.17-.624.03-.926h.01Zm-3.713-12.404a2.95 2.95 0 0 1-.558 3.34l-2.37-5.02a2.929 2.929 0 0 1 2.928 1.67v.01ZM6.128 27.908l-1.713-3.632c-1.264-2.686.717-3.933 1.085-4.144l5.486-2.636 4.25 9.024-5.604 2.696c-1.702.815-3.216-.936-3.504-1.308Zm8.422 9.738-3.285-6.982 2.3-1.106 3.284 6.981-2.3 1.107Zm2.598-11.74-4.51-9.567 12.942-13.6 9.946 21.095-18.358 2.072h-.02Z",
    fill: "currentColor"
  }));
};
var AnnouncementIcon = function AnnouncementIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$1N, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$1M = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M10.992 13H6.997C5.9 13 5 12.1 5 11V7c0-1.1.899-2 1.997-2h3.995c1.098 0 1.997.9 1.997 2v4c0 1.1-.899 2-1.997 2ZM21.977 13h-3.994c-1.099 0-1.998-.9-1.998-2V7c0-1.1.9-2 1.998-2h3.994c1.099 0 1.998.9 1.998 2v4c0 1.1-.9 2-1.998 2ZM33.003 13h-3.995c-1.098 0-1.997-.9-1.997-2V7c0-1.1.899-2 1.997-2h3.995C34.1 5 35 5.9 35 7v4c0 1.1-.899 2-1.997 2ZM10.992 24H6.997C5.9 24 5 23.1 5 22v-4c0-1.1.899-2 1.997-2h3.995c1.098 0 1.997.9 1.997 2v4c0 1.1-.899 2-1.997 2ZM21.977 24h-3.994c-1.099 0-1.998-.9-1.998-2v-4c0-1.1.9-2 1.998-2h3.994c1.099 0 1.998.9 1.998 2v4c0 1.1-.9 2-1.998 2ZM33.003 24h-3.995c-1.098 0-1.997-.9-1.997-2v-4c0-1.1.899-2 1.997-2h3.995C34.1 16 35 16.9 35 18v4c0 1.1-.899 2-1.997 2ZM10.992 35H6.997C5.9 35 5 34.1 5 33v-4c0-1.1.899-2 1.997-2h3.995c1.098 0 1.997.9 1.997 2v4c0 1.1-.899 2-1.997 2ZM21.977 35h-3.994c-1.099 0-1.998-.9-1.998-2v-4c0-1.1.9-2 1.998-2h3.994c1.099 0 1.998.9 1.998 2v4c0 1.1-.9 2-1.998 2ZM33.003 35h-3.995c-1.098 0-1.997-.9-1.997-2v-4c0-1.1.899-2 1.997-2h3.995C34.1 27 35 27.9 35 29v4c0 1.1-.899 2-1.997 2Z",
    fill: "currentColor"
  }));
};
var AppsIcon = function AppsIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$1M, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$1L = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M19.97 26.41c-.24 0-.47-.08-.66-.25L6.34 14.75c-.41-.36-.46-1-.09-1.41.37-.41 1-.46 1.41-.09l12.31 10.83 12.31-10.83c.41-.36 1.05-.32 1.41.09.36.42.32 1.05-.09 1.41L20.63 26.16c-.19.17-.42.25-.66.25Z",
    fill: "currentColor"
  }));
};
var ArrowDownIcon = function ArrowDownIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$1L, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$1K = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M19.943 32a1 1 0 0 1-.68-.28l-10-9.43a1 1 0 0 1 1.37-1.45l9.31 8.78 9.32-8.78a1.001 1.001 0 0 1 1.735.74.998.998 0 0 1-.365.71l-10 9.43a1 1 0 0 1-.69.28Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M19.943 31.34a1 1 0 0 1-1-1V9a1 1 0 0 1 2 0v21.34a1 1 0 0 1-1 1Z",
    fill: "currentColor"
  }));
};
var ArrowDownwardIcon = function ArrowDownwardIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$1K, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$1J = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M12 19.97c0-.24.08-.47.25-.66L23.66 6.34c.36-.41 1-.46 1.41-.09.41.37.46 1 .09 1.41L14.33 19.97l10.83 12.31c.36.41.32 1.05-.09 1.41-.42.36-1.05.32-1.41-.09L12.25 20.63a.973.973 0 0 1-.25-.66Z",
    fill: "currentColor"
  }));
};
var ArrowLeftIcon = function ArrowLeftIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$1J, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$1I = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M24.226 12.004v14.97c0 .89-1.08 1.34-1.71.71l-7.48-7.49a.996.996 0 0 1 0-1.41l7.48-7.49c.63-.63 1.71-.18 1.71.71Z",
    fill: "currentColor"
  }));
};
var ArrowLittelLeftIcon = function ArrowLittelLeftIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$1I, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$1H = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M13 16h14.97c.89 0 1.34 1.08.71 1.71l-7.49 7.48a.996.996 0 0 1-1.41 0l-7.49-7.48c-.63-.63-.18-1.71.71-1.71Z",
    fill: "currentColor"
  }));
};
var ArrowLittleDownIcon = function ArrowLittleDownIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$1H, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$1G = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M15.744 27.485v-14.97c0-.89 1.08-1.34 1.71-.71l7.48 7.49c.39.39.39 1.02 0 1.41l-7.48 7.49c-.63.63-1.71.18-1.71-.71Z",
    fill: "currentColor"
  }));
};
var ArrowLittleRightIcon = function ArrowLittleRightIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$1G, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$1F = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M27.97 23.483H13c-.89 0-1.34-1.08-.71-1.71l7.49-7.48a.996.996 0 0 1 1.41 0l7.49 7.48c.63.63.18 1.71-.71 1.71Z",
    fill: "currentColor"
  }));
};
var ArrowLittleUpIcon = function ArrowLittleUpIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$1F, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$1E = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M28.41 19.97c0 .24-.08.47-.25.66L16.75 33.61c-.36.41-1 .46-1.41.09-.41-.37-.46-1-.09-1.41l10.83-12.31L15.25 7.66c-.36-.41-.32-1.05.09-1.41.42-.36 1.05-.32 1.41.09l11.41 12.97c.17.19.25.43.25.66Z",
    fill: "currentColor"
  }));
};
var ArrowRightIcon = function ArrowRightIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$1E, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$1D = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M19.97 13c.24 0 .47.08.66.25L33.6 24.66c.41.36.46 1 .09 1.41-.37.41-1 .46-1.41.09L19.97 15.33 7.66 26.16c-.41.36-1.05.32-1.41-.09-.36-.42-.32-1.05.09-1.41l12.97-11.41a.99.99 0 0 1 .66-.25Z",
    fill: "currentColor"
  }));
};
var ArrowUpIcon = function ArrowUpIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$1D, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$1C = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M30.001 19.42c-.253 0-.497-.097-.682-.27l-9.346-8.78-9.336 8.78A1.005 1.005 0 0 1 9 18.383a.999.999 0 0 1 .264-.683L19.29 8.27a1.004 1.004 0 0 1 1.374 0l10.028 9.43a.999.999 0 0 1-.692 1.72Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M19.973 32a1.004 1.004 0 0 1-1.002-1V9.65a.999.999 0 0 1 1.002-1 1.004 1.004 0 0 1 1.003 1V31a.999.999 0 0 1-1.003 1Z",
    fill: "currentColor"
  }));
};
var ArrowUpwardIcon = function ArrowUpwardIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$1C, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$1B = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M35.834 13.033a.829.829 0 0 1-.568-.23l-7.788-7.456-3.89 3.729-3.89 3.728a.827.827 0 0 1-1.136-.074.857.857 0 0 1-.009-1.158l8.357-8.008a.828.828 0 0 1 1.145 0l8.356 8.009a.854.854 0 0 1 .196.927.846.846 0 0 1-.306.386.826.826 0 0 1-.467.147Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M27.478 23.989a1.12 1.12 0 0 1-.707-.24.754.754 0 0 1-.293-.581V5.643c0-.218.105-.427.293-.58a1.12 1.12 0 0 1 .707-.241c.265 0 .52.086.707.24a.754.754 0 0 1 .293.58v17.526a.754.754 0 0 1-.293.58 1.12 1.12 0 0 1-.707.24ZM12.5 36.374a.99.99 0 0 1-.673-.277l-8.233-7.673a.99.99 0 0 1 1.356-1.436l7.55 7.029 7.45-7.03a.989.989 0 0 1 1.61 1.123.99.99 0 0 1-.255.314l-8.122 7.673a.99.99 0 0 1-.683.277Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M12.457 35.167a1.12 1.12 0 0 1-.707-.24.755.755 0 0 1-.293-.581V16.82c0-.218.105-.427.293-.58a1.12 1.12 0 0 1 .707-.241c.265 0 .52.087.707.24a.755.755 0 0 1 .293.581v17.524a.755.755 0 0 1-.293.581 1.12 1.12 0 0 1-.707.24Z",
    fill: "currentColor"
  }));
};
var ArrowUpwardDownwardIcon = function ArrowUpwardDownwardIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$1B, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$1A = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M20 3c9.37 0 17 7.63 17 17 0 9.37-7.63 17-17 17-9.37 0-17-7.63-17-17 0-9.37 7.63-17 17-17Zm0-2C9.51 1 1 9.51 1 20s8.51 19 19 19 19-8.51 19-19S30.49 1 20 1Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M20.08 32.69a2.14 2.14 0 1 0 0-4.28 2.14 2.14 0 0 0 0 4.28ZM22.07 10.03l-.98 15.04a1 1 0 0 1-1.07.93.992.992 0 0 1-.93-.93l-.99-15.04c-.07-1.09.76-2.04 1.85-2.11 1.09-.07 2.04.76 2.11 1.85.01.09.01.18.01.26Z",
    fill: "currentColor"
  }));
};
var AttentionCircleIcon = function AttentionCircleIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$1A, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$1z = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M10.505 34V5.44h11.28c3.48 0 5.24.48 6.72 1.76 1.52 1.32 2.32 3.44 2.32 6.04 0 2.72-.72 4.52-2.4 5.84 1.16 1 1.4 1.24 1.76 1.8.76 1.2 1.16 3 1.16 5.12 0 3-.88 5.16-2.64 6.52-1.48 1.08-3.16 1.48-6.4 1.48h-11.8Zm6.12-16.96h4.72c2.44 0 3.4-.96 3.4-3.36 0-2.44-.96-3.36-3.4-3.36h-4.72v6.72Zm0 12.08h5.24c2.4 0 3.36-1.04 3.36-3.6 0-2.6-.96-3.6-3.36-3.6h-5.24v7.2Z",
    fill: "currentColor"
  }));
};
var BoldIcon = function BoldIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$1z, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$1y = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M33.98 6.01c-.26-.36-.69-.97-.72-1.26 0-.25.51-.91.73-1.19.46-.59.93-1.2.59-1.91-.1-.2-.4-.65-1.15-.65H10.8C8.51 1 6.59 2.41 6.12 4.28H6v31.45c0 2.01 1.64 3.65 3.65 3.65h21.39c2.01 0 3.65-1.64 3.65-3.65V7.41h-.01c-.04-.47-.36-.93-.69-1.4h-.01ZM10.8 3h21.11c-.38.56-.71 1.22-.65 1.92.05.63.38 1.23.73 1.75H9.97C8.9 6.67 8 5.99 8 5.18 8 3.98 9.26 3 10.8 3Zm1.8 5.67h6.1v10.2l-2.22-2.28a.996.996 0 0 0-1.41-.02l-2.47 2.4V8.67Zm18.43 28.71H9.65c-.91 0-1.65-.74-1.65-1.65V8.19c.58.3 1.25.48 1.97.48h.64v12.66a1.004 1.004 0 0 0 1.7.72l3.45-3.35L19 22.03c.19.2.45.3.72.3a.99.99 0 0 0 1-1V8.67h11.97v27.06c0 .91-.74 1.65-1.65 1.65h-.01Z",
    fill: "currentColor"
  }));
};
var BookmarkIcon = function BookmarkIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$1y, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$1x = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M15.9 3c1.88 0 3.42 1.53 3.42 3.42 0 1.88-1.53 3.42-3.42 3.42-1.88 0-3.42-1.53-3.42-3.42S14.01 3 15.9 3Zm0-2c-2.99 0-5.42 2.43-5.42 5.42 0 2.99 2.43 5.42 5.42 5.42 2.99 0 5.42-2.43 5.42-5.42C21.32 3.43 18.89 1 15.9 1ZM18.41 14.41c1.93 0 3.54 1.37 3.92 3.18H9.47a4.002 4.002 0 0 1 3.92-3.18h5.02Zm0-2h-5.03c-3.31 0-6 2.69-6 6v1.18h17.03v-1.18c0-3.32-2.68-6-6-6Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M18.82 35.67H4c-1.65 0-3-1.35-3-3V20.68c0-1.65 1.35-3 3-3h24.02c1.65 0 3 1.35 3 3v1.89c0 .55-.45 1-1 1s-1-.45-1-1v-1.89c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v11.99c0 .55.45 1 1 1h14.82c.55 0 1 .45 1 1s-.45 1-1 1Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M36.82 28.53H20.89c-.55 0-1-.45-1-1s.45-1 1-1h15.93c.55 0 1 .45 1 1s-.45 1-1 1Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M34.63 23.98c1.1 0 2 .9 2 2v8.88c0 1.1-.9 2-2 2H23.08c-1.1 0-2-.9-2-2v-8.88c0-1.1.9-2 2-2h11.55Zm0-2H23.08c-2.21 0-4 1.79-4 4v8.88c0 2.21 1.79 4 4 4h11.55c2.21 0 4-1.79 4-4v-8.88c0-2.21-1.79-4-4-4Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M24.53 25.21c-.55 0-1-.45-1-1v-3.27c0-.55.45-1 1-1s1 .45 1 1v3.27c0 .55-.45 1-1 1ZM33.18 25.21c-.55 0-1-.45-1-1v-3.27c0-.55.45-1 1-1s1 .45 1 1v3.27c0 .55-.45 1-1 1Z",
    fill: "currentColor"
  }));
};
var BoothReserveIcon = function BoothReserveIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$1x, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$1w = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M37.955 37.25H2.045a1 1 0 0 1 0-2h35.91a1 1 0 0 1 0 2Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M21.195 37.03H4.335a1 1 0 0 1-1-1V16.97a1 1 0 0 1 1-1h16.86a1 1 0 0 1 1 1v19.06a1 1 0 0 1-1 1Zm-15.86-2h14.86V17.97H5.335v17.06Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M16.395 22.51h-7.26a1 1 0 1 1 0-2h7.26a1 1 0 0 1 0 2ZM16.395 27.01h-7.26a1 1 0 1 1 0-2h7.26a1 1 0 0 1 0 2ZM16.395 31.51h-7.26a1 1 0 1 1 0-2h7.26a1 1 0 0 1 0 2ZM35.655 37.03a1 1 0 0 1-1-1V4.75h-14.29v12.22a1 1 0 1 1-2 0V3.75a1 1 0 0 1 1-1h16.29a1 1 0 0 1 1 1v32.28a1 1 0 0 1-1 1Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M29.005 10.02h-3.23a1 1 0 1 1 0-2h3.23a1 1 0 1 1 0 2ZM29.005 14.64h-3.23a1 1 0 1 1 0-2h3.23a1 1 0 0 1 0 2ZM29.005 19.27h-3.23a1 1 0 1 1 0-2h3.23a1 1 0 0 1 0 2ZM29.005 23.89h-3.23a1 1 0 1 1 0-2h3.23a1 1 0 0 1 0 2ZM29.005 28.52h-3.23a1 1 0 1 1 0-2h3.23a1 1 0 0 1 0 2Z",
    fill: "currentColor"
  }));
};
var BuildingIcon = function BuildingIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$1w, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$1v = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M30 4a2 2 0 0 1 2 2v28a2 2 0 0 1-2 2H10a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h20Zm0-2H10a4 4 0 0 0-4 4v28a4 4 0 0 0 4 4h20a4 4 0 0 0 4-4V6a4 4 0 0 0-4-4Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M28.08 7.88v3.22H11.92V7.88h16.16Zm0-2H11.92a2 2 0 0 0-2 2v3.22a2 2 0 0 0 2 2h16.16a2 2 0 0 0 2-2V7.88a2 2 0 0 0-2-2ZM13.85 15.92v1.93h-2v-1.93h2Zm0-2h-2a2 2 0 0 0-2 2v1.93a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-1.93a2 2 0 0 0-2-2ZM20.97 15.92v1.93h-2v-1.93h2Zm0-2h-2a2 2 0 0 0-2 2v1.93a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-1.93a2 2 0 0 0-2-2ZM28.08 15.92v1.93h-2v-1.93h2Zm0-2h-2a2 2 0 0 0-2 2v1.93a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-1.93a2 2 0 0 0-2-2ZM13.85 23.1v1.93h-2V23.1h2Zm0-2h-2a2 2 0 0 0-2 2v1.93a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2V23.1a2 2 0 0 0-2-2ZM20.97 23.1v1.93h-2V23.1h2Zm0-2h-2a2 2 0 0 0-2 2v1.93a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2V23.1a2 2 0 0 0-2-2ZM28.08 23.1v1.93h-2V23.1h2Zm0-2h-2a2 2 0 0 0-2 2v1.93a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2V23.1a2 2 0 0 0-2-2ZM20.97 29.89v1.93h-9.11v-1.93h9.11Zm0-2h-9.11a2 2 0 0 0-2 2v1.93a2 2 0 0 0 2 2h9.11a2 2 0 0 0 2-2v-1.93a2 2 0 0 0-2-2ZM28.08 29.89v1.93h-2v-1.93h2Zm0-2h-2a2 2 0 0 0-2 2v1.93a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-1.93a2 2 0 0 0-2-2Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M30 4a2 2 0 0 1 2 2v28a2 2 0 0 1-2 2H10a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h20Zm0-2H10a4 4 0 0 0-4 4v28a4 4 0 0 0 4 4h20a4 4 0 0 0 4-4V6a4 4 0 0 0-4-4Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M28.08 7.88v3.22H11.92V7.88h16.16Zm0-2H11.92a2 2 0 0 0-2 2v3.22a2 2 0 0 0 2 2h16.16a2 2 0 0 0 2-2V7.88a2 2 0 0 0-2-2ZM13.85 15.92v1.93h-2v-1.93h2Zm0-2h-2a2 2 0 0 0-2 2v1.93a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-1.93a2 2 0 0 0-2-2ZM20.97 15.92v1.93h-2v-1.93h2Zm0-2h-2a2 2 0 0 0-2 2v1.93a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-1.93a2 2 0 0 0-2-2ZM28.08 15.92v1.93h-2v-1.93h2Zm0-2h-2a2 2 0 0 0-2 2v1.93a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-1.93a2 2 0 0 0-2-2ZM13.85 23.1v1.93h-2V23.1h2Zm0-2h-2a2 2 0 0 0-2 2v1.93a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2V23.1a2 2 0 0 0-2-2ZM20.97 23.1v1.93h-2V23.1h2Zm0-2h-2a2 2 0 0 0-2 2v1.93a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2V23.1a2 2 0 0 0-2-2ZM28.08 23.1v1.93h-2V23.1h2Zm0-2h-2a2 2 0 0 0-2 2v1.93a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2V23.1a2 2 0 0 0-2-2ZM20.97 29.89v1.93h-9.11v-1.93h9.11Zm0-2h-9.11a2 2 0 0 0-2 2v1.93a2 2 0 0 0 2 2h9.11a2 2 0 0 0 2-2v-1.93a2 2 0 0 0-2-2ZM28.08 29.89v1.93h-2v-1.93h2Zm0-2h-2a2 2 0 0 0-2 2v1.93a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-1.93a2 2 0 0 0-2-2Z",
    fill: "currentColor"
  }));
};
var CalculatorIcon = function CalculatorIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$1v, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$1u = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M34 8.79c1.1 0 2 .9 2 2V33c0 1.1-.9 2-2 2H7c-1.1 0-2-.9-2-2V10.79c0-1.1.9-2 2-2h27Zm0-2H7c-2.21 0-4 1.79-4 4V33c0 2.21 1.79 4 4 4h27c2.21 0 4-1.79 4-4V10.79c0-2.21-1.79-4-4-4Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M12.18 11.56H12c-.55 0-1-.45-1-1V4c0-.55.45-1 1-1h.19c.55 0 1 .45 1 1v6.56c-.01.56-.46 1-1.01 1Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M12.18 3H12c-.56 0-1 .45-1 1v6.56c0 .55.45 1 1 1h.18c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1ZM29 11.56h-.19c-.55 0-1-.45-1-1V4c0-.55.45-1 1-1H29c.55 0 1 .45 1 1v6.56c0 .56-.44 1-1 1Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M29 3h-.18c-.55 0-1 .45-1 1v6.56c0 .55.45 1 1 1H29c.55 0 1-.45 1-1V4c0-.55-.44-1-1-1ZM36.48 16H4.52c-.55 0-1-.45-1-1s.45-1 1-1h31.96c.55 0 1 .45 1 1s-.45 1-1 1Z",
    fill: "currentColor"
  }));
};
var CalenderIcon = function CalenderIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$1u, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$1t = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M34.66 6H5c-2.21 0-4 1.79-4 4v19.76c0 2.21 1.79 4 4 4h29.66c2.21 0 4-1.79 4-4V10c0-2.21-1.79-4-4-4ZM5 8h29.66c1.1 0 2 .9 2 2v2.78H3V10c0-1.1.9-2 2-2Zm29.66 23.76H5c-1.1 0-2-.9-2-2V17.89h33.66v11.87a2 2 0 0 1-2 2Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M10.32 22.98H8.67c-1.1 0-2 .9-2 2v1.65c0 1.1.9 2 2 2h1.65c1.1 0 2-.9 2-2v-1.65c0-1.1-.9-2-2-2Z",
    fill: "currentColor"
  }));
};
var CardIcon = function CardIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$1t, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$1s = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M27.31 38.96a1 1 0 0 1-.76-.35l-6.13-7.17H6.5a5 5 0 0 1-5-5V6.04a5 5 0 0 1 5-5h27a5 5 0 0 1 5 5v20.4a5 5 0 0 1-5 5h-5.19v6.52a1 1 0 0 1-.65.94c-.113.04-.23.06-.35.06ZM6.5 2.96a3 3 0 0 0-3 3v20.4a3 3 0 0 0 3 3h14.38a1 1 0 0 1 .76.35l4.67 5.46v-4.73a1 1 0 0 1 1-1h6.19a3 3 0 0 0 3-3V6.04a3 3 0 0 0-3-3l-27-.08Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M20 26.18a2.14 2.14 0 1 0 0-4.28 2.14 2.14 0 0 0 0 4.28ZM21.98 7.54l-1 12a1 1 0 1 1-2 0l-1-12a2 2 0 1 1 4 0Z",
    fill: "currentColor"
  }));
};
var CautionIcon = function CautionIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$1s, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$1r = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M20 1a19 19 0 1 0 0 38 19 19 0 0 0 0-38Zm10.32 13.84-11.9 12.34a1 1 0 0 1-.72.31 1.24 1.24 0 0 1-.73-.32l-6.43-6.73a1 1 0 0 1 1.45-1.38l5.72 6 11.18-11.62a1.002 1.002 0 0 1 1.71.698 1 1 0 0 1-.28.702Z",
    fill: "currentColor"
  }));
};
var CheckCircleSolidIcon = function CheckCircleSolidIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$1r, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$1q = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M31.85 5.59h-1.98v-.45c0-.55-.45-1-1-1H24C23.55 2.34 21.93 1 20 1c-1.92 0-3.54 1.33-3.99 3.14h-4.87c-.55 0-1 .45-1 1v.46H8.15A3.133 3.133 0 0 0 5 8.73v27.73c0 1.73 1.41 3.13 3.15 3.13h23.69c1.74 0 3.15-1.41 3.15-3.13V8.73C35 7 33.59 5.59 31.85 5.59Zm-19.71.55h4.75c.55 0 1-.48 1-1.03C17.89 3.95 18.84 3 20 3s2.11.95 2.11 2.11v.03c0 .55.45 1 1 1h4.75v2.58H12.14V6.14ZM33 36.46c0 .62-.52 1.13-1.15 1.13H8.15c-.63 0-1.15-.5-1.15-1.13V8.73c0-.63.52-1.14 1.15-1.14h1.98v2.13c0 .55.45 1 1 1h17.72c.55 0 1-.45 1-1V7.59h1.98c.65 0 1.17.51 1.17 1.14v27.73Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M28.86 15.1H19.4c-.55 0-1 .45-1 1s.45 1 1 1h9.46c.55 0 1-.45 1-1s-.45-1-1-1ZM14.63 14.07l-1.94 1.94-.84-.84a.996.996 0 1 0-1.41 1.41l1.55 1.55c.2.2.45.29.71.29.26 0 .51-.1.71-.29l2.65-2.65a.996.996 0 0 0 0-1.41 1.02 1.02 0 0 0-1.43 0ZM28.86 23.1H19.4c-.55 0-1 .45-1 1s.45 1 1 1h9.46c.55 0 1-.45 1-1s-.45-1-1-1ZM14.63 22.07l-1.94 1.94-.84-.84a.996.996 0 1 0-1.41 1.41l1.55 1.55c.2.2.45.29.71.29.26 0 .51-.1.71-.29l2.65-2.65a.996.996 0 0 0 0-1.41 1.02 1.02 0 0 0-1.43 0ZM28.86 31.1H19.4c-.55 0-1 .45-1 1s.45 1 1 1h9.46c.55 0 1-.45 1-1s-.45-1-1-1ZM14.63 30.07l-1.94 1.94-.84-.84a.996.996 0 1 0-1.41 1.41l1.55 1.55c.2.2.45.29.71.29.26 0 .51-.1.71-.29l2.65-2.65a.996.996 0 0 0 0-1.41 1.02 1.02 0 0 0-1.43 0Z",
    fill: "currentColor"
  }));
};
var CheckListIcon = function CheckListIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$1q, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$1p = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M33 5a2 2 0 0 1 2 2v26a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h26Zm0-2H7a4 4 0 0 0-4 4v26a4 4 0 0 0 4 4h26a4 4 0 0 0 4-4V7a4 4 0 0 0-4-4Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M16.66 28.18a.999.999 0 0 1-.72-.31l-7.17-7.52a1 1 0 1 1 1.45-1.38l6.45 6.77 12.51-13a1.001 1.001 0 0 1 1.44 1.39L17.38 27.89a1 1 0 0 1-.72.29Z",
    fill: "currentColor"
  }));
};
var CheckboxIcon = function CheckboxIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$1p, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$1o = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M20 6.974A13.026 13.026 0 1 1 6.974 20 13.036 13.036 0 0 1 20 6.974ZM20 5a15 15 0 1 0 0 30 15 15 0 0 0 0-30Z",
    fill: "currentColor"
  }));
};
var CircleIcon = function CircleIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$1o, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$1n = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M20 3c9.37 0 17 7.63 17 17 0 9.37-7.63 17-17 17-9.37 0-17-7.63-17-17 0-9.37 7.63-17 17-17Zm0-2C9.51 1 1 9.51 1 20s8.51 19 19 19 19-8.51 19-19S30.49 1 20 1Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M28.72 29.72c-.26 0-.51-.1-.71-.29L10.58 11.99a.996.996 0 1 1 1.41-1.41l17.43 17.43c.39.39.39 1.02 0 1.41-.19.2-.45.3-.7.3Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M11.28 29.72c-.26 0-.51-.1-.71-.29a.996.996 0 0 1 0-1.41l17.44-17.44a.996.996 0 1 1 1.41 1.41L11.99 29.42c-.19.2-.45.3-.71.3Z",
    fill: "currentColor"
  }));
};
var CloseCircleIcon = function CloseCircleIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$1n, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$1m = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M20 1C9.51 1 1 9.51 1 20s8.51 19 19 19 19-8.51 19-19S30.49 1 20 1Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.57 29.43c.2.19.45.29.71.29.26 0 .52-.1.71-.3l8.007-8.007 8.013 8.017c.2.19.45.29.71.29.25 0 .51-.1.7-.3a.996.996 0 0 0 0-1.41L21.41 20l8.01-8.01a.996.996 0 1 0-1.41-1.41L20 18.59l-8.01-8.01a.996.996 0 1 0-1.41 1.41l8.008 8.012-8.018 8.018a.996.996 0 0 0 0 1.41Z",
    fill: "#fff"
  }));
};
var CloseCircleSolidIcon = function CloseCircleSolidIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$1m, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$1l = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M37.33 16.3a.996.996 0 0 0-1.41-.01c-3.02 2.98-9.12 7.99-16.11 7.99S6.72 19.27 3.7 16.29a.987.987 0 0 0-1.41.01.987.987 0 0 0 .01 1.41c1.03 1.02 2.4 2.26 4.03 3.47l-2.34 2.79a1 1 0 0 0 .12 1.41c.19.15.42.23.64.23.29 0 .57-.12.77-.36l2.45-2.92c1.06.69 2.2 1.35 3.42 1.92l-1.25 3.44a.998.998 0 0 0 .94 1.34c.41 0 .79-.25.94-.66l1.22-3.34c1.75.65 3.62 1.09 5.57 1.21v3.25c0 .55.45 1 1 1s1-.45 1-1v-3.25c1.66-.1 3.26-.43 4.77-.93l1.11 3.06a.998.998 0 0 0 1.28.6c.52-.19.79-.76.6-1.28l-1.12-3.09c1.28-.55 2.49-1.2 3.61-1.89l2.14 2.55c.2.24.48.36.77.36.23 0 .45-.08.64-.23a1 1 0 0 0 .12-1.41l-2-2.38c1.88-1.34 3.45-2.74 4.59-3.87.39-.41.4-1.04.01-1.43Z",
    fill: "currentColor"
  }));
};
var CloseEyeIcon = function CloseEyeIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$1l, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$1k = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M15.24 29h20c.55 0 1 .45 1 1s-.45 1-1 1h-20c-.55 0-1-.45-1-1s.45-1 1-1ZM15.24 18.5h20c.55 0 1 .45 1 1s-.45 1-1 1h-20c-.55 0-1-.45-1-1s.45-1 1-1ZM15.24 8h20c.55 0 1 .45 1 1s-.45 1-1 1h-20c-.55 0-1-.45-1-1s.45-1 1-1ZM8.1 14c.24 0 .48.09.67.26.41.37.44 1 .07 1.41l-3.49 3.84 3.47 3.81a.997.997 0 1 1-1.48 1.34l-4.08-4.49a1 1 0 0 1 0-1.35l4.1-4.51c.2-.2.47-.31.74-.31Z",
    fill: "currentColor"
  }));
};
var CloseMenuIcon = function CloseMenuIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$1k, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$1j = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M5 2.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM9 2.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM13 2.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM17 2.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM21 2.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM25 2.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM29 2.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM33 2.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM3 5.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM7 5.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM11 5.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM15 5.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM19 5.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM23 5.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM27 5.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM31 5.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM5 8.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM9 8.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM13 8.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM17 8.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM21 8.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM25 8.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM29 8.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM33 8.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM3 11.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM7 11.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM11 11.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM15 11.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM19 11.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM23 11.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM27 11.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM31 11.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM5 14.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM9 14.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM13 14.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM17 14.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM21 14.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM25 14.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM29 14.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM33 14.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM3 17.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM7 17.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM11 17.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM15 17.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM19 17.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM23 17.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM27 17.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM31 17.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM5 20.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM9 20.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM13 20.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM17 20.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM21 20.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM25 20.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM29 20.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM33 20.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM3 23.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM7 23.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM11 23.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM15 23.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM19 23.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM23 23.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM27 23.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM31 23.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM5 26.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM9 26.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM13 26.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM17 26.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM21 26.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM25 26.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM29 26.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM33 26.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM3 29.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM7 29.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM11 29.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM15 29.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM19 29.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM23 29.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM27 29.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM31 29.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM5 32.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM9 32.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM13 32.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM17 32.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM21 32.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM25 32.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM29 32.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM33 32.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM3 35.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM7 35.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM11 35.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM15 35.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM19 35.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM23 35.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM27 35.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM31 35.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM37 2.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM35 5.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM37 8.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM35 11.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM37 14.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM35 17.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM37 20.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM35 23.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM37 26.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM35 29.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM37 32.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM35 35.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z",
    fill: "currentColor"
  }));
};
var ColorPatternIcon = function ColorPatternIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$1j, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$1i = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M26.81 36.82c-.28 0-.56-.12-.76-.35l-6.13-7.08H6c-2.76 0-5-2.24-5-5V8.18c0-2.76 2.24-5 5-5h27c2.76 0 5 2.24 5 5v16.21c0 2.76-2.24 5-5 5h-5.19v6.43c0 .42-.26.79-.65.94-.12.04-.23.06-.35.06ZM6 5.18c-1.65 0-3 1.35-3 3v16.21c0 1.65 1.35 3 3 3h14.38c.29 0 .57.13.76.35l4.67 5.4v-4.75c0-.55.45-1 1-1H33c1.65 0 3-1.35 3-3V8.18c0-1.65-1.35-3-3-3H6Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M10.5 18.33a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM19.5 18.33a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM28.5 18.33a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
    fill: "currentColor"
  }));
};
var CommentIcon = function CommentIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$1i, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$1h = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.809 5.042c.063.012.128.018.191.018v-.01a.996.996 0 0 0 .73-1.68l-1.01-1.06a1.01 1.01 0 0 0-.73-.31h-1.47c-.55 0-1 .45-1 1s.45 1 1 1h.47v.47c0 .55.45 1 1 1a1 1 0 0 0 .819-.428ZM26.83 36.96c1.454 0 2.66-1.114 2.868-2.57h.632c.55 0 1-.45 1-1s-.45-1-1-1h-.6V16.381a.995.995 0 0 0-.422-.963l-7.88-8.393a1.001 1.001 0 0 0-.98-.445H12.26V5.01c0-.37.19-.72.49-.9.47-.28.63-.9.34-1.37a.995.995 0 0 0-1.37-.34c-.89.54-1.45 1.55-1.45 2.62v1.56H5.9C4.3 6.58 3 7.93 3 9.6v24.34c0 1.66 1.3 3.02 2.9 3.02h20.93ZM5.9 8.58h13.69v5.65c0 1.66 1.3 3.02 2.9 3.02h5.25v16.69c0 .56-.4 1.02-.9 1.02H5.9c-.49 0-.9-.46-.9-1.02V9.59c0-.56.4-1.02.9-1.02v.01Zm16.59 6.66h3.924l-4.824-5.129v4.109c0 .56.41 1.02.9 1.02Zm11.79 19.15h-1.09c-.55 0-1-.45-1-1s.45-1 1-1h1.09c.28 0 .53-.14.71-.38.33-.45.95-.54 1.4-.21.44.33.54.95.21 1.4-.56.76-1.4 1.19-2.32 1.19Zm1.93-3.56c-.55 0-1-.45-1-1v-2.86c0-.55.45-1 1-1s1 .45 1 1v2.86c0 .55-.45 1-1 1Zm0-5.73c-.55 0-1-.45-1-1v-2.86c0-.55.45-1 1-1s1 .45 1 1v2.86c0 .55-.45 1-1 1Zm0-5.73c-.55 0-1-.45-1-1v-2.86c0-.55.45-1 1-1s1 .45 1 1v2.86c0 .55-.45 1-1 1Zm.687-8.415L35.63 9.61a.997.997 0 0 0-1.517 1.292 1 1 0 0 0 .627 1.778h.47c.022.532.463.96 1 .96l-.01.01c.55 0 1-.45 1-1v-.829a.995.995 0 0 0-.303-.866ZM32.935 9.22a1.007 1.007 0 0 1-.725-.31l-1.97-2.08a.996.996 0 1 1 1.45-1.37l1.97 2.08a.996.996 0 0 1-.725 1.68Zm0 0h.005-.01.005ZM23.64 4h-2.86c-.55 0-1-.45-1-1s.45-1 1-1h2.86c.55 0 1 .45 1 1s-.45 1-1 1Zm-5.73 0h-2.86c-.55 0-1-.45-1-1s.45-1 1-1h2.86c.55 0 1 .45 1 1s-.45 1-1 1Zm14.2 8.68H29.9c-.21 0-.43-.02-.63-.07a.992.992 0 0 1-.75-1.2c.12-.54.66-.88 1.2-.75.06.01.13.02.19.02h2.21c.55 0 1 .45 1 1s-.45 1-1 1h-.01Zm-4.13-1.99c-.54 0-.98-.4-1-.94V7.1c0-.55.45-1 1-1s1 .45 1 1v2.56c0 .55-.44 1.02-.99 1.03h-.01Z",
    fill: "currentColor"
  }));
};
var CopyIcon = function CopyIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$1h, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$1g = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M32.77 39H8.23C6.45 39 5 37.54 5 35.75V4.25C5 2.46 6.45 1 8.23 1h17.21a1 1 0 0 1 .71.3l9.56 9.64c.19.19.29.44.29.7v24.11c0 1.79-1.45 3.25-3.23 3.25ZM8.23 3C7.55 3 7 3.56 7 4.25v31.5c0 .69.55 1.25 1.23 1.25h24.54c.68 0 1.23-.56 1.23-1.25V12.06L25.03 3H8.23Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M35 12.64h-7.33c-1.78 0-3.23-1.46-3.23-3.25V2c0-.55.45-1 1-1s1 .45 1 1v7.39c0 .69.55 1.25 1.23 1.25H35c.55 0 1 .45 1 1s-.45 1-1 1ZM27.059 27.375l2.784-11.36h1.808l-2.784 11.36h-1.808Zm-.032 0-2.8-11.36h1.808l2.8 11.36h-1.808ZM21.95 24.751c0-.373-.113-.699-.337-.976a4.09 4.09 0 0 0-.88-.816 20.99 20.99 0 0 0-1.136-.768c-.405-.267-.789-.56-1.152-.88a4.46 4.46 0 0 1-.88-1.152c-.224-.437-.336-.95-.336-1.536h1.856c0 .363.112.688.336.976.235.288.528.56.88.816.363.256.747.517 1.152.784.406.256.784.55 1.136.88.363.32.656.699.88 1.136.224.427.336.939.336 1.536H21.95Zm-4.72-6.112c0-.576.143-1.077.431-1.504a2.809 2.809 0 0 1 1.184-1.008c.512-.245 1.094-.368 1.744-.368v1.52c-.469 0-.837.123-1.104.368-.266.235-.4.565-.4.992H17.23Zm6.575 6.096c0 .587-.144 1.093-.432 1.52a2.967 2.967 0 0 1-1.184 1.008c-.501.235-1.082.352-1.744.352v-1.504c.47 0 .838-.123 1.104-.368.267-.245.4-.581.4-1.008h1.856Zm-1.856-6.112c-.053-.448-.208-.784-.464-1.008a1.281 1.281 0 0 0-.896-.336v-1.52c.544 0 1.03.107 1.456.32.427.213.774.512 1.04.896.278.373.454.816.528 1.328l-1.664.32Zm-3.264 5.424c.054.64.235 1.147.544 1.52.31.363.715.544 1.216.544v1.504c-.97 0-1.76-.288-2.368-.864-.597-.576-.954-1.376-1.072-2.4l1.68-.304ZM9.663 24.511v-5.648h1.856v5.648H9.663Zm0-5.632c0-.608.144-1.147.432-1.616a3.03 3.03 0 0 1 1.184-1.104c.512-.267 1.093-.4 1.744-.4v1.504c-.47 0-.838.144-1.104.432-.267.277-.4.672-.4 1.184H9.663Zm0 5.632h1.856c0 .501.133.896.4 1.184.266.277.634.416 1.104.416v1.52c-.65 0-1.232-.133-1.744-.4a3.028 3.028 0 0 1-1.184-1.104c-.288-.47-.432-1.008-.432-1.616Zm5.104-5.184c-.053-.64-.235-1.141-.544-1.504-.31-.373-.715-.56-1.216-.56v-1.504c.97 0 1.76.288 2.368.864.608.565.965 1.365 1.072 2.4l-1.68.304Zm0 4.72 1.68.32c-.107 1.024-.464 1.824-1.072 2.4-.608.576-1.398.864-2.368.864v-1.52c.501 0 .907-.181 1.216-.544.31-.363.49-.87.544-1.52Z",
    fill: "currentColor"
  }));
};
var CsvIcon = function CsvIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$1g, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$1f = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("g", {
    clipPath: "url(#dateTime_svg__a)",
    fill: "currentColor"
  }, /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M8.48 0h-.03a1 1 0 0 0-1 1v5.98a1 1 0 0 0 1 1h.03a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1Z"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M8.48 0a1 1 0 0 0-1 1v6a1 1 0 1 0 2 0V1a1 1 0 0 0-1-1ZM24.14 0h-.03a1 1 0 0 0-1 1v5.98a1 1 0 0 0 1 1h.03a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1Z"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M24.15 0a1 1 0 0 0-1 1v6a1 1 0 0 0 2 0V1a1 1 0 0 0-1-1ZM31.18 12.17H1.41a1 1 0 1 1 0-2h29.77a1 1 0 0 1 0 2ZM28.328 18.506a9.553 9.553 0 1 1 0 19.106 9.553 9.553 0 0 1 0-19.106Zm0-1.948a11.5 11.5 0 1 0-.02 23 11.5 11.5 0 0 0 .02-23Z"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M14.59 29.66H4.01a2 2 0 0 1-2-2V7.53a2 2 0 0 1 2-2H28.6a2 2 0 0 1 2 2v6.89c.677.094 1.346.24 2 .44V7.53a4 4 0 0 0-4-4H4.01a4 4 0 0 0-4 4v20.13a4 4 0 0 0 4 4h11a13.095 13.095 0 0 1-.42-2ZM34.81 29.07h-6.24a1 1 0 0 1-1-1V21.9a1 1 0 0 1 2 0v5.17h5.24a1 1 0 0 1 0 2Z"
  })), /*#__PURE__*/React__namespace.default.createElement("defs", null, /*#__PURE__*/React__namespace.default.createElement("clipPath", {
    id: "dateTime_svg__a"
  }, /*#__PURE__*/React__namespace.default.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  }))));
};
var DateTimeIcon = function DateTimeIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$1f, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$1e = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M13 25.12c.23 0 .46.08.65.24L20 30.8l6.35-5.44a.999.999 0 1 1 1.3 1.52l-7 6a1 1 0 0 1-1.3 0l-7-6a.999.999 0 0 1 .65-1.76Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M20 13.88c.55 0 1 .45 1 1v16.37c0 .55-.45 1-1 1s-1-.45-1-1V14.88c0-.55.45-1 1-1ZM4 7h32c.55 0 1 .45 1 1s-.45 1-1 1H4c-.55 0-1-.45-1-1s.45-1 1-1Z",
    fill: "currentColor"
  }));
};
var DownloadIcon = function DownloadIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$1e, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$1d = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M6 32.17c.04 0 .08 0 .12-.01l6.45-.75c.06-.01.11-.03.16-.05a1.029 1.029 0 0 0 .43-.24l20.13-20.13a3 3 0 0 0 0-4.24l-2.87-2.87a3 3 0 0 0-4.24 0L6.05 24.01c-.09.09-.15.19-.2.31-.02.04-.02.08-.04.12-.02.05-.04.11-.05.16l-.75 6.46c-.04.3.07.61.29.82.18.19.44.29.7.29Zm1.51-5.29 2.78 2.78-3.15.37.37-3.15ZM27.59 5.29a.996.996 0 0 1 1.41 0l2.87 2.87c.39.39.39 1.02 0 1.41L12.45 29l-4.29-4.29L27.59 5.29ZM38 35H2c-.55 0-1 .45-1 1s.45 1 1 1h36c.55 0 1-.45 1-1s-.45-1-1-1Z",
    fill: "currentColor"
  }));
};
var EditIcon = function EditIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$1d, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$1c = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M14.32 6.5A1.69 1.69 0 0 1 16 8.18v6.64a1.69 1.69 0 0 1-1.68 1.68H7.68A1.69 1.69 0 0 1 6 14.82V8.18A1.69 1.69 0 0 1 7.68 6.5h6.64Zm0-2H7.68A3.68 3.68 0 0 0 4 8.18v6.64a3.68 3.68 0 0 0 3.68 3.68h6.64A3.68 3.68 0 0 0 18 14.82V8.18a3.68 3.68 0 0 0-3.68-3.68ZM32.32 6.5A1.69 1.69 0 0 1 34 8.18v6.64a1.69 1.69 0 0 1-1.68 1.68h-6.64A1.69 1.69 0 0 1 24 14.82V8.18a1.69 1.69 0 0 1 1.68-1.68h6.64Zm0-2h-6.64A3.68 3.68 0 0 0 22 8.18v6.64a3.68 3.68 0 0 0 3.68 3.68h6.64A3.68 3.68 0 0 0 36 14.82V8.18a3.68 3.68 0 0 0-3.68-3.68ZM14.32 23.5A1.69 1.69 0 0 1 16 25.18v6.64a1.69 1.69 0 0 1-1.68 1.68H7.68A1.69 1.69 0 0 1 6 31.82v-6.64a1.69 1.69 0 0 1 1.68-1.68h6.64Zm0-2H7.68A3.68 3.68 0 0 0 4 25.18v6.64a3.68 3.68 0 0 0 3.68 3.68h6.64A3.68 3.68 0 0 0 18 31.82v-6.64a3.68 3.68 0 0 0-3.68-3.68ZM32.32 23.5A1.69 1.69 0 0 1 34 25.18v6.64a1.69 1.69 0 0 1-1.68 1.68h-6.64A1.69 1.69 0 0 1 24 31.82v-6.64a1.69 1.69 0 0 1 1.68-1.68h6.64Zm0-2h-6.64A3.68 3.68 0 0 0 22 25.18v6.64a3.68 3.68 0 0 0 3.68 3.68h6.64A3.68 3.68 0 0 0 36 31.82v-6.64a3.68 3.68 0 0 0-3.68-3.68Z",
    fill: "currentColor"
  }));
};
var GlidviewIcon = function GlidviewIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$1c, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$1b = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M29.429 34.56V11.68l-3.2 1.76-1.96-4.04 6.92-3.4h3.4v28.56h-5.16ZM5 34.56V6h5.16v12.04h5.56V6h5.16v28.56h-5.16V22.28h-5.56v12.28H5Z",
    fill: "currentColor"
  }));
};
var Heading1Icon = function Heading1Icon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$1b, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$1a = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M22.029 34v-3.64l6.12-9.44c2.04-3.2 3.08-5.96 3.08-8.32 0-2.44-.56-3.44-1.88-3.44-1.6 0-2.2 1.2-2.28 4.48h-4.72c.08-5.92 2.28-8.64 7.08-8.64 4.56 0 6.96 2.56 6.96 7.4 0 2.56-.44 4.36-1.56 6.52-.8 1.56-.8 1.56-3.4 5.52l-3.48 5.32h8.36V34h-14.28ZM3 34V5.44h5.16v12.04h5.56V5.44h5.16V34h-5.16V21.72H8.16V34H3Z",
    fill: "currentColor"
  }));
};
var Heading2Icon = function Heading2Icon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$1a, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$19 = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M37 37H25c-.55 0-1-.45-1-1V26c0-2.21-1.79-4-4-4s-4 1.79-4 4v10c0 .55-.45 1-1 1H3c-.55 0-1-.45-1-1V18c0-.3.13-.58.36-.77l17-14c.37-.3.9-.3 1.27 0l17 14c.24.19.37.47.37.77v18c0 .55-.45 1-1 1Zm-11-2h10V18.47L20 5.3 4 18.47V35h10v-9c0-3.31 2.69-6 6-6s6 2.69 6 6v9Z",
    fill: "currentColor"
  }));
};
var HomeIcon = function HomeIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$19, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$18 = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M33 10H7c-.55 0-1-.45-1-1s.45-1 1-1h26c.55 0 1 .45 1 1s-.45 1-1 1ZM33 21H7c-.55 0-1-.45-1-1s.45-1 1-1h26c.55 0 1 .45 1 1s-.45 1-1 1ZM33 32H7c-.55 0-1-.45-1-1s.45-1 1-1h26c.55 0 1 .45 1 1s-.45 1-1 1Z",
    fill: "currentColor"
  }));
};
var HumbergerIcon = function HumbergerIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$18, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$17 = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M32.77 39H8.23C6.45 39 5 37.54 5 35.75V4.25C5 2.46 6.45 1 8.23 1h16.55c.69 0 1.36.28 1.85.77l8.62 8.69c.49.5.76 1.15.76 1.85v23.44C36 37.54 34.55 39 32.77 39ZM8.23 3C7.55 3 7 3.56 7 4.25v31.5c0 .69.55 1.25 1.23 1.25h24.54c.68 0 1.23-.56 1.23-1.25V12.31c0-.17-.06-.32-.18-.44L25.2 3.18a.56.56 0 0 0-.42-.18H8.23Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M35 12.64h-7.33c-1.78 0-3.23-1.46-3.23-3.25V2c0-.55.45-1 1-1s1 .45 1 1v7.39c0 .69.55 1.25 1.23 1.25H35c.55 0 1 .45 1 1s-.45 1-1 1ZM11.42 33.34H29.6c.89 0 1.61-.73 1.61-1.62v-8.38c0-1.35-1.55-2.11-2.6-1.27l-5.31 4.22c-1.05.84-2.6.08-2.6-1.27 0-1.33-1.5-2.09-2.56-1.3l-7.68 5.73c-.41.31-.65.79-.65 1.3v.97c0 .9.72 1.62 1.61 1.62ZM13.38 21.89a2.99 2.99 0 0 0 2.98-3c0-1.657-1.334-3-2.98-3a2.99 2.99 0 0 0-2.98 3c0 1.657 1.334 3 2.98 3Z",
    fill: "currentColor"
  }));
};
var ImageIcon = function ImageIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$17, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$16 = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("circle", {
    cx: 20,
    cy: 8,
    r: 3,
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 3,
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("circle", {
    cx: 20,
    cy: 32,
    r: 3,
    fill: "currentColor"
  }));
};
var KebabIcon = function KebabIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$16, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$15 = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.12 24.87a7.043 7.043 0 0 0 5.01 2.08l-.01.01c1.89 0 3.67-.74 5.01-2.08l8.6-8.6c2.76-2.77 2.76-7.26 0-10.02-2.77-2.76-7.26-2.76-10.02 0l-2.4 2.4a.996.996 0 1 0 1.41 1.41l2.4-2.4a5.094 5.094 0 0 1 7.19 0 5.094 5.094 0 0 1 0 7.19l-8.6 8.6c-.96.96-2.24 1.49-3.59 1.49-1.35 0-2.63-.53-3.59-1.49-.32-.32-.6-.68-.82-1.07a.988.988 0 0 0-1.36-.37c-.48.27-.64.88-.37 1.36.31.54.69 1.04 1.14 1.49Zm-9.86 9.87a7.071 7.071 0 0 0 5.005 2.07h-.005.01-.005a7.054 7.054 0 0 0 5.005-2.07l2.87-2.87a.996.996 0 1 0-1.41-1.41l-2.87 2.87a5.094 5.094 0 0 1-7.19 0 5.094 5.094 0 0 1 0-7.19l8.62-8.61c.96-.96 2.24-1.49 3.59-1.49 1.35 0 2.63.53 3.59 1.49a.996.996 0 1 0 1.41-1.41 7.043 7.043 0 0 0-5.01-2.08c-1.89 0-3.67.74-5.01 2.08l-8.6 8.6c-2.76 2.77-2.76 7.26 0 10.02Z",
    fill: "currentColor"
  }));
};
var LinkIcon$1 = function LinkIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$15, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$14 = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M34.84 9h-16a1 1 0 0 1 0-2h16a1 1 0 1 1 0 2ZM34.84 21h-16a1 1 0 0 1 0-2h16a1 1 0 1 1 0 2ZM34.84 33h-16a1 1 0 0 1 0-2h16a1 1 0 1 1 0 2ZM9.307 12V5.895l-1.21.495-.528-1.287 2.32-.957h1.112V12H9.307ZM7.37 24v-1.089l2.2-2.64c.287-.341.749-1.012.892-1.298a1.94 1.94 0 0 0 .209-.869c0-.473-.253-.715-.737-.715-.385 0-.594.121-.748.451-.11.209-.154.374-.176.594l-1.551-.11c.077-1.54.913-2.299 2.53-2.299 1.529 0 2.354.77 2.354 2.178 0 .616-.154 1.122-.528 1.716-.286.451-.286.451-1.2 1.507l-1.033 1.199h2.75V24H7.37ZM8.9 32.513v-1.298h.572c.704 0 1.078-.319 1.078-.935 0-.572-.264-.891-.76-.891-.483 0-.78.286-.857.836l-1.496-.11c.088-1.408.88-2.09 2.442-2.09 1.529 0 2.343.759 2.343 2.178 0 .814-.22 1.265-.792 1.65.726.473.979.957.979 1.903 0 1.584-.825 2.365-2.508 2.365-1.056 0-1.804-.286-2.233-.858-.275-.374-.385-.704-.418-1.331l1.584-.187c.077.693.396 1.012 1 1.012.584 0 .903-.374.903-1.045 0-.726-.451-1.199-1.155-1.199H8.9Z",
    fill: "currentColor"
  }));
};
var ListOrderedIcon = function ListOrderedIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$14, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$13 = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M21.69 10.38H8.23c-.55 0-1-.45-1-1s.45-1 1-1h13.46c.55 0 1 .45 1 1s-.45 1-1 1ZM25.53 14.86H8.23c-.55 0-1-.45-1-1s.45-1 1-1h17.3c.55 0 1 .45 1 1s-.45 1-1 1ZM25.53 19.35H8.23c-.55 0-1-.45-1-1s.45-1 1-1h17.3c.55 0 1 .45 1 1s-.45 1-1 1ZM19.66 23.83H8.23c-.55 0-1-.45-1-1s.45-1 1-1h11.43c.55 0 1 .45 1 1s-.45 1-1 1ZM17.45 28H8.23c-.55 0-1-.45-1-1s.45-1 1-1h9.22c.55 0 1 .45 1 1s-.45 1-1 1Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M20.78 36.6H5.14C3.41 36.6 2 35.18 2 33.44V3.16C2 1.42 3.41 0 5.14 0h15.9c.68 0 1.32.27 1.8.75l8.28 8.36c.48.48.74 1.12.74 1.8v9.99c0 .55-.45 1-1 1s-1-.45-1-1v-9.99c0-.15-.06-.29-.16-.4l-8.28-8.36a.539.539 0 0 0-.37-.15H5.14C4.51 2 4 2.52 4 3.16v30.27c0 .64.51 1.16 1.14 1.16h15.64c.55 0 1 .45 1 1s-.45 1.01-1 1.01Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M30.87 11.27h-7.04c-1.73 0-3.14-1.42-3.14-3.16V1c0-.55.45-1 1-1s1 .45 1 1v7.11c0 .64.51 1.16 1.14 1.16h7.04c.55 0 1 .45 1 1s-.45 1-1 1ZM28.59 38.75h-2.43c-.89 0-1.61-.72-1.61-1.61v-1.25c-.25-.09-.49-.2-.72-.32l-.89.89a1.6 1.6 0 0 1-2.27 0l-1.71-1.71a1.6 1.6 0 0 1 0-2.27l.97-.97c-.09-.21-.18-.43-.25-.65h-1.39c-.89 0-1.61-.72-1.61-1.61v-2.42c0-.89.72-1.61 1.61-1.61h1.48c.07-.19.15-.38.24-.57l-1.05-1.05a1.6 1.6 0 0 1 0-2.27l1.71-1.71a1.6 1.6 0 0 1 2.27 0l1.05 1.05c.19-.09.38-.17.57-.24v-1.48c0-.89.72-1.61 1.61-1.61h2.43c.89 0 1.61.72 1.61 1.61v1.39c.22.08.43.16.64.25l.97-.97a1.6 1.6 0 0 1 2.27 0l1.71 1.71a1.6 1.6 0 0 1 0 2.27l-.89.89c.12.24.22.48.32.72h1.25c.89 0 1.61.72 1.61 1.61v2.42c0 .89-.72 1.61-1.61 1.61H35.3c-.09.27-.2.54-.32.8l.82.82a1.6 1.6 0 0 1 0 2.27l-1.71 1.71a1.6 1.6 0 0 1-2.27 0l-.82-.82c-.26.12-.53.23-.8.32v1.17c-.01.91-.73 1.63-1.61 1.63Zm-2.03-2h1.64v-1.52c0-.46.32-.86.77-.97.6-.15 1.18-.38 1.71-.69.39-.23.89-.17 1.22.15l1.06 1.06 1.16-1.16-1.06-1.06a.996.996 0 0 1-.15-1.22 6.2 6.2 0 0 0 .69-1.71c.11-.45.51-.77.97-.77h1.52v-1.64H34.5c-.45 0-.84-.3-.96-.73-.16-.58-.4-1.13-.72-1.64a.984.984 0 0 1 .14-1.23l1.15-1.15-1.16-1.16-1.2 1.2c-.32.32-.8.38-1.2.17-.49-.27-1.02-.48-1.59-.62-.45-.11-.77-.51-.77-.97v-1.75h-1.64v1.81c0 .45-.3.84-.73.96-.53.15-1.04.36-1.52.64-.39.23-.89.17-1.22-.15l-1.29-1.29-1.16 1.16 1.29 1.29c.32.32.39.82.15 1.22-.28.47-.5.98-.64 1.51-.12.43-.51.73-.96.73h-1.81v1.64h1.75c.46 0 .86.32.97.77.14.57.34 1.1.62 1.59.22.39.15.88-.17 1.2l-1.2 1.2 1.16 1.16 1.15-1.15c.33-.33.84-.39 1.23-.14.51.32 1.06.56 1.64.72.43.12.73.51.73.96v1.58h.02Zm.93-5.16c-1.89 0-3.43-1.54-3.43-3.42s1.54-3.43 3.43-3.43c1.89 0 3.43 1.54 3.43 3.43 0 1.89-1.54 3.42-3.43 3.42Zm0-4.85c-.79 0-1.43.64-1.43 1.43 0 .79.64 1.42 1.43 1.42.79 0 1.43-.64 1.43-1.42-.01-.79-.65-1.43-1.43-1.43Z",
    fill: "currentColor"
  }));
};
var ListSettingIcon = function ListSettingIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$13, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$12 = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M34.84 9h-16a1 1 0 0 1 0-2h16a1 1 0 1 1 0 2ZM34.84 21h-16a1 1 0 0 1 0-2h16a1 1 0 1 1 0 2ZM34.84 33h-16a1 1 0 0 1 0-2h16a1 1 0 1 1 0 2Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("circle", {
    cx: 9,
    cy: 8,
    r: 3,
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("circle", {
    cx: 9,
    cy: 20,
    r: 3,
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("circle", {
    cx: 9,
    cy: 32,
    r: 3,
    fill: "currentColor"
  }));
};
var ListUnorderedIcon = function ListUnorderedIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$12, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$11 = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M10.48 5a1.69 1.69 0 0 1 1.68 1.69v2.63A1.69 1.69 0 0 1 10.48 11H7.84a1.69 1.69 0 0 1-1.68-1.68V6.69A1.69 1.69 0 0 1 7.84 5h2.64Zm0-2H7.84a3.69 3.69 0 0 0-3.68 3.69v2.63A3.68 3.68 0 0 0 7.84 13h2.64a3.68 3.68 0 0 0 3.68-3.68V6.69A3.69 3.69 0 0 0 10.48 3ZM34.84 9h-16a1 1 0 0 1 0-2h16a1 1 0 1 1 0 2ZM10.48 17a1.69 1.69 0 0 1 1.68 1.69v2.63A1.69 1.69 0 0 1 10.48 23H7.84a1.69 1.69 0 0 1-1.68-1.68v-2.63A1.69 1.69 0 0 1 7.84 17h2.64Zm0-2H7.84a3.69 3.69 0 0 0-3.68 3.69v2.63A3.68 3.68 0 0 0 7.84 25h2.64a3.68 3.68 0 0 0 3.68-3.68v-2.63A3.69 3.69 0 0 0 10.48 15ZM34.84 21h-16a1 1 0 0 1 0-2h16a1 1 0 1 1 0 2ZM10.48 29a1.69 1.69 0 0 1 1.68 1.69v2.63A1.69 1.69 0 0 1 10.48 35H7.84a1.69 1.69 0 0 1-1.68-1.68v-2.63A1.69 1.69 0 0 1 7.84 29h2.64Zm0-2H7.84a3.69 3.69 0 0 0-3.68 3.69v2.63A3.68 3.68 0 0 0 7.84 37h2.64a3.68 3.68 0 0 0 3.68-3.68v-2.63A3.69 3.69 0 0 0 10.48 27ZM34.84 33h-16a1 1 0 0 1 0-2h16a1 1 0 1 1 0 2Z",
    fill: "currentColor"
  }));
};
var ListviewIcon = function ListviewIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$11, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$10 = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M21.99 2C13.08 2 5.71 8.59 4.43 17.15l-2.64-3.39a.993.993 0 0 0-1.4-.18c-.44.34-.51.97-.18 1.4l4.21 5.41c.01.01.03.02.04.03.07.08.15.14.24.2.03.02.06.05.09.06.13.06.26.09.41.09.12 0 .23-.03.34-.07.03-.01.06-.02.08-.04.03-.01.05-.02.08-.03l5.9-3.48c.48-.28.63-.89.35-1.37a.998.998 0 0 0-1.37-.35L6.3 17.96C7.23 10.12 13.9 4 21.99 4c8.7 0 15.78 7.08 15.78 15.78S30.7 35.57 21.99 35.57c-4.1 0-7.99-1.57-10.94-4.41a.996.996 0 1 0-1.38 1.44C13 35.8 17.38 37.57 22 37.57c9.81 0 17.78-7.98 17.78-17.78S31.8 2 21.99 2Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M21.99 9.3c-.55 0-1 .45-1 1v9.5c0 .55.45 1 1 1h9.6c.55 0 1-.45 1-1s-.45-1-1-1h-8.6v-8.5c0-.55-.45-1-1-1Z",
    fill: "currentColor"
  }));
};
var LogIcon = function LogIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$10, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$$ = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "m26.74 19.3-6.37-7a.997.997 0 1 0-1.48 1.34l4.85 5.33H6.5c-.55 0-1 .45-1 1s.45 1 1 1h17.24l-4.85 5.33a.997.997 0 0 0 .07 1.41.996.996 0 0 0 1.41-.07l6.37-7c.35-.37.35-.96 0-1.34Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M14.01 29.51c.55 0 1 .45 1 1V34c0 .55.43 1 .97 1h16.06c.54 0 .97-.45.97-1V6c0-.55-.43-1-.97-1H15.97c-.53 0-.96.45-.96 1v2.69c0 .55-.45 1-1 1s-1-.45-1-1V6c0-1.65 1.33-3 2.97-3h16.06c1.64 0 2.97 1.35 2.97 3v28c0 1.65-1.33 3-2.97 3H15.97C14.33 37 13 35.65 13 34v-3.49c.01-.55.46-1 1.01-1Z",
    fill: "currentColor"
  }));
};
var LoginIcon = function LoginIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$$, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$_ = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "m37.29 19.3-6.37-7a.997.997 0 1 0-1.48 1.34l4.85 5.33H20.55c-.55 0-1 .45-1 1s.45 1 1 1h13.74l-4.85 5.33a.997.997 0 0 0 .07 1.41.996.996 0 0 0 1.41-.07l6.37-7c.35-.37.35-.96 0-1.34Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M23 29.51c-.55 0-1 .45-1 1V34c0 .55-.43 1-.97 1H4.97c-.54 0-.97-.45-.97-1V6c0-.55.43-1 .97-1h16.07c.53 0 .96.45.96 1v2.69c0 .55.45 1 1 1s1-.45 1-1V6c0-1.65-1.33-3-2.97-3H4.97C3.33 3 2 4.35 2 6v28c0 1.65 1.33 3 2.97 3h16.07c1.64 0 2.97-1.35 2.97-3v-3.49c-.01-.55-.46-1-1.01-1Z",
    fill: "currentColor"
  }));
};
var LogoutIcon = function LogoutIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$_, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$Z = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M35 32.79H5a3 3 0 0 1-3-3V10a3 3 0 0 1 3-3h30a3 3 0 0 1 3 3v19.79a3 3 0 0 1-3 3ZM5 9a1 1 0 0 0-1 1v19.79a1 1 0 0 0 1 1h30a1 1 0 0 0 1-1V10a1 1 0 0 0-1-1H5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M20.08 24.73a3 3 0 0 1-1.74-.56L2.42 12.82a1.001 1.001 0 0 1 1.16-1.63L19.5 22.54a1 1 0 0 0 1.17 0l15.74-11.35a.997.997 0 0 1 1.115-.038.999.999 0 0 1 .055 1.658L21.84 24.16c-.512.37-1.128.57-1.76.57Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M35 32.79H5a3 3 0 0 1-3-3V10a3 3 0 0 1 3-3h30a3 3 0 0 1 3 3v19.79a3 3 0 0 1-3 3ZM5 9a1 1 0 0 0-1 1v19.79a1 1 0 0 0 1 1h30a1 1 0 0 0 1-1V10a1 1 0 0 0-1-1H5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M20.08 24.73a3 3 0 0 1-1.74-.56L2.42 12.82a1.001 1.001 0 0 1 1.16-1.63L19.5 22.54a1 1 0 0 0 1.17 0l15.74-11.35a.997.997 0 0 1 1.115-.038.999.999 0 0 1 .055 1.658L21.84 24.16c-.512.37-1.128.57-1.76.57Z",
    fill: "currentColor"
  }));
};
var MailIcon = function MailIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$Z, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$Y = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M31 21H9c-.55 0-1-.45-1-1s.45-1 1-1h22c.55 0 1 .45 1 1s-.45 1-1 1Z",
    fill: "currentColor"
  }));
};
var MinusIcon = function MinusIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$Y, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$X = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M20 3c4.54 0 8.81 1.77 12.02 4.98C35.23 11.19 37 15.46 37 20c0 4.54-1.77 8.81-4.98 12.02A16.891 16.891 0 0 1 20 37c-4.54 0-8.81-1.77-12.02-4.98-6.63-6.63-6.63-17.41 0-24.04C11.19 4.77 15.46 3 20 3Zm0-2c-4.86 0-9.73 1.85-13.44 5.56-7.42 7.42-7.42 19.45 0 26.87A18.92 18.92 0 0 0 20 39c4.86 0 9.73-1.85 13.43-5.56 7.42-7.42 7.42-19.45 0-26.87C29.73 2.85 24.86 1 20 1Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M31 21H9c-.55 0-1-.45-1-1s.45-1 1-1h22c.55 0 1 .45 1 1s-.45 1-1 1Z",
    fill: "currentColor"
  }));
};
var MinusCircleIcon = function MinusCircleIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$X, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$W = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M36 34.61H5c-.55 0-1-.45-1-1s.45-1 1-1h31c.55 0 1 .45 1 1s-.45 1-1 1Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M30.37 34.61H10.63c-1.21 0-2.2-.99-2.2-2.2V17.76c0-6.66 5.42-12.07 12.07-12.07s12.07 5.42 12.07 12.07v14.65c0 1.21-.99 2.2-2.2 2.2ZM20.5 7.69c-5.55 0-10.07 4.52-10.07 10.07v14.65c0 .11.09.2.2.2h19.74a.2.2 0 0 0 .2-.2V17.76c0-5.56-4.52-10.07-10.07-10.07Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M21.29 39H19.7c-2.97 0-5.39-2.42-5.39-5.39 0-.55.45-1 1-1h10.37c.55 0 1 .45 1 1 .01 2.97-2.41 5.39-5.39 5.39Zm-4.83-4.39A3.403 3.403 0 0 0 19.7 37h1.59c1.52 0 2.81-1.01 3.24-2.39h-8.07ZM20.5 7.49c-.55 0-1-.45-1-1V2c0-.55.45-1 1-1s1 .45 1 1v4.49c0 .55-.45 1-1 1Z",
    fill: "currentColor"
  }));
};
var NotificcationIcon = function NotificcationIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$W, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$V = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M8.775 27.801v-13.29l-2.3 1.65v-2.37l2.3-1.63h2.24v15.66l-2.24-.02ZM16.005 27.801v-2.11l4.05-7.64a2.86 2.86 0 0 0 .35-1c.018-.353.018-.707 0-1.06v-.61a1.59 1.59 0 0 0-.12-.56 1 1 0 0 0-.33-.41 1.06 1.06 0 0 0-.64-.16 1.1 1.1 0 0 0-.8.28 1.12 1.12 0 0 0-.3.84v1.28h-2.24v-1.24c0-.453.089-.901.26-1.32.171-.401.419-.764.73-1.07a3.172 3.172 0 0 1 1.05-.74c.416-.185.865-.28 1.32-.28a3.33 3.33 0 0 1 1.51.32c.409.21.767.508 1.05.87.265.383.462.81.58 1.26.125.487.19.987.19 1.49v1a5.78 5.78 0 0 1-.08.74c-.05.24-.124.474-.22.7-.11.24-.25.52-.42.86l-3.3 6.36h4v2.24l-6.64-.04ZM29.485 18.741a2.73 2.73 0 0 0 1.4-.25c.26-.16.39-.53.39-1.12v-2a1.08 1.08 0 0 0-.3-.79 1.05 1.05 0 0 0-.8-.31 1 1 0 0 0-.85.37 1.28 1.28 0 0 0-.25.73v1.27h-2.25v-1.29a3.19 3.19 0 0 1 .27-1.3c.164-.4.409-.76.72-1.06.315-.296.68-.534 1.08-.7a3.249 3.249 0 0 1 1.32-.27 2.938 2.938 0 0 1 1.53.37c.34.192.648.439.91.73.14.169.27.346.39.53.12.2.21.415.27.64.155.709.222 1.434.2 2.16v1.32a2.64 2.64 0 0 1-.17.83c-.093.232-.24.438-.43.6-.236.198-.49.372-.76.52.294.174.566.382.81.62.182.187.318.412.4.66.096.305.15.62.16.94V24.591c-.017.278-.05.555-.1.83a2.52 2.52 0 0 1-.18.6c-.08.174-.174.34-.28.5-.288.4-.651.74-1.07 1a3.18 3.18 0 0 1-1.71.4 4.24 4.24 0 0 1-1.12-.17 3.152 3.152 0 0 1-1.08-.58 3.001 3.001 0 0 1-.8-1 3.5 3.5 0 0 1-.32-1.56v-1.28h2.25v1.17c-.01.315.093.624.29.87a1.12 1.12 0 0 0 1.61 0 1.34 1.34 0 0 0 .3-.92v-2.29a1.52 1.52 0 0 0-.36-1.21.999.999 0 0 0-.54-.22 7.105 7.105 0 0 0-.89 0l-.04-1.99Z",
    fill: "currentColor"
  }));
};
var NumberIcon = function NumberIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$V, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$U = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M32 35.5H8a1 1 0 0 1 0-2h24a1 1 0 1 1 0 2ZM12.51 17.5v10a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-10a2 2 0 0 0-2-2h-1a2 2 0 0 0-2 2Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M15.5 30.5h-1a3 3 0 0 1-3-3v-10a3 3 0 0 1 3-3h1a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3Zm-1-14a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-10a1 1 0 0 0-1-1h-1ZM22.51 7.5v20a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-20a2 2 0 0 0-2-2h-1a2 2 0 0 0-2 2Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M25.5 30.5h-1a3 3 0 0 1-3-3v-20a3 3 0 0 1 3-3h1a3 3 0 0 1 3 3v20a3 3 0 0 1-3 3Zm-1-24a1 1 0 0 0-1 1v20a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-20a1 1 0 0 0-1-1h-1Z",
    fill: "currentColor"
  }));
};
var ObjectAlignBottomIcon = function ObjectAlignBottomIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$U, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$T = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M20 33a1 1 0 0 1-1-1V8a1 1 0 0 1 2 0v24a1 1 0 0 1-1 1Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M25.03 11.85h-10a2 2 0 0 0-2 2v1a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-1a2 2 0 0 0-2-2Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M25 17.83H15a3 3 0 0 1-3-3v-1a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v1a3 3 0 0 1-3 3Zm-10-5a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1H15ZM30.03 21.85h-20a2 2 0 0 0-2 2v1a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2v-1a2 2 0 0 0-2-2Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M30 27.83H10a3 3 0 0 1-3-3v-1a3 3 0 0 1 3-3h20a3 3 0 0 1 3 3v1a3 3 0 0 1-3 3Zm-20-5a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h20a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1H10Z",
    fill: "currentColor"
  }));
};
var ObjectAlignCenterIcon = function ObjectAlignCenterIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$T, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$S = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M5.5 33a1 1 0 0 1-1-1V8a1 1 0 0 1 2 0v24a1 1 0 0 1-1 1ZM22.5 11.5h-10a2 2 0 0 0-2 2v1a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-1a2 2 0 0 0-2-2Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M22.5 17.5h-10a3 3 0 0 1-3-3v-1a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v1a3 3 0 0 1-3 3Zm-10-5a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-10ZM32.5 21.5h-20a2 2 0 0 0-2 2v1a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2v-1a2 2 0 0 0-2-2Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M32.5 27.5h-20a3 3 0 0 1-3-3v-1a3 3 0 0 1 3-3h20a3 3 0 0 1 3 3v1a3 3 0 0 1-3 3Zm-20-5a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h20a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-20Z",
    fill: "currentColor"
  }));
};
var ObjectAlignLeftIcon = function ObjectAlignLeftIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$S, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$R = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M32 21H8a1 1 0 0 1 0-2h24a1 1 0 0 1 0 2Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M17.5 25V15a2 2 0 0 0-2-2h-1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M15.5 28h-1a3 3 0 0 1-3-3V15a3 3 0 0 1 3-3h1a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3Zm-1-14a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V15a1 1 0 0 0-1-1h-1ZM27.5 30V10a2 2 0 0 0-2-2h-1a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M25.5 33h-1a3 3 0 0 1-3-3V10a3 3 0 0 1 3-3h1a3 3 0 0 1 3 3v20a3 3 0 0 1-3 3Zm-1-24a1 1 0 0 0-1 1v20a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V10a1 1 0 0 0-1-1h-1Z",
    fill: "currentColor"
  }));
};
var ObjectAlignMiddleIcon = function ObjectAlignMiddleIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$R, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$Q = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M34.5 33a1 1 0 0 1-1-1V8a1 1 0 0 1 2 0v24a1 1 0 0 1-1 1ZM17.5 16.5h10a2 2 0 0 0 2-2v-1a2 2 0 0 0-2-2h-10a2 2 0 0 0-2 2v1a2 2 0 0 0 2 2Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M27.5 17.5h-10a3 3 0 0 1-3-3v-1a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v1a3 3 0 0 1-3 3Zm-10-5a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-10ZM7.5 26.5h20a2 2 0 0 0 2-2v-1a2 2 0 0 0-2-2h-20a2 2 0 0 0-2 2v1a2 2 0 0 0 2 2Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M27.5 27.5h-20a3 3 0 0 1-3-3v-1a3 3 0 0 1 3-3h20a3 3 0 0 1 3 3v1a3 3 0 0 1-3 3Zm-20-5a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h20a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-20Z",
    fill: "currentColor"
  }));
};
var ObjectAlignRightIcon = function ObjectAlignRightIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$Q, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$P = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M32 6.5H8a1 1 0 0 1 0-2h24a1 1 0 1 1 0 2ZM17.5 22.5v-10a2 2 0 0 0-2-2h-1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M15.5 25.5h-1a3 3 0 0 1-3-3v-10a3 3 0 0 1 3-3h1a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3Zm-1-14a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-10a1 1 0 0 0-1-1h-1ZM27.5 32.5v-20a2 2 0 0 0-2-2h-1a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M25.5 35.5h-1a3 3 0 0 1-3-3v-20a3 3 0 0 1 3-3h1a3 3 0 0 1 3 3v20a3 3 0 0 1-3 3Zm-1-24a1 1 0 0 0-1 1v20a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-20a1 1 0 0 0-1-1h-1Z",
    fill: "currentColor"
  }));
};
var ObjectAlignTopIcon = function ObjectAlignTopIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$P, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$O = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M10.5 32a1 1 0 0 1-1-1V9a1 1 0 1 1 2 0v22a1 1 0 0 1-1 1ZM17.5 15v10a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2V15a2 2 0 0 0-2-2h-1a2 2 0 0 0-2 2Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M20.5 28h-1a3 3 0 0 1-3-3V15a3 3 0 0 1 3-3h1a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3Zm-1-14a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V15a1 1 0 0 0-1-1h-1ZM29.5 32a1 1 0 0 1-1-1V9a1 1 0 1 1 2 0v22a1 1 0 0 1-1 1Z",
    fill: "currentColor"
  }));
};
var ObjectSpacingHorizontalIcon = function ObjectSpacingHorizontalIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$O, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$N = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M31 11.5H9a1 1 0 0 1 0-2h22a1 1 0 0 1 0 2ZM25.02 17.5h-10a2 2 0 0 0-2 2v1a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-1a2 2 0 0 0-2-2Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M25 23.5H15a3 3 0 0 1-3-3v-1a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v1a3 3 0 0 1-3 3Zm-10-5a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1H15ZM31 30.5H9a1 1 0 0 1 0-2h22a1 1 0 0 1 0 2Z",
    fill: "currentColor"
  }));
};
var ObjectSpacingVerticalIcon = function ObjectSpacingVerticalIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$N, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$M = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M20 11c6.823 0 12.837 5.2 15.816 8.3.238.25.276.54.276.7 0 .16-.038.45-.276.7C32.837 23.8 26.814 29 20 29c-6.823 0-12.837-5.2-15.816-8.3a1.026 1.026 0 0 1 0-1.4C7.163 16.2 13.186 11 20 11Zm0-2c-7.556 0-14.084 5.69-17.158 8.88-1.123 1.16-1.123 3.07 0 4.23C5.916 25.31 12.444 31 20 31c7.556 0 14.084-5.69 17.158-8.88 1.123-1.16 1.123-3.07 0-4.23C34.094 14.69 27.565 9 20 9Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M19.91 12.39c-4.2 0-7.61 3.41-7.61 7.61s3.41 7.61 7.61 7.61 7.61-3.41 7.61-7.61-3.4-7.61-7.61-7.61Zm0 10.22c-1.44 0-2.61-1.17-2.61-2.61s1.17-2.61 2.61-2.61 2.61 1.17 2.61 2.61-1.17 2.61-2.61 2.61Z",
    fill: "currentColor"
  }));
};
var OpenEyeIcon = function OpenEyeIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$M, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$L = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M36 26.03c-.55 0-1 .45-1 1v6.83c0 .62-.51 1.13-1.13 1.13H6.13C5.51 35 5 34.49 5 33.87V6.13C5 5.51 5.51 5 6.13 5h6.83c.55 0 1-.45 1-1s-.45-1-1-1H6.13C4.41 3 3 4.41 3 6.13v27.73C3 35.59 4.41 37 6.13 37h27.73c1.73 0 3.13-1.41 3.13-3.13v-6.83a.99.99 0 0 0-.99-1.01Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M36.92 3.62A1.019 1.019 0 0 0 36 3H23.43c-.55 0-1 .45-1 1s.45 1 1 1h10.15L20.04 18.54a.996.996 0 0 0 .71 1.7c.26 0 .51-.1.71-.29L35 6.41v10.15c0 .55.45 1 1 1s1-.45 1-1V4c0-.13-.03-.26-.08-.38Z",
    fill: "currentColor"
  }));
};
var OpenInNewIcon = function OpenInNewIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$L, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$K = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M25 10H5c-.55 0-1-.45-1-1s.45-1 1-1h20c.55 0 1 .45 1 1s-.45 1-1 1ZM25 20.5H5c-.55 0-1-.45-1-1s.45-1 1-1h20c.55 0 1 .45 1 1s-.45 1-1 1ZM25 31H5c-.55 0-1-.45-1-1s.45-1 1-1h20c.55 0 1 .45 1 1s-.45 1-1 1ZM32.14 25c-.24 0-.48-.09-.67-.26-.41-.37-.44-1-.07-1.41l3.49-3.84-3.47-3.81a.997.997 0 1 1 1.48-1.34l4.08 4.49a1 1 0 0 1 0 1.35l-4.1 4.51c-.2.2-.47.31-.74.31Z",
    fill: "currentColor"
  }));
};
var OpenMenuIcon = function OpenMenuIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$K, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$J = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m25.91 2.45 8.28 8.36c.093.093.179.193.255.298a1.002 1.002 0 0 1 .459 1.13c.017.122.026.246.026.372v22.52c0 1.74-1.41 3.16-3.14 3.16H8.21c-1.73 0-3.14-1.42-3.14-3.16V4.86c0-1.74 1.41-3.16 3.14-3.16h15.9c.136 0 .27.01.403.031a1.002 1.002 0 0 1 1.112.468c.1.076.195.16.285.251Zm-.15 2.692 5.772 5.828H26.9c-.63 0-1.14-.52-1.14-1.16V5.142Zm-2-1.442v6.11c0 .09.004.18.011.27H11.29c-.55 0-1 .45-1 1s.45 1 1 1h13.43a3.12 3.12 0 0 0 2.18.89h6.03v22.17c0 .64-.51 1.16-1.14 1.16H8.21c-.63 0-1.14-.52-1.14-1.16V4.86c0-.64.51-1.16 1.14-1.16h15.55ZM11.29 16.56h17.3c.55 0 1-.45 1-1s-.45-1-1-1h-17.3c-.55 0-1 .45-1 1s.45 1 1 1Zm17.3 4.49h-17.3c-.55 0-1-.45-1-1s.45-1 1-1h17.3c.55 0 1 .45 1 1s-.45 1-1 1Zm-17.3 4.48h17.3c.55 0 1-.45 1-1s-.45-1-1-1h-17.3c-.55 0-1 .45-1 1s.45 1 1 1Zm9.22 4.17h-9.22c-.55 0-1-.45-1-1s.45-1 1-1h9.22c.55 0 1 .45 1 1s-.45 1-1 1Z",
    fill: "currentColor"
  }));
};
var PaperIcon = function PaperIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$J, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$I = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M36 4H4C2.35 4 1 5.35 1 7v20c0 1.65 1.35 3 3 3h11.18v3.14H6c-.55 0-1 .45-1 1s.45 1 1 1h28c.55 0 1-.45 1-1s-.45-1-1-1h-9.18V30H36c1.65 0 3-1.35 3-3V7c0-1.65-1.35-3-3-3ZM17.18 33.14V30.1h5.63v3.04h-5.63ZM4 6h32c.55 0 1 .45 1 1v15.07H3V7c0-.55.45-1 1-1Zm32 22H4c-.55 0-1-.45-1-1v-2.93h34V27c0 .55-.45 1-1 1Z",
    fill: "currentColor"
  }));
};
var PcIcon = function PcIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$I, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$H = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M32.77 39H8.23C6.45 39 5 37.54 5 35.75V4.25C5 2.46 6.45 1 8.23 1h17.21a1 1 0 0 1 .71.3l9.56 9.64c.19.19.29.44.29.7v24.11c0 1.79-1.45 3.25-3.23 3.25ZM8.23 3C7.55 3 7 3.56 7 4.25v31.5c0 .69.55 1.25 1.23 1.25h24.54c.68 0 1.23-.56 1.23-1.25V12.06L25.03 3H8.23Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M35 12.64h-7.33c-1.78 0-3.23-1.46-3.23-3.25V2c0-.55.45-1 1-1s1 .45 1 1v7.39c0 .69.55 1.25 1.23 1.25H35c.55 0 1 .45 1 1s-.45 1-1 1ZM11.09 27.92v-12.1h2.6c.48 0 .9.06 1.26.19.36.12.69.35.99.66.29.32.5.69.61 1.11.11.43.17 1 .17 1.73 0 .54-.03 1-.09 1.38-.06.37-.2.73-.4 1.05-.24.4-.56.71-.95.93-.4.22-.92.33-1.56.33h-.9v4.73h-1.73v-.01Zm1.73-10.47v4.11h.83c.35 0 .62-.05.82-.15.19-.1.33-.24.42-.42.09-.17.14-.38.16-.63.02-.25.03-.53.03-.83 0-.28-.01-.55-.02-.81s-.06-.48-.15-.67a.972.972 0 0 0-.41-.44c-.18-.1-.44-.15-.78-.15h-.9v-.01ZM18.01 27.92v-12.1h2.57c1 0 1.75.27 2.27.82.52.55.77 1.31.77 2.31v5.66c0 1.13-.27 1.97-.82 2.51-.55.54-1.34.81-2.37.81h-2.42v-.01Zm1.73-10.47v8.84h.8c.49 0 .83-.12 1.04-.37.2-.24.31-.63.31-1.15v-5.83c0-.48-.1-.84-.29-1.1-.19-.26-.54-.39-1.05-.39h-.81ZM25.25 27.92v-12.1h5.17v1.63h-3.43v3.67h2.99v1.63h-2.99v5.17h-1.74Z",
    fill: "currentColor"
  }));
};
var PdfIcon = function PdfIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$H, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$G = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M30.065 36c-2.62 0-9.43-.91-16.86-9.29-9.3-10.5-7-18.53-6.88-18.86a1 1 0 0 1 .51-.6l6.29-3.14a1 1 0 0 1 1.33.43l3.72 7.2a1 1 0 0 1-.14 1.12l-3.55 4a22 22 0 0 0 8.72 9.89l4.53-3a1 1 0 0 1 1.11 0l6.72 4.59a1 1 0 0 1 .42.65.999.999 0 0 1-.16.75l-4 5.75a1 1 0 0 1-.66.41 6.39 6.39 0 0 1-1.1.1ZM8.155 8.82c-.29 1.64-.83 8.23 6.55 16.56 7.38 8.33 14.11 8.7 15.76 8.61l3.14-4.53-5.33-3.65-4.47 2.94a1 1 0 0 1-1 .07 23.31 23.31 0 0 1-10.45-11.75 1 1 0 0 1 .17-1.06l3.53-4-3-5.7-4.9 2.51Z",
    fill: "currentColor"
  }));
};
var PhoneIcon = function PhoneIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$G, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$F = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M20.35 9.16c-3.5 0-6.35 2.85-6.35 6.35 0 3.5 2.85 6.35 6.35 6.35 3.5 0 6.35-2.85 6.35-6.35 0-3.5-2.85-6.35-6.35-6.35Zm0 10.7c-2.4 0-4.35-1.95-4.35-4.35 0-2.4 1.95-4.35 4.35-4.35 2.4 0 4.35 1.95 4.35 4.35 0 2.4-1.95 4.35-4.35 4.35Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M20.51 1C12.51 1 6 7.51 6 15.51c0 10.87 13.28 23.05 13.84 23.56.19.17.43.26.67.26.24 0 .47-.08.66-.25.57-.5 13.85-12.29 13.85-23.57 0-8-6.51-14.51-14.51-14.51Zm0 35.96c-2.67-2.6-12.52-12.77-12.52-21.45C8 8.61 13.61 3 20.51 3c6.9 0 12.51 5.61 12.51 12.51 0 9-9.82 18.91-12.5 21.45h-.01Z",
    fill: "currentColor"
  }));
};
var PinIcon = function PinIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$F, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$E = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M20 32c-.55 0-1-.45-1-1V9c0-.55.45-1 1-1s1 .45 1 1v22c0 .55-.45 1-1 1Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M31 21H9c-.55 0-1-.45-1-1s.45-1 1-1h22c.55 0 1 .45 1 1s-.45 1-1 1Z",
    fill: "currentColor"
  }));
};
var PlusIcon = function PlusIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$E, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$D = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M20 3c4.54 0 8.81 1.77 12.02 4.98C35.23 11.19 37 15.46 37 20c0 4.54-1.77 8.81-4.98 12.02A16.891 16.891 0 0 1 20 37c-4.54 0-8.81-1.77-12.02-4.98-6.63-6.63-6.63-17.41 0-24.04C11.19 4.77 15.46 3 20 3Zm0-2c-4.86 0-9.73 1.85-13.44 5.56-7.42 7.42-7.42 19.45 0 26.87A18.92 18.92 0 0 0 20 39c4.86 0 9.73-1.85 13.43-5.56 7.42-7.42 7.42-19.45 0-26.87C29.73 2.85 24.86 1 20 1Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M20 32c-.55 0-1-.45-1-1V9c0-.55.45-1 1-1s1 .45 1 1v22c0 .55-.45 1-1 1Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M31 21H9c-.55 0-1-.45-1-1s.45-1 1-1h22c.55 0 1 .45 1 1s-.45 1-1 1Z",
    fill: "currentColor"
  }));
};
var PlusCircleIcon = function PlusCircleIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$D, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$C = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.56 6.56A18.95 18.95 0 0 1 20 1c4.86 0 9.73 1.85 13.43 5.57 7.42 7.42 7.42 19.45 0 26.87C29.73 37.15 24.86 39 20 39c-4.86 0-9.73-1.85-13.44-5.57-7.42-7.42-7.42-19.45 0-26.87ZM20 32c-.55 0-1-.45-1-1V21H9c-.55 0-1-.45-1-1s.45-1 1-1h10V9c0-.55.45-1 1-1s1 .45 1 1v10h10c.55 0 1 .45 1 1s-.45 1-1 1H21v10c0 .55-.45 1-1 1Z",
    fill: "currentColor"
  }));
};
var PlusCircleSolidIcon = function PlusCircleSolidIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$C, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$B = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M27.28 37.6H7.14C5.41 37.6 4 36.18 4 34.44V4.16C4 2.42 5.41 1 7.14 1h15.9c.68 0 1.32.27 1.8.75l8.28 8.36c.48.48.74 1.12.74 1.8v9.42c0 .55-.45 1-1 1s-1-.45-1-1v-9.42c0-.15-.06-.29-.16-.4l-8.27-8.35c-.1-.1-.24-.16-.38-.16H7.14C6.51 3 6 3.52 6 4.16v30.27c0 .64.51 1.16 1.14 1.16h20.14c.55 0 1 .45 1 1s-.45 1-1 1v.01Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M32.87 12.27h-7.04c-1.73 0-3.14-1.42-3.14-3.16V2c0-.55.45-1 1-1s1 .45 1 1v7.11c0 .64.51 1.16 1.14 1.16h7.04c.55 0 1 .45 1 1s-.45 1-1 1Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M23.69 11.38H10.23c-.55 0-1-.45-1-1s.45-1 1-1h13.46c.55 0 1 .45 1 1s-.45 1-1 1ZM27.53 15.86h-17.3c-.55 0-1-.45-1-1s.45-1 1-1h17.3c.55 0 1 .45 1 1s-.45 1-1 1ZM27.53 20.35h-17.3c-.55 0-1-.45-1-1s.45-1 1-1h17.3c.55 0 1 .45 1 1s-.45 1-1 1ZM20.45 24.83H10.23c-.55 0-1-.45-1-1s.45-1 1-1h10.22c.55 0 1 .45 1 1s-.45 1-1 1ZM19.45 29h-9.22c-.55 0-1-.45-1-1s.45-1 1-1h9.22c.55 0 1 .45 1 1s-.45 1-1 1Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "m29.07 38.74-.57-.39s-2.13-1.47-4.71-3.29c-2.77-1.96-2.79-4.33-2.77-4.79v-8.72l.91-.09c2.96-.28 6.52-2.8 6.55-2.83l.58-.42.58.42s3.59 2.55 6.55 2.83l.91.09v8.72c.02.46 0 2.83-2.77 4.79-2.57 1.82-4.71 3.29-4.71 3.29l-.57.39h.02Zm-6.04-15.41v7.08s-.09 1.6 1.92 3.02c1.77 1.25 3.32 2.33 4.12 2.88.8-.55 2.35-1.63 4.12-2.88 2.01-1.42 1.93-2.97 1.93-3.04v-7.07c-2.47-.49-4.95-1.96-6.05-2.67-1.1.71-3.57 2.17-6.04 2.67v.01Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M28.41 31.49c-.24 0-.49-.09-.68-.26l-2.19-2.02a.997.997 0 1 1 1.35-1.47l1.51 1.4 3.11-2.86a.996.996 0 0 1 1.41.06c.37.41.35 1.04-.06 1.41l-3.79 3.49c-.19.18-.43.26-.68.26l.02-.01Z",
    fill: "currentColor"
  }));
};
var PolicyIcon = function PolicyIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$B, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$A = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M20 3c9.37 0 17 7.63 17 17 0 9.37-7.63 17-17 17-9.37 0-17-7.63-17-17 0-9.37 7.63-17 17-17Zm0-2C9.51 1 1 9.51 1 20s8.51 19 19 19 19-8.51 19-19S30.49 1 20 1Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M20 26.68c-.83 0-1.5-.67-1.5-1.5V20.2l1.05-.33c3.27-1.02 3.96-3.16 3.96-4.77 0-1.68-1.23-3.46-3.51-3.46-1.85 0-3.15.94-3.56 2.58a1.5 1.5 0 0 1-2.91-.73c.75-3 3.22-4.86 6.47-4.86 4.08 0 6.51 3.28 6.51 6.46 0 3.3-1.81 5.89-5.01 7.24v2.84c0 .83-.67 1.51-1.5 1.51ZM20 32.79a2.14 2.14 0 1 0 0-4.28 2.14 2.14 0 0 0 0 4.28Z",
    fill: "currentColor"
  }));
};
var QuestionCircleIcon = function QuestionCircleIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$A, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$z = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M20 3a17 17 0 1 1 0 34 17 17 0 0 1 0-34Zm0-2a19 19 0 1 0 0 38 19 19 0 0 0 0-38Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M20 31.4c6.296 0 11.4-5.104 11.4-11.4S26.296 8.6 20 8.6 8.6 13.704 8.6 20 13.704 31.4 20 31.4Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M20 10.6a9.4 9.4 0 1 1-9.4 9.4 9.41 9.41 0 0 1 9.4-9.4Zm0-2A11.4 11.4 0 1 0 31.4 20 11.41 11.41 0 0 0 20 8.6Z",
    fill: "currentColor"
  }));
};
var RadioIcon = function RadioIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$z, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$y = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M6.912 22.363a1 1 0 0 1-1-1v-8.08a5 5 0 0 1 5-5h22a1 1 0 0 1 0 2h-22a3 3 0 0 0-3 3v8.08a1 1 0 0 1-1 1Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M28.162 15.854a1 1 0 0 1-.75-1.66l4.35-4.95-4.35-4.95a1 1 0 0 1 1.5-1.32l4.93 5.61a1 1 0 0 1 0 1.32l-4.93 5.61a1 1 0 0 1-.75.34ZM29.092 31.764h-22a1 1 0 0 1 0-2h22a3 3 0 0 0 3-3v-8.09a1 1 0 1 1 2 0v8.09a5 5 0 0 1-5 5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M11.842 37.364a.999.999 0 0 1-.75-.34l-4.93-5.6a1 1 0 0 1 0-1.33l4.93-5.6a1 1 0 0 1 1.5 1.32l-4.35 5 4.35 4.94a1 1 0 0 1-.09 1.41 1 1 0 0 1-.66.2Z",
    fill: "currentColor"
  }));
};
var RepeatIcon = function RepeatIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$y, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$x = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 2h13.2v2.4H4.4v10.8H2V2Zm22.8 0v2.4h10.8v10.8H38V2H24.8Zm10.8 33.6H24.8V38H38V24.8h-2.4v10.8Zm-31.2 0V24.8H2V38h13.2v-2.4H4.4Zm4.8-21.55v11.9c0 .838.57 1.25.954 1.25h19.692c.384 0 .954-.412.954-1.25v-11.9c0-.838-.57-1.25-.954-1.25H10.154c-.385 0-.954.412-.954 1.25ZM8 25.95v-11.9c0-1.351.966-2.45 2.154-2.45h19.692c1.188 0 2.154 1.099 2.154 2.45v11.9c0 1.351-.966 2.45-2.154 2.45H10.154C8.966 28.4 8 27.301 8 25.95ZM28.4 15.2h-7.2v1.2h7.2v-1.2Zm-10.8 3.6a2.4 2.4 0 0 1-2.399 2.4H16.8a2 2 0 0 1 2 2v.8a2 2 0 0 1-2 2h-3.2a2 2 0 0 1-2-2v-.8a2 2 0 0 1 2-2h1.598a2.4 2.4 0 1 1 2.402-2.4Zm3.6 0h7.2V20h-7.2v-1.2Zm7.2 3.6h-7.2v1.2h7.2v-1.2Z",
    fill: "currentColor"
  }));
};
var ScancardIcon = function ScancardIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$x, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$w = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 2h13.2v2.4H4.4v10.8H2V2Zm22.8 0v2.4h10.8v10.8H38V2H24.8Zm10.8 33.6H24.8V38H38V24.8h-2.4v10.8Zm-31.2 0V24.8H2V38h13.2v-2.4H4.4ZM8 25.95v-11.9c0-1.351.966-2.45 2.154-2.45h19.692c1.188 0 2.154 1.099 2.154 2.45v11.9c0 1.351-.966 2.45-2.154 2.45H10.154C8.966 28.4 8 27.301 8 25.95Zm7.208-4.75a2.4 2.4 0 1 0-.016 0H13.6a2 2 0 0 0-2 2v.8a2 2 0 0 0 2 2h3.2a2 2 0 0 0 2-2v-.8a2 2 0 0 0-2-2h-1.592Zm0 0h-.016.016Zm5.992-6h7.2v1.2h-7.2v-1.2Zm7.2 3.6h-7.2V20h7.2v-1.2Zm-7.2 3.6h7.2v1.2h-7.2v-1.2Z",
    fill: "currentColor"
  }));
};
var ScancardSolidIcon = function ScancardSolidIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$w, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$v = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "m37.71 35.29-9.02-9.02c2.25-2.58 3.62-5.93 3.62-9.62C32.31 8.56 25.75 2 17.65 2 9.55 2 3 8.56 3 16.65S9.56 31.3 17.65 31.3c3.69 0 7.05-1.37 9.62-3.62l9.02 9.02c.2.2.45.3.71.3.26 0 .51-.1.71-.29.39-.39.39-1.03 0-1.42ZM5 16.65C5 9.68 10.68 4 17.65 4 24.62 4 30.3 9.68 30.3 16.65c0 6.97-5.68 12.65-12.65 12.65C10.68 29.3 5 23.63 5 16.65Z",
    fill: "currentColor"
  }));
};
var SearchIcon = function SearchIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$v, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$u = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M32 39.45H8c-1.65 0-3-1.35-3-3v-19c0-1.65 1.35-3 3-3h24c1.65 0 3 1.35 3 3v19c0 1.66-1.35 3-3 3Zm-24-23c-.55 0-1 .45-1 1v19c0 .55.45 1 1 1h24c.55 0 1-.45 1-1v-19c0-.55-.45-1-1-1H8Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M29.95 16.45c-.55 0-1-.45-1-1v-3.5C28.95 7.02 24.94 3 20 3c-4.94 0-8.95 4.02-8.95 8.95v3.5c0 .55-.45 1-1 1s-1-.45-1-1v-3.5C9.05 5.91 13.96 1 20 1c6.04 0 10.95 4.91 10.95 10.95v3.5c0 .56-.45 1-1 1ZM20 27.41a3.18 3.18 0 1 0 0-6.36 3.18 3.18 0 0 0 0 6.36Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M20 32.39c-.55 0-1-.45-1-1v-7.15c0-.55.45-1 1-1s1 .45 1 1v7.15c0 .55-.45 1-1 1Z",
    fill: "currentColor"
  }));
};
var SecurityIcon = function SecurityIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$u, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$t = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M33 5a2 2 0 0 1 2 2v26a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h26Zm0-2H7a4 4 0 0 0-4 4v26a4 4 0 0 0 4 4h26a4 4 0 0 0 4-4V7a4 4 0 0 0-4-4Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M20 27a1 1 0 0 1-.69-.27l-10-9.43a1 1 0 1 1 1.37-1.45L20 24.63l9.31-8.78a1.002 1.002 0 0 1 1.71.705 1 1 0 0 1-.29.705l-10 9.43A.999.999 0 0 1 20 27Z",
    fill: "currentColor"
  }));
};
var SelectIcon = function SelectIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$t, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$s = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M22 37h-4c-1.1 0-2-.9-2-2v-2.52c-.68-.23-1.34-.52-1.97-.86l-1.81 1.81c-.78.78-2.05.78-2.83 0L6.56 30.6c-.78-.78-.78-2.05 0-2.83l1.93-1.93c-.28-.58-.53-1.2-.72-1.84H5c-1.1 0-2-.9-2-2v-4c0-1.1.9-2 2-2h2.89c.2-.59.45-1.17.73-1.72l-2.05-2.06c-.78-.78-.78-2.05 0-2.83L9.4 6.56c.78-.78 2.05-.78 2.83 0l2.05 2.05c.56-.28 1.13-.53 1.72-.73V5c0-1.1.9-2 2-2h4c1.1 0 2 .9 2 2v2.77c.64.19 1.26.44 1.85.72l1.93-1.93c.78-.78 2.05-.78 2.83 0l2.83 2.83c.78.78.78 2.05 0 2.83l-1.81 1.81c.34.63.63 1.29.86 1.97H35c1.1 0 2 .9 2 2v4c0 1.1-.9 2-2 2h-2.4c-.22.72-.51 1.42-.85 2.1l1.68 1.68c.78.78.78 2.05 0 2.83l-2.83 2.83c-.78.78-2.05.78-2.83 0l-1.68-1.68c-.67.34-1.37.63-2.1.85V35c.01 1.1-.89 2-1.99 2Zm-8.13-7.63c.18 0 .37.05.53.15.89.56 1.86.98 2.87 1.26a1 1 0 0 1 .73.97V35h4v-3.16c0-.46.32-.86.77-.97 1.05-.25 2.06-.66 3-1.21.39-.23.89-.17 1.21.15l2.21 2.21 2.83-2.83-2.21-2.21a.996.996 0 0 1-.15-1.22c.55-.93.96-1.94 1.21-3 .11-.45.51-.77.97-.77H35v-4h-3.25c-.45 0-.84-.3-.96-.73-.28-1.01-.7-1.98-1.26-2.87a.984.984 0 0 1 .14-1.23l2.35-2.35-2.83-2.83-2.45 2.44c-.32.32-.8.38-1.2.17-.86-.48-1.8-.85-2.79-1.08a1.02 1.02 0 0 1-.75-.98V5h-4v3.63c0 .45-.3.84-.73.96-.93.26-1.83.63-2.66 1.13-.39.23-.89.17-1.22-.15l-2.58-2.59-2.83 2.83 2.58 2.59c.32.32.39.82.15 1.22-.49.83-.87 1.73-1.13 2.66-.11.42-.5.72-.95.72H5v4h3.53c.46 0 .86.32.97.77.24.99.6 1.93 1.09 2.79.22.39.15.88-.17 1.2L7.98 29.2l2.83 2.83 2.35-2.35c.19-.21.45-.31.71-.31Zm6.32-4.18c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.25 5-5 5Zm0-8c-1.65 0-3 1.35-3 3s1.35 3 3 3 3-1.35 3-3-1.35-3-3-3Z",
    fill: "currentColor"
  }));
};
var SettingIcon = function SettingIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$s, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$r = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M32.86 19.94c-3.21 0-5.83 2.61-5.83 5.83 0 .1.01.2.02.3L12.52 29.8c-.36-1.63-1.4-3-2.8-3.8l7.53-11.68c.51.18 1.05.3 1.61.34.12 0 .24.01.36.01 1.42 0 2.78-.51 3.85-1.46a5.754 5.754 0 0 0 1.95-4.01c.09-1.55-.42-3.05-1.45-4.22a5.756 5.756 0 0 0-4.01-1.97c-3.19-.19-5.98 2.26-6.17 5.46-.12 1.93.73 3.69 2.11 4.84L7.78 25.3a5.99 5.99 0 0 0-.95-.08 5.83 5.83 0 1 0 0 11.66c2.94 0 5.38-2.2 5.77-5.04l14.89-3.83c.88 2.1 2.96 3.58 5.37 3.58a5.83 5.83 0 1 0 0-11.66v.01ZM19.21 5h.23c1.02.06 1.96.52 2.63 1.28.67.76 1.02 1.75.96 2.77a3.79 3.79 0 0 1-1.28 2.63 3.75 3.75 0 0 1-2.77.95 3.832 3.832 0 0 1-3.59-4.05c.12-2.03 1.81-3.6 3.82-3.6V5ZM6.83 34.88C4.72 34.88 3 33.16 3 31.05c0-2.11 1.72-3.83 3.83-3.83 2.11 0 3.83 1.72 3.83 3.83 0 2.11-1.72 3.83-3.83 3.83Zm26.03-5.29c-2.11 0-3.83-1.72-3.83-3.83 0-2.11 1.72-3.83 3.83-3.83 2.11 0 3.83 1.72 3.83 3.83 0 2.11-1.72 3.83-3.83 3.83Z",
    fill: "currentColor"
  }));
};
var ShareIcon = function ShareIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$r, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$q = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M22.82 39.08h-7.63c-.55 0-1-.45-1-1v-5.04c0-.55.45-1 1-1h7.63c.55 0 1 .45 1 1v5.04c0 .55-.45 1-1 1Zm-6.64-2h5.63v-3.04h-5.63v3.04Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M23.75 33.93H3c-1.65 0-3-1.35-3-3v-20c0-1.65 1.35-3 3-3h3c.55 0 1 .45 1 1s-.45 1-1 1H3c-.55 0-1 .45-1 1v20c0 .55.45 1 1 1h20.75c.55 0 1 .45 1 1s-.44 1-1 1ZM37 27.72c-.55 0-1-.45-1-1V10.93c0-.55-.45-1-1-1h-4.28c-.55 0-1-.45-1-1s.45-1 1-1H35c1.65 0 3 1.35 3 3v15.79c0 .55-.45 1-1 1Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M2.01 28h22.95c.55 0 1-.45 1-1s-.45-1-1-1H2.01v2ZM29.16 39.08H5c-.55 0-1-.45-1-1s.45-1 1-1h24.16c.55 0 1 .45 1 1s-.45 1-1 1ZM23.16 9.93H12c-.55 0-1-.45-1-1s.45-1 1-1h11.16c.55 0 1 .45 1 1s-.45 1-1 1ZM26 14.6H12c-.55 0-1-.45-1-1s.45-1 1-1h14c.55 0 1 .45 1 1s-.45 1-1 1ZM26 19.27H12c-.55 0-1-.45-1-1s.45-1 1-1h14c.55 0 1 .45 1 1s-.45 1-1 1ZM26 23.93H12c-.55 0-1-.45-1-1s.45-1 1-1h14c.55 0 1 .45 1 1s-.45 1-1 1Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M32.01 11.65h-6.57c-1.65 0-3-1.35-3-3.02V2c0-.55.45-1 1-1s1 .45 1 1v6.63c0 .56.45 1.02 1 1.02h6.57c.55 0 1 .45 1 1s-.45 1-1 1Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M5 4v22h2V4c0-.55.45-1 1-1h15.02L31 11.06v12.82c0 .55.45 1 1 1s1-.45 1-1V10.65c0-.26-.1-.52-.29-.7L24.15 1.3a1 1 0 0 0-.71-.3H8C6.35 1 5 2.35 5 4Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M31.02 24.93c3.42 0 6.2 2.78 6.2 6.2 0 3.42-2.78 6.2-6.2 6.2-3.42 0-6.2-2.78-6.2-6.2 0-3.42 2.78-6.2 6.2-6.2Zm0-2c-4.53 0-8.2 3.67-8.2 8.2 0 4.53 3.67 8.2 8.2 8.2 4.53 0 8.2-3.67 8.2-8.2 0-4.53-3.67-8.2-8.2-8.2Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M30.04 34.34a.96.96 0 0 1-.72-.31l-2.31-2.43a.996.996 0 1 1 1.44-1.38l1.59 1.67 3.54-3.67a.996.996 0 1 1 1.44 1.38l-4.27 4.42c-.18.21-.44.32-.71.32Z",
    fill: "currentColor"
  }));
};
var SmartapplyIcon = function SmartapplyIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$q, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$p = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M29 0H11C9.35 0 8 1.35 8 3v34c0 1.65 1.35 3 3 3h18c1.65 0 3-1.35 3-3V3c0-1.65-1.35-3-3-3ZM10 9.14h20v23.33H10V9.14ZM11 2h18c.55 0 1 .45 1 1v4.14H10V3c0-.55.45-1 1-1Zm18 36H11c-.55 0-1-.45-1-1v-2.53h20V37c0 .55-.45 1-1 1Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M16.81 6.33h6.69c.55 0 1-.45 1-1s-.45-1-1-1h-6.69c-.55 0-1 .45-1 1s.45 1 1 1ZM13.5 6.33c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1ZM26.5 6.33c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1ZM23.5 35.33h-6.69c-.55 0-1 .45-1 1s.45 1 1 1h6.69c.55 0 1-.45 1-1s-.44-1-1-1Z",
    fill: "currentColor"
  }));
};
var SpIcon = function SpIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$p, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$o = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M32 6a2 2 0 0 1 2 2v24a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h24Zm0-2H8a4 4 0 0 0-4 4v24a4 4 0 0 0 4 4h24a4 4 0 0 0 4-4V8a4 4 0 0 0-4-4Z",
    fill: "currentColor"
  }));
};
var SquareIcon = function SquareIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$o, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$n = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M20 3c9.37 0 17 7.63 17 17 0 9.37-7.63 17-17 17-9.37 0-17-7.63-17-17 0-9.37 7.63-17 17-17Zm0-2C9.51 1 1 9.51 1 20s8.51 19 19 19 19-8.51 19-19S30.49 1 20 1Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M14.79 29.6c-.17 0-.35-.04-.5-.13-.31-.18-.5-.51-.5-.87V11.4c0-.36.19-.69.5-.87.31-.18.69-.18 1 0l14.9 8.6c.31.18.5.51.5.87s-.19.69-.5.87l-14.9 8.6c-.15.09-.33.13-.5.13Zm1-16.47v13.74L27.69 20l-11.9-6.87Z",
    fill: "currentColor"
  }));
};
var StartCircleIcon = function StartCircleIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$n, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$m = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M20 1C9.51 1 1 9.51 1 20s8.51 19 19 19 19-8.51 19-19S30.49 1 20 1Zm0 2c4.77 0 9.08 1.98 12.17 5.16L5.6 28.98C3.97 26.37 3 23.3 3 20c0-9.37 7.63-17 17-17Zm0 34c-5.36 0-10.13-2.5-13.25-6.38L33.47 9.68 32.94 9A16.91 16.91 0 0 1 37 20c0 9.37-7.63 17-17 17Z",
    fill: "currentColor"
  }));
};
var StopCircleIcon = function StopCircleIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$m, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$l = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M37.63 1.8c-.54-.54-1.28-.82-2.07-.8L21.64 2.1c-1.22.05-2.36.54-3.23 1.41l-16 15.97c-1.88 1.88-1.88 4.94 0 6.81l10.73 10.73c.94.94 2.17 1.41 3.41 1.41 1.24 0 2.47-.47 3.41-1.41l16-15.97c.87-.87 1.37-2.02 1.41-3.21l1.07-14.02c.02-.75-.27-1.49-.8-2.02h-.01Zm-2.26 15.94c-.02.72-.32 1.39-.82 1.9l-16 15.97c-1.1 1.1-2.88 1.1-3.99 0L3.82 24.88c-1.1-1.1-1.1-2.89 0-3.98L19.83 4.92c.51-.51 1.18-.8 1.9-.82L35.67 3h.03a.735.735 0 0 1 .74.71l-1.07 14.02v.01Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M27.25 6.74a5.04 5.04 0 0 0-5.03 5.03 5.04 5.04 0 0 0 5.03 5.03 5.04 5.04 0 0 0 5.03-5.03c0-2.77-2.25-5.03-5.03-5.03Zm0 8.06c-1.67 0-3.03-1.36-3.03-3.03 0-1.67 1.36-3.03 3.03-3.03 1.67 0 3.03 1.36 3.03 3.03 0 1.67-1.36 3.03-3.03 3.03Z",
    fill: "currentColor"
  }));
};
var TagIcon = function TagIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$l, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$k = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M36 12.59a1 1 0 0 1-1-1V5H5v6.58a1 1 0 0 1-2 0V4a1 1 0 0 1 1-1h32a1 1 0 0 1 1 1v7.58a1.002 1.002 0 0 1-1 1.01Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M20 37.22a1 1 0 0 1-1-1V4.59a1 1 0 1 1 2 0v31.63a1 1 0 0 1-1 1Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M27.02 37.22h-14a1 1 0 0 1 0-2h14a1 1 0 1 1 0 2Z",
    fill: "currentColor"
  }));
};
var TextIcon = function TextIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$k, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$j = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M35 24H5a3 3 0 0 1-3-3v-2a3 3 0 0 1 3-3h30a3 3 0 0 1 3 3v2a3 3 0 0 1-3 3ZM5 18a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h30a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1H5Z",
    fill: "currentColor"
  }));
};
var Text1LineIcon = function Text1LineIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$j, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$i = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M34 11H6a1 1 0 0 1 0-2h28a1 1 0 1 1 0 2ZM29.89 20.49H10.12a1 1 0 0 1 0-2h19.77a1 1 0 0 1 0 2ZM32.5 31h-25a1 1 0 0 1 0-2h25a1 1 0 1 1 0 2Z",
    fill: "currentColor"
  }));
};
var TextAlignCenterIcon = function TextAlignCenterIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$i, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$h = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M34 11H6a1 1 0 0 1 0-2h28a1 1 0 0 1 0 2ZM25.76 20.54H6a1 1 0 1 1 0-2h19.76a1 1 0 0 1 0 2ZM31 31H6a1 1 0 0 1 0-2h25a1 1 0 0 1 0 2Z",
    fill: "currentColor"
  }));
};
var TextAlignLeftIcon = function TextAlignLeftIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$h, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$g = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M30.5 11h-2a1 1 0 0 1 0-2h2a1 1 0 1 1 0 2Zm-7 0h-2a1 1 0 0 1 0-2h2a1 1 0 1 1 0 2Zm-7 0h-2a1 1 0 0 1 0-2h2a1 1 0 1 1 0 2Zm-7 0h-2a1 1 0 0 1 0-2h2a1 1 0 1 1 0 2ZM23.5 20.5h-2a1 1 0 0 1 0-2h2a1 1 0 1 1 0 2Zm-7 0h-2a1 1 0 0 1 0-2h2a1 1 0 1 1 0 2Zm-7 0h-2a1 1 0 0 1 0-2h2a1 1 0 1 1 0 2ZM32.5 31.5h-25a1.5 1.5 0 1 1 0-3h25a1.5 1.5 0 1 1 0 3Z",
    fill: "currentColor"
  }));
};
var TextAlignLeftBottomIcon = function TextAlignLeftBottomIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$g, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$f = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M31.5 11h-2a1 1 0 0 1 0-2h2a1 1 0 1 1 0 2Zm-7 0h-2a1 1 0 0 1 0-2h2a1 1 0 1 1 0 2Zm-7 0h-2a1 1 0 0 1 0-2h2a1 1 0 1 1 0 2Zm-7 0h-2a1 1 0 0 1 0-2h2a1 1 0 1 1 0 2ZM28.26 21H8.5a1.5 1.5 0 1 1 0-3h19.76a1.5 1.5 0 1 1 0 3ZM31.5 31h-2a1 1 0 0 1 0-2h2a1 1 0 1 1 0 2Zm-7 0h-2a1 1 0 0 1 0-2h2a1 1 0 1 1 0 2Zm-7 0h-2a1 1 0 0 1 0-2h2a1 1 0 1 1 0 2Zm-7 0h-2a1 1 0 0 1 0-2h2a1 1 0 1 1 0 2Z",
    fill: "currentColor"
  }));
};
var TextAlignLeftCenterIcon = function TextAlignLeftCenterIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$f, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$e = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M33.5 12h-28a1.5 1.5 0 1 1 0-3h28a1.5 1.5 0 0 1 0 3ZM21.5 21h-2a1 1 0 0 1 0-2h2a1 1 0 1 1 0 2Zm-7 0h-2a1 1 0 0 1 0-2h2a1 1 0 1 1 0 2Zm-7 0h-2a1 1 0 0 1 0-2h2a1 1 0 1 1 0 2ZM28.5 31.5h-2a1 1 0 0 1 0-2h2a1 1 0 1 1 0 2Zm-7 0h-2a1 1 0 0 1 0-2h2a1 1 0 1 1 0 2Zm-7 0h-2a1 1 0 0 1 0-2h2a1 1 0 1 1 0 2Zm-7 0h-2a1 1 0 0 1 0-2h2a1 1 0 1 1 0 2Z",
    fill: "currentColor"
  }));
};
var TextAlignLeftTopIcon = function TextAlignLeftTopIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$e, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$d = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M31.5 10.99h-2a1 1 0 1 1 0-2h2a1 1 0 0 1 0 2Zm-7 0h-2a1 1 0 1 1 0-2h2a1 1 0 0 1 0 2Zm-7 0h-2a1 1 0 1 1 0-2h2a1 1 0 0 1 0 2Zm-7 0h-2a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2ZM28 20.5h-2a1 1 0 1 1 0-2h2a1 1 0 1 1 0 2Zm-7 0h-2a1 1 0 1 1 0-2h2a1 1 0 1 1 0 2Zm-7 0h-2a1 1 0 1 1 0-2h2a1 1 0 1 1 0 2ZM32.5 31.5h-25a1.5 1.5 0 0 1 0-3h25a1.5 1.5 0 1 1 0 3Z",
    fill: "currentColor"
  }));
};
var TextAlignMiddleBottomIcon = function TextAlignMiddleBottomIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$d, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$c = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M32 10.99h-2a1 1 0 0 1 0-2h2a1 1 0 1 1 0 2Zm-7 0h-2a1 1 0 0 1 0-2h2a1 1 0 1 1 0 2Zm-7 0h-2a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2Zm-7 0H9a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2ZM30.41 20.99H10.65a1.5 1.5 0 1 1 0-3h19.76a1.5 1.5 0 1 1 0 3ZM32 30.99h-2a1 1 0 0 1 0-2h2a1 1 0 1 1 0 2Zm-7 0h-2a1 1 0 0 1 0-2h2a1 1 0 1 1 0 2Zm-7 0h-2a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2Zm-7 0H9a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2Z",
    fill: "currentColor"
  }));
};
var TextAlignMiddleCenterIcon = function TextAlignMiddleCenterIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$c, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$b = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M34.5 12h-28a1.5 1.5 0 0 1 0-3h28a1.5 1.5 0 0 1 0 3ZM26.62 21h-2a1 1 0 0 1 0-2h2a1 1 0 1 1 0 2Zm-7 0h-2a1 1 0 0 1 0-2h2a1 1 0 1 1 0 2Zm-7 0h-2a1 1 0 0 1 0-2h2a1 1 0 1 1 0 2ZM31 31.49h-2a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2Zm-7 0h-2a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2Zm-7 0h-2a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2Zm-7 0H8a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2Z",
    fill: "currentColor"
  }));
};
var TextAlignMiddleTopIcon = function TextAlignMiddleTopIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$b, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$a = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M34 11H6a1 1 0 0 1 0-2h28a1 1 0 1 1 0 2ZM34 20.49H14.24a1 1 0 0 1 0-2H34a1 1 0 0 1 0 2ZM34 31H9a1 1 0 0 1 0-2h25a1 1 0 1 1 0 2Z",
    fill: "currentColor"
  }));
};
var TextAlignRightIcon = function TextAlignRightIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$a, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$9 = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M33 10.99h-2a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2Zm-7 0h-2a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2Zm-7 0h-2a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2Zm-7 0h-2a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2ZM33 20.5h-2a1 1 0 0 1 0-2h2a1 1 0 1 1 0 2Zm-7 0h-2a1 1 0 0 1 0-2h2a1 1 0 1 1 0 2Zm-7 0h-2a1 1 0 0 1 0-2h2a1 1 0 1 1 0 2ZM32.5 31.5h-25a1.5 1.5 0 0 1 0-3h25a1.5 1.5 0 1 1 0 3Z",
    fill: "currentColor"
  }));
};
var TextAlignRightBottomIcon = function TextAlignRightBottomIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$9, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$8 = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M34 10.99h-2a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2Zm-7 0h-2a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2Zm-7 0h-2a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2Zm-7 0h-2a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2ZM33.5 20.99H13.74a1.5 1.5 0 1 1 0-3H33.5a1.5 1.5 0 1 1 0 3ZM34 30.99h-2a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2Zm-7 0h-2a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2Zm-7 0h-2a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2Zm-7 0h-2a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2Z",
    fill: "currentColor"
  }));
};
var TextAlignRightCenterIcon = function TextAlignRightCenterIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$8, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$7 = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M34 12H6a1.5 1.5 0 0 1 0-3h28a1.5 1.5 0 0 1 0 3ZM34.5 21h-2a1 1 0 0 1 0-2h2a1 1 0 1 1 0 2Zm-7 0h-2a1 1 0 0 1 0-2h2a1 1 0 1 1 0 2Zm-7 0h-2a1 1 0 0 1 0-2h2a1 1 0 1 1 0 2ZM34.5 31.49h-2a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2Zm-7 0h-2a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2Zm-7 0h-2a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2Zm-7 0h-2a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2Z",
    fill: "currentColor"
  }));
};
var TextAlignRightTopIcon = function TextAlignRightTopIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$7, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$6 = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M34 8H6a1 1 0 0 1 0-2h28a1 1 0 1 1 0 2ZM25.75 14.5H6a1 1 0 0 1 0-2h19.75a1 1 0 0 1 0 2ZM34 21H6a1 1 0 0 1 0-2h28a1 1 0 0 1 0 2ZM25.75 27.5H6a1 1 0 0 1 0-2h19.75a1 1 0 1 1 0 2ZM34 34H6a1 1 0 0 1 0-2h28a1 1 0 1 1 0 2Z",
    fill: "currentColor"
  }));
};
var TextMultiIcon = function TextMultiIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$6, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$5 = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M28.072 34.998a.997.997 0 0 1-.69-.282.968.968 0 0 1 0-1.371l5.962-5.96a.969.969 0 1 1 1.371 1.37l-5.962 5.96a.974.974 0 0 1-.68.283ZM20.019 34.998a.997.997 0 0 1-.69-.282.968.968 0 0 1 0-1.371l14.005-14.002a.969.969 0 1 1 1.372 1.37L20.7 34.717a.941.941 0 0 1-.681.282ZM11.975 34.998a.997.997 0 0 1-.69-.282.968.968 0 0 1 0-1.371l22.06-22.063a.969.969 0 1 1 1.37 1.371l-22.05 22.053a.966.966 0 0 1-.69.292Z",
    fill: "currentColor"
  }));
};
var TextareaIcon = function TextareaIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$5, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$4 = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M20 3c9.37 0 17 7.63 17 17 0 9.37-7.63 17-17 17-9.37 0-17-7.63-17-17 0-9.37 7.63-17 17-17Zm0-2C9.51 1 1 9.51 1 20s8.51 19 19 19 19-8.51 19-19S30.49 1 20 1Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M32 20.82H20.18c-.55 0-1-.45-1-1V8.11c0-.55.45-1 1-1s1 .45 1 1v10.71H32c.55 0 1 .45 1 1s-.45 1-1 1Z",
    fill: "currentColor"
  }));
};
var TimeIcon = function TimeIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$4, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$3 = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M16.06 34.46c-.55 0-1-.45-1-1V11.74c0-.55.45-1 1-1s1 .45 1 1v21.71c0 .56-.45 1.01-1 1.01ZM24.94 34.46c-.55 0-1-.45-1-1V11.74c0-.55.45-1 1-1s1 .45 1 1v21.71c0 .56-.44 1.01-1 1.01Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M30.65 39h-20.3c-1.95 0-3.54-1.55-3.54-3.46V8.43c0-.55.45-1 1-1s1 .45 1 1v27.11c0 .8.69 1.46 1.54 1.46h20.31c.85 0 1.54-.66 1.54-1.46V8.43c0-.55.45-1 1-1s1 .45 1 1v27.11c-.01 1.91-1.59 3.46-3.55 3.46Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M37 8.2H4c-.55 0-1-.45-1-1s.45-1 1-1h33c.55 0 1 .45 1 1s-.45 1-1 1Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M11.06 6.97c-.55 0-1-.45-1-1V3.85c0-1.57 1.31-2.85 2.91-2.85h15.37c1.6 0 2.9 1.28 2.9 2.85V5.8c0 .55-.45 1-1 1s-1-.45-1-1V3.85c0-.47-.41-.85-.9-.85H12.97c-.5 0-.9.38-.9.85v2.12c-.01.55-.45 1-1.01 1Z",
    fill: "currentColor"
  }));
};
var TrashIcon = function TrashIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$3, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$2 = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M27 15c-.23 0-.46-.08-.65-.24L20 9.32l-6.35 5.44a.999.999 0 1 1-1.3-1.52l7-6a1 1 0 0 1 1.3 0l7 6A.999.999 0 0 1 27 15Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M20 26.24c-.55 0-1-.45-1-1V8.87c0-.55.45-1 1-1s1 .45 1 1v16.37c0 .55-.45 1-1 1ZM36 33.12H4c-.55 0-1-.45-1-1s.45-1 1-1h32c.55 0 1 .45 1 1s-.45 1-1 1Z",
    fill: "currentColor"
  }));
};
var UploadIcon = function UploadIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$2, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon$1 = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M20 4.98a6.95 6.95 0 1 1-6.94 7 7 7 0 0 1 6.94-7Zm0-2a8.95 8.95 0 1 0 .1 17.9 8.95 8.95 0 0 0-.1-17.9ZM33.5 36.43c-.265 0-.52-.102-.707-.283a.952.952 0 0 1-.293-.684v-3.87a7.12 7.12 0 0 0-2.19-5.108 7.609 7.609 0 0 0-5.28-2.12h-10a7.62 7.62 0 0 0-5.283 2.12 7.13 7.13 0 0 0-2.197 5.108v3.87a.952.952 0 0 1-.293.684 1.017 1.017 0 0 1-.707.283c-.265 0-.52-.102-.707-.283a.952.952 0 0 1-.293-.684v-3.87c.005-2.43 1.006-4.76 2.783-6.477 1.777-1.718 4.185-2.683 6.697-2.686h10c2.51.003 4.918.969 6.693 2.686 1.776 1.718 2.774 4.047 2.777 6.477v3.87a.952.952 0 0 1-.293.684 1.017 1.017 0 0 1-.707.283Z",
    fill: "currentColor"
  }));
};
var UserIcon = function UserIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$1, _objectSpread2({
    focusable: "false"
  }, props));
};

var SvgIcon = function SvgIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement("svg", _objectSpread2({
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M13.02 12.31c1.5 0 2.72 1.22 2.72 2.72 0 1.5-1.22 2.72-2.72 2.72-1.5 0-2.72-1.22-2.72-2.72 0-1.5 1.22-2.72 2.72-2.72Zm0-2c-2.61 0-4.72 2.11-4.72 4.72s2.11 4.72 4.72 4.72 4.72-2.11 4.72-4.72-2.11-4.72-4.72-4.72ZM14.44 22.25c2.21 0 4 1.79 4 4v.49H7.6v-.49c0-2.21 1.79-4 4-4h2.84Zm0-2H11.6c-3.31 0-6 2.69-6 6v2.49h14.84v-2.49c0-3.31-2.68-6-6-6ZM33.45 13.87H24.8c-.55 0-1-.45-1-1s.45-1 1-1h8.65c.55 0 1 .45 1 1s-.45 1-1 1ZM33.45 18.54H24.8c-.55 0-1-.45-1-1s.45-1 1-1h8.65c.55 0 1 .45 1 1s-.45 1-1 1ZM33.45 27.89H24.8c-.55 0-1-.45-1-1s.45-1 1-1h8.65c.55 0 1 .45 1 1s-.45 1-1 1ZM33.45 23.22H24.8c-.55 0-1-.45-1-1s.45-1 1-1h8.65c.55 0 1 .45 1 1s-.45 1-1 1Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M35 8c1.1 0 2 .9 2 2v20c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V10c0-1.1.9-2 2-2h30Zm0-2H5c-2.21 0-4 1.79-4 4v20c0 2.21 1.79 4 4 4h30c2.21 0 4-1.79 4-4V10c0-2.21-1.79-4-4-4Z",
    fill: "currentColor"
  }));
};
var UserinfoIcon = function UserinfoIcon(props) {
  return /*#__PURE__*/React__namespace.default.createElement(SvgIcon, _objectSpread2({
    focusable: "false"
  }, props));
};

var Icons = {
  AddressIcon: AddressIcon,
  AnnouncementIcon: AnnouncementIcon,
  AppsIcon: AppsIcon,
  ArrowDownIcon: ArrowDownIcon,
  ArrowDownwardIcon: ArrowDownwardIcon,
  ArrowLeftIcon: ArrowLeftIcon,
  ArrowLittelLeftIcon: ArrowLittelLeftIcon,
  ArrowLittleDownIcon: ArrowLittleDownIcon,
  ArrowLittleRightIcon: ArrowLittleRightIcon,
  ArrowLittleUpIcon: ArrowLittleUpIcon,
  ArrowRightIcon: ArrowRightIcon,
  ArrowUpIcon: ArrowUpIcon,
  ArrowUpwardIcon: ArrowUpwardIcon,
  ArrowUpwardDownwardIcon: ArrowUpwardDownwardIcon,
  AttentionCircleIcon: AttentionCircleIcon,
  BoldIcon: BoldIcon,
  BookmarkIcon: BookmarkIcon,
  BoothReserveIcon: BoothReserveIcon,
  BuildingIcon: BuildingIcon,
  CalculatorIcon: CalculatorIcon,
  CalenderIcon: CalenderIcon,
  CardIcon: CardIcon,
  CautionIcon: CautionIcon,
  CheckCircleIcon: CheckCircleIcon,
  CheckCircleSolidIcon: CheckCircleSolidIcon,
  CheckListIcon: CheckListIcon,
  CheckboxIcon: CheckboxIcon,
  CircleIcon: CircleIcon,
  CloseIcon: CloseIcon,
  CloseCircleIcon: CloseCircleIcon,
  CloseCircleSolidIcon: CloseCircleSolidIcon,
  CloseEyeIcon: CloseEyeIcon,
  CloseMenuIcon: CloseMenuIcon,
  ColorPatternIcon: ColorPatternIcon,
  CommentIcon: CommentIcon,
  CopyIcon: CopyIcon,
  CsvIcon: CsvIcon,
  DateTimeIcon: DateTimeIcon,
  DownloadIcon: DownloadIcon,
  EditIcon: EditIcon,
  GlidviewIcon: GlidviewIcon,
  Heading1Icon: Heading1Icon,
  Heading2Icon: Heading2Icon,
  HomeIcon: HomeIcon,
  HumbergerIcon: HumbergerIcon,
  ImageIcon: ImageIcon,
  InfoCircleIcon: InfoCircleIcon,
  KebabIcon: KebabIcon,
  LinkIcon: LinkIcon$1,
  ListOrderedIcon: ListOrderedIcon,
  ListSettingIcon: ListSettingIcon,
  ListUnorderedIcon: ListUnorderedIcon,
  ListviewIcon: ListviewIcon,
  LogIcon: LogIcon,
  LoginIcon: LoginIcon,
  LogoutIcon: LogoutIcon,
  MailIcon: MailIcon,
  MinusIcon: MinusIcon,
  MinusCircleIcon: MinusCircleIcon,
  NotificcationIcon: NotificcationIcon,
  NumberIcon: NumberIcon,
  ObjectAlignBottomIcon: ObjectAlignBottomIcon,
  ObjectAlignCenterIcon: ObjectAlignCenterIcon,
  ObjectAlignLeftIcon: ObjectAlignLeftIcon,
  ObjectAlignMiddleIcon: ObjectAlignMiddleIcon,
  ObjectAlignRightIcon: ObjectAlignRightIcon,
  ObjectAlignTopIcon: ObjectAlignTopIcon,
  ObjectSpacingHorizontalIcon: ObjectSpacingHorizontalIcon,
  ObjectSpacingVerticalIcon: ObjectSpacingVerticalIcon,
  OpenEyeIcon: OpenEyeIcon,
  OpenInNewIcon: OpenInNewIcon,
  OpenMenuIcon: OpenMenuIcon,
  PaperIcon: PaperIcon,
  PcIcon: PcIcon,
  PdfIcon: PdfIcon,
  PhoneIcon: PhoneIcon,
  PinIcon: PinIcon,
  PlusIcon: PlusIcon,
  PlusCircleIcon: PlusCircleIcon,
  PlusCircleSolidIcon: PlusCircleSolidIcon,
  PolicyIcon: PolicyIcon,
  QuestionCircleIcon: QuestionCircleIcon,
  RadioIcon: RadioIcon,
  RepeatIcon: RepeatIcon,
  ScancardIcon: ScancardIcon,
  ScancardSolidIcon: ScancardSolidIcon,
  SearchIcon: SearchIcon,
  SecurityIcon: SecurityIcon,
  SelectIcon: SelectIcon,
  SettingIcon: SettingIcon,
  ShareIcon: ShareIcon,
  SmartapplyIcon: SmartapplyIcon,
  SpIcon: SpIcon,
  SquareIcon: SquareIcon,
  StartCircleIcon: StartCircleIcon,
  StopCircleIcon: StopCircleIcon,
  TagIcon: TagIcon,
  TextIcon: TextIcon,
  Text1LineIcon: Text1LineIcon,
  TextAlignCenterIcon: TextAlignCenterIcon,
  TextAlignLeftIcon: TextAlignLeftIcon,
  TextAlignLeftBottomIcon: TextAlignLeftBottomIcon,
  TextAlignLeftCenterIcon: TextAlignLeftCenterIcon,
  TextAlignLeftTopIcon: TextAlignLeftTopIcon,
  TextAlignMiddleBottomIcon: TextAlignMiddleBottomIcon,
  TextAlignMiddleCenterIcon: TextAlignMiddleCenterIcon,
  TextAlignMiddleTopIcon: TextAlignMiddleTopIcon,
  TextAlignRightIcon: TextAlignRightIcon,
  TextAlignRightBottomIcon: TextAlignRightBottomIcon,
  TextAlignRightCenterIcon: TextAlignRightCenterIcon,
  TextAlignRightTopIcon: TextAlignRightTopIcon,
  TextMultiIcon: TextMultiIcon,
  TextareaIcon: TextareaIcon,
  TimeIcon: TimeIcon,
  TrashIcon: TrashIcon,
  UploadIcon: UploadIcon,
  UserIcon: UserIcon,
  UserinfoIcon: UserinfoIcon,
  WarningIcon: WarningIcon$1
};

var css_248z$Q = ":root {\n  /* Color styles */\n\n  /* Text-size styles */\n\n  /* Effect styles */\n  /* border-radius */\n}\n\n.loader-module_loader__1r11v {\n  width: 20px;\n  height: 20px;\n  border-top: 2px solid #ffffff;\n  border-right: 2px solid #ffffff;\n  border-bottom: 2px solid rgba(255, 255, 255, 0.2);\n  border-left: 2px solid #ffffff;\n  border-radius: 50%;\n  display: inline-block;\n  box-sizing: border-box;\n  font-size: 10px;\n  position: relative;\n  text-indent: -9999em;\n  animation: loader-module_rotation__Rt0PZ 1s linear infinite;\n}\n\n@keyframes loader-module_rotation__Rt0PZ {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n";
var styles$P = {"loader":"loader-module_loader__1r11v","rotation":"loader-module_rotation__Rt0PZ"};
styleInject(css_248z$Q);

var Loader = function Loader(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/React__namespace.createElement("div", {
    className: classnames__default.default(styles$P.loader, className)
  }, "Loading...");
};

var _excluded$f = ["children", "onClick"],
  _excluded2$3 = ["type", "children", "className", "isSmall", "icon", "iconPosition"],
  _excluded3$1 = ["text", "isLoading"],
  _excluded4$1 = ["text", "isLoading"],
  _excluded5$1 = ["text", "isLoading"],
  _excluded6$1 = ["text", "isLoading"],
  _excluded7$1 = ["text", "color", "type", "icon"];
var BaseButton = function BaseButton(_ref) {
  var children = _ref.children,
    onClick = _ref.onClick,
    props = _objectWithoutProperties(_ref, _excluded$f);
  return /*#__PURE__*/React__namespace.createElement("button", _objectSpread2(_objectSpread2({}, props), {}, {
    onClick: !props.disabled && onClick ? onClick : undefined
  }), children);
};
var BaseSubmitButtonIcon = function BaseSubmitButtonIcon(_ref2) {
  var isSmall = _ref2.isSmall,
    icon = _ref2.icon,
    iconPosition = _ref2.iconPosition,
    children = _ref2.children;
  var Icon = icon !== undefined ? Icons[icon] : null;
  var IconSize = isSmall ? IconSizes.small : IconSizes.medium;
  if (!Icon) {
    return null;
  }
  if (iconPosition === "right") {
    return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, children, /*#__PURE__*/React__namespace.createElement("div", {
      className: classnames__default.default(styles$Q.icon, styles$Q.iconRight)
    }, /*#__PURE__*/React__namespace.createElement(Icon, {
      size: IconSize
    })));
  }
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, /*#__PURE__*/React__namespace.createElement("div", {
    className: classnames__default.default(styles$Q.icon, styles$Q.iconLeft)
  }, /*#__PURE__*/React__namespace.createElement(Icon, {
    size: IconSize
  })), children);
};
var BaseSubmitButton = function BaseSubmitButton(_ref3) {
  var _ref3$type = _ref3.type,
    type = _ref3$type === void 0 ? "submit" : _ref3$type,
    children = _ref3.children,
    className = _ref3.className,
    isSmall = _ref3.isSmall,
    icon = _ref3.icon,
    _ref3$iconPosition = _ref3.iconPosition,
    iconPosition = _ref3$iconPosition === void 0 ? "left" : _ref3$iconPosition,
    props = _objectWithoutProperties(_ref3, _excluded2$3);
  return /*#__PURE__*/React__namespace.createElement(BaseButton, _objectSpread2(_objectSpread2({}, props), {}, {
    type: type,
    className: "button ".concat(styles$Q.button, "  ").concat(isSmall ? styles$Q.small : "", " ").concat(className, " ")
  }), icon !== undefined ? (/*#__PURE__*/React__namespace.createElement(BaseSubmitButtonIcon, _objectSpread2({
    isSmall: isSmall,
    iconPosition: iconPosition,
    icon: icon
  }, props), children)) : (/*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, children)));
};
var PrimaryButton = function PrimaryButton(_ref4) {
  var text = _ref4.text,
    isLoading = _ref4.isLoading,
    props = _objectWithoutProperties(_ref4, _excluded3$1);
  return /*#__PURE__*/React__namespace.createElement(BaseSubmitButton, _objectSpread2(_objectSpread2({}, props), {}, {
    className: styles$Q.primary,
    disabled: props.disabled || !!isLoading
  }), !!isLoading && /*#__PURE__*/React__namespace.createElement(Loader, {
    className: styles$Q.loader
  }), text);
};
var SecondaryButton = function SecondaryButton(_ref5) {
  var text = _ref5.text,
    isLoading = _ref5.isLoading,
    props = _objectWithoutProperties(_ref5, _excluded4$1);
  return /*#__PURE__*/React__namespace.createElement(BaseSubmitButton, _objectSpread2(_objectSpread2({}, props), {}, {
    className: styles$Q.secondary,
    disabled: props.disabled || !!isLoading
  }), !!isLoading && /*#__PURE__*/React__namespace.createElement(Loader, {
    className: styles$Q.loader
  }), text);
};
var KebabButton = function KebabButton(_ref6) {
  var props = Object.assign({}, (_objectDestructuringEmpty(_ref6), _ref6));
  return /*#__PURE__*/React__namespace.createElement(BaseSubmitButton, _objectSpread2(_objectSpread2({}, props), {}, {
    className: classnames__default.default(styles$Q.secondary, styles$Q.kebab),
    disabled: props.disabled,
    icon: "KebabIcon"
  }));
};
var DangerButton = function DangerButton(_ref7) {
  var text = _ref7.text,
    isLoading = _ref7.isLoading,
    props = _objectWithoutProperties(_ref7, _excluded5$1);
  return /*#__PURE__*/React__namespace.createElement(BaseSubmitButton, _objectSpread2(_objectSpread2({}, props), {}, {
    className: styles$Q.danger,
    disabled: props.disabled || !!isLoading
  }), !!isLoading && /*#__PURE__*/React__namespace.createElement(Loader, {
    className: styles$Q.loader
  }), text);
};
var DangerSecondaryButton = function DangerSecondaryButton(_ref8) {
  var text = _ref8.text,
    isLoading = _ref8.isLoading,
    props = _objectWithoutProperties(_ref8, _excluded6$1);
  return /*#__PURE__*/React__namespace.createElement(BaseSubmitButton, _objectSpread2(_objectSpread2({}, props), {}, {
    className: styles$Q.dangerSecondary,
    disabled: props.disabled || !!isLoading
  }), !!isLoading && /*#__PURE__*/React__namespace.createElement(Loader, {
    className: styles$Q.loader
  }), /*#__PURE__*/React__namespace.createElement("p", null, text));
};
var TextButton = function TextButton(_ref9) {
  var text = _ref9.text,
    _ref9$color = _ref9.color,
    color = _ref9$color === void 0 ? "default" : _ref9$color,
    _ref9$type = _ref9.type,
    type = _ref9$type === void 0 ? "button" : _ref9$type,
    icon = _ref9.icon,
    props = _objectWithoutProperties(_ref9, _excluded7$1);
  var Icon = Icons[icon];
  return /*#__PURE__*/React__namespace.createElement(BaseButton, _objectSpread2(_objectSpread2({}, props), {}, {
    type: type,
    className: classnames__default.default("is-flex is-align-items-center ".concat(styles$Q.textButton, " ").concat(props.disabled ? "disabled" : styles$Q.clear), color === "danger" ? styles$Q.textButtonDanger : null)
  }), /*#__PURE__*/React__namespace.createElement("div", {
    className: styles$Q.textButtonIcon
  }, /*#__PURE__*/React__namespace.createElement(Icon, {
    size: IconSizes.medium
  })), text);
};

var css_248z$P = ":root {\n  /* Color styles */\n\n  /* Text-size styles */\n\n  /* Effect styles */\n  /* border-radius */\n}\n\n.tabs-module_tabItem__2d7iJ {\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  margin: 0px 20px;\n  vertical-align: top;\n  padding-bottom: 8px;\n}\n\n.tabs-module_baseline__1Wrs8 {\n  border-bottom-color: #b2b8c8;\n}\n\n.tabs-module_active__15Xak {\n  border-bottom: 4px solid #353ebd;\n  margin-bottom: -3px;\n}\n\n.tabs-module_tabItem__2d7iJ > [aria-selected=\"false\"]:focus {\n  border-radius: 4px;\n  background-color: #f1f2f7;\n}\n\n.tabs-module_tabItem__2d7iJ > [aria-selected=\"false\"]:hover {\n  border-radius: 4px;\n  background-color: #f1f2f7;\n}\n\n.tabs-module_tabItem__2d7iJ > [aria-selected=\"false\"]:active {\n  background-color: #cfd4e0;\n}\n\n.tabs-module_tabItem__2d7iJ > [aria-selected=\"true\"] {\n  font: 600 16px/24px Meiryo, Arial, system-ui, sans-serif;\n  color: #353ebd;\n  padding: 4px 8px;\n}\n\n.tabs-module_tabItem__2d7iJ > [aria-selected=\"false\"] {\n  font: 600 16px/24px Meiryo, Arial, system-ui, sans-serif;\n  color: #4c505c;\n  padding: 4px 8px;\n}\n";
var styles$O = {"tabItem":"tabs-module_tabItem__2d7iJ","baseline":"tabs-module_baseline__1Wrs8","active":"tabs-module_active__15Xak"};
styleInject(css_248z$P);

/**
 * @deprecated
 * タブとパネル（タブの下に表示するコンテンツ部分）をセットで提供している TabPanelGroup を使用してください。
 * TabPanelGroup を使用することで、タブ部分とパネル部分の関連付けが自動で行われます。（関連付けに必要な各idも自動で生成されます）
 * TODO: Tabs は削除する。（StorybookでTabsを呼び出している箇所も削除する）
 */
var Tabs = function Tabs(_ref) {
  var id = _ref.id,
    tabItems = _ref.tabItems;
  var generatedID = "tabs-".concat(React__namespace.useId());
  return /*#__PURE__*/React__namespace.createElement("div", {
    className: "tabs"
  }, /*#__PURE__*/React__namespace.createElement("ul", {
    className: styles$O.baseline,
    role: "tablist"
  }, tabItems.map(function (i, index) {
    return i.hidden ? (/*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null)) : (/*#__PURE__*/React__namespace.createElement("li", {
      className: "".concat(styles$O.tabItem, " ").concat(i.isActive ? styles$O.active : ""),
      key: "".concat(id ? id : generatedID, "-").concat(index),
      role: "presentation"
    }, /*#__PURE__*/React__namespace.createElement("button", {
      onClick: i.onClick,
      role: "tab",
      "aria-selected": i.isActive
    }, i.label)));
  })));
};

var css_248z$O = ":root {\n  /* Color styles */\n\n  /* Text-size styles */\n\n  /* Effect styles */\n  /* border-radius */\n}\n\n.filterContainer-module_container__1K_ai {\n  display: grid;\n  grid-template-rows: repeat(auto-fit, minmax(36px, 1fr));\n  grid-template-columns: repeat(1, 1fr);\n  grid-gap: 16px;\n  border-radius: 8px;\n  background-color: #f8f9fc;\n  padding: 16px;\n  width: 100%;\n}\n\n.filterContainer-module_container__1K_ai .filterContainer-module_row__5z2VP {\n  display: grid;\n  grid-gap: 16px;\n}\n\n.filterContainer-module_buttonGroup__1_S9g {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 16px;\n}\n";
var styles$N = {"container":"filterContainer-module_container__1K_ai","row":"filterContainer-module_row__5z2VP","buttonGroup":"filterContainer-module_buttonGroup__1_S9g"};
styleInject(css_248z$O);

var FilterRow = function FilterRow(_ref) {
  var children = _ref.children,
    fullWidth = _ref.fullWidth,
    maxWidth = _ref.maxWidth;
  var max = fullWidth ? "1fr" : "".concat(maxWidth !== null && maxWidth !== void 0 ? maxWidth : 300, "px");
  return /*#__PURE__*/React__namespace.default.createElement("div", {
    className: styles$N.row,
    style: {
      gridTemplateColumns: "repeat(auto-fit, minmax(300px, ".concat(max, "))")
    }
  }, children);
};
var FilterContainer = function FilterContainer(_ref2) {
  var children = _ref2.children,
    buttons = _ref2.buttons;
  return /*#__PURE__*/React__namespace.default.createElement("div", {
    className: styles$N.container
  }, children, !!buttons && /*#__PURE__*/React__namespace.default.createElement("div", {
    className: styles$N.buttonGroup
  }, buttons));
};

var css_248z$N = ":root {\n  /* Color styles */\n\n  /* Text-size styles */\n\n  /* Effect styles */\n  /* border-radius */\n}\n\n.table-module_tableWrapper__3qN3e {\n  overflow: auto;\n}\n\n.table-module_tableWrapper__3qN3e:not(.table-module_row__1PibV) {\n  border: 1px solid #cfd4e0;\n}\n\n.table-module_table__1Zf_V.table-module_default__25J7h {\n  border: 1px solid #cfd4e0;\n}\n\n.table-module_table__1Zf_V {\n  width: 100%;\n  display: table;\n  border-collapse: collapse;\n}\n\n.table-module_table__1Zf_V .table-module_tableHeader__12Sfn {\n  display: table-header-group;\n  border-bottom: 2px solid #cfd4e0;\n}\n\n.table-module_table__1Zf_V .table-module_tableBody__WeYfz {\n  display: table-row-group;\n}\n\n.table-module_table__1Zf_V .table-module_tableBody__WeYfz .table-module_tableRow__3TCg5 {\n  display: table-row;\n}\n\n.table-module_table__1Zf_V .table-module_tableBody__WeYfz .table-module_tableRow__3TCg5:not(:last-child) {\n  border-bottom: 1px solid #cfd4e0;\n}\n\n.table-module_table__1Zf_V .table-module_tableBody__WeYfz .table-module_tableRow__3TCg5.table-module_hoverRow__32omK:hover {\n  background-color: #f1f2f7;\n  cursor: pointer;\n}\n\n.table-module_table__1Zf_V .table-module_td__1fFY8 {\n  display: table-cell;\n  font: 300 13px/18px Meiryo, Arial, system-ui, sans-serif;\n  vertical-align: middle;\n}\n\n.table-module_table__1Zf_V.table-module_all__1eNYQ .table-module_td__1fFY8 {\n  border: 1px solid #cfd4e0;\n}\n\n.table-module_table__1Zf_V.table-module_all__1eNYQ .table-module_th__J4u5v {\n  border: 1px solid #cfd4e0;\n}\n\n.table-module_table__1Zf_V td,\n.table-module_table__1Zf_V th {\n  padding: 12px;\n}\n\n.table-module_table__1Zf_V .table-module_th__J4u5v {\n  display: table-cell;\n  vertical-align: middle;\n}\n\n.table-module_inlineWrapper___sYMm {\n  display: inline-flex;\n  align-items: center;\n}\n\n.table-module_table__1Zf_V .table-module_td__1fFY8.table-module_alignLight__1HDBt {\n  text-align: right;\n}\n\n.table-module_table__1Zf_V .table-module_td__1fFY8.table-module_ellipsis__2JfJN {\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  max-width: 0;\n}\n";
var styles$M = {"tableWrapper":"table-module_tableWrapper__3qN3e","row":"table-module_row__1PibV","table":"table-module_table__1Zf_V","default":"table-module_default__25J7h","tableHeader":"table-module_tableHeader__12Sfn","tableBody":"table-module_tableBody__WeYfz","tableRow":"table-module_tableRow__3TCg5","hoverRow":"table-module_hoverRow__32omK","td":"table-module_td__1fFY8","all":"table-module_all__1eNYQ","th":"table-module_th__J4u5v","inlineWrapper":"table-module_inlineWrapper___sYMm","alignLight":"table-module_alignLight__1HDBt","ellipsis":"table-module_ellipsis__2JfJN"};
styleInject(css_248z$N);

var generateID = function generateID(name) {
  return "".concat(name ? "".concat(name, "-") : "").concat(Math.random().toString(16).slice(2));
};

/**
 * ValueObjectの基本型
 */
var BaseValue = /*#__PURE__*/function () {
  function BaseValue(value) {
    _classCallCheck(this, BaseValue);
    this.value = value;
  }
  return _createClass(BaseValue, [{
    key: "getValue",
    value: function getValue() {
      return this.value;
    }
  }]);
}();

/**
 * StringLiteralsをベースにした選択可能なValueObjectの基本型
 */
var BaseType = /*#__PURE__*/function (_BaseValue) {
  function BaseType() {
    _classCallCheck(this, BaseType);
    return _callSuper(this, BaseType, arguments);
  }
  _inherits(BaseType, _BaseValue);
  return _createClass(BaseType, [{
    key: "equals",
    value: function equals(type) {
      return this.value === type;
    }
  }, {
    key: "typeEquals",
    value: function typeEquals(target) {
      return this.value === target.value;
    }
  }, {
    key: "matchType",
    value: function matchType(matcher) {
      return matcher[this.value];
    }
  }, {
    key: "matchCall",
    value: function matchCall(matcher) {
      return matcher[this.getValue()]();
    }
  }]);
}(BaseValue);

var FormState = /*#__PURE__*/function (_BaseType) {
  function FormState(value, errorMessage) {
    var _this;
    _classCallCheck(this, FormState);
    _this = _callSuper(this, FormState, [value]);
    _this.errorMessage = errorMessage;
    return _this;
  }
  /**
   * UIの状態を管理するStateを生成する
   *
   * @param isTouched
   * @param isValid
   * @param noValidate
   * @param disabled
   * @param errorMessage
   * @returns
   */
  _inherits(FormState, _BaseType);
  return _createClass(FormState, [{
    key: "matchComponents",
    value: function matchComponents(matcher) {
      return matcher[this.value];
    }
    /**
     * 状態が fail の場合 true 、それ以外の場合 false を返す
     */
  }, {
    key: "isFail",
    value: function isFail() {
      return this.matchType({
        "default": false,
        success: false,
        disabled: false,
        fail: true
      });
    }
  }], [{
    key: "create",
    value: function create(isTouched, isValid, noValidate, disabled, errorMessage, shouldShowError) {
      if (disabled) {
        return new FormState("disabled", errorMessage);
      }
      if (shouldShowError && !isValid) {
        return new FormState("fail", errorMessage);
      }
      if (!isTouched) {
        return new FormState("default", errorMessage);
      }
      if (noValidate) {
        return new FormState("default", errorMessage);
      }
      if (isValid) {
        return new FormState("success", errorMessage);
      }
      if (!isValid) {
        return new FormState("fail", errorMessage);
      }
      return new FormState("default", errorMessage);
    }
    /**
     * 絞り込み用コンポーネントの状態を管理するStateを生成する
     *
     * @param disabled
     * @returns
     * @example
     * const state = FormState.createNoValidate(true);
     */
  }, {
    key: "createNoValidate",
    value: function createNoValidate(isTouched, disabled) {
      if (isTouched) {
        return new FormState("default", undefined);
      }
      if (disabled) {
        return new FormState("disabled", undefined);
      }
      return new FormState("default", undefined);
    }
  }]);
}(BaseType);

var randomSeed = function randomSeed() {
  return String(Math.random()).replace(".", "");
};
var makeId = function makeId(componentName, idNumber, value) {
  return "graffer-design-kit--".concat(componentName, "--").concat(idNumber, "--").concat(value);
};
/**
 * コンポーネント毎のランダムIDを生成
 *
 * 固定IDを設定したくない場合に使用
 * （IDが固定だとそのIDをベースにextension等を動作される可能性があるため）
 *
 * @param componentName コンポーネントの名前
 * @param seed ランダムIDを生成するためのseed function。テスト時にIDを固定するために使用。テスト以外からは使用しない
 */
function useRandomId(componentName) {
  var seed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : randomSeed;
  var _useState = React.useState(seed()),
    _useState2 = _slicedToArray(_useState, 1),
    idNumber = _useState2[0];
  return function (value) {
    return makeId(componentName, idNumber, value);
  };
}

var CheckBoxIconWrapper = function CheckBoxIconWrapper(_ref) {
  var checked = _ref.checked;
  return /*#__PURE__*/React__namespace.default.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": checked ? "選択済み" : "未選択"
  }, checked ? (/*#__PURE__*/React__namespace.default.createElement("g", null, /*#__PURE__*/React__namespace.default.createElement("title", null, "\u9078\u629E\u6E08\u307F\u30A2\u30A4\u30B3\u30F3"), /*#__PURE__*/React__namespace.default.createElement("desc", null, "\u9078\u629E\u3057\u3066\u3044\u308B\u3053\u3068\u3092\u793A\u3057\u3066\u3044\u308B\u30A2\u30A4\u30B3\u30F3\u3067\u3059"), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M0 4.37C0 2.16086 1.79086 0.369995 4 0.369995H20C22.2091 0.369995 24 2.16086 24 4.37V20.37C24 22.5791 22.2091 24.37 20 24.37H4C1.79086 24.37 0 22.5791 0 20.37V4.37Z",
    fill: "inherit"
  }), /*#__PURE__*/React__namespace.default.createElement("rect", {
    y: "0.369995",
    width: "24",
    height: "24",
    rx: "4",
    fill: "inherit"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M10.0711 17.725C9.90124 17.7037 9.68891 17.6471 9.56151 17.5056L4.99635 12.7139C4.72739 12.4308 4.73447 11.9849 5.01758 11.7159C5.30069 11.447 5.74659 11.4541 6.01555 11.7372L10.0711 15.9909L17.9841 7.78778C18.253 7.50467 18.706 7.4976 18.982 7.76655C19.2651 8.03551 19.2722 8.48848 19.0033 8.76452L10.5807 17.4985C10.4462 17.6471 10.2622 17.725 10.0711 17.725Z",
    fill: "white"
  }))) : (/*#__PURE__*/React__namespace.default.createElement("g", null, /*#__PURE__*/React__namespace.default.createElement("title", null, "\u672A\u9078\u629E\u30A2\u30A4\u30B3\u30F3"), /*#__PURE__*/React__namespace.default.createElement("desc", null, "\u9078\u629E\u3055\u308C\u3066\u3044\u306A\u3044\u3053\u3068\u3092\u793A\u3057\u3066\u3044\u308B\u30A2\u30A4\u30B3\u30F3\u3067\u3059"), /*#__PURE__*/React__namespace.default.createElement("rect", {
    x: "0.5",
    y: "0.869995",
    width: "23",
    height: "23",
    rx: "3.5",
    fill: "white",
    stroke: "#949CB0"
  }))));
};

var css_248z$M = ":root {\n  /* Color styles */\n\n  /* Text-size styles */\n\n  /* Effect styles */\n  /* border-radius */\n}\n\n.baseCheckbox-module_checkboxWrapper__3ZFCb {\n  display: block;\n}\n\n.baseCheckbox-module_input__3JtQt[type=\"checkbox\"] {\n  opacity: 0;\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n  position: absolute;\n}\n\n.baseCheckbox-module_label__2tvJY {\n  display: flex;\n  align-items: center;\n}\n\n.baseCheckbox-module_text__26Sbz {\n  display: block;\n  font: 300 16px/24px Meiryo, Arial, system-ui, sans-serif;\n  color: #262b38;\n}\n\n.baseCheckbox-module_description__3ur4r {\n  display: block;\n  margin-top: 8px;\n  font: 300 13px/18px Meiryo, Arial, system-ui, sans-serif;\n  color: #4c505c;\n}\n\n/******************** ラベル ********************/\n\n.baseCheckbox-module_checkbox__IyZ_j input[type=\"checkbox\"] + label {\n  display: none;\n  cursor: pointer;\n  display: inline-block;\n  position: relative;\n  vertical-align: middle;\n  font: 300 16px/24px Meiryo, Arial, system-ui, sans-serif;\n  color: #262b38;\n}\n\n/*  hover */\n\n.baseCheckbox-module_checkbox__IyZ_j input[type=\"checkbox\"] + label:hover {\n  color: #5f636d;\n}\n\n/* focus */\n\n.baseCheckbox-module_checkbox__IyZ_j input[type=\"checkbox\"]:focus + label {\n  color: #5f636d;\n}\n\n/* disabled (選択されていない)*/\n\n.baseCheckbox-module_checkbox__IyZ_j input[type=\"checkbox\"]:disabled:not(:checked) + label {\n  cursor: not-allowed;\n  color: #5f636d;\n}\n\n/* disabled (選択されている)*/\n\n.baseCheckbox-module_checkbox__IyZ_j input[type=\"checkbox\"]:disabled:checked + label {\n  cursor: not-allowed;\n  color: #262b38;\n}\n\n/******************** ICON ********************/\n\n.baseCheckbox-module_icon__1Ol2Q {\n  display: inline-block;\n  vertical-align: middle;\n  width: 40px;\n  height: 40px;\n  padding: 8px;\n  border-radius: 50%;\n  margin-right: 8px;\n}\n\n/* focus時の円 */\n\n.baseCheckbox-module_checkbox__IyZ_j input[type=\"checkbox\"]:focus + label .baseCheckbox-module_icon__1Ol2Q {\n  background: #f1f2f7;\n}\n\n/********** 選択されている **********/\n\n/* default */\n\n.baseCheckbox-module_checkbox__IyZ_j input[type=\"checkbox\"]:checked + label svg {\n  fill: #353ebd;\n}\n\n.baseCheckbox-module_checkbox__IyZ_j input[type=\"checkbox\"]:checked + label svg rect {\n  stroke: #353ebd;\n}\n\n/* default + hover */\n\n.baseCheckbox-module_checkbox__IyZ_j input[type=\"checkbox\"]:checked + label:hover svg {\n  fill: #0f1192;\n}\n\n.baseCheckbox-module_checkbox__IyZ_j input[type=\"checkbox\"]:checked + label:hover svg rect {\n  stroke: #0f1192;\n}\n\n/* disabled */\n\n.baseCheckbox-module_checkbox__IyZ_j input[type=\"checkbox\"]:checked:disabled + label svg {\n  fill: #cfd4e0;\n}\n\n.baseCheckbox-module_checkbox__IyZ_j input[type=\"checkbox\"]:checked:disabled + label svg rect {\n  stroke: #cfd4e0;\n}\n\n/* error（使われない想定） */\n\n.baseCheckbox-module_error__3n-U3 > .baseCheckbox-module_checkbox__IyZ_j input[type=\"checkbox\"]:checked + label svg {\n  fill: #de3226;\n}\n\n.baseCheckbox-module_error__3n-U3 > .baseCheckbox-module_checkbox__IyZ_j input[type=\"checkbox\"]:checked + label svg rect {\n  stroke: #de3226;\n}\n\n/* error + hover （使われない想定）*/\n\n.baseCheckbox-module_error__3n-U3 > .baseCheckbox-module_checkbox__IyZ_j input[type=\"checkbox\"]:checked + label:hover svg {\n  fill: #b1110c;\n}\n\n.baseCheckbox-module_error__3n-U3 > .baseCheckbox-module_checkbox__IyZ_j input[type=\"checkbox\"]:checked + label:hover svg rect {\n  stroke: #b1110c;\n}\n\n/********** 選択されていない **********/\n\n/* default */\n\n.baseCheckbox-module_checkbox__IyZ_j input[type=\"checkbox\"] + label svg rect {\n  stroke: #949cb0;\n}\n\n/* default + hover */\n\n.baseCheckbox-module_checkbox__IyZ_j input[type=\"checkbox\"] + label:hover svg rect {\n  stroke: #5f636d;\n}\n\n/* disabled */\n\n.baseCheckbox-module_checkbox__IyZ_j input[type=\"checkbox\"]:disabled + label svg rect {\n  stroke: #5f636d;\n}\n\n/* error */\n\n.baseCheckbox-module_error__3n-U3 > .baseCheckbox-module_checkbox__IyZ_j input[type=\"checkbox\"] + label svg rect {\n  stroke: #de3226;\n}\n\n/* error + hover */\n\n.baseCheckbox-module_error__3n-U3 > .baseCheckbox-module_checkbox__IyZ_j input[type=\"checkbox\"] + label:hover svg rect {\n  stroke: #b1110c;\n}\n\n.baseCheckbox-module_list__1Bbpb.baseCheckbox-module_column__khFmp > .baseCheckbox-module_element__1KMS3:not(:first-child) {\n  margin-top: 16px;\n}\n\n.baseCheckbox-module_list__1Bbpb.baseCheckbox-module_row__349Zp {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px;\n  align-items: center;\n}\n";
var styles$L = {"checkboxWrapper":"baseCheckbox-module_checkboxWrapper__3ZFCb","input":"baseCheckbox-module_input__3JtQt","label":"baseCheckbox-module_label__2tvJY","text":"baseCheckbox-module_text__26Sbz","description":"baseCheckbox-module_description__3ur4r","checkbox":"baseCheckbox-module_checkbox__IyZ_j","icon":"baseCheckbox-module_icon__1Ol2Q","error":"baseCheckbox-module_error__3n-U3","list":"baseCheckbox-module_list__1Bbpb","column":"baseCheckbox-module_column__khFmp","element":"baseCheckbox-module_element__1KMS3","row":"baseCheckbox-module_row__349Zp"};
styleInject(css_248z$M);

var BaseCheckBox = function BaseCheckBox(_ref) {
  var formState = _ref.formState,
    option = _ref.option,
    disabled = _ref.disabled,
    checked = _ref.checked,
    onChange = _ref.onChange,
    onClick = _ref.onClick,
    onBlur = _ref.onBlur,
    onTouch = _ref.onTouch;
  var handleChange = React.useCallback(function (e) {
    onTouch();
    onChange && onChange(e);
  }, [onChange, onTouch]);
  var handleOnClick = React.useCallback(function (e) {
    onTouch();
    onClick && onClick(e);
  }, [onClick, onTouch]);
  var handleBlur = React.useCallback(function (e) {
    onTouch();
    onBlur && onBlur(e);
  }, [onBlur, onTouch]);
  var id = useRandomId("checkbox")(option.value);
  return /*#__PURE__*/React__namespace.default.createElement("div", {
    className: classnames__default.default(styles$L.checkboxWrapper, formState.matchType({
      "default": "",
      success: "",
      disabled: "",
      fail: styles$L.error
    }))
  }, /*#__PURE__*/React__namespace.default.createElement("div", {
    className: styles$L.checkbox
  }, /*#__PURE__*/React__namespace.default.createElement("input", {
    type: "checkbox",
    className: styles$L.input,
    disabled: disabled,
    checked: checked,
    value: option.value,
    onChange: handleChange,
    onClick: handleOnClick,
    onBlur: handleBlur,
    id: id
  }), /*#__PURE__*/React__namespace.default.createElement("label", {
    className: styles$L.label,
    htmlFor: id
  }, /*#__PURE__*/React__namespace.default.createElement("span", {
    className: styles$L.label
  }, /*#__PURE__*/React__namespace.default.createElement("span", {
    className: styles$L.icon
  }, /*#__PURE__*/React__namespace.default.createElement(CheckBoxIconWrapper, {
    checked: checked
  })), !!option.name && (/*#__PURE__*/React__namespace.default.createElement("span", {
    className: styles$L.textWrap
  }, /*#__PURE__*/React__namespace.default.createElement("span", {
    className: styles$L.text,
    "data-testid": "test-checkbox-option-name"
  }, option.name), !!option.description && (/*#__PURE__*/React__namespace.default.createElement("span", {
    className: styles$L.description,
    "data-testid": "test-checkbox-option-description"
  }, option.description))))))));
};
var BaseCheckBoxList = function BaseCheckBoxList(_ref2) {
  var id = _ref2.id,
    options = _ref2.options,
    values = _ref2.values,
    disabled = _ref2.disabled,
    _ref2$direction = _ref2.direction,
    direction = _ref2$direction === void 0 ? "column" : _ref2$direction,
    onTouch = _ref2.onTouch,
    formState = _ref2.formState,
    onChange = _ref2.onChange,
    onBlur = _ref2.onBlur;
  return /*#__PURE__*/React__namespace.default.createElement("ul", {
    className: classnames__default.default(styles$L.list, direction === "row" ? styles$L.row : styles$L.column)
  }, options.map(function (v) {
    var checked = values.includes(v.value);
    return /*#__PURE__*/React__namespace.default.createElement("li", {
      key: "".concat(id, "-option-").concat(v.value),
      className: styles$L.element
    }, /*#__PURE__*/React__namespace.default.createElement(BaseCheckBox, {
      formState: formState,
      option: v,
      onTouch: onTouch,
      onChange: onChange,
      onBlur: onBlur,
      checked: checked,
      disabled: v.disabled || disabled
    }));
  }));
};

var TableCheckbox = function TableCheckbox(_ref) {
  var value = _ref.value,
    checked = _ref.checked,
    disabled = _ref.disabled,
    onClick = _ref.onClick,
    onChange = _ref.onChange;
  var _useState = React.useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    touched = _useState2[0],
    setTouched = _useState2[1];
  var formState = FormState.create(touched, true, true, disabled, undefined);
  var handleOnTouch = React.useCallback(function () {
    setTouched(true);
  }, []);
  return /*#__PURE__*/React__namespace.default.createElement(BaseCheckBox, {
    formState: formState,
    option: {
      value: value
    },
    onTouch: handleOnTouch,
    checked: checked,
    onClick: onClick,
    onChange: onChange
  });
};

var _excluded$e = ["children", "whiteSpace"],
  _excluded2$2 = ["children", "textAlign", "whiteSpace", "enabledEllipsis"],
  _excluded3 = ["checked", "onCheck", "onClickCheckbox"],
  _excluded4 = ["children"],
  _excluded5 = ["children", "onClick", "onChange"],
  _excluded6 = ["children"],
  _excluded7 = ["checked", "onCheckAll", "onClickAll"],
  _excluded8 = ["id", "borderType", "children", "wrapper"];
var TableGroupContext = /*#__PURE__*/React.createContext({
  group: "body"
});
var BORDER_TYPE = {
  "default": styles$M["default"],
  all: styles$M.all,
  row: styles$M.row
};
var Th = function Th(_ref) {
  var children = _ref.children,
    _ref$whiteSpace = _ref.whiteSpace,
    whiteSpace = _ref$whiteSpace === void 0 ? "nowrap" : _ref$whiteSpace,
    props = _objectWithoutProperties(_ref, _excluded$e);
  return /*#__PURE__*/React__namespace.default.createElement("th", _objectSpread2(_objectSpread2({}, props), {}, {
    style: {
      whiteSpace: whiteSpace
    },
    className: classnames__default.default(styles$M.th)
  }), /*#__PURE__*/React__namespace.default.createElement("div", {
    className: styles$M.inlineWrapper
  }, children));
};
var Td = function Td(_ref2) {
  var children = _ref2.children,
    _ref2$textAlign = _ref2.textAlign,
    textAlign = _ref2$textAlign === void 0 ? "default" : _ref2$textAlign,
    whiteSpace = _ref2.whiteSpace,
    enabledEllipsis = _ref2.enabledEllipsis,
    props = _objectWithoutProperties(_ref2, _excluded2$2);
  return /*#__PURE__*/React__namespace.default.createElement("td", _objectSpread2(_objectSpread2({}, props), {}, {
    style: {
      whiteSpace: whiteSpace
    },
    className: classnames__default.default(styles$M.td, textAlign === "right" ? styles$M.alignLight : undefined, enabledEllipsis ? styles$M.ellipsis : undefined)
  }), children);
};
var TableCheckBoxTd = function TableCheckBoxTd(_ref3) {
  var checked = _ref3.checked,
    onCheck = _ref3.onCheck,
    onClickCheckbox = _ref3.onClickCheckbox,
    props = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/React__namespace.default.createElement(Td, _objectSpread2(_objectSpread2({}, props), {}, {
    onClick: function onClick(e) {
      e.stopPropagation();
    }
  }), /*#__PURE__*/React__namespace.default.createElement(TableCheckbox, {
    onChange: onCheck,
    onClick: onClickCheckbox,
    checked: checked,
    value: "checked"
  }), props.children);
};
var TableBody = function TableBody(_ref4) {
  var children = _ref4.children,
    props = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/React__namespace.default.createElement("tbody", _objectSpread2(_objectSpread2({}, props), {}, {
    className: classnames__default.default(styles$M.tableBody)
  }), children);
};
var TableRow = function TableRow(_ref5) {
  var children = _ref5.children,
    onClick = _ref5.onClick,
    onChange = _ref5.onChange,
    props = _objectWithoutProperties(_ref5, _excluded5);
  var handleOnKeyDown = React.useCallback(function (e) {
    if (e.key === "Enter" && onClick) {
      onClick(e);
    }
  }, [onClick]);
  return /*#__PURE__*/React__namespace.default.createElement("tr", _objectSpread2(_objectSpread2({}, props), {}, {
    onClick: onClick,
    onKeyDown: handleOnKeyDown,
    className: classnames__default.default(styles$M.tableRow, (onClick || onChange) && styles$M.hoverRow),
    tabIndex: onClick ? 0 : undefined
  }), children);
};
var TableHeader = function TableHeader(_ref6) {
  var children = _ref6.children,
    props = _objectWithoutProperties(_ref6, _excluded6);
  return /*#__PURE__*/React__namespace.default.createElement("thead", _objectSpread2(_objectSpread2({}, props), {}, {
    className: classnames__default.default(styles$M.tableHeader)
  }), children);
};
var TableCheckBoxTh = function TableCheckBoxTh(_ref7) {
  var checked = _ref7.checked,
    onCheckAll = _ref7.onCheckAll,
    onClickAll = _ref7.onClickAll,
    props = _objectWithoutProperties(_ref7, _excluded7);
  return /*#__PURE__*/React__namespace.default.createElement(Th, _objectSpread2({}, props), /*#__PURE__*/React__namespace.default.createElement(TableCheckbox, {
    onChange: onCheckAll,
    onClick: onClickAll,
    checked: checked,
    value: "allChecked"
  }), props.children);
};
var Table = function Table(_ref8) {
  var _ref8$id = _ref8.id,
    id = _ref8$id === void 0 ? generateID() : _ref8$id,
    _ref8$borderType = _ref8.borderType,
    borderType = _ref8$borderType === void 0 ? "default" : _ref8$borderType,
    children = _ref8.children,
    _ref8$wrapper = _ref8.wrapper,
    wrapper = _ref8$wrapper === void 0 ? true : _ref8$wrapper,
    props = _objectWithoutProperties(_ref8, _excluded8);
  var component = /*#__PURE__*/React__namespace.default.createElement("table", _objectSpread2(_objectSpread2({}, props), {}, {
    id: id,
    className: classnames__default.default(styles$M.table, BORDER_TYPE[borderType], wrapper && styles$M.wrapper)
  }), children);
  return wrapper ? (/*#__PURE__*/React__namespace.default.createElement(TableWrapper, {
    borderType: borderType
  }, component)) : component;
};
var TableWrapper = function TableWrapper(_ref9) {
  var children = _ref9.children,
    _ref9$borderType = _ref9.borderType,
    borderType = _ref9$borderType === void 0 ? "default" : _ref9$borderType;
  return /*#__PURE__*/React__namespace.default.createElement("div", {
    className: classnames__default.default(styles$M.tableWrapper, BORDER_TYPE[borderType])
  }, children);
};

var css_248z$L = ":root {\n  /* Color styles */\n\n  /* Text-size styles */\n\n  /* Effect styles */\n  /* border-radius */\n}\n\n.status-tag-module_tag__1ajPH,\n.status-tag-module_secondaryTag__13u6K {\n  display: inline-flex;\n  align-items: center;\n  text-align: center;\n  white-space: nowrap;\n}\n\n.status-tag-module_tag__1ajPH {\n  padding: 3px 16px;\n  gap: 10px;\n  font: 600 16px/24px Meiryo, Arial, system-ui, sans-serif;\n  border-radius: 8px;\n}\n\n.status-tag-module_secondaryTag__13u6K {\n  padding: calc(8px / 4) 16px;\n  font: 300 14px/20px Meiryo, Arial, system-ui, sans-serif;\n  border-radius: 30px;\n}\n\n.status-tag-module_tag__1ajPH.status-tag-module_warn__2b8C2 {\n  background: #f1ba19;\n  color: #262b38;\n}\n\n.status-tag-module_tag__1ajPH.status-tag-module_secondaryError__2zUwR {\n  background: #dcab7e;\n  color: #262b38;\n}\n\n.status-tag-module_tag__1ajPH.status-tag-module_tag__1ajPH.status-tag-module_primary__3B1xO {\n  background: #a3c1e3;\n  color: #262b38;\n}\n\n.status-tag-module_tag__1ajPH.status-tag-module_success__2Q8d9 {\n  background-color: #c6e79d;\n  color: #262b38;\n}\n\n.status-tag-module_tag__1ajPH.status-tag-module_error__2rj-v {\n  background: #f1a6a1;\n  color: #262b38;\n}\n\n.status-tag-module_tag__1ajPH.status-tag-module_accent__2h0nE {\n  background: #eaa6e3;\n  color: #262b38;\n}\n\n.status-tag-module_tag__1ajPH.status-tag-module_secondary__xYF1X {\n  background: #cfd4e0;\n  color: #262b38;\n}\n\n.status-tag-module_tag__1ajPH.status-tag-module_light__m4Bnb {\n  background: #ffffff;\n  border: 1px solid #262b38;\n  color: #262b38;\n}\n\n.status-tag-module_secondaryTag__13u6K.status-tag-module_light__m4Bnb {\n  background: #ffffff;\n  border: 1px solid #262b38;\n  color: #262b38;\n}\n\n.status-tag-module_tag__1ajPH.status-tag-module_dark__2sxej {\n  background: #262b38;\n  color: #ffffff;\n}\n\n.status-tag-module_secondaryTag__13u6K.status-tag-module_dark__2sxej {\n  background: #262b38;\n  color: #ffffff;\n}\n\n.status-tag-module_secondaryTag__13u6K.status-tag-module_primary__3B1xO {\n  background-color: #ffffff;\n  border: 1px solid #0f1192;\n  color: #0f1192;\n}\n\n.status-tag-module_secondaryTag__13u6K.status-tag-module_success__2Q8d9 {\n  background-color: #ffffff;\n  border: 1px solid #06705d;\n  color: #06705d;\n}\n\n.status-tag-module_secondaryTag__13u6K.status-tag-module_error__2rj-v {\n  background-color: #ffffff;\n  border: 1px solid #b1110c;\n  color: #b1110c;\n}\n";
var styles$K = {"tag":"status-tag-module_tag__1ajPH","secondaryTag":"status-tag-module_secondaryTag__13u6K","warn":"status-tag-module_warn__2b8C2","secondaryError":"status-tag-module_secondaryError__2zUwR","primary":"status-tag-module_primary__3B1xO","success":"status-tag-module_success__2Q8d9","error":"status-tag-module_error__2rj-v","accent":"status-tag-module_accent__2h0nE","secondary":"status-tag-module_secondary__xYF1X","light":"status-tag-module_light__m4Bnb","dark":"status-tag-module_dark__2sxej"};
styleInject(css_248z$L);

var SECONDARY_STATUS_CLASS_NAME = {
  LIGHT: styles$K.light,
  PRIMARY: styles$K.primary,
  DARK: styles$K.dark,
  SUCCESS: styles$K.success,
  ERROR: styles$K.error
};
var STATUS_CLASS_NAME = {
  SECONDARY_ERROR: styles$K.secondaryError,
  ACCENT: styles$K.accent,
  LIGHT: styles$K.light,
  WARN: styles$K.warn,
  PRIMARY: styles$K.primary,
  SUCCESS: styles$K.success,
  ERROR: styles$K.error,
  SECONDARY: styles$K.secondary,
  DARK: styles$K.dark
};
var StatusTag = function StatusTag(_ref) {
  var type = _ref.type,
    _ref$hiddenCheckIcon = _ref.hiddenCheckIcon,
    hiddenCheckIcon = _ref$hiddenCheckIcon === void 0 ? false : _ref$hiddenCheckIcon,
    children = _ref.children;
  return /*#__PURE__*/React__namespace.createElement("span", {
    className: classnames__default.default(styles$K.tag, STATUS_CLASS_NAME[type])
  }, type === "SUCCESS" && !hiddenCheckIcon ? (/*#__PURE__*/React__namespace.createElement(CheckCircleIcon, {
    size: 16
  })) : undefined, children);
};
var SecondaryStatusTag = function SecondaryStatusTag(_ref2) {
  var type = _ref2.type,
    children = _ref2.children,
    hiddenCheckIcon = _ref2.hiddenCheckIcon;
  return /*#__PURE__*/React__namespace.createElement("span", {
    className: classnames__default.default(styles$K.secondaryTag, SECONDARY_STATUS_CLASS_NAME[type])
  }, type === "SUCCESS" && !hiddenCheckIcon ? (/*#__PURE__*/React__namespace.createElement(CheckCircleIcon, {
    size: 16
  })) : undefined, children);
};

var css_248z$K = ":root {\n  /* Color styles */\n\n  /* Text-size styles */\n\n  /* Effect styles */\n  /* border-radius */\n}\n\n.clusterWrap-module_clusterWrap__3F33e {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.clusterWrap-module_clusterWrap__3F33e.clusterWrap-module_inline__29C9u {\n  display: inline-flex;\n}\n\n.clusterWrap-module_clusterWrap__3F33e.clusterWrap-module_gap__5vVKy.clusterWrap-module_small__1BOS6 {\n  gap: 8px;\n}\n\n.clusterWrap-module_clusterWrap__3F33e.clusterWrap-module_gap__5vVKy.clusterWrap-module_medium__2TL9C {\n  gap: 16px;\n}\n\n.clusterWrap-module_clusterWrap__3F33e.clusterWrap-module_gap__5vVKy.clusterWrap-module_large__sFvYt {\n  gap: 24px;\n}\n\n.clusterWrap-module_clusterWrap__3F33e.clusterWrap-module_marginTop__24Pmu.clusterWrap-module_small__1BOS6 {\n  margin-top: 8px;\n}\n\n.clusterWrap-module_clusterWrap__3F33e.clusterWrap-module_marginTop__24Pmu.clusterWrap-module_medium__2TL9C {\n  margin-top: 16px;\n}\n\n.clusterWrap-module_clusterWrap__3F33e.clusterWrap-module_marginTop__24Pmu.clusterWrap-module_large__sFvYt {\n  margin-top: 24px;\n}\n\n.clusterWrap-module_clusterWrap__3F33e.clusterWrap-module_marginBottom__2DWYk.clusterWrap-module_small__1BOS6 {\n  margin-bottom: 8px;\n}\n\n.clusterWrap-module_clusterWrap__3F33e.clusterWrap-module_marginBottom__2DWYk.clusterWrap-module_medium__2TL9C {\n  margin-bottom: 16px;\n}\n\n.clusterWrap-module_clusterWrap__3F33e.clusterWrap-module_marginBottom__2DWYk.clusterWrap-module_large__sFvYt {\n  margin-bottom: 24px;\n}\n\n.clusterWrap-module_clusterWrap__3F33e.clusterWrap-module_marginLeft__3-neO.clusterWrap-module_small__1BOS6 {\n  margin-left: 8px;\n}\n\n.clusterWrap-module_clusterWrap__3F33e.clusterWrap-module_marginLeft__3-neO.clusterWrap-module_medium__2TL9C {\n  margin-left: 16px;\n}\n\n.clusterWrap-module_clusterWrap__3F33e.clusterWrap-module_marginLeft__3-neO.clusterWrap-module_large__sFvYt {\n  margin-left: 24px;\n}\n\n.clusterWrap-module_clusterWrap__3F33e.clusterWrap-module_marginRight__2r-30.clusterWrap-module_small__1BOS6 {\n  margin-right: 8px;\n}\n\n.clusterWrap-module_clusterWrap__3F33e.clusterWrap-module_marginRight__2r-30.clusterWrap-module_medium__2TL9C {\n  margin-right: 16px;\n}\n\n.clusterWrap-module_clusterWrap__3F33e.clusterWrap-module_marginRight__2r-30.clusterWrap-module_large__sFvYt {\n  margin-right: 24px;\n}\n";
var styles$J = {"clusterWrap":"clusterWrap-module_clusterWrap__3F33e","inline":"clusterWrap-module_inline__29C9u","gap":"clusterWrap-module_gap__5vVKy","small":"clusterWrap-module_small__1BOS6","medium":"clusterWrap-module_medium__2TL9C","large":"clusterWrap-module_large__sFvYt","marginTop":"clusterWrap-module_marginTop__24Pmu","marginBottom":"clusterWrap-module_marginBottom__2DWYk","marginLeft":"clusterWrap-module_marginLeft__3-neO","marginRight":"clusterWrap-module_marginRight__2r-30"};
styleInject(css_248z$K);

var _excluded$d = ["children", "gap", "marginTop", "marginBottom", "marginRight", "marginLeft", "align", "justify", "inline"];
var GAP = {
  small: styles$J.small,
  medium: styles$J.medium,
  large: styles$J.large
};
var ClusterWrap = function ClusterWrap(_ref) {
  var children = _ref.children,
    _ref$gap = _ref.gap,
    gap = _ref$gap === void 0 ? "small" : _ref$gap,
    marginTop = _ref.marginTop,
    marginBottom = _ref.marginBottom,
    marginRight = _ref.marginRight,
    marginLeft = _ref.marginLeft,
    align = _ref.align,
    justify = _ref.justify,
    inline = _ref.inline,
    props = _objectWithoutProperties(_ref, _excluded$d);
  var style = React.useMemo(function () {
    return {
      alignItems: align,
      justifyContent: justify
    };
  }, [align, justify]);
  return /*#__PURE__*/React__namespace.default.createElement("div", _objectSpread2(_objectSpread2({}, props), {}, {
    style: style,
    className: classnames__default.default(styles$J.clusterWrap, "".concat(styles$J.gap, " ").concat(GAP[gap]), inline && styles$J.inline, marginTop && "".concat(styles$J.marginTop, " ").concat(styles$J[marginTop]), marginBottom && "".concat(styles$J.marginBottom, " ").concat(styles$J[marginBottom]), marginRight && "".concat(styles$J.marginRight, " ").concat(styles$J[marginRight]), marginLeft && "".concat(styles$J.marginLeft, " ").concat(styles$J[marginLeft]))
  }), children);
};

var css_248z$J = ":root {\n  /* Color styles */\n\n  /* Text-size styles */\n\n  /* Effect styles */\n  /* border-radius */\n}\n\n.formContainer-module_container__OQI-i {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n";
var styles$I = {"container":"formContainer-module_container__OQI-i"};
styleInject(css_248z$J);

var _excluded$c = ["children"],
  _excluded2$1 = ["children", "maxWidth"];
var FormContainerItem = function FormContainerItem(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded$c);
  return /*#__PURE__*/React__namespace.default.createElement("div", _objectSpread2({}, props), children);
};
var FormContainer = function FormContainer(_ref2) {
  var children = _ref2.children,
    maxWidth = _ref2.maxWidth,
    props = _objectWithoutProperties(_ref2, _excluded2$1);
  var style = {
    maxWidth: maxWidth
  };
  return /*#__PURE__*/React__namespace.default.createElement("div", _objectSpread2({
    className: styles$I.container,
    style: style
  }, props), children);
};

var css_248z$I = ":root {\n  /* Color styles */\n\n  /* Text-size styles */\n\n  /* Effect styles */\n  /* border-radius */\n}\n\n.contents-module_contentsHeaderContainer__lrieo {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  padding: 16px;\n  gap: 16px;\n}\n\n.contents-module_contentsHeaderContainer__lrieo.contents-module_border__2Ym0Q {\n  border-bottom: 1px solid #b2b8c8;\n}\n\n.contents-module_contentsContainer__37rUG {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  gap: 16px;\n}\n\n.contents-module_headerWrapper__1JFBY {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 16px;\n}\n\n.contents-module_header__cwXvC {\n  display: flex;\n  gap: 8px;\n  flex-direction: row;\n  flex-basis: 0;\n  flex-grow: 1;\n  flex-shrink: 1;\n  flex-wrap: wrap;\n}\n\n.contents-module_header__cwXvC.contents-module_column__1tC-b {\n  flex-direction: column;\n}\n\n.contents-module_header__cwXvC h1 {\n  font: 600 20px/30px Meiryo, Arial, system-ui, sans-serif;\n  display: flex;\n}\n\n.contents-module_header__cwXvC.contents-module_row__3dzs6 h1 {\n  flex-direction: row;\n  align-items: center;\n  margin-right: 16px;\n}\n\n.contents-module_headerWrapper__1JFBY .contents-module_caption__18EDW {\n  font: 300 13px/18px Meiryo, Arial, system-ui, sans-serif;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.contents-module_headerWrapper__1JFBY .contents-module_buttonRow__3QOYT {\n  display: inline-flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 16px;\n  flex-shrink: 2;\n  justify-content: flex-end;\n}\n\n.contents-module_buttons__31snC {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.contents-module_headerWrapper__1JFBY .contents-module_buttonRow__3QOYT.contents-module_wrapped__10CCi {\n  justify-content: flex-start;\n}\n\n.contents-module_headerWrapper__1JFBY .contents-module_buttons__31snC.contents-module_wrapped__10CCi .contents-module_buttonRow__3QOYT {\n  justify-content: flex-start;\n}\n\n.contents-module_contents__2cPhr {\n  padding-inline: 16px;\n}\n\n@media screen and (max-width: 800px) {\n  .contents-module_headerWrapper__1JFBY {\n    flex-direction: column;\n    gap: 16px;\n    align-items: start;\n  }\n\n  .contents-module_headerWrapper__1JFBY .contents-module_header__cwXvC {\n    flex-basis: 100%;\n  }\n\n  .contents-module_headerWrapper__1JFBY .contents-module_buttons__31snC {\n    flex-basis: 100%;\n    width: 100%;\n  }\n}\n";
var styles$H = {"contentsHeaderContainer":"contents-module_contentsHeaderContainer__lrieo","border":"contents-module_border__2Ym0Q","contentsContainer":"contents-module_contentsContainer__37rUG","headerWrapper":"contents-module_headerWrapper__1JFBY","header":"contents-module_header__cwXvC","column":"contents-module_column__1tC-b","row":"contents-module_row__3dzs6","caption":"contents-module_caption__18EDW","buttonRow":"contents-module_buttonRow__3QOYT","buttons":"contents-module_buttons__31snC","wrapped":"contents-module_wrapped__10CCi","contents":"contents-module_contents__2cPhr"};
styleInject(css_248z$I);

var ContentsHeader = function ContentsHeader(_ref) {
  var title = _ref.title,
    caption = _ref.caption,
    buttons = _ref.buttons,
    _ref$border = _ref.border,
    border = _ref$border === void 0 ? true : _ref$border,
    breadcrumb = _ref.breadcrumb,
    _ref$captionDirection = _ref.captionDirection,
    captionDirection = _ref$captionDirection === void 0 ? "column" : _ref$captionDirection,
    children = _ref.children;
  return /*#__PURE__*/React__namespace.createElement("div", {
    className: classnames__default.default(styles$H.contentsHeaderContainer, border && styles$H.border)
  }, breadcrumb, /*#__PURE__*/React__namespace.createElement("div", {
    className: classnames__default.default(styles$H.headerWrapper)
  }, /*#__PURE__*/React__namespace.createElement("div", {
    className: classnames__default.default(styles$H.header, captionDirection === "column" ? styles$H.column : styles$H.row)
  }, /*#__PURE__*/React__namespace.createElement("h1", null, title), /*#__PURE__*/React__namespace.createElement("div", {
    className: classnames__default.default(styles$H.caption)
  }, React__namespace.Children.map(caption, function (child) {
    return child;
  }))), !!buttons && (/*#__PURE__*/React__namespace.createElement("div", {
    className: classnames__default.default(styles$H.buttons)
  }, buttons.map(function (button, index) {
    return /*#__PURE__*/React__namespace.createElement("div", {
      className: classnames__default.default(styles$H.buttonRow),
      key: index
    }, React__namespace.Children.map(button, function (child) {
      return child;
    }));
  })))), React__namespace.Children.map(children, function (child) {
    return child;
  }));
};
var ContentsContainer = function ContentsContainer(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/React__namespace.createElement("div", {
    className: styles$H.contentsContainer
  }, children);
};
var Contents = function Contents(_ref3) {
  var children = _ref3.children;
  return /*#__PURE__*/React__namespace.createElement("div", {
    className: styles$H.contents
  }, children);
};

var css_248z$H = ":root {\n  /* Color styles */\n\n  /* Text-size styles */\n\n  /* Effect styles */\n  /* border-radius */\n}\n\n.navigation-module_wrapper___P2uD {\n  display: grid;\n  grid-template-columns: 150px auto;\n  grid-template-rows: repeat(2, 100px);\n  grid-template-areas:\n    \"header header\"\n    \"sidemenu content\";\n  grid-template-columns: auto 1fr;\n  grid-template-rows: auto auto;\n  height: 100%;\n  overflow: hidden;\n}\n\n.navigation-module_content__3LESt {\n  grid-area: content;\n  max-height: calc(100vh - 56px);\n  overflow: auto;\n}\n\n@media print {\n  .navigation-module_content__3LESt {\n    max-height: initial;\n  }\n}\n\n@media screen and (max-width: 768px) {\n  .navigation-module_wrapper___P2uD {\n    grid-template:\n      \"header\" auto\n      \"sidemenu\" auto\n      \"content\" 1fr;\n  }\n\n  .navigation-module_content__3LESt {\n    max-height: inherit;\n  }\n}\n";
var styles$G = {"wrapper":"navigation-module_wrapper___P2uD","content":"navigation-module_content__3LESt"};
styleInject(css_248z$H);

var _excluded$b = ["children"];
var Navigation = function Navigation(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded$b);
  var _React$Children$toArr = React__namespace.default.Children.toArray(children),
    _React$Children$toArr2 = _slicedToArray(_React$Children$toArr, 3),
    header = _React$Children$toArr2[0],
    sidemenu = _React$Children$toArr2[1],
    child = _React$Children$toArr2[2];
  return /*#__PURE__*/React__namespace.default.createElement("div", _objectSpread2(_objectSpread2({}, props), {}, {
    className: classnames__default.default(styles$G.wrapper)
  }), header, sidemenu, /*#__PURE__*/React__namespace.default.createElement("div", {
    className: styles$G.content
  }, child));
};

var LinkIcon = function LinkIcon(_ref) {
  var title = _ref.title,
    desc = _ref.desc;
  return /*#__PURE__*/React__namespace.default.createElement("svg", {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__namespace.default.createElement("g", null, title && /*#__PURE__*/React__namespace.default.createElement("title", null, title), desc && /*#__PURE__*/React__namespace.default.createElement("desc", null, desc), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M22.7 22.2001H2.29999V1.80005H11.3996V3.65459H4.15453V20.3455H20.8454V13.1004H22.7V22.2001Z"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M14.4905 1.80005V3.65459H19.5349L12.2774 10.912L13.588 12.2226L20.8454 4.96514V10.0095H22.6999V1.80005H14.4905Z"
  })));
};

var css_248z$G = ":root {\n  /* Color styles */\n\n  /* Text-size styles */\n\n  /* Effect styles */\n  /* border-radius */\n}\n.link-module_link__1yRqL a {\n  display: inline-flex;\n  padding: 8px;\n  align-items: center;\n  color: #353ebd;\n  fill: #353ebd;\n}\n.link-module_link__1yRqL svg {\n  margin-left: 8px;\n  width: 20px;\n}\n.link-module_disabled__2dxC4 svg {\n  margin-left: 8px;\n  width: 20px;\n}\n.link-module_link__1yRqL.link-module_small__37dCL svg {\n  margin-left: 8px;\n  width: 14px;\n}\n.link-module_link__1yRqL.link-module_medium__1xSA6 a {\n  font: 300 14px/20px Meiryo, Arial, system-ui, sans-serif;\n}\n.link-module_link__1yRqL.link-module_medium__1xSA6.link-module_bold__wfYKR a {\n  font: 600 14px/20px Meiryo, Arial, system-ui, sans-serif;\n}\n.link-module_link__1yRqL.link-module_small__37dCL a {\n  font: 300 10px/10px Meiryo, Arial, system-ui, sans-serif;\n}\n.link-module_link__1yRqL.link-module_small__37dCL.link-module_bold__wfYKR a {\n  font: 600 10px/10px Meiryo, Arial, system-ui, sans-serif;\n}\n.link-module_link__1yRqL a:active {\n  color: #0f1192;\n  -webkit-text-decoration: underline #0f1192;\n          text-decoration: underline #0f1192;\n  fill: #0f1192;\n}\n.link-module_link__1yRqL a:focus {\n  color: #353ebd;\n  background-color: #f1f2f7;\n}\n.link-module_link__1yRqL a:visited {\n  color: #6f3a9a;\n  fill: #6f3a9a;\n}\n.link-module_externalLink__1yahO svg {\n  flex-shrink: 0;\n  flex-grow: 0;\n}\n.link-module_disabled__2dxC4 {\n  cursor: not-allowed;\n  color: #949cb0;\n  -webkit-text-decoration: underline #949cb0;\n          text-decoration: underline #949cb0;\n  fill: #949cb0;\n  display: inline-flex;\n  padding: 8px;\n  align-items: center;\n}\n.link-module_icon__3bk3V {\n  margin-right: 8px;\n  display: inline-flex;\n  align-items: center;\n}\n.link-module_link__1yRqL.link-module_small__37dCL .link-module_icon__3bk3V svg {\n  margin-left: inherit;\n}\n@media (hover: hover) {\n  .link-module_link__1yRqL a:hover:not(.link-module_disabled__2dxC4) {\n    color: #353ebd;\n    -webkit-text-decoration: underline #353ebd;\n            text-decoration: underline #353ebd;\n    fill: #353ebd;\n  }\n}\n";
var styles$F = {"link":"link-module_link__1yRqL","disabled":"link-module_disabled__2dxC4","small":"link-module_small__37dCL","medium":"link-module_medium__1xSA6","bold":"link-module_bold__wfYKR","externalLink":"link-module_externalLink__1yahO","icon":"link-module_icon__3bk3V"};
styleInject(css_248z$G);

var _excluded$a = ["anchor", "children"];
/**
 * AnchorPropsがある場合はAnchorPropsを、ない場合は<></>を使ってchildrenをrenderします。
 *
 * @param AnchorProps
 * @param children
 * @constructor
 */
function Anchor(_ref) {
  var AnchorProps = _ref.anchor,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded$a);
  if (AnchorProps) {
    return /*#__PURE__*/React__namespace.default.createElement(AnchorProps, _objectSpread2({}, props), children);
  }
  return /*#__PURE__*/React__namespace.default.createElement(React__namespace.default.Fragment, null, children);
}

var FONT_SIZE = {
  small: styles$F.small,
  medium: styles$F.medium
};
var FONT_WEIGHT = {
  bold: styles$F.bold
};
var DisabledLink = function DisabledLink(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React__namespace.createElement("span", {
    className: styles$F.disabled
  }, children);
};
function useIcon(icon, size) {
  var Icon = icon !== undefined ? Icons[icon] : null;
  return React__namespace.useMemo(function () {
    return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, !!Icon && (/*#__PURE__*/React__namespace.createElement("span", {
      className: styles$F.icon
    }, /*#__PURE__*/React__namespace.createElement(Icon, {
      size: size === "small" ? 24 : 32
    }))));
  }, [Icon, size]);
}
var Link = function Link(_ref2) {
  var children = _ref2.children,
    _ref2$size = _ref2.size,
    size = _ref2$size === void 0 ? "medium" : _ref2$size,
    fontWeight = _ref2.fontWeight,
    _ref2$disabled = _ref2.disabled,
    disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
    icon = _ref2.icon,
    anchor = _ref2.anchor;
  var Icon = useIcon(icon, size);
  return disabled ? (/*#__PURE__*/React__namespace.createElement(DisabledLink, null, Icon, children)) : (/*#__PURE__*/React__namespace.createElement("span", {
    className: classnames__default.default(styles$F.link, FONT_SIZE[size], fontWeight && FONT_WEIGHT[fontWeight], disabled && styles$F.disabled)
  }, /*#__PURE__*/React__namespace.createElement(Anchor, {
    anchor: anchor,
    "aria-disabled": disabled
  }, Icon, children)));
};
var ExternalLink = function ExternalLink(_ref3) {
  var _ref3$disabled = _ref3.disabled,
    disabled = _ref3$disabled === void 0 ? false : _ref3$disabled,
    _ref3$size = _ref3.size,
    size = _ref3$size === void 0 ? "medium" : _ref3$size,
    fontWeight = _ref3.fontWeight,
    children = _ref3.children,
    icon = _ref3.icon,
    anchor = _ref3.anchor;
  var Icon = useIcon(icon, size);
  return /*#__PURE__*/React__namespace.createElement("span", {
    className: classnames__default.default(styles$F.link, styles$F.externalLink, FONT_SIZE[size], fontWeight && FONT_WEIGHT[fontWeight], disabled && styles$F.disabled)
  }, /*#__PURE__*/React__namespace.createElement(Anchor, {
    anchor: anchor,
    target: "_blank",
    rel: "noreferrer noopener"
  }, Icon, children, !icon && /*#__PURE__*/React__namespace.createElement(LinkIcon, null)));
};

var css_248z$F = ":root {\n  /* Color styles */\n\n  /* Text-size styles */\n\n  /* Effect styles */\n  /* border-radius */\n}\n\n.spinner-module_wrapper__11b9l {\n  position: fixed;\n  border: none;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  /* 背景だけ透過させたい時にはrgbaを使用する => https://qiita.com/ritukiii/items/6568875a3eaaf0c0bde9*/\n  background-color: rgba(255, 255, 255, 0.3);\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.spinner-module_box__9ryqw {\n  background-color: #4c505c;\n  width: 192px;\n  height: 223px;\n  opacity: 0.8;\n\n  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);\n  border-radius: 8px;\n}\n\n.spinner-module_text__1O3a_ {\n  color: #ffffff;\n}\n\n.spinner-module_spinner__3QAWs {\n  margin-top: 40px;\n  margin-bottom: 10px;\n  width: 88px;\n  height: 88px;\n  border: 4px #4c505c solid;\n  border-top: 4px #ffffff solid;\n  border-right: 4px #ffffff solid;\n  border-bottom: 4px #ffffff solid;\n  border-radius: 50%;\n  animation: spinner-module_spinner-animation__1Hjsg 1s infinite linear;\n}\n\n@keyframes spinner-module_spinner-animation__1Hjsg {\n  100% {\n    transform: rotate(360deg);\n  }\n}\n";
var styles$E = {"wrapper":"spinner-module_wrapper__11b9l","box":"spinner-module_box__9ryqw","text":"spinner-module_text__1O3a_","spinner":"spinner-module_spinner__3QAWs","spinner-animation":"spinner-module_spinner-animation__1Hjsg"};
styleInject(css_248z$F);

var SpinnerState = /*#__PURE__*/function (_BaseType) {
  function SpinnerState(value, startTime) {
    var _this;
    _classCallCheck(this, SpinnerState);
    _this = _callSuper(this, SpinnerState, [value]);
    _this.startTime = startTime;
    return _this;
  }
  _inherits(SpinnerState, _BaseType);
  return _createClass(SpinnerState, [{
    key: "matchNewState",
    value: function matchNewState(loading, matcher) {
      var newState = loading ? this.getOpenState() : this.getCloseState();
      if (newState === this || this.typeEquals(newState)) {
        return matcher.noChange({
          state: this
        });
      }
      var time = newState.getTimeout();
      if (time) {
        return matcher.newStateWithTime({
          state: newState,
          time: time
        });
      }
      return matcher.newStateWithoutTime({
        state: newState
      });
    }
  }, {
    key: "getOpenState",
    value: function getOpenState() {
      var _this2 = this;
      return this.matchCall({
        hidden: function hidden() {
          return new SpinnerState("first200ms", Date.now());
        },
        first200ms: function first200ms() {
          return _this2.matchTime({
            before200ms: _this2,
            before600ms: _this2.newState("show600ms"),
            after600ms: _this2.newState("show")
          });
        },
        show600ms: function show600ms() {
          return _this2.matchTime({
            before200ms: _this2,
            before600ms: _this2,
            after600ms: _this2.newState("show")
          });
        },
        hide600ms: function hide600ms() {
          return _this2.matchTime({
            before200ms: _this2,
            before600ms: _this2.newState("show600ms"),
            after600ms: _this2.newState("show")
          });
        },
        show: function show() {
          return _this2;
        }
      });
    }
  }, {
    key: "getCloseState",
    value: function getCloseState() {
      var _this3 = this;
      var closeState = this.matchTime({
        before200ms: this.newHiddenState(),
        before600ms: this.newState("hide600ms"),
        after600ms: this.newHiddenState()
      });
      return this.matchCall({
        hidden: function hidden() {
          return _this3;
        },
        first200ms: function first200ms() {
          return closeState;
        },
        show600ms: function show600ms() {
          return closeState;
        },
        hide600ms: function hide600ms() {
          return closeState;
        },
        show: function show() {
          return _this3.newHiddenState();
        }
      });
    }
  }, {
    key: "newState",
    value: function newState(value) {
      return new SpinnerState(value, this.startTime);
    }
  }, {
    key: "newHiddenState",
    value: function newHiddenState() {
      return new SpinnerState("hidden", 0);
    }
  }, {
    key: "matchTime",
    value: function matchTime(matcher) {
      if (this.getPassedTime() < 200) {
        return matcher.before200ms;
      }
      if (this.getPassedTime() < 200 + 600) {
        return matcher.before600ms;
      }
      return matcher.after600ms;
    }
  }, {
    key: "getTimeout",
    value: function getTimeout() {
      var passed800ms = 200 + 600 - this.getPassedTime();
      var before600ms = this.matchTime({
        before200ms: passed800ms,
        // 例外状況だが安全に倒す
        before600ms: passed800ms,
        after600ms: 0
      });
      return this.matchType({
        hidden: 0,
        first200ms: this.matchTime({
          before200ms: 200 - this.getPassedTime(),
          before600ms: passed800ms,
          after600ms: 0
        }),
        show600ms: before600ms,
        hide600ms: before600ms,
        show: 0
      });
    }
  }, {
    key: "getPassedTime",
    value: function getPassedTime() {
      return Date.now() - this.startTime;
    }
  }], [{
    key: "hidden",
    value: function hidden() {
      return new this("hidden", 0);
    }
  }]);
}(BaseType);

var useSpinner = function useSpinner(loading) {
  var _useState = React.useState(SpinnerState.hidden()),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  var timeoutCount = React.useRef(0);
  React.useEffect(function () {
    setState(function (state) {
      return state.matchNewState(loading, {
        noChange: function noChange(_ref) {
          var state = _ref.state;
          return state;
        },
        newStateWithTime: function newStateWithTime(_ref2) {
          var state = _ref2.state,
            time = _ref2.time;
          timeoutCount.current = setTimeout(function () {
            setState(function (state) {
              return state.matchNewState(loading, {
                noChange: function noChange(_ref3) {
                  var state = _ref3.state;
                  return state;
                },
                newStateWithTime: function newStateWithTime(_ref4) {
                  var state = _ref4.state;
                  return state;
                },
                newStateWithoutTime: function newStateWithoutTime(_ref5) {
                  var state = _ref5.state;
                  return state;
                }
              });
            });
          }, time);
          return state;
        },
        newStateWithoutTime: function newStateWithoutTime(_ref6) {
          var state = _ref6.state;
          clearTimeout(timeoutCount.current);
          timeoutCount.current = 0;
          return state;
        }
      });
    });
  }, [loading]);
  return {
    isHidden: state.matchType({
      hidden: true,
      first200ms: true,
      show600ms: false,
      hide600ms: false,
      show: false
    })
  };
};

// TODO 一旦カスタマー向けのSpinnerを流用する。デザイン確定後、リニューアルする。
var Spinner = function Spinner(_ref) {
  var loading = _ref.loading;
  var _useSpinner = useSpinner(loading),
    isHidden = _useSpinner.isHidden;
  if (isHidden) {
    return null;
  }
  return /*#__PURE__*/React__namespace.createElement(SpinnerInner, null);
};
// ReactDOM.createPortalを使用して、div="app"の外にコンポーネントを差し込む => https://ja.reactjs.org/docs/portals.html
// 上位のDOMからスタイルを渡されてしまうとDOMが壊れてしまうので、上位のDOM外に差し込む。
var SpinnerInner = function SpinnerInner() {
  return /*#__PURE__*/ReactDOM__default.default.createPortal(/*#__PURE__*/React__namespace.createElement(FocusTrap__default.default, null, /*#__PURE__*/React__namespace.createElement("dialog", {
    className: styles$E.wrapper
  }, /*#__PURE__*/React__namespace.createElement("div", {
    className: styles$E.box
  }, /*#__PURE__*/React__namespace.createElement("div", {
    className: "is-flex is-flex-direction-column is-align-items-center"
  }, /*#__PURE__*/React__namespace.createElement("div", {
    className: styles$E.spinner
  }), /*#__PURE__*/React__namespace.createElement("p", {
    className: styles$E.text,
    tabIndex: 0
  }, "\u901A\u4FE1\u4E2D..."))))), document.body);
};
var ForTestSpinnerInner = SpinnerInner;

var css_248z$E = ":root {\n  /* font */\n  /* color */\n  /* shadow */\n  /* 余白 */\n  /* border-radius */\n}\n\n.dialog-module_dialog__knU2_ {\n  top: 0;\n  /* 背景だけ透過させたい時にはrgbaを使用する => https://qiita.com/ritukiii/items/6568875a3eaaf0c0bde9*/\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  width: 100%;\n  height: 100%;\n\n  /* For Polyfill */\n  position: fixed;\n  left: 0;\n  right: 0;\n  margin: auto;\n  z-index: 100;\n}\n\n/* For Native */\n\n.dialog-module_dialog__knU2_::backdrop {\n  background-color: rgba(0, 0, 0, 0.5);\n  position: fixed;\n  top: 0;\n  left: 0;\n}\n\n/* For Polyfill */\n\n.dialog-module_dialog__knU2_ + .dialog-module_backdrop__2OvKJ {\n  background-color: rgba(0, 0, 0, 0.5);\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.dialog-module_header__3d15b {\n  position: relative;\n  display: flex;\n  align-items: center;\n  font: bold 24px/42px Hiragino Sans, Arial, Meiryo, system-ui,\n    sans-serif;\n  margin-bottom: 24px;\n  margin-right: 16px;\n}\n\n@media screen and (max-width: 800px) {\n\n  .dialog-module_header__3d15b {\n  font: bold 20px/35px Hiragino Sans, Arial, Meiryo, system-ui,\n      sans-serif;\n  }\n}\n\n.dialog-module_title__1c_bN {\n  margin-left: 8px;\n  margin-right: 32px;\n}\n\n.dialog-module_box__3Pd_9 {\n  background-color: #fff;\n  max-width: 640px;\n  border: 1px solid #949cb0;\n  box-sizing: border-box;\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.3);\n  border-radius: 6px;\n  padding: 32px;\n}\n\n.dialog-module_cancel__2A7br {\n  cursor: pointer;\n  position: absolute;\n  right: -10px;\n  top: 5px;\n}\n\n.dialog-module_cancel__2A7br:hover {\n  outline: 0;\n  border: 1px solid #353ebd;\n  background-color: #fff;\n  filter: drop-shadow(0px 0px 4px rgba(57, 68, 179, 0.6));\n}\n\n.dialog-module_cancel__2A7br:focus {\n  outline: 0;\n  border: 1px solid #353ebd;\n  background-color: #fff;\n  filter: drop-shadow(0px 0px 4px rgba(57, 68, 179, 0.6));\n}\n\n.dialog-module_contents__2li6x {\n  margin: 24px 0;\n}\n\n.dialog-module_dialogButtons__33rO3 {\n  display: flex;\n  justify-content: center;\n}\n\n.dialog-module_button__3WReD {\n  margin: 0 40px;\n}\n\n@media screen and (max-width: 800px) {\n  .dialog-module_cancel__2A7br {\n    top: -5px;\n  }\n  .dialog-module_dialogButtons__33rO3 {\n    flex-direction: column-reverse;\n  }\n  .dialog-module_button__3WReD {\n    margin: 0 0 16px 0;\n  }\n  .dialog-module_box__3Pd_9 {\n    max-width: 375px;\n    padding: 16px;\n  }\n}\n";
var styles$D = {"dialog":"dialog-module_dialog__knU2_","backdrop":"dialog-module_backdrop__2OvKJ","header":"dialog-module_header__3d15b","title":"dialog-module_title__1c_bN","box":"dialog-module_box__3Pd_9","cancel":"dialog-module_cancel__2A7br","contents":"dialog-module_contents__2li6x","dialogButtons":"dialog-module_dialogButtons__33rO3","button":"dialog-module_button__3WReD"};
styleInject(css_248z$E);

var CancelIcon = function CancelIcon(_ref) {
  var size = _ref.size,
    _ref$isReversible = _ref.isReversible,
    isReversible = _ref$isReversible === void 0 ? false : _ref$isReversible;
  return /*#__PURE__*/React__namespace.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__namespace.default.createElement("g", null, /*#__PURE__*/React__namespace.default.createElement("title", null, "\u30AD\u30E3\u30F3\u30BB\u30EB\u30A2\u30A4\u30B3\u30F3"), /*#__PURE__*/React__namespace.default.createElement("desc", null, "\u64CD\u4F5C\u3092\u30AD\u30E3\u30F3\u30BB\u30EB\u3059\u308B\u3053\u3068\u304C\u3067\u304D\u308B\u3053\u3068\u3092\u793A\u3057\u3066\u3044\u308B\u30A2\u30A4\u30B3\u30F3\u3067\u3059"), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M35 7.11155L32.8884 5L20 17.8884L7.11155 5L5 7.11155L17.8884 20L5 32.8884L7.11155 35L20 22.1116L32.8884 35L35 32.8884L22.1116 20L35 7.11155Z",
    fill: isReversible ? "#ffffff" : "#706D6C"
  })));
};

var WarningIcon = function WarningIcon(_ref) {
  var width = _ref.width,
    height = _ref.height,
    _ref$isReversible = _ref.isReversible,
    isReversible = _ref$isReversible === void 0 ? false : _ref$isReversible;
  return /*#__PURE__*/React__namespace.default.createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__namespace.default.createElement("g", null, /*#__PURE__*/React__namespace.default.createElement("title", null, "\u6CE8\u610F\u559A\u8D77\u306E\u30A2\u30A4\u30B3\u30F3"), /*#__PURE__*/React__namespace.default.createElement("desc", null, "\u6CE8\u610F\u559A\u8D77\u3092\u4FC3\u3059\u30A2\u30A4\u30B3\u30F3\u3067\u3059"), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M34.8104 37.6H5.00043C2.71043 37.6 1.26043 35.13 2.38043 33.13L17.4404 6.31002C18.5904 4.26002 21.5504 4.27002 22.6804 6.33002L37.4304 33.15C38.5404 35.16 37.0904 37.6 34.8104 37.6Z",
    fill: isReversible ? "white" : "#E07E02"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M17.79 30.44C17.79 29.14 18.73 28.14 19.97 28.14C21.21 28.14 22.18 29.15 22.18 30.44C22.18 31.74 21.22 32.74 19.97 32.74C18.72 32.74 17.79 31.74 17.79 30.44ZM18.31 17.5L18.19 14.16H21.74L21.62 17.5L21.12 26.36H18.82L18.31 17.5Z",
    fill: isReversible ? "#E07E02" : "white"
  })));
};

var AttentionIcon = function AttentionIcon(_ref) {
  var width = _ref.width,
    height = _ref.height,
    _ref$isReversible = _ref.isReversible,
    isReversible = _ref$isReversible === void 0 ? false : _ref$isReversible;
  return /*#__PURE__*/React__namespace.default.createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__namespace.default.createElement("g", null, /*#__PURE__*/React__namespace.default.createElement("title", null, "\u30A8\u30E9\u30FC\u30A2\u30A4\u30B3\u30F3"), /*#__PURE__*/React__namespace.default.createElement("desc", null, "\u30A8\u30E9\u30FC\u3092\u793A\u3057\u3066\u3044\u308B\u30A2\u30A4\u30B3\u30F3\u3067\u3059"), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M20 40.3075C31.0457 40.3075 40 31.3532 40 20.3075C40 9.2618 31.0457 0.307495 20 0.307495C8.9543 0.307495 0 9.2618 0 20.3075C0 31.3532 8.9543 40.3075 20 40.3075Z",
    fill: isReversible ? "white" : "#D53B3A"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M17.5596 29.2575C17.5596 27.6375 18.7296 26.3775 20.2896 26.3775C21.8496 26.3775 23.0496 27.6375 23.0496 29.2575C23.0496 30.8775 21.8496 32.1375 20.2896 32.1375C18.7296 32.1375 17.5596 30.8775 17.5596 29.2575ZM18.2196 13.0875L18.0696 8.91748H22.5096L22.3596 13.0875L21.7296 24.1575H18.8496L18.2196 13.0875Z",
    fill: isReversible ? "#D53B3A" : "white"
  })));
};

var useDialog = function useDialog(onCancel) {
  var dialogRef = React.useRef(null);
  var closeDialog = React.useCallback(function () {
    if (dialogRef.current) {
      onCancel();
    }
  }, [onCancel]);
  return {
    dialogRef: dialogRef,
    closeDialog: closeDialog
  };
};

var useDeviceType = function useDeviceType() {
  var getWindowDimensions = function getWindowDimensions() {
    var _window = window,
      width = _window.innerWidth;
    var isPc = width >= 800;
    return {
      isPc: isPc
    };
  };
  var _useState = React.useState(getWindowDimensions()),
    _useState2 = _slicedToArray(_useState, 2),
    deviceType = _useState2[0],
    setDeviceType = _useState2[1];
  React.useEffect(function () {
    var onResize = function onResize() {
      setDeviceType(getWindowDimensions());
    };
    window.addEventListener("resize", onResize);
    window.addEventListener("load", onResize);
    return function () {
      window.removeEventListener("resize", onResize);
      window.removeEventListener("load", onResize);
    };
  }, []);
  return deviceType;
};

var BaseDialog = function BaseDialog(_ref) {
  var props = Object.assign({}, (_objectDestructuringEmpty(_ref), _ref));
  var _useDialog = useDialog(props.onCancel),
    dialogRef = _useDialog.dialogRef,
    closeDialog = _useDialog.closeDialog;
  var dialogHeaderId = "dialog-header-".concat(React__namespace.useId());
  var stopPropagation = React.useCallback(function (e) {
    e.stopPropagation();
  }, []);
  var handleKeyPress = function handleKeyPress(e) {
    if (e.key === "Escape") {
      props.onCancel();
    }
  };
  var _useDeviceType = useDeviceType(),
    isPc = _useDeviceType.isPc;
  return /*#__PURE__*/ReactDOM__default.default.createPortal(/*#__PURE__*/React__namespace.createElement(FocusTrap__default.default, null, /*#__PURE__*/React__namespace.createElement("dialog", {
    className: styles$D.dialog,
    onClick: closeDialog,
    ref: dialogRef,
    "aria-modal": "true",
    "aria-hidden": true,
    "aria-labelledby": dialogHeaderId,
    onKeyDown: handleKeyPress
  }, /*#__PURE__*/React__namespace.createElement("div", {
    className: styles$D.box,
    onClick: stopPropagation,
    tabIndex: -1
  }, /*#__PURE__*/React__namespace.createElement("div", {
    className: styles$D.header
  }, props.icon, /*#__PURE__*/React__namespace.createElement("p", {
    className: styles$D.title,
    id: dialogHeaderId
  }, props.title), /*#__PURE__*/React__namespace.createElement("button", {
    className: styles$D.cancel,
    onClick: closeDialog
  }, /*#__PURE__*/React__namespace.createElement(CancelIcon, {
    size: isPc ? 40 : 24
  }))), /*#__PURE__*/React__namespace.createElement("div", {
    className: styles$D.contents
  }, props.contents), props.children))), document.body);
};
var DefaultDialog = function DefaultDialog(_ref2) {
  var props = Object.assign({}, (_objectDestructuringEmpty(_ref2), _ref2));
  return /*#__PURE__*/React__namespace.createElement(BaseDialog, _objectSpread2({}, props), /*#__PURE__*/React__namespace.createElement("div", {
    className: styles$D.dialogButtons
  }, /*#__PURE__*/React__namespace.createElement("div", {
    className: styles$D.button
  }, /*#__PURE__*/React__namespace.createElement(SecondaryButton, {
    text: props.cancelText,
    onClick: props.onCancel
  })), /*#__PURE__*/React__namespace.createElement("div", {
    className: styles$D.button
  }, /*#__PURE__*/React__namespace.createElement(PrimaryButton, {
    text: props.proceedText,
    onClick: props.onProceed,
    disabled: props.proceedDisabled
  }))));
};
var MessageDialog = function MessageDialog(_ref3) {
  var props = Object.assign({}, (_objectDestructuringEmpty(_ref3), _ref3));
  return /*#__PURE__*/React__namespace.createElement(BaseDialog, _objectSpread2({}, props), /*#__PURE__*/React__namespace.createElement("div", {
    className: styles$D.dialogButtons
  }, /*#__PURE__*/React__namespace.createElement(SecondaryButton, {
    text: props.cancelText,
    onClick: props.onCancel
  })));
};
var WarningDialog = function WarningDialog(_ref4) {
  var props = Object.assign({}, (_objectDestructuringEmpty(_ref4), _ref4));
  return /*#__PURE__*/React__namespace.createElement(BaseDialog, _objectSpread2(_objectSpread2({}, props), {}, {
    icon: /*#__PURE__*/React__namespace.createElement(WarningIcon, {
      height: 40,
      width: 40
    })
  }), /*#__PURE__*/React__namespace.createElement("div", {
    className: styles$D.dialogButtons
  }, /*#__PURE__*/React__namespace.createElement("div", {
    className: styles$D.button
  }, /*#__PURE__*/React__namespace.createElement(SecondaryButton, {
    text: props.cancelText,
    onClick: props.onCancel
  })), /*#__PURE__*/React__namespace.createElement("div", {
    className: styles$D.button
  }, /*#__PURE__*/React__namespace.createElement(PrimaryButton, {
    text: props.proceedText,
    onClick: props.onProceed,
    disabled: props.proceedDisabled
  }))));
};
var ErrorDialog = function ErrorDialog(_ref5) {
  var props = Object.assign({}, (_objectDestructuringEmpty(_ref5), _ref5));
  return /*#__PURE__*/React__namespace.createElement(BaseDialog, _objectSpread2(_objectSpread2({}, props), {}, {
    icon: /*#__PURE__*/React__namespace.createElement(AttentionIcon, {
      height: 40,
      width: 40
    })
  }), /*#__PURE__*/React__namespace.createElement("div", {
    className: styles$D.dialogButtons
  }, /*#__PURE__*/React__namespace.createElement("div", {
    className: styles$D.button
  }, /*#__PURE__*/React__namespace.createElement(DangerSecondaryButton, {
    text: props.cancelText,
    onClick: props.onCancel
  })), /*#__PURE__*/React__namespace.createElement("div", {
    className: styles$D.button
  }, /*#__PURE__*/React__namespace.createElement(DangerButton, {
    text: props.proceedText,
    onClick: props.onProceed,
    disabled: props.proceedDisabled
  }))));
};

var css_248z$D = ":root {\n  /* Color styles */\n\n  /* Text-size styles */\n\n  /* Effect styles */\n  /* border-radius */\n}\n\n.pagination-module_wrapper__rAvTg,\n.pagination-module_paginationList__3J5E9 {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.pagination-module_link__2OlYI,\n.pagination-module_current__3aS9u {\n  border: none;\n  border-radius: 24px;\n  margin: 20px;\n  height: 1.5em;\n  min-width: 1em;\n  padding-left: 1em;\n  padding-right: 1em;\n  padding-top: 1.25em;\n  padding-bottom: 1.25em;\n}\n\n.pagination-module_link__2OlYI:hover {\n  border: none;\n  background-color: #f1f2f7;\n}\n\n.pagination-module_link__2OlYI:focus {\n  border: none;\n  background-color: #f1f2f7;\n}\n\n.pagination-module_current__3aS9u {\n  cursor: default;\n  background-color: #353ebd;\n  color: #fff;\n}\n\n.pagination-module_ellipsis__2snii {\n  color: #393e4a;\n}\n\n.pagination-module_arrow__3GtzS {\n  cursor: pointer;\n  border-radius: 24px;\n  border: none;\n}\n\n.pagination-module_arrow__3GtzS:hover {\n  cursor: pointer;\n  background-color: #f1f2f7;\n}\n\n.pagination-module_arrow__3GtzS:focus {\n  cursor: pointer;\n  background-color: #f1f2f7;\n}\n\n.pagination-module_disabled__1O8pd:active {\n  box-shadow: none;\n}\n\n.pagination-module_current__3aS9u:active {\n  box-shadow: none;\n}\n\n.pagination-module_current__3aS9u:hover {\n  color: #ffffff;\n  background-color: #353ebd;\n}\n\n.pagination-module_current__3aS9u:focus {\n  color: #ffffff;\n  background-color: #353ebd;\n  box-shadow: 0px 0px 5px rgba(53, 62, 189, 1);\n  fill: #0f1192;\n}\n\n.pagination-module_wrapper__rAvTg .pagination-module_disabled__1O8pd {\n  cursor: default;\n  color: #b2b8c8;\n  border: none;\n  background-color: transparent;\n  opacity: 1;\n}\n\n@media screen and (max-width: 800px) {\n  .pagination-module_paginationList__3J5E9 {\n    flex-wrap: wrap;\n  }\n}\n";
var styles$C = {"wrapper":"pagination-module_wrapper__rAvTg","paginationList":"pagination-module_paginationList__3J5E9","link":"pagination-module_link__2OlYI","current":"pagination-module_current__3aS9u","ellipsis":"pagination-module_ellipsis__2snii","arrow":"pagination-module_arrow__3GtzS","disabled":"pagination-module_disabled__1O8pd"};
styleInject(css_248z$D);

function usePagination(_ref) {
  var currentPage = _ref.currentPage,
    lastPage = _ref.lastPage;
  var middle = lastPage / 2;
  var itemList = React.useMemo(function () {
    if (currentPage > lastPage || !currentPage || !lastPage) {
      return [];
    }
    if (lastPage === 1) {
      return [{
        type: "page",
        value: 1
      }];
    }
    if (currentPage > 3 && lastPage - currentPage > 2) {
      return _toConsumableArray(Array(7)).map(function (_, index) {
        var page = index + 1;
        var next = currentPage + 1;
        var prev = currentPage - 1;
        if (page === 2 || page === 6) {
          return {
            type: "ellipsis",
            value: null
          };
        }
        if (page === 3) {
          return {
            type: "page",
            value: prev
          };
        }
        if (page === 4) {
          return {
            type: "page",
            value: currentPage
          };
        }
        if (page === 5) {
          return {
            type: "page",
            value: next
          };
        }
        if (page === 7) {
          return {
            type: "page",
            value: lastPage
          };
        }
        return {
          type: "page",
          value: page
        };
      }, []);
    }
    if (lastPage !== 1 && lastPage < 7) {
      return _toConsumableArray(Array(lastPage)).map(function (_, index) {
        var page = index + 1;
        return {
          type: "page",
          value: page
        };
      }, []);
    }
    if (currentPage < middle) {
      return _toConsumableArray(Array(6)).map(function (_, index) {
        var page = index + 1;
        if (page === 5) {
          return {
            type: "ellipsis",
            value: null
          };
        }
        if (page === 6) {
          return {
            type: "page",
            value: lastPage
          };
        }
        return {
          type: "page",
          value: page
        };
      }, []);
    }
    if (currentPage > middle) {
      return _toConsumableArray(Array(6)).map(function (_, index) {
        var page = index + 1;
        if (page === 1) {
          return {
            type: "page",
            value: 1
          };
        }
        if (page === 2) {
          return {
            type: "ellipsis",
            value: null
          };
        }
        if (page === 6) {
          return {
            type: "page",
            value: lastPage
          };
        }
        return {
          type: "page",
          value: lastPage - 6 + page
        };
      }, []);
    }
    return [];
  }, [currentPage, lastPage, middle]);
  return itemList;
}

var _excluded$9 = ["children", "className"];
var LinkButton$1 = function LinkButton(_ref) {
  var children = _ref.children,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded$9);
  return /*#__PURE__*/React__namespace.default.createElement("button", _objectSpread2({
    type: "button",
    className: "".concat(className, " ").concat(styles$C.link)
  }, props), children);
};
var Pagination = function Pagination(_ref2) {
  var onPageClick = _ref2.onPageClick,
    currentPage = _ref2.currentPage,
    lastPage = _ref2.lastPage;
  var nextPage = currentPage + 1 <= lastPage ? currentPage + 1 : null;
  var prevPage = currentPage - 1 > 0 ? currentPage - 1 : null;
  var itemList = usePagination({
    currentPage: currentPage,
    lastPage: lastPage
  });
  var id = React.useId();
  return /*#__PURE__*/React__namespace.default.createElement("nav", {
    className: styles$C.wrapper,
    "aria-label": "\u30DA\u30FC\u30B8\u30CD\u30FC\u30B7\u30E7\u30F3"
  }, /*#__PURE__*/React__namespace.default.createElement("button", {
    className: classnames__default.default("pagination-link", !prevPage ? styles$C.disabled : styles$C.arrow),
    onClick: function onClick() {
      if (!prevPage) return;
      onPageClick(prevPage);
    },
    disabled: !prevPage,
    type: "button",
    "aria-label": "\u524D\u306E\u30DA\u30FC\u30B8\u3078\u79FB\u52D5"
  }, /*#__PURE__*/React__namespace.default.createElement(ArrowLeftIcon, {
    size: 24
  })), /*#__PURE__*/React__namespace.default.createElement("ul", {
    className: styles$C.paginationList
  }, itemList.length === 1 && (/*#__PURE__*/React__namespace.default.createElement("li", {
    key: "".concat(id, "-page-").concat(itemList.length)
  }, /*#__PURE__*/React__namespace.default.createElement("button", {
    "aria-label": "".concat(itemList.length, "\u30DA\u30FC\u30B8"),
    className: styles$C.disabled,
    disabled: true,
    type: "button"
  }, itemList.length))), itemList.length > 1 && itemList.map(function (item, index) {
    if (item.type === "ellipsis") {
      return /*#__PURE__*/React__namespace.default.createElement("li", {
        key: "".concat(id, "-ellipsis-").concat(index)
      }, /*#__PURE__*/React__namespace.default.createElement("span", {
        "aria-hidden": "true",
        className: "pagination-ellipsis"
      }, "\u2026"));
    }
    return /*#__PURE__*/React__namespace.default.createElement("li", {
      key: "".concat(id, "-page-").concat(item.value)
    }, /*#__PURE__*/React__namespace.default.createElement(LinkButton$1, {
      onClick: function onClick() {
        return onPageClick(item.value);
      },
      className: classnames__default.default("pagination-link", currentPage === item.value && styles$C.current),
      "aria-label": currentPage === item.value ? "".concat(item.value, "\u30DA\u30FC\u30B8\u76EE") : "".concat(item.value, "\u30DA\u30FC\u30B8\u76EE\u3078\u79FB\u52D5"),
      "aria-current": currentPage === item.value ? "page" : undefined
    }, item.value));
  })), /*#__PURE__*/React__namespace.default.createElement("button", {
    className: classnames__default.default("pagination-link", !nextPage ? styles$C.disabled : styles$C.arrow),
    onClick: function onClick() {
      if (!nextPage) return;
      onPageClick(nextPage);
    },
    disabled: !nextPage,
    type: "button",
    "aria-label": "\u6B21\u306E\u30DA\u30FC\u30B8\u3078\u79FB\u52D5"
  }, /*#__PURE__*/React__namespace.default.createElement(ArrowRightIcon, {
    size: 24
  })));
};

var css_248z$C = ":root {\n  /* font */\n  /* color */\n  /* shadow */\n  /* 余白 */\n  /* border-radius */\n}\n\n.error-message-module_failText__1Xiqs {\n  padding-top: 8px;\n  color: #b1110c;\n  font: 14px/24px Hiragino Sans, Arial, Meiryo, system-ui, sans-serif;\n}\n\n@media screen and (max-width: 800px) {\n\n  .error-message-module_failText__1Xiqs {\n  font: 14px/24px Hiragino Sans, Arial, Meiryo, system-ui,\n      sans-serif;\n  }\n}\n";
var styles$B = {"failText":"error-message-module_failText__1Xiqs"};
styleInject(css_248z$C);

var ErrorMessages = function ErrorMessages(_ref) {
  var messages = _ref.messages,
    id = _ref.id,
    ariaLive = _ref.ariaLive;
  if (!messages || !messages.length) {
    return null;
  }
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, Array.isArray(messages) ? (/*#__PURE__*/React__namespace.createElement("div", {
    id: id,
    "aria-live": "assertive"
  }, messages.map(function (e, index) {
    return /*#__PURE__*/React__namespace.createElement("p", {
      "data-testid": "test-form-error-".concat(id),
      className: styles$B.failText,
      key: index
    }, e);
  }))) : (/*#__PURE__*/React__namespace.createElement("p", {
    "data-testid": "test-form-error-".concat(id),
    id: id,
    "aria-live": ariaLive,
    className: styles$B.failText
  }, messages)));
};

var css_248z$B = ":root {\n  /* font */\n  /* color */\n  /* shadow */\n  /* 余白 */\n  /* border-radius */\n}\n\n.inputTag-module_tag__3ihWp {\n  padding: 4px 6px;\n  border-radius: 30px;\n  margin-left: 8px;\n  font: 14px/24px Hiragino Sans, Arial, Meiryo, system-ui, sans-serif;\n}\n\n@media screen and (max-width: 800px) {\n\n  .inputTag-module_tag__3ihWp {\n  font: 14px/24px Hiragino Sans, Arial, Meiryo, system-ui,\n      sans-serif;\n  }\n}\n\n.inputTag-module_required__2kuS_ {\n  background: #fff6f8;\n  color: #b1110c;\n}\n\n.inputTag-module_optional__1dTvB {\n  background: #e5e6ea;\n  color: #1d1c1a;\n}\n";
var styles$A = {"tag":"inputTag-module_tag__3ihWp","required":"inputTag-module_required__2kuS_","optional":"inputTag-module_optional__1dTvB"};
styleInject(css_248z$B);

var Tag = function Tag(_ref) {
  var required = _ref.required;
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, required ? (/*#__PURE__*/React__namespace.createElement("span", {
    className: classnames__default.default(styles$A.tag, styles$A.required)
  }, "\u5FC5\u9808")) : (/*#__PURE__*/React__namespace.createElement("span", {
    className: classnames__default.default(styles$A.tag, styles$A.optional)
  }, "\u4EFB\u610F")));
};

var css_248z$A = ":root {\n  /* font */\n  /* color */\n  /* shadow */\n  /* 余白 */\n  /* border-radius */\n}\n\n.title-wrap-module_title__3hvCs {\n  display: inline-block;\n  vertical-align: baseline;\n  color: #1d1c1a;\n  font-family: \"Hiragino Sans\";\n  font-style: normal;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n  color: #1d1c1a;\n  margin-bottom: 8px;\n}\n\n.title-wrap-module_description__1oQYM {\n  display: block;\n  margin-bottom: 8px;\n  font: 14px/24px Hiragino Sans, Arial, Meiryo, system-ui, sans-serif;\n  white-space: pre-line;\n}\n\n@media screen and (max-width: 800px) {\n\n  .title-wrap-module_description__1oQYM {\n  font: 14px/24px Hiragino Sans, Arial, Meiryo, system-ui,\n      sans-serif;\n  }\n}\n";
var styles$z = {"title":"title-wrap-module_title__3hvCs","description":"title-wrap-module_description__1oQYM"};
styleInject(css_248z$A);

var TitleWrap = function TitleWrap(_ref) {
  var title = _ref.title,
    description = _ref.description,
    id = _ref.id,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required;
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, !!title && (/*#__PURE__*/React__namespace.createElement("label", {
    "data-testid": "test-form-label-".concat(id),
    className: styles$z.title,
    htmlFor: id
  }, title, /*#__PURE__*/React__namespace.createElement(Tag, {
    required: required
  }))), !!description && (/*#__PURE__*/React__namespace.createElement("p", {
    "data-testid": "test-form-description-".concat(id),
    className: styles$z.description,
    id: "form-description-".concat(id)
  }, description)));
};

var checkErrorMessages = function checkErrorMessages(errorMessages) {
  if (errorMessages) {
    return typeof errorMessages === "string" && errorMessages !== "" || errorMessages.length > 0;
  }
  return false;
};
var generateErrorMessages = function generateErrorMessages(errorMessages, message) {
  if (!errorMessages && !message) {
    return [];
  }
  var messages = message ? [message] : [];
  if (errorMessages) {
    if (typeof errorMessages === "string") {
      messages.push(errorMessages);
    } else {
      messages = [].concat(_toConsumableArray(messages), _toConsumableArray(errorMessages));
    }
  }
  return messages;
};
var ErrorState = /*#__PURE__*/function () {
  function ErrorState(_ref) {
    var id = _ref.id,
      errorMessage = _ref.errorMessage,
      hasError = _ref.hasError;
    _classCallCheck(this, ErrorState);
    this.errorMessages = errorMessage;
    this.id = id;
    this.hasError = hasError;
  }
  return _createClass(ErrorState, null, [{
    key: "create",
    value: function create(_ref2) {
      var id = _ref2.id,
        errorMessages = _ref2.errorMessages,
        validator = _ref2.validator;
      var message = validator === null || validator === void 0 ? void 0 : validator.validate();
      var hasError = !!message || checkErrorMessages(errorMessages);
      var messages = generateErrorMessages(errorMessages, message);
      return new ErrorState({
        id: "errorMessage-".concat(id),
        errorMessage: messages,
        hasError: hasError
      });
    }
  }]);
}();

function useFormController(_ref) {
  var id = _ref.id,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    errorMessages = _ref.errorMessages,
    noValidate = _ref.noValidate,
    validator = _ref.validator,
    shouldDisplayError = _ref.shouldDisplayError,
    onError = _ref.onError,
    render = _ref.render;
  var _useState = React.useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    touched = _useState2[0],
    setTouched = _useState2[1];
  var generatedID = React.useMemo(function () {
    return id !== null && id !== void 0 ? id : generateID();
  }, [id]);
  var errorState = React.useMemo(function () {
    return ErrorState.create({
      id: generatedID,
      errorMessages: errorMessages,
      validator: validator
    });
  }, [errorMessages, generatedID, validator]);
  var formState = React.useMemo(function () {
    return FormState.create(touched, !errorState.hasError, noValidate, disabled, undefined, shouldDisplayError);
  }, [disabled, errorState.hasError, noValidate, shouldDisplayError, touched]);
  React.useEffect(function () {
    onError && errorState && onError(errorState);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorState === null || errorState === void 0 ? void 0 : errorState.hasError]);
  var handleOnTouch = React__namespace.default.useCallback(function () {
    setTouched(true);
  }, []);
  var component = render({
    formState: formState,
    onTouch: handleOnTouch,
    id: generatedID
  });
  return {
    component: component,
    formState: formState,
    errorState: errorState,
    generatedID: generatedID
  };
}

var css_248z$z = ":root {\n  /* Color styles */\n\n  /* Text-size styles */\n\n  /* Effect styles */\n  /* border-radius */\n}\n\n.helperText-module_helperText__2eIwy {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font: 16px/28px Meiryo, Arial, system-ui, sans-serif;\n  color: #262b38;\n}\n";
var styles$y = {"helperText":"helperText-module_helperText__2eIwy"};
styleInject(css_248z$z);

var HelperText = function HelperText(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React__namespace.default.createElement("p", {
    className: styles$y.helperText
  }, /*#__PURE__*/React__namespace.default.createElement(InfoCircleIcon, {
    size: 24
  }), children);
};

var FormController = function FormController(_ref) {
  var id = _ref.id,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    errorMessages = _ref.errorMessages,
    shouldDisplayError = _ref.shouldDisplayError,
    noValidate = _ref.noValidate,
    validator = _ref.validator,
    required = _ref.required,
    label = _ref.label,
    description = _ref.description,
    helperText = _ref.helperText,
    onError = _ref.onError,
    render = _ref.render;
  var _useFormController = useFormController({
      id: id,
      noValidate: noValidate,
      disabled: disabled,
      errorMessages: errorMessages,
      shouldDisplayError: shouldDisplayError,
      validator: validator,
      helperText: helperText,
      onError: onError,
      render: render
    }),
    component = _useFormController.component,
    formState = _useFormController.formState,
    errorState = _useFormController.errorState,
    generatedID = _useFormController.generatedID;
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, /*#__PURE__*/React__namespace.createElement(TitleWrap, {
    title: label,
    required: required,
    description: description,
    id: generatedID
  }), component, formState.isFail() && (/*#__PURE__*/React__namespace.createElement(ErrorMessages, {
    messages: errorState === null || errorState === void 0 ? void 0 : errorState.errorMessages,
    id: errorState === null || errorState === void 0 ? void 0 : errorState.id
  })), !!helperText && /*#__PURE__*/React__namespace.createElement(HelperText, null, helperText));
};

var css_248z$y = ":root {\n  /* Color styles */\n\n  /* Text-size styles */\n\n  /* Effect styles */\n  /* border-radius */\n}\n\n.file-uploader-module_fileInputWrapper__2jp3n {\n  background: #ffffff;\n  border: 1px solid #949cb0;\n  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);\n  border-radius: 4px;\n  cursor: pointer;\n  padding: 8px 16px;\n  font: 16px/28px Meiryo, Arial, system-ui, sans-serif;\n  display: flex;\n  align-items: center;\n  width: 296px;\n}\n\n.file-uploader-module_fileInputWrapper__2jp3n:focus {\n  border: 1px solid #353ebd;\n  box-shadow: 0px 0px 5px rgba(53, 62, 189, 1);\n}\n\n.file-uploader-module_fileInputWrapper__2jp3n.file-uploader-module_fail__1R5X_:focus {\n  border: 1px solid #b1110c;\n  box-shadow: 0px 0px 5px rgba(222, 50, 38, 0.7);\n}\n\n.file-uploader-module_fileInputWrapper__2jp3n.file-uploader-module_disabled__6Mf4r {\n  cursor: not-allowed;\n  background: #f1f2f7;\n  color: #949cb0;\n  border: 1px solid #f1f2f7;\n  box-shadow: none;\n}\n\n.file-uploader-module_fileInputWrapper__2jp3n.file-uploader-module_fail__1R5X_ {\n  border-color: #de3226;\n  background: #fff5f6;\n}\n\n.file-uploader-module_fileLabelWrapper__2qh3E {\n  display: flex;\n  align-items: center;\n}\n\n.file-uploader-module_fileLabelWrapper__2qh3E svg {\n  margin-right: 16px;\n}\n\n.file-uploader-module_fileInput__1CGuG {\n  display: none;\n}\n\n.file-uploader-module_uploadedItemWrapper__3b_Uv {\n  margin-top: 24px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 0px;\n  padding-left: 8px;\n  border-top: 1px solid #b2b8c8;\n  border-bottom: 1px solid #b2b8c8;\n}\n\n.file-uploader-module_uploadedItemWrapper__3b_Uv .file-uploader-module_fileName__2OS9e > svg {\n  color: #5f636d;\n}\n\n.file-uploader-module_uploadedItemWrapper__3b_Uv.file-uploader-module_fail__1R5X_ {\n  background-color: #fff5f6;\n}\n\n.file-uploader-module_uploadedItemWrapper__3b_Uv.file-uploader-module_disabled__6Mf4r {\n  background-color: #fff5f6;\n  cursor: not-allowed;\n  background: #ffffff;\n  color: #949cb0;\n}\n\n.file-uploader-module_fileName__2OS9e {\n  display: flex;\n  align-items: center;\n}\n\n.file-uploader-module_fileName__2OS9e a {\n  display: inline-flex;\n  align-items: center;\n  color: #353ebd;\n  border-radius: 4px;\n  padding: 8px 4px;\n}\n\n.file-uploader-module_fileName__2OS9e a svg {\n  fill: #353ebd;\n  margin-left: 8px;\n}\n\n.file-uploader-module_fileName__2OS9e a:focus {\n  opacity: 0.8;\n}\n\n.file-uploader-module_fileName__2OS9e a:focus {\n  background-color: #f1f2f7;\n}\n\n.file-uploader-module_deleteIcon__3qxQe {\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  color: #de3226;\n  font: 16px/28px Meiryo, Arial, system-ui, sans-serif;\n  margin-right: calc(8px);\n  border-radius: 4px;\n  padding: 8px 4px;\n}\n\n.file-uploader-module_deleteIcon__3qxQe svg {\n  fill: #de3226;\n}\n\n.file-uploader-module_deleteIcon__3qxQe.file-uploader-module_disabled__6Mf4r {\n  cursor: not-allowed;\n  color: #949cb0;\n}\n\n.file-uploader-module_deleteIcon__3qxQe.file-uploader-module_disabled__6Mf4r svg {\n  fill: #949cb0;\n}\n\n.file-uploader-module_deleteIcon__3qxQe:focus {\n  background-color: #fff5f6;\n}\n\n.file-uploader-module_uploadedItemWrapper__3b_Uv:not(.file-uploader-module_disabled__6Mf4r) .file-uploader-module_prefixIcon__6Wfmg {\n  color: #5f636d;\n}\n\n.file-uploader-module_uploadedItemWrapper__3b_Uv.file-uploader-module_fail__1R5X_ .file-uploader-module_prefixIcon__6Wfmg {\n  color: #de3226;\n}\n\n@media (hover: hover) {\n  .file-uploader-module_fileInputWrapper__2jp3n:not(.file-uploader-module_disabled__6Mf4r):hover {\n    border: 1px solid #5f636d;\n  }\n  .file-uploader-module_fileInputWrapper__2jp3n:not(.file-uploader-module_disabled__6Mf4r).file-uploader-module_fail__1R5X_:hover {\n    border: 1px solid #b1110c;\n  }\n  .file-uploader-module_uploadedItemWrapper__3b_Uv:not(.file-uploader-module_disabled__6Mf4r) .file-uploader-module_fileName__2OS9e a:hover {\n    color: #0f1192;\n  }\n\n  .file-uploader-module_deleteIcon__3qxQe:not(.file-uploader-module_disabled__6Mf4r):hover {\n    color: #b1110c;\n  }\n}\n";
var styles$x = {"fileInputWrapper":"file-uploader-module_fileInputWrapper__2jp3n","fail":"file-uploader-module_fail__1R5X_","disabled":"file-uploader-module_disabled__6Mf4r","fileLabelWrapper":"file-uploader-module_fileLabelWrapper__2qh3E","fileInput":"file-uploader-module_fileInput__1CGuG","uploadedItemWrapper":"file-uploader-module_uploadedItemWrapper__3b_Uv","fileName":"file-uploader-module_fileName__2OS9e","deleteIcon":"file-uploader-module_deleteIcon__3qxQe","prefixIcon":"file-uploader-module_prefixIcon__6Wfmg"};
styleInject(css_248z$y);

var SIZES = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
function compareSize(bytes, maxSize) {
  if (!maxSize) {
    return true;
  }
  var k = 1024;
  var i = maxSize.size * Math.pow(k, SIZES.indexOf(maxSize.unit));
  return bytes <= i;
}
var FileUploadValidator = /*#__PURE__*/function () {
  function FileUploadValidator(_ref) {
    var files = _ref.files,
      required = _ref.required,
      maxSize = _ref.maxSize;
    _classCallCheck(this, FileUploadValidator);
    this.files = files;
    this.required = required;
    this.maxSize = maxSize;
  }
  return _createClass(FileUploadValidator, [{
    key: "validateMaxByte",
    value: function validateMaxByte() {
      var _this = this;
      if (!this.maxSize) return true;
      var sizeTotal = 0;
      return this.files.reduce(function (carry, current) {
        sizeTotal += current.size;
        carry = compareSize(sizeTotal, _this.maxSize);
        return carry;
      }, true);
    }
  }, {
    key: "validate",
    value: function validate() {
      var _a, _b;
      if (this.required && !this.files.length) return "必須項目です。";
      if (!this.validateMaxByte()) return "\u3053\u308C\u4EE5\u4E0A\u306F\u30D5\u30A1\u30A4\u30EB\u3092\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u3067\u304D\u307E\u305B\u3093\u3002\u5408\u8A08".concat((_a = this.maxSize) === null || _a === void 0 ? void 0 : _a.size).concat((_b = this.maxSize) === null || _b === void 0 ? void 0 : _b.unit, "\u4EE5\u5185\u3067\u304A\u9858\u3044\u3057\u307E\u3059\u3002");
      return undefined;
    }
  }], [{
    key: "create",
    value: function create(props) {
      return new FileUploadValidator(props);
    }
  }]);
}();

var _excluded$8 = ["disabled", "shouldDisplayError", "errorMessages", "label", "required", "id", "description", "helperText", "onError"];
var UploadedItem = function UploadedItem(_ref) {
  var inputRef = _ref.inputRef,
    formState = _ref.formState,
    file = _ref.file,
    index = _ref.index,
    deleteFile = _ref.deleteFile;
  var handleOnClick = React.useCallback(function () {
    var _a, _b;
    deleteFile(index);
    if (((_b = (_a = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _a === void 0 ? void 0 : _a.files) === null || _b === void 0 ? void 0 : _b.length) === 1) {
      inputRef.current.value = "";
    }
  }, [deleteFile, index, inputRef]);
  var url = React.useMemo(function () {
    return URL.createObjectURL(file);
  }, [file]);
  return /*#__PURE__*/React__namespace.default.createElement("div", {
    className: classnames__default.default(styles$x.uploadedItemWrapper, styles$x.uploadItemWrapper, formState.matchType({
      "default": "",
      fail: styles$x.fail,
      success: "",
      disabled: styles$x.disabled
    }))
  }, /*#__PURE__*/React__namespace.default.createElement("p", {
    className: styles$x.fileName
  }, /*#__PURE__*/React__namespace.default.createElement("span", {
    className: classnames__default.default(styles$x.prefixIcon)
  }, formState.matchComponents({
    "default": /*#__PURE__*/React__namespace.default.createElement(ImageIcon, {
      size: 32
    }),
    fail: /*#__PURE__*/React__namespace.default.createElement(WarningIcon$1, {
      size: 32
    }),
    success: /*#__PURE__*/React__namespace.default.createElement(ImageIcon, {
      size: 32
    }),
    disabled: /*#__PURE__*/React__namespace.default.createElement(WarningIcon$1, {
      size: 32
    })
  })), formState.matchType({
    "default": true,
    fail: true,
    success: true,
    disabled: false
  }) ? (/*#__PURE__*/React__namespace.default.createElement("a", {
    className: styles$x.link,
    href: url,
    target: "_blank",
    rel: "noopener noreferrer"
  }, file.name, /*#__PURE__*/React__namespace.default.createElement(OpenInNewIcon, {
    size: 24
  }))) : (/*#__PURE__*/React__namespace.default.createElement("span", {
    className: styles$x.uploadItem
  }, file.name))), /*#__PURE__*/React__namespace.default.createElement("button", {
    disabled: formState.matchType({
      "default": false,
      fail: false,
      success: false,
      disabled: true
    }),
    className: classnames__default.default(styles$x.deleteIcon, formState.matchType({
      "default": "",
      fail: styles$x.fail,
      success: "",
      disabled: styles$x.disabled
    })),
    onClick: handleOnClick
  }, /*#__PURE__*/React__namespace.default.createElement(TrashIcon, {
    size: 32
  }), "\u524A\u9664"));
};
var BaseFileUploader = function BaseFileUploader(_ref2) {
  var acceptFileType = _ref2.acceptFileType,
    setFile = _ref2.setFile,
    formState = _ref2.formState,
    value = _ref2.value,
    multiple = _ref2.multiple,
    id = _ref2.id,
    onTouch = _ref2.onTouch,
    deleteFile = _ref2.deleteFile;
  var accept = React.useMemo(function () {
    return acceptFileType ? acceptFileType.join(",") : undefined;
  }, [acceptFileType]);
  var ref = React.useRef(null);
  return /*#__PURE__*/React__namespace.default.createElement("div", {
    className: styles$x.fileUploadContainer
  }, /*#__PURE__*/React__namespace.default.createElement("input", {
    id: id,
    ref: ref,
    className: styles$x.fileInput,
    type: "file",
    name: "resume",
    accept: accept,
    "data-testid": "test-file-input",
    onChange: function onChange(e) {
      onTouch();
      if (!e.target.files) return;
      var fileList = e.target.files;
      var files = Array.from(fileList);
      if (multiple) {
        setFile(files);
        return;
      }
      setFile(files[0]);
    },
    disabled: formState.matchType({
      "default": false,
      disabled: true,
      success: false,
      fail: false
    }),
    multiple: multiple,
    onBlur: function onBlur() {
      onTouch();
    }
  }), /*#__PURE__*/React__namespace.default.createElement("button", {
    className: classnames__default.default(styles$x.fileInputWrapper, formState.matchType({
      "default": "",
      disabled: styles$x.disabled,
      success: "",
      fail: styles$x.fail
    })),
    onClick: function onClick() {
      var _a;
      return (_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.click();
    }
  }, /*#__PURE__*/React__namespace.default.createElement("span", {
    className: classnames__default.default(styles$x.fileLabelWrapper, formState.matchType({
      "default": styles$x["default"],
      disabled: "",
      success: styles$x.success,
      fail: styles$x.fail
    }))
  }, /*#__PURE__*/React__namespace.default.createElement(UploadIcon, {
    size: 24
  }), /*#__PURE__*/React__namespace.default.createElement("span", {
    className: styles$x.fileLabel
  }, "\u30D5\u30A1\u30A4\u30EB\u3092\u9078\u629E"))), !!value.length && (/*#__PURE__*/React__namespace.default.createElement(React__namespace.default.Fragment, null, value.map(function (file, index) {
    return /*#__PURE__*/React__namespace.default.createElement(UploadedItem, {
      inputRef: ref,
      key: "file-item-".concat(index),
      formState: formState,
      file: file,
      index: index,
      deleteFile: deleteFile
    });
  }))));
};
var FileUploader = function FileUploader(_ref3) {
  var _ref3$disabled = _ref3.disabled,
    disabled = _ref3$disabled === void 0 ? false : _ref3$disabled,
    _ref3$shouldDisplayEr = _ref3.shouldDisplayError,
    shouldDisplayError = _ref3$shouldDisplayEr === void 0 ? false : _ref3$shouldDisplayEr,
    errorMessages = _ref3.errorMessages,
    label = _ref3.label,
    _ref3$required = _ref3.required,
    required = _ref3$required === void 0 ? false : _ref3$required,
    id = _ref3.id,
    description = _ref3.description,
    helperText = _ref3.helperText,
    onError = _ref3.onError,
    fileProps = _objectWithoutProperties(_ref3, _excluded$8);
  var validator = FileUploadValidator.create({
    files: fileProps.value,
    required: required,
    maxSize: fileProps.maxFileSize
  });
  return /*#__PURE__*/React__namespace.default.createElement(FormController, {
    label: label,
    description: description,
    required: required,
    disabled: disabled,
    id: id,
    shouldDisplayError: shouldDisplayError,
    onError: onError,
    errorMessages: errorMessages,
    noValidate: false,
    validator: validator,
    helperText: helperText,
    render: function FileUploader(_ref4) {
      var id = _ref4.id,
        formState = _ref4.formState,
        onTouch = _ref4.onTouch;
      return /*#__PURE__*/React__namespace.default.createElement(BaseFileUploader, _objectSpread2(_objectSpread2({}, fileProps), {}, {
        id: id,
        formState: formState,
        onTouch: onTouch
      }));
    }
  });
};
var SingleFileUploader = function SingleFileUploader(props) {
  return /*#__PURE__*/React__namespace.default.createElement(FileUploader, _objectSpread2(_objectSpread2({}, props), {}, {
    value: props.value ? [props.value] : [],
    multiple: false
  }));
};
var MultipleFileUploader = function MultipleFileUploader(props) {
  return /*#__PURE__*/React__namespace.default.createElement(FileUploader, _objectSpread2(_objectSpread2({}, props), {}, {
    multiple: true
  }));
};

var css_248z$x = ":root {\n  /* Color styles */\n\n  /* Text-size styles */\n\n  /* Effect styles */\n  /* border-radius */\n}\n\n.textarea-module_wrapper__2fgjS {\n  width: 100%;\n}\n\n.textarea-module_textarea__YMLNZ {\n  width: 100%;\n  background: #ffffff;\n  border: 1px solid #949cb0;\n  border-radius: 4px;\n  padding-left: 16px;\n  padding-top: 8px;\n  font-family: \"Hiragino Sans\";\n  font-style: normal;\n  font-weight: 300;\n  font-size: 14px;\n  line-height: 20px;\n  color: #262b38;\n}\n\n.textarea-module_textarea__YMLNZ::-moz-placeholder {\n  opacity: 0.9;\n}\n\n.textarea-module_textarea__YMLNZ::placeholder {\n  opacity: 0.9;\n}\n\n.textarea-module_textarea__YMLNZ:hover {\n  border: 1px solid #5f636d;\n}\n\n.textarea-module_textarea__YMLNZ:focus {\n  border: 1px solid #353ebd;\n  outline: unset;\n  box-shadow: 0px 0px 5px #353ebd;\n}\n\n.textarea-module_textarea__YMLNZ:focus-visible {\n  border: 1px solid #353ebd;\n  outline: unset;\n  box-shadow: 0px 0px 5px #353ebd;\n}\n\n.textarea-module_textarea__YMLNZ.textarea-module_fail__1RwGS {\n  border: 1px solid #de3226;\n  border-radius: 4px;\n}\n\n.textarea-module_textarea__YMLNZ.textarea-module_fail__1RwGS:hover {\n  border: 1px solid #b1110c;\n}\n\n.textarea-module_textarea__YMLNZ.textarea-module_fail__1RwGS:focus {\n  border: 1px solid #de3226;\n  outline: unset;\n  box-shadow: 0px 0px 5px rgba(222, 50, 38, 0.7);\n}\n\n.textarea-module_textarea__YMLNZ.textarea-module_fail__1RwGS:focus-visible {\n  border: 1px solid #de3226;\n  outline: unset;\n  box-shadow: 0px 0px 5px rgba(222, 50, 38, 0.7);\n}\n\n.textarea-module_textarea__YMLNZ.textarea-module_success__1s6A2 {\n  border: 1px solid #3aa393;\n  border-radius: 4px;\n}\n\n.textarea-module_textarea__YMLNZ.textarea-module_success__1s6A2:hover {\n  border: 1px solid #258675;\n}\n\n.textarea-module_textarea__YMLNZ.textarea-module_success__1s6A2:focus {\n  border: 1px solid #3aa393;\n  outline: unset;\n  box-shadow: 0px 0px 5px #3aa393;\n}\n\n.textarea-module_textarea__YMLNZ.textarea-module_success__1s6A2:focus-visible {\n  border: 1px solid #3aa393;\n  outline: unset;\n  box-shadow: 0px 0px 5px #3aa393;\n}\n\n.textarea-module_textarea__YMLNZ.textarea-module_disabled__3SBYG {\n  background: #f1f2f7;\n  border-color: #f1f2f7;\n  cursor: not-allowed;\n}\n\n.textarea-module_charCount__3jG26 {\n  font-family: \"Hiragino Sans\";\n  font-style: normal;\n  font-weight: 300;\n  font-size: 12px;\n  line-height: 18px;\n  text-align: right;\n  letter-spacing: 1px;\n  color: #262b38;\n}\n\n.textarea-module_disableResize__2O_fD {\n  resize: none;\n}\n";
var styles$w = {"wrapper":"textarea-module_wrapper__2fgjS","textarea":"textarea-module_textarea__YMLNZ","fail":"textarea-module_fail__1RwGS","success":"textarea-module_success__1s6A2","disabled":"textarea-module_disabled__3SBYG","charCount":"textarea-module_charCount__3jG26","disableResize":"textarea-module_disableResize__2O_fD"};
styleInject(css_248z$x);

var CharCount = function CharCount(_ref) {
  var text = _ref.text,
    maxLength = _ref.maxLength;
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, /*#__PURE__*/React__namespace.createElement("p", {
    className: styles$w.charCount
  }, text.length, "/", maxLength));
};
var TextArea = /*#__PURE__*/React__namespace.forwardRef(function (_ref2, ref) {
  var onChange = _ref2.onChange,
    _ref2$disabled = _ref2.disabled,
    disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
    value = _ref2.value,
    _ref2$shouldDisplayEr = _ref2.shouldDisplayError,
    shouldDisplayError = _ref2$shouldDisplayEr === void 0 ? false : _ref2$shouldDisplayEr,
    errorMessages = _ref2.errorMessages,
    maxLength = _ref2.maxLength,
    label = _ref2.label,
    _ref2$required = _ref2.required,
    required = _ref2$required === void 0 ? false : _ref2$required,
    id = _ref2.id,
    placeholder = _ref2.placeholder,
    helperText = _ref2.helperText,
    description = _ref2.description,
    _ref2$rows = _ref2.rows,
    rows = _ref2$rows === void 0 ? 5 : _ref2$rows,
    _ref2$disableResize = _ref2.disableResize,
    disableResize = _ref2$disableResize === void 0 ? false : _ref2$disableResize;
  var v = value !== null && value !== void 0 ? value : undefined;
  return /*#__PURE__*/React__namespace.createElement(FormController, {
    label: label,
    description: description,
    required: required,
    disabled: disabled,
    id: id,
    shouldDisplayError: shouldDisplayError,
    validator: undefined,
    onError: undefined,
    errorMessages: errorMessages,
    noValidate: false,
    helperText: helperText,
    render: function BaseTextArea(_ref3) {
      var formState = _ref3.formState,
        onTouch = _ref3.onTouch,
        id = _ref3.id;
      return /*#__PURE__*/React__namespace.createElement("div", {
        className: styles$w.wrapper
      }, /*#__PURE__*/React__namespace.createElement("textarea", {
        id: id,
        ref: ref,
        className: classnames__default.default(styles$w.textarea, formState.matchType({
          "default": "",
          disabled: styles$w.disabled,
          success: styles$w.success,
          fail: styles$w.fail
        }), disableResize && styles$w.disableResize),
        placeholder: placeholder,
        rows: rows,
        value: v,
        onChange: onChange,
        onBlur: function onBlur() {
          onTouch();
        },
        disabled: disabled
      }), /*#__PURE__*/React__namespace.createElement("div", {
        className: styles$w.textArea
      }, typeof maxLength === "number" && maxLength > 0 && (/*#__PURE__*/React__namespace.createElement(CharCount, {
        text: v !== null && v !== void 0 ? v : "",
        maxLength: maxLength
      }))));
    }
  });
});
TextArea.displayName = "TextArea";

var css_248z$w = ":root {\n  /* Color styles */\n\n  /* Text-size styles */\n\n  /* Effect styles */\n  /* border-radius */\n}\n\n.breadcrumbs-module_breadcrumbs__2NsRt {\n  display: flex;\n  align-items: center;\n  /* bulmaのCSSを上書きする */\n  -webkit-user-select: auto;\n     -moz-user-select: auto;\n          user-select: auto;\n}\n\n.breadcrumbs-module_breadcrumbs__2NsRt .breadcrumbs-module_item__39RNm a {\n  padding-left: calc(8px / 2);\n  padding-right: calc(8px / 2);\n  border-radius: calc(8px / 2);\n  color: #353ebd;\n}\n\n.breadcrumbs-module_breadcrumbs__2NsRt .breadcrumbs-module_item__39RNm a:visited {\n  color: #353ebd;\n}\n\n.breadcrumbs-module_breadcrumbs__2NsRt .breadcrumbs-module_item__39RNm span {\n  padding-left: calc(8px / 2);\n  border-radius: calc(8px / 2);\n  color: #4c505c;\n  font: 300 14px/20px Meiryo, Arial, system-ui, sans-serif;\n}\n\n.breadcrumbs-module_breadcrumbs__2NsRt .breadcrumbs-module_item__39RNm a:first-child {\n  /* Bulmaの.breadcrumbsのcssを強制的に上書きする */\n  padding-left: calc(8px / 2);\n  padding-right: calc(8px / 2);\n}\n\n.breadcrumbs-module_breadcrumbs__2NsRt .breadcrumbs-module_item__39RNm::before {\n  margin-left: 8px;\n  margin-right: 8px;\n}\n\n.breadcrumbs-module_breadcrumbs__2NsRt .breadcrumbs-module_item__39RNm a {\n  font: 300 14px/20px Meiryo, Arial, system-ui, sans-serif;\n}\n\n@media (hover: hover) {\n  .breadcrumbs-module_breadcrumbs__2NsRt .breadcrumbs-module_item__39RNm a:hover {\n    background-color: #f1f2f7;\n    color: #0f1192;\n    text-decoration: none;\n  }\n}\n";
var styles$v = {"breadcrumbs":"breadcrumbs-module_breadcrumbs__2NsRt","item":"breadcrumbs-module_item__39RNm"};
styleInject(css_248z$w);

var Breadcrumbs$1 = function Breadcrumbs(_ref) {
  var anchor = _ref.anchor,
    list = _ref.list;
  return /*#__PURE__*/React__namespace.default.createElement("nav", {
    className: classnames__default.default("breadcrumb is-small", styles$v.breadcrumbs),
    "aria-label": "\u30D1\u30F3\u304F\u305A\u30EA\u30B9\u30C8"
  }, /*#__PURE__*/React__namespace.default.createElement("ul", null, list.map(function (l, index) {
    var isActive = list.length - 1 === index;
    return /*#__PURE__*/React__namespace.default.createElement("li", {
      className: styles$v.item,
      key: l.title
    }, isActive ? (/*#__PURE__*/React__namespace.default.createElement("span", null, l.title)) : (/*#__PURE__*/React__namespace.default.createElement(Anchor, {
      "data-for-rpa-id": "breadcrumbs-".concat(l.title),
      anchor: anchor,
      href: "".concat(isActive ? "#" : l.to)
    }, l.title)));
  })));
};

var css_248z$v = ":root {\n  /* Color styles */\n\n  /* Text-size styles */\n\n  /* Effect styles */\n  /* border-radius */\n}\n\n.breadcrumbs-module_breadcrumbs__3qGH0 {\n  display: flex;\n  align-items: center;\n  word-break: break-all;\n  /* bulmaのCSSを上書きする */\n  margin-bottom: 0 !important;\n  -webkit-user-select: auto;\n     -moz-user-select: auto;\n          user-select: auto;\n}\n\n.breadcrumbs-module_breadcrumbs__3qGH0 ul {\n  gap: 8px 0;\n  flex-wrap: wrap;\n}\n\n.breadcrumbs-module_breadcrumbs__3qGH0 li {\n  align-items: center;\n  display: flex;\n}\n\n.breadcrumbs-module_breadcrumbs__3qGH0 .breadcrumbs-module_item__36o0L a {\n  padding-left: calc(8px / 2);\n  padding-right: calc(8px / 2);\n  border-radius: calc(8px / 2);\n  color: #353ebd;\n}\n\n.breadcrumbs-module_breadcrumbs__3qGH0 .breadcrumbs-module_item__36o0L button {\n  padding-left: calc(8px / 2);\n  padding-right: calc(8px / 2);\n  border-radius: calc(8px / 2);\n  color: #353ebd;\n}\n\n.breadcrumbs-module_breadcrumbs__3qGH0 .breadcrumbs-module_item__36o0L a,\n.breadcrumbs-module_breadcrumbs__3qGH0 .breadcrumbs-module_item__36o0L button,\n.breadcrumbs-module_breadcrumbs__3qGH0 .breadcrumbs-module_item__36o0L span {\n  white-space: normal;\n}\n\n.breadcrumbs-module_breadcrumbs__3qGH0 .breadcrumbs-module_item__36o0L a:visited {\n  color: #353ebd;\n}\n\n.breadcrumbs-module_breadcrumbs__3qGH0 .breadcrumbs-module_item__36o0L span {\n  padding-left: calc(8px / 2);\n  border-radius: calc(8px / 2);\n  color: #4c505c;\n  font: 300 14px/20px Meiryo, Arial, system-ui, sans-serif;\n}\n\n.breadcrumbs-module_breadcrumbs__3qGH0 .breadcrumbs-module_item__36o0L a:first-child {\n  /* Bulmaの.breadcrumbsのcssを強制的に上書きする */\n  padding-left: calc(8px / 2);\n  padding-right: calc(8px / 2);\n}\n\n.breadcrumbs-module_breadcrumbs__3qGH0 .breadcrumbs-module_item__36o0L::before {\n  margin-left: 8px;\n  margin-right: 8px;\n}\n\n.breadcrumbs-module_breadcrumbs__3qGH0 .breadcrumbs-module_item__36o0L button:focus {\n  outline: 2px solid #353ebd;\n  background-color: #f1f2f7;\n}\n\n.breadcrumbs-module_breadcrumbs__3qGH0 .breadcrumbs-module_item__36o0L a {\n  font: 300 14px/20px Meiryo, Arial, system-ui, sans-serif;\n}\n\n@media (hover: hover) {\n  .breadcrumbs-module_breadcrumbs__3qGH0 .breadcrumbs-module_item__36o0L a:hover {\n    background-color: #f1f2f7;\n    color: #0f1192;\n    text-decoration: none;\n  }\n  .breadcrumbs-module_breadcrumbs__3qGH0 .breadcrumbs-module_item__36o0L button:hover {\n    background-color: #f1f2f7;\n    color: #0f1192;\n    text-decoration: none;\n  }\n}\n";
var styles$u = {"breadcrumbs":"breadcrumbs-module_breadcrumbs__3qGH0","item":"breadcrumbs-module_item__36o0L"};
styleInject(css_248z$v);

var Breadcrumbs = function Breadcrumbs(_ref) {
  var anchor = _ref.anchor,
    list = _ref.list;
  var _React$useState = React__namespace.default.useState(true),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isHide = _React$useState2[0],
    setIsHide = _React$useState2[1];
  var handleOnClick = React.useCallback(function () {
    setIsHide(false);
  }, []);
  return /*#__PURE__*/React__namespace.default.createElement(React__namespace.default.Fragment, null, list.length > 2 && (/*#__PURE__*/React__namespace.default.createElement("nav", {
    className: classnames__default.default("breadcrumb is-small", styles$u.breadcrumbs),
    "aria-label": "\u30D1\u30F3\u304F\u305A\u30EA\u30B9\u30C8"
  }, /*#__PURE__*/React__namespace.default.createElement("ul", null, list.length > 7 && isHide ? (/*#__PURE__*/React__namespace.default.createElement(React__namespace.default.Fragment, null, /*#__PURE__*/React__namespace.default.createElement("li", {
    className: styles$u.item
  }, /*#__PURE__*/React__namespace.default.createElement(Anchor, {
    "data-for-rpa-id": "breadcrumbs-".concat(list[0].title),
    anchor: anchor,
    href: list[0].to
  }, list[0].title)), /*#__PURE__*/React__namespace.default.createElement("li", {
    className: styles$u.item
  }, /*#__PURE__*/React__namespace.default.createElement("button", {
    className: styles$u.ellipsis,
    onClick: handleOnClick
  }, "...")), /*#__PURE__*/React__namespace.default.createElement("li", {
    className: styles$u.item
  }, /*#__PURE__*/React__namespace.default.createElement(Anchor, {
    "data-for-rpa-id": "breadcrumbs-".concat(list[list.length - 2].title),
    anchor: anchor,
    href: list[list.length - 2].to
  }, list[list.length - 2].title)), /*#__PURE__*/React__namespace.default.createElement("li", {
    className: styles$u.item
  }, /*#__PURE__*/React__namespace.default.createElement("span", null, list[list.length - 1].title)))) : list.map(function (l, index) {
    var isActive = list.length - 1 === index;
    return /*#__PURE__*/React__namespace.default.createElement("li", {
      className: styles$u.item,
      key: l.title
    }, isActive ? (/*#__PURE__*/React__namespace.default.createElement("span", null, l.title)) : (/*#__PURE__*/React__namespace.default.createElement(Anchor, {
      "data-for-rpa-id": "breadcrumbs-".concat(l.title),
      anchor: anchor,
      href: "".concat(isActive ? "#" : l.to)
    }, l.title)));
  })))));
};

var breadcrumbs = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Breadcrumbs: Breadcrumbs
});

function useCheckboxListRender(_ref) {
  var options = _ref.options,
    values = _ref.values,
    disabled = _ref.disabled,
    _ref$direction = _ref.direction,
    direction = _ref$direction === void 0 ? "column" : _ref$direction,
    onChange = _ref.onChange,
    onBlur = _ref.onBlur;
  var render = React.useCallback(function (_ref2) {
    var formState = _ref2.formState,
      onTouch = _ref2.onTouch,
      id = _ref2.id;
    return /*#__PURE__*/React__namespace.default.createElement(BaseCheckBoxList, {
      id: id,
      direction: direction,
      formState: formState,
      options: options,
      onTouch: onTouch,
      disabled: disabled,
      values: values,
      onChange: onChange,
      onBlur: onBlur
    });
  }, [direction, options, values, onChange, onBlur, disabled]);
  return render;
}

var Checkbox = /*#__PURE__*/React__namespace.default.memo(function (_ref) {
  var options = _ref.options,
    values = _ref.values,
    disabled = _ref.disabled,
    label = _ref.label,
    required = _ref.required,
    id = _ref.id,
    description = _ref.description,
    errorMessages = _ref.errorMessages,
    _ref$shouldDisplayErr = _ref.shouldDisplayError,
    shouldDisplayError = _ref$shouldDisplayErr === void 0 ? false : _ref$shouldDisplayErr,
    _ref$direction = _ref.direction,
    direction = _ref$direction === void 0 ? "column" : _ref$direction,
    helperText = _ref.helperText,
    onChange = _ref.onChange,
    onBlur = _ref.onBlur;
  var render = useCheckboxListRender({
    options: options,
    values: values,
    disabled: disabled,
    direction: direction,
    onChange: onChange,
    onBlur: onBlur
  });
  return /*#__PURE__*/React__namespace.default.createElement(FormController, {
    label: label,
    description: description,
    required: required,
    disabled: disabled,
    id: id,
    shouldDisplayError: shouldDisplayError,
    validator: undefined,
    onError: undefined,
    errorMessages: errorMessages,
    noValidate: false,
    render: render,
    helperText: helperText
  });
});
Checkbox.displayName = "Checkbox";

var css_248z$u = ":root {\n  /* Color styles */\n\n  /* Text-size styles */\n\n  /* Effect styles */\n  /* border-radius */\n}\n\n.baseRadioButton-module_list__3waxD.baseRadioButton-module_column__zV1WJ {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.baseRadioButton-module_list__3waxD.baseRadioButton-module_row__3rd3w {\n  display: flex;\n  flex-direction: row;\n}\n\n.baseRadioButton-module_list__3waxD.baseRadioButton-module_row__3rd3w > .baseRadioButton-module_element__2rw59:not(:first-child) {\n  margin-left: 16px;\n}\n\n.baseRadioButton-module_radioButtonWrapper__27TzT {\n  display: block;\n}\n\n.baseRadioButton-module_input__20PT-[type=\"radio\"] {\n  opacity: 0;\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n  position: absolute;\n}\n\n.baseRadioButton-module_label__14O9O {\n  width: 100%;\n}\n\n.baseRadioButton-module_labelInner__VG2Mo {\n  display: flex;\n  align-items: center;\n}\n\n.baseRadioButton-module_text__1-LyD {\n  display: block;\n  font: 300 16px/24px Meiryo, Arial, system-ui, sans-serif;\n  color: #262b38;\n}\n\n.baseRadioButton-module_description__Ib0nx {\n  display: block;\n  margin-top: 8px;\n  font: 300 13px/18px Meiryo, Arial, system-ui, sans-serif;\n  color: #4c505c;\n  white-space: pre-wrap;\n}\n\n.baseRadioButton-module_tags__2p_7c {\n  margin-left: 8px;\n}\n\n/******************** ラベル ********************/\n\ninput[type=\"radio\"] + label {\n  display: none;\n  cursor: pointer;\n  display: inline-block;\n  position: relative;\n  vertical-align: middle;\n}\n\n/*  hover */\n\ninput[type=\"radio\"] + label:hover .baseRadioButton-module_text__1-LyD {\n  color: #5f636d;\n}\n\n/* focus */\n\ninput[type=\"radio\"]:focus + label .baseRadioButton-module_text__1-LyD {\n  color: #5f636d;\n}\n\n/* disabled (選択されていない)*/\n\ninput[type=\"radio\"]:disabled:not(:checked) + label .baseRadioButton-module_text__1-LyD {\n  cursor: not-allowed;\n  color: #5f636d;\n}\n\n/* disabled (選択されている)*/\n\ninput[type=\"radio\"]:disabled:checked + label .baseRadioButton-module_text__1-LyD {\n  cursor: not-allowed;\n  color: #5f636d;\n}\n\n/******************** ICON ********************/\n\n.baseRadioButton-module_icon__3JVJ6 {\n  align-self: start;\n  vertical-align: top;\n  width: 40px;\n  height: 40px;\n  padding: 8px;\n  border-radius: 50%;\n  margin-right: 8px;\n}\n\n/* focus時の円 */\n\ninput[type=\"radio\"]:focus + label .baseRadioButton-module_icon__3JVJ6 {\n  background: #f1f2f7;\n}\n\n/********** 選択されている **********/\n\n/* default */\n\ninput[type=\"radio\"]:checked + label svg {\n  fill: #353ebd;\n}\n\ninput[type=\"radio\"]:checked + label svg circle {\n  stroke: #353ebd;\n}\n\n/* default + hover */\n\ninput[type=\"radio\"]:checked + label:hover svg {\n  fill: #0f1192;\n}\n\ninput[type=\"radio\"]:checked + label:hover svg circle {\n  stroke: #0f1192;\n}\n\n/* disabled */\n\ninput[type=\"radio\"]:checked:disabled + label svg {\n  fill: #cfd4e0;\n}\n\ninput[type=\"radio\"]:checked:disabled + label svg circle {\n  stroke: #cfd4e0;\n}\n\n/* error（使われない想定） */\n\n.baseRadioButton-module_error__37XFC > input[type=\"radio\"]:checked + label svg {\n  fill: #de3226;\n}\n\n.baseRadioButton-module_error__37XFC > input[type=\"radio\"]:checked + label svg circle {\n  stroke: #de3226;\n}\n\n/* error + hover （使われない想定）*/\n\n.baseRadioButton-module_error__37XFC > input[type=\"radio\"]:checked + label:hover svg {\n  fill: #b1110c;\n}\n\n.baseRadioButton-module_error__37XFC > input[type=\"radio\"]:checked + label:hover svg circle {\n  stroke: #b1110c;\n}\n\n/********** 選択されていない **********/\n\n/* default */\n\ninput[type=\"radio\"] + label svg circle {\n  stroke: #949cb0;\n}\n\n/* default + hover */\n\ninput[type=\"radio\"] + label:hover svg circle {\n  stroke: #5f636d;\n}\n\n/* disabled */\n\ninput[type=\"radio\"]:disabled + label svg circle {\n  stroke: #cfd4e0;\n}\n\n/* error */\n\n.baseRadioButton-module_error__37XFC > input[type=\"radio\"] + label svg circle {\n  stroke: #de3226;\n}\n\n/* error + hover */\n\n.baseRadioButton-module_error__37XFC > input[type=\"radio\"] + label:hover svg circle {\n  stroke: #b1110c;\n}\n";
var styles$t = {"list":"baseRadioButton-module_list__3waxD","column":"baseRadioButton-module_column__zV1WJ","row":"baseRadioButton-module_row__3rd3w","element":"baseRadioButton-module_element__2rw59","radioButtonWrapper":"baseRadioButton-module_radioButtonWrapper__27TzT","input":"baseRadioButton-module_input__20PT-","label":"baseRadioButton-module_label__14O9O","labelInner":"baseRadioButton-module_labelInner__VG2Mo","text":"baseRadioButton-module_text__1-LyD","description":"baseRadioButton-module_description__Ib0nx","tags":"baseRadioButton-module_tags__2p_7c","icon":"baseRadioButton-module_icon__3JVJ6","error":"baseRadioButton-module_error__37XFC"};
styleInject(css_248z$u);

// ラジオボタンのみで使う予定のコンポーネント。
var RadioButtonIconWrapper = function RadioButtonIconWrapper(_ref) {
  var checked = _ref.checked;
  return /*#__PURE__*/React__namespace.default.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": checked ? "選択済み" : "未選択"
  }, checked ? (/*#__PURE__*/React__namespace.default.createElement("g", null, /*#__PURE__*/React__namespace.default.createElement("title", null, "\u9078\u629E\u6E08\u307F\u30A2\u30A4\u30B3\u30F3"), /*#__PURE__*/React__namespace.default.createElement("desc", null, "\u9078\u629E\u3057\u3066\u3044\u308B\u3053\u3068\u3092\u793A\u3057\u3066\u3044\u308B\u30A2\u30A4\u30B3\u30F3\u3067\u3059"), /*#__PURE__*/React__namespace.default.createElement("circle", {
    cx: "12",
    cy: "12.37",
    r: "11.5",
    fill: "white",
    stroke: "#353EBD"
  }), /*#__PURE__*/React__namespace.default.createElement("circle", {
    cx: "11.9999",
    cy: "12.37",
    r: "5.6",
    fill: "inherit",
    stroke: "#353EBD",
    strokeWidth: "2"
  }))) : (/*#__PURE__*/React__namespace.default.createElement("g", null, /*#__PURE__*/React__namespace.default.createElement("title", null, "\u672A\u9078\u629E\u30A2\u30A4\u30B3\u30F3"), /*#__PURE__*/React__namespace.default.createElement("desc", null, "\u9078\u629E\u3055\u308C\u3066\u3044\u306A\u3044\u3053\u3068\u3092\u793A\u3057\u3066\u3044\u308B\u30A2\u30A4\u30B3\u30F3\u3067\u3059"), /*#__PURE__*/React__namespace.default.createElement("circle", {
    cx: "12",
    cy: "12.37",
    r: "11.5",
    fill: "white",
    stroke: "#949CB0"
  }))));
};

var BaseRadioButtonItem = function BaseRadioButtonItem(_ref) {
  var formState = _ref.formState,
    option = _ref.option,
    disabled = _ref.disabled,
    value = _ref.value,
    onChange = _ref.onChange,
    onBlur = _ref.onBlur,
    onTouch = _ref.onTouch;
  var id = useRandomId("radioButton")("".concat(option.value));
  var checked = value === option.value;
  var handleChange = React.useCallback(function (e) {
    onTouch();
    onChange(e);
  }, [onChange, onTouch]);
  var handleBlur = React.useCallback(function (e) {
    onTouch();
    onBlur && onBlur(e);
  }, [onBlur, onTouch]);
  return /*#__PURE__*/React__namespace.default.createElement("li", {
    className: classnames__default.default(styles$t.element, styles$t.radioButtonWrapper, formState.matchType({
      "default": "",
      success: "",
      disabled: "",
      fail: styles$t.error
    }))
  }, /*#__PURE__*/React__namespace.default.createElement("input", {
    type: "radio",
    name: typeof option.name === "string" ? "".concat(id, "-").concat(option.name) : id,
    className: styles$t.input,
    disabled: disabled,
    checked: checked,
    value: option.value,
    onChange: handleChange,
    onBlur: handleBlur,
    id: id
  }), /*#__PURE__*/React__namespace.default.createElement("label", {
    htmlFor: id,
    className: styles$t.label
  }, /*#__PURE__*/React__namespace.default.createElement("span", {
    className: styles$t.labelInner
  }, /*#__PURE__*/React__namespace.default.createElement("span", {
    className: styles$t.icon
  }, /*#__PURE__*/React__namespace.default.createElement(RadioButtonIconWrapper, {
    checked: checked
  })), /*#__PURE__*/React__namespace.default.createElement("span", {
    className: styles$t.textWrap
  }, /*#__PURE__*/React__namespace.default.createElement("span", {
    className: styles$t.text
  }, option.name, React__namespace.default.Children.map(option.tags, function (child) {
    return /*#__PURE__*/React__namespace.default.createElement("span", {
      className: styles$t.tags
    }, child);
  })), !!option.description && (/*#__PURE__*/React__namespace.default.createElement("span", {
    className: styles$t.description
  }, option.description))))));
};
var BaseRadioButton = /*#__PURE__*/React__namespace.default.memo(function (_ref2) {
  var options = _ref2.options,
    value = _ref2.value,
    disabled = _ref2.disabled,
    id = _ref2.id,
    formState = _ref2.formState,
    _ref2$direction = _ref2.direction,
    direction = _ref2$direction === void 0 ? "column" : _ref2$direction,
    onTouch = _ref2.onTouch,
    onChange = _ref2.onChange,
    onBlur = _ref2.onBlur;
  return /*#__PURE__*/React__namespace.default.createElement("ul", {
    className: classnames__default.default(styles$t.list, direction === "row" ? styles$t.row : styles$t.column),
    id: id
  }, options.map(function (v) {
    return /*#__PURE__*/React__namespace.default.createElement(BaseRadioButtonItem, {
      key: v.value,
      formState: formState,
      option: v,
      onTouch: onTouch,
      disabled: disabled,
      value: value,
      onChange: onChange,
      onBlur: onBlur
    });
  }));
});
BaseRadioButton.displayName = "BaseRadioButton";

function useRadioButtonRender(_ref) {
  var options = _ref.options,
    value = _ref.value,
    disabled = _ref.disabled,
    _ref$direction = _ref.direction,
    direction = _ref$direction === void 0 ? "column" : _ref$direction,
    onChange = _ref.onChange,
    onBlur = _ref.onBlur;
  var render = React.useCallback(function (_ref2) {
    var formState = _ref2.formState,
      onTouch = _ref2.onTouch,
      id = _ref2.id;
    return /*#__PURE__*/React__namespace.default.createElement(BaseRadioButton, {
      id: id,
      direction: direction,
      formState: formState,
      options: options,
      onTouch: onTouch,
      disabled: disabled,
      value: value,
      onChange: onChange,
      onBlur: onBlur
    });
  }, [direction, options, disabled, value, onChange, onBlur]);
  return render;
}

var RadioButton = /*#__PURE__*/React__namespace.default.memo(function (_ref) {
  var options = _ref.options,
    value = _ref.value,
    disabled = _ref.disabled,
    label = _ref.label,
    required = _ref.required,
    id = _ref.id,
    description = _ref.description,
    errorMessages = _ref.errorMessages,
    _ref$shouldDisplayErr = _ref.shouldDisplayError,
    shouldDisplayError = _ref$shouldDisplayErr === void 0 ? false : _ref$shouldDisplayErr,
    _ref$direction = _ref.direction,
    direction = _ref$direction === void 0 ? "column" : _ref$direction,
    helperText = _ref.helperText,
    onChange = _ref.onChange,
    onBlur = _ref.onBlur;
  var render = useRadioButtonRender({
    options: options,
    value: value,
    disabled: disabled,
    onChange: onChange,
    onBlur: onBlur,
    direction: direction
  });
  return /*#__PURE__*/React__namespace.default.createElement(FormController, {
    label: label,
    description: description,
    required: required,
    disabled: disabled,
    id: id,
    onErrors: undefined,
    shouldDisplayError: shouldDisplayError,
    validator: undefined,
    onError: undefined,
    errorMessages: errorMessages,
    noValidate: false,
    render: render,
    helperText: helperText
  });
});
RadioButton.displayName = "RadioButton";

var css_248z$t = ":root {\n  /* Color styles */\n\n  /* Text-size styles */\n\n  /* Effect styles */\n  /* border-radius */\n}\n\n.baseInput-module_description__24LYs {\n  color: #4c505c;\n  font: 300 13px/18px Meiryo, Arial, system-ui, sans-serif;\n  margin-bottom: 8px;\n}\n\n.baseInput-module_wrap__2wAL7 {\n  padding-inline: 8px;\n  border-radius: 4px;\n  border: 1px solid #b2b8c8;\n  display: inline-flex;\n  align-items: center;\n  height: 36px;\n  width: auto;\n  box-sizing: border-box;\n  cursor: text;\n  position: relative;\n  background-color: #ffffff;\n}\n\n.baseInput-module_wrap__2wAL7.baseInput-module_withIcon__49GDJ {\n  padding-left: 48px;\n}\n\n.baseInput-module_input__15ap5 {\n  box-sizing: border-box;\n  width: 100%;\n  border: none;\n  background-color: #ffffff;\n  color: #262b38;\n  font: 300 14px/20px Meiryo, Arial, system-ui, sans-serif;\n  /* font-family: inherit; */\n  flex-grow: 1;\n  display: inline-block;\n  outline: none;\n  line-height: 1;\n  background-color: inherit;\n}\n\n.baseInput-module_input__15ap5::-moz-placeholder {\n  color: #949cb0;\n  font: 300 14px/20px Meiryo, Arial, system-ui, sans-serif;\n}\n\n.baseInput-module_input__15ap5::placeholder {\n  color: #949cb0;\n  font: 300 14px/20px Meiryo, Arial, system-ui, sans-serif;\n}\n\n.baseInput-module_wrap__2wAL7:not(.baseInput-module_disabled__1j7W6):hover {\n  border: 1px solid #262b38;\n}\n\n.baseInput-module_wrap__2wAL7.baseInput-module_disabled__1j7W6 {\n  color: #949cb0;\n  border: none;\n  cursor: not-allowed;\n}\n\n.baseInput-module_input__15ap5:disabled {\n  color: #949cb0;\n  border: none;\n  cursor: not-allowed;\n}\n\n.baseInput-module_wrap__2wAL7.baseInput-module_disabled__1j7W6 {\n  background-color: #e5e6ea;\n}\n\n.baseInput-module_input__15ap5:disabled::-moz-placeholder {\n  color: #949cb0;\n}\n\n.baseInput-module_input__15ap5:disabled::placeholder {\n  color: #949cb0;\n}\n\n.baseInput-module_wrap__2wAL7:focus-within {\n  outline: 1px solid #353ebd;\n  box-shadow: none;\n  background-color: #ffffff;\n  box-shadow: 0px 0px 5px rgba(53, 62, 189, 1);\n}\n\n.baseInput-module_input__15ap5:focus {\n  outline: 0;\n  box-shadow: none;\n}\n\n.baseInput-module_error__V3cGs.baseInput-module_wrap__2wAL7 {\n  border: 1px solid #de3226;\n  background-color: #fff5f6;\n}\n\n.baseInput-module_error__V3cGs.baseInput-module_wrap__2wAL7:not(:disabled):hover {\n  border: 1px solid #b1110c;\n  background-color: #fff5f6;\n}\n\n.baseInput-module_error__V3cGs.baseInput-module_wrap__2wAL7:not(:disabled):focus-within {\n  outline: 1px solid #b1110c;\n  box-shadow: none;\n  background-color: #fff5f6;\n  filter: drop-shadow(0px 0px 5px rgba(222, 50, 38, 0.7));\n}\n\n.baseInput-module_success__1A0Mq.baseInput-module_wrap__2wAL7 {\n  border: 1px solid #3aa393;\n  background-color: #ffffff;\n}\n\n.baseInput-module_success__1A0Mq.baseInput-module_wrap__2wAL7:not(:disabled):hover {\n  border: 1px solid #258675;\n  background-color: #ffffff;\n}\n\n.baseInput-module_success__1A0Mq.baseInput-module_wrap__2wAL7:not(:disabled):focus-within {\n  outline: 1px solid #258675;\n  background-color: #ffffff;\n  box-shadow: 0px 0px 5px #3aa393;\n}\n\n.baseInput-module_outerWrap__3Lmca {\n  display: flex;\n  align-items: center;\n  width: 100%;\n}\n\n.baseInput-module_wrap__2wAL7 {\n  position: relative;\n  width: auto;\n}\n\n.baseInput-module_wrap__2wAL7.baseInput-module_fullWidth__2bTGr {\n  width: 100%;\n}\n\n.baseInput-module_wrap__2wAL7.baseInput-module_default__1kbHp {\n  color: #949cb0;\n}\n\n.baseInput-module_wrap__2wAL7.baseInput-module_disabled__1j7W6 {\n  color: #949cb0;\n}\n\n.baseInput-module_wrap__2wAL7.baseInput-module_success__1A0Mq {\n  color: #3aa393;\n}\n\n.baseInput-module_wrap__2wAL7.baseInput-module_error__V3cGs {\n  color: #de3226;\n  padding-right: 48px;\n}\n\n.baseInput-module_warnIcon__lTs-0 {\n  position: absolute;\n  display: inline-block;\n  line-height: 1;\n  right: 12px;\n}\n\n.baseInput-module_prefixText__2sxOM {\n  color: #262b38;\n  font: 300 13px/18px Meiryo, Arial, system-ui, sans-serif;\n  margin-right: 8px;\n}\n";
var styles$s = {"description":"baseInput-module_description__24LYs","wrap":"baseInput-module_wrap__2wAL7","withIcon":"baseInput-module_withIcon__49GDJ","input":"baseInput-module_input__15ap5","disabled":"baseInput-module_disabled__1j7W6","error":"baseInput-module_error__V3cGs","success":"baseInput-module_success__1A0Mq","outerWrap":"baseInput-module_outerWrap__3Lmca","fullWidth":"baseInput-module_fullWidth__2bTGr","default":"baseInput-module_default__1kbHp","warnIcon":"baseInput-module_warnIcon__lTs-0","prefixText":"baseInput-module_prefixText__2sxOM"};
styleInject(css_248z$t);

var _excluded$7 = ["placeholder", "onChange", "onBlur", "disabled", "value", "maxLength", "className"],
  _excluded2 = ["formState", "onTouch", "onChange", "onBlur", "disabled", "placeholder", "value", "maxLength", "icon", "prefixText", "fullWidth"];
var BaseInputOuterWrap = function BaseInputOuterWrap(_ref) {
  var prefixText = _ref.prefixText,
    className = _ref.className,
    children = _ref.children;
  return /*#__PURE__*/React__namespace.createElement("div", {
    className: classnames__default.default(styles$s.outerWrap)
  }, !!prefixText && (/*#__PURE__*/React__namespace.createElement("span", {
    className: classnames__default.default(styles$s.prefixText, className)
  }, prefixText)), children);
};
var BaseInputWrap = function BaseInputWrap(_ref2) {
  var icon = _ref2.icon,
    _ref2$fullWidth = _ref2.fullWidth,
    fullWidth = _ref2$fullWidth === void 0 ? true : _ref2$fullWidth,
    className = _ref2.className,
    children = _ref2.children;
  return /*#__PURE__*/React__namespace.createElement("div", {
    className: classnames__default.default(styles$s.wrap, fullWidth && styles$s.fullWidth, !!icon && styles$s.withIcon, className)
  }, children, !!icon && icon);
};
var BaseInput = function BaseInput(_ref3) {
  var placeholder = _ref3.placeholder,
    onChange = _ref3.onChange,
    onBlur = _ref3.onBlur,
    disabled = _ref3.disabled,
    value = _ref3.value,
    maxLength = _ref3.maxLength,
    className = _ref3.className,
    props = _objectWithoutProperties(_ref3, _excluded$7);
  return /*#__PURE__*/React__namespace.createElement("input", _objectSpread2(_objectSpread2({}, props), {}, {
    placeholder: placeholder,
    disabled: disabled,
    value: value,
    onChange: onChange,
    onBlur: onBlur,
    className: classnames__default.default(styles$s.input, className),
    maxLength: maxLength
  }));
};
var BaseFormInput = /*#__PURE__*/React__namespace.memo(function (_ref4) {
  var formState = _ref4.formState,
    onTouch = _ref4.onTouch,
    onChange = _ref4.onChange,
    onBlur = _ref4.onBlur,
    disabled = _ref4.disabled,
    placeholder = _ref4.placeholder,
    value = _ref4.value,
    maxLength = _ref4.maxLength,
    icon = _ref4.icon,
    prefixText = _ref4.prefixText,
    _ref4$fullWidth = _ref4.fullWidth,
    fullWidth = _ref4$fullWidth === void 0 ? true : _ref4$fullWidth,
    props = _objectWithoutProperties(_ref4, _excluded2);
  // PRODUCTS-8794 数値コンポーネントに対してフォーカスが当たっている状態でスクロールして意図せず値を変更してしまう by chiharu-matsukura · Pull Request #1327 · graffer-inc/graffer-design-kit https://github.com/graffer-inc/graffer-design-kit/pull/1327
  var disableWheel = function disableWheel(e) {
    e.target && e.target.blur();
  };
  var handleWheel = React__namespace.useMemo(function () {
    return props.type === "number" ? disableWheel : undefined;
  }, [props.type]);
  var handleChange = React__namespace.useCallback(function (e) {
    onTouch();
    onChange(e);
  }, [onChange, onTouch]);
  var handleBlur = React__namespace.useCallback(function (e) {
    onTouch();
    onBlur && onBlur(e);
  }, [onBlur, onTouch]);
  return /*#__PURE__*/React__namespace.createElement(BaseInputOuterWrap, {
    prefixText: prefixText
  }, /*#__PURE__*/React__namespace.createElement(BaseInputWrap, {
    className: formState.matchType({
      "default": styles$s["default"],
      disabled: styles$s.disabled,
      success: styles$s.success,
      fail: styles$s.error
    }),
    icon: icon,
    fullWidth: fullWidth
  }, /*#__PURE__*/React__namespace.createElement(BaseInput, _objectSpread2(_objectSpread2({}, props), {}, {
    placeholder: placeholder,
    disabled: disabled,
    value: value,
    onChange: handleChange,
    onBlur: handleBlur,
    className: classnames__default.default(styles$s.input, formState.matchType({
      "default": "",
      disabled: "",
      success: styles$s.success,
      fail: styles$s.error
    })),
    onWheel: handleWheel,
    maxLength: maxLength
  })), formState.matchComponents({
    "default": null,
    success: null,
    disabled: null,
    fail: /*#__PURE__*/React__namespace.createElement(WarningIcon$1, {
      size: 24,
      className: styles$s.warnIcon
    })
  })));
});
BaseFormInput.displayName = "Input";

var _excluded$6 = ["description", "placeholder", "value", "disabled", "onChange", "onBlur", "id", "shouldDisplayError", "required", "label", "errorMessages", "maxLength", "prefixText", "helperText", "onError"];
var TextField = /*#__PURE__*/React__namespace.memo(function (_ref) {
  var description = _ref.description,
    placeholder = _ref.placeholder,
    value = _ref.value,
    disabled = _ref.disabled,
    onChange = _ref.onChange,
    onBlur = _ref.onBlur,
    id = _ref.id,
    shouldDisplayError = _ref.shouldDisplayError,
    required = _ref.required,
    label = _ref.label,
    errorMessages = _ref.errorMessages,
    maxLength = _ref.maxLength,
    prefixText = _ref.prefixText,
    helperText = _ref.helperText,
    onError = _ref.onError,
    props = _objectWithoutProperties(_ref, _excluded$6);
  var render = React__namespace.useCallback(function (_ref2) {
    var formState = _ref2.formState,
      onTouch = _ref2.onTouch,
      id = _ref2.id;
    return /*#__PURE__*/React__namespace.createElement(BaseFormInput, _objectSpread2(_objectSpread2({}, props), {}, {
      id: id,
      placeholder: placeholder,
      onChange: onChange,
      onBlur: onBlur,
      formState: formState,
      onTouch: onTouch,
      disabled: disabled,
      value: value,
      maxLength: maxLength,
      prefixText: prefixText
    }));
  }, [disabled, maxLength, onBlur, onChange, placeholder, prefixText, props, value]);
  return /*#__PURE__*/React__namespace.createElement(FormController, {
    label: label,
    description: description,
    required: required,
    disabled: disabled,
    id: id,
    shouldDisplayError: shouldDisplayError,
    validator: undefined,
    onError: onError,
    errorMessages: errorMessages,
    noValidate: false,
    render: render,
    helperText: helperText
  });
});
TextField.displayName = "TextField";

var css_248z$s = ":root {\n  /* Color styles */\n\n  /* Text-size styles */\n\n  /* Effect styles */\n  /* border-radius */\n}\n\n/**      content      **/\n\n.baseToggle-module_switchContent__30rsJ {\n  display: flex;\n  align-items: center;\n  position: relative;\n  border-radius: 60px;\n  width: 90px;\n  height: 26px;\n  overflow: hidden;\n  box-sizing: border-box;\n  margin: 0px 8px;\n  margin-left: 0px;\n  flex-shrink: 0;\n}\n\n/** content off **/\n\n.baseToggle-module_switchContent__30rsJ:before {\n  content: \"ON\";\n  display: flex;\n  align-items: center;\n  position: absolute;\n  justify-content: flex-end;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  color: #ffffff;\n  padding: 4px 10px;\n  border-radius: 60px;\n  border: 1px solid #b2b8c8;\n  background-color: #b2b8c8;\n}\n\n.baseToggle-module_switchContent__30rsJ:after {\n  content: \"\";\n  display: block;\n  position: absolute;\n  background-color: transparent;\n  width: 0;\n  height: 0;\n  top: 50%;\n  left: 50%;\n  border-radius: 60px;\n}\n\n/** content on **/\n\n.baseToggle-module_onContent__1bX0p.baseToggle-module_switchContent__30rsJ:after {\n  content: \"OFF\";\n  display: flex;\n  align-items: center;\n  padding: 4px 10px;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: #353ebd;\n  color: #ffffff;\n}\n\n/** content on-focus **/\n\n.baseToggle-module_onContent__1bX0p:focus {\n  box-shadow: 0px 0px 5px #353ebd;\n}\n\n/** content off-focus **/\n\n.baseToggle-module_offContent__3UGis:focus {\n  filter: drop-shadow(0px 0px 6px rgba(38, 43, 56, 0.5));\n}\n\n/** content off-disabled **/\n\n.baseToggle-module_offContent__3UGis:disabled::before {\n  border: 1px solid #949cb0;\n  background-color: #cfd4e0;\n  cursor: not-allowed;\n}\n\n/** circle on-disabled **/\n\n.baseToggle-module_onContent__1bX0p:disabled::after {\n  border: 1px solid #949cb0;\n  background-color: #cfd4e0;\n  cursor: not-allowed;\n}\n\n/**      circle      **/\n\n/** circle (off) **/\n\n.baseToggle-module_switchCircle__2-Y1F {\n  display: inline-flex;\n  align-items: center;\n  cursor: pointer;\n  position: absolute;\n  top: 0;\n  left: 0;\n  text-align: center;\n  height: 26px;\n  padding: 4px 10px;\n  border-radius: 60px;\n  border: 1px solid #949cb0;\n  background-color: #ffffff;\n  font-weight: 600;\n  color: #949cb0;\n  z-index: 10;\n}\n\n/** circle on **/\n\n.baseToggle-module_onContent__1bX0p .baseToggle-module_switchCircle__2-Y1F {\n  left: 47.5px;\n  border: 1px solid #353ebd;\n  color: #0f1192;\n}\n\n/** circle off-disabled **/\n\n.baseToggle-module_offContent__3UGis:disabled .baseToggle-module_switchCircle__2-Y1F {\n  border: 1px solid #949cb0;\n  cursor: not-allowed;\n}\n\n/** circle on-disabled **/\n\n.baseToggle-module_onContent__1bX0p:disabled .baseToggle-module_switchCircle__2-Y1F {\n  border: 1px solid #949cb0;\n  cursor: not-allowed;\n  color: #949cb0;\n}\n\n@media (hover: hover) {\n  /** content off-hover **/\n  .baseToggle-module_offContent__3UGis:not(:disabled):hover::before {\n    border: 1px solid #949cb0;\n    background-color: #949cb0;\n  }\n  /** circle off-hover **/\n  .baseToggle-module_offContent__3UGis:not(:disabled):hover .baseToggle-module_switchCircle__2-Y1F {\n    border: 1px solid #949cb0;\n  }\n  /** content on-hover **/\n  .baseToggle-module_onContent__1bX0p:not(:disabled):hover:after {\n    background-color: #0f1192;\n  }\n  /** circle on-hover **/\n  .baseToggle-module_onContent__1bX0p:not(:disabled):hover .baseToggle-module_switchCircle__2-Y1F {\n    border: 1px solid #0f1192;\n  }\n\n  /** circle on-hover **/\n  .baseToggle-module_offContent__3UGis:not(:disabled):focus .baseToggle-module_switchCircle__2-Y1F {\n    border: 1px solid #949cb0;\n  }\n}\n";
var styles$r = {"switchContent":"baseToggle-module_switchContent__30rsJ","onContent":"baseToggle-module_onContent__1bX0p","offContent":"baseToggle-module_offContent__3UGis","switchCircle":"baseToggle-module_switchCircle__2-Y1F"};
styleInject(css_248z$s);

var BaseToggle = function BaseToggle(_ref) {
  var id = _ref.id,
    onTouch = _ref.onTouch,
    checked = _ref.checked,
    disabled = _ref.disabled,
    onChange = _ref.onChange;
  return /*#__PURE__*/React__namespace.default.createElement("button", {
    id: id,
    onClick: function onClick() {
      onTouch();
      onChange(function (oldValue) {
        return !oldValue;
      });
    },
    className: classnames__default.default(styles$r.switchContent, checked ? styles$r.onContent : styles$r.offContent),
    disabled: disabled,
    "aria-label": "".concat(checked ? "ON" : "OFF", "\u304C\u9078\u629E\u3055\u308C\u3066\u3044\u307E\u3059")
  }, /*#__PURE__*/React__namespace.default.createElement("span", {
    className: styles$r.switchCircle
  }, checked ? "ON" : "OFF"));
};

function useToggleRender(_ref) {
  var checked = _ref.checked,
    disabled = _ref.disabled,
    onChange = _ref.onChange;
  var render = React.useCallback(function (_ref2) {
    var formState = _ref2.formState,
      onTouch = _ref2.onTouch,
      id = _ref2.id;
    return /*#__PURE__*/React__namespace.default.createElement(BaseToggle, {
      id: id,
      formState: formState,
      onTouch: onTouch,
      checked: checked,
      disabled: disabled,
      onChange: onChange
    });
  }, [checked, disabled, onChange]);
  return render;
}

var Toggle = function Toggle(_ref) {
  var onChange = _ref.onChange,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$shouldDisplayErr = _ref.shouldDisplayError,
    shouldDisplayError = _ref$shouldDisplayErr === void 0 ? false : _ref$shouldDisplayErr,
    errorMessages = _ref.errorMessages,
    label = _ref.label,
    required = _ref.required,
    checked = _ref.checked,
    id = _ref.id,
    description = _ref.description,
    helperText = _ref.helperText;
  var render = useToggleRender({
    onChange: onChange,
    checked: checked,
    disabled: disabled
  });
  return /*#__PURE__*/React__namespace.createElement(FormController, {
    label: label,
    description: description,
    required: required,
    disabled: disabled,
    id: id,
    errorMessages: errorMessages,
    shouldDisplayError: shouldDisplayError,
    validator: undefined,
    onError: undefined,
    noValidate: false,
    render: render,
    helperText: helperText
  });
};

var css_248z$r = ":root {\n  /* Color styles */\n\n  /* Text-size styles */\n\n  /* Effect styles */\n  /* border-radius */\n}\n\n.inlineController-module_wrapper__3hoLA {\n  display: flex;\n  align-items: center;\n}\n\n.inlineController-module_label__G6TH7 {\n  margin-right: 8px;\n  text-align: right;\n  white-space: nowrap;\n  min-width: 60px;\n  flex-shrink: 0;\n}\n\n@media screen and (max-width: 640px) {\n  .inlineController-module_wrapper__3hoLA {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .inlineController-module_label__G6TH7 {\n    margin-right: 0px;\n    margin-bottom: 8px;\n    text-align: left;\n  }\n}\n";
var styles$q = {"wrapper":"inlineController-module_wrapper__3hoLA","label":"inlineController-module_label__G6TH7"};
styleInject(css_248z$r);

var css_248z$q = ":root {\n  /* Color styles */\n\n  /* Text-size styles */\n\n  /* Effect styles */\n  /* border-radius */\n}\n\n.label-module_label__4ZCv9 {\n  font: 600 16px/24px Meiryo, Arial, system-ui, sans-serif;\n}\n";
var styles$p = {"label":"label-module_label__4ZCv9"};
styleInject(css_248z$q);

var Label = function Label(_ref) {
  var children = _ref.children,
    className = _ref.className,
    id = _ref.id;
  return /*#__PURE__*/React__namespace.createElement("label", {
    "data-testid": "test-inline-label-".concat(id),
    className: classnames__default.default(styles$p.label, className),
    htmlFor: id
  }, children);
};

var InlineController = function InlineController(_ref) {
  var id = _ref.id,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    label = _ref.label,
    render = _ref.render;
  var _React$useState = React__namespace.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    touched = _React$useState2[0],
    setTouched = _React$useState2[1];
  var formState = FormState.createNoValidate(touched, disabled);
  var handleOnTouch = React__namespace.useCallback(function () {
    setTouched(true);
  }, []);
  var generatedID = React__namespace.useMemo(function () {
    return id !== null && id !== void 0 ? id : generateID();
  }, [id]);
  var component = render({
    formState: formState,
    onTouch: handleOnTouch,
    id: generatedID
  });
  var labelComponent = React__namespace.useMemo(function () {
    var _a;
    return ((_a = Icons[label]) === null || _a === void 0 ? void 0 : _a.call(Icons, {
      size: 24
    })) || label;
  }, [label]);
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, /*#__PURE__*/React__namespace.createElement("div", {
    className: styles$q.wrapper
  }, !!label && (/*#__PURE__*/React__namespace.createElement(Label, {
    className: styles$q.label,
    id: generatedID
  }, labelComponent)), component));
};

function useInputRender(_ref) {
  var placeholder = _ref.placeholder,
    value = _ref.value,
    disabled = _ref.disabled,
    onChange = _ref.onChange,
    onBlur = _ref.onBlur,
    maxLength = _ref.maxLength;
  var render = React.useCallback(function (_ref2) {
    var formState = _ref2.formState,
      onTouch = _ref2.onTouch,
      id = _ref2.id;
    return /*#__PURE__*/React__namespace.default.createElement(BaseFormInput, {
      id: id,
      placeholder: placeholder,
      onChange: onChange,
      onBlur: onBlur,
      formState: formState,
      onTouch: onTouch,
      disabled: disabled,
      value: value,
      maxLength: maxLength
    });
  }, [placeholder, disabled, maxLength, onBlur, onChange, value]);
  return render;
}

/**
 * FilterContainer内で使用可能なコンポーネントです。
 * Formでは使用できません。
 * Formで使用する場合は、TextFieldを使用してください。
 */
var InlineTextField = function InlineTextField(_ref) {
  var id = _ref.id,
    placeholder = _ref.placeholder,
    value = _ref.value,
    disabled = _ref.disabled,
    label = _ref.label,
    name = _ref.name,
    maxLength = _ref.maxLength,
    onFocus = _ref.onFocus,
    onChange = _ref.onChange,
    onBlur = _ref.onBlur;
  var render = useInputRender({
    placeholder: placeholder,
    value: value,
    disabled: disabled,
    name: name,
    maxLength: maxLength,
    onFocus: onFocus,
    onChange: onChange,
    onBlur: onBlur
  });
  return /*#__PURE__*/React__namespace.createElement(InlineController, {
    render: render,
    disabled: disabled,
    label: label,
    id: id
  });
};

var css_248z$p = ".image-encode_check-background-image__3qtmR {\n  background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAM5SURBVHgBtVcxdtpAEJ1ZOXXwDUjnLvgEkBvIdpMO+wR2unRanSD4BJa7VIlyAkOXzqRzF3ICK7VB6z+7Kx5gIQSIX/hhaTX/7+zM7AxTXeiwhb9hQKpryHSYqI3/W/5tZogmTDwmykczopR0mtUxyxtX6LAdEEVYGhaEIBs7sjlaENWGsc6C6WRGeQwhE9pJAHasSEVM5sY/GeJ3PAX52t3hG4jtEak+ZIaOgAdTJySrL8Dumh/IuXk4I3O1aSflNkiDAmJoAhufymxwyYcdkP+Em1uBMfFLnA5oD6govGHmbyJCkTl70el4vQC/cyHPneIxNYB32FTuPJqteoIXyHF+/IhfbSw6bYp8jYjTIiZUsUACTsiVMV+aJheI6w2OVDiOHJeF84Bz/V+bOvrHFR0QgT4TL/TghQ9yFNYDLs+JbN4eGDajLKfzAvuzf0be/prpNKQmIdWzJP+9FzriBYXdF6QJNQgVn0c2qF0JX4IUNJI0B7ccQVceon4PqSEIORuj4dVRmQdsNXUru8oQd0xVed2d/B5Helm6CFzCKZeaklsNLvlHDaAW+Rzmj3DLEeCM1HOlYR3qsrMsI5edbSafo6U2rQh0GOJGi5RUsTUiFsltCd8CIqDy7LGbVKJW7nrlSmk1ef1G5L1wK+lkJBiqFk91qgsRgT6/K54H8UXfk0+2IRcg+Nu2i8L5JnBxH0XheJOBI8QCPpTuKCHmIZk8WSCfUF3Mix8nkgVDa3ypnSpH4Qnov9yZnGzp77lf+UjZBtI2lRzV+VhESJrtSu4hXRJ5bhvpCeqzkVuxtokNaVnxXVu4ilhSXom2Qojv6hvarXKu3ryBfTp8yoLeyTGC4jN3T/6b0dNvOgBUfHGNmPuKOLrNdfrdPite4oKw6YQGMpL2iZoGbLLJB8Ix9R5fEiAulaDCgkx6t0ZFuE77oaxeLJdiRHSA1tmLeJSWmvaEuN2TywbPVrNm7WAiZdfNf/VGrDIbPqh7VSlbOZod2bjga780hZB7ksJVMZqRlGtXU3qOwNzaM99qNHuzk/mIZeGH0wktXGR+Yu749xk7wXsMp2+FtHz/CJfyR7KNzHxaFiE7jeev3xe7XSJjRKkAAAAASUVORK5CYII=\");\n}.image-encode_fail-background-image__3LL46 {\n  background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAANvSURBVHgBxVddbtNAEJ4Zpy8UhIV6APehlXjCKQdoeoP0BIUTNJygyQloT0A5QcMJkl6AmCcQFcI8g8AVDRKKvcNM/FPXzc86lconOWtt1vO384tgiZHru+tr0CZDu4zsI6PHCK7+hwyR7IWyFxiA83Fi+s0oiGzo4rIDH13fW3PoSF7bOUMADpRZ6ZgrAnhCzi8IM5xOEtN7GgUhrCKAavywMWXcyZgO5eldxRDM006/eeRAC4AORNh2tn18FZvevG9mCpBpPRAinjKOY365TJNZNBwHu4h4INYIxRp7s2jcEuCz6/vk0BkDu4DY2/rx/hjugIsnfgeIXqsQhsz+9vcgmCtAobkw54T3tqObh1dFptRAXqOqJQoB0vujkZqdY9Ncxjz1EZg6XRxDuOyKykL8Tkwz9wnKD6jDpXcOr2w0X18jcTIlSAPHoday80qT2fSUR+bcUAigppelo6Fz1ztfhK2fwXEaTdDJeKYCZHEOGrewAhBNaHtWI6rMk77KXYpZXhjgd3VCDdmeaRkpDx5qnlA/oolDacJgPoV7A6ul3XXhTXIHu7r1J4FhDQrAMRSZ7S+CVd7P0ZBsqqvyJslUvsR9YFs8ciRwzfTBBH/V+BQ2hReBFC4pasTMHgN8g3tGzOYDAnqkFc7hehpUcQl8CavBJVgR5Yipe31lkDYT8B/gAD6WJVInDNUZYHWspIDwFd/jkDJn8DUpQE00YrMpTxNqQpOfJD6JAAwICYe6mVe2OpBwCjdrNiqKxHFauhow57Q2Mf3UD/CoDhEtJhcbO2f65IXFHnygv+ME+qRJQeuACNCqQ6jRwDeyaBpvZ+/Wgmsd0MrbnCYkQZJwt0TUTgdxouIdwNp/qpV3KoDGtEh0olb4tLHTsSGEiTkpBGC2KuNfnjw/1Morz0meR4qWTD1z4uBIwkPKs9mrNo+zkEeOTSLSlgwb0vIxh+OEi5bsVlMqrfSgjhA2yPtB8bVIrvtGU3ojFU//SHhfpIyQaWR7HYugZs+ZK+1q0zN3MMks4dmOWLNopE6NLTV7VfOFAijUJxKHuuIwh9lW37B5q43LotEsTWiaU7Cle+pw44np1hrNqprkI9b1LotvYFguZDytJ9lwqlcI2L/TcFrFdDx3NPFgCxGeSfB7UlHcnKFQSsdzMufjCViP5/8AyrLp4/rtmdYAAAAASUVORK5CYII=\");\n}.image-encode_down-arrow-background-image__guKgg {\n  background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAJCAYAAAA/33wPAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAB7SURBVHgBrZBhDYAgFIRvJiACEYxgBCMYwQYQgQZGMIIRiEAEK3jgYzo3xlC/7eMHPA52wD+ojstEV6rRjqKbZCQsDY1hWu6458FMdzrWM9JMuP+k9IpBGSMzPSpo6umCs4OMkj2Pxj4drt5yuMNLrITF7mZ8JHYx1IYOaasVQeOJ3XsAAAAASUVORK5CYII=\");\n}\n\n:root {\n  /* Color styles */\n\n  /* Text-size styles */\n\n  /* Effect styles */\n  /* border-radius */\n}\n\n.baseSelect-module_wrapper__2vQ0F {\n  position: relative;\n  width: 100%;\n}\n\n.baseSelect-module_select__sT7F_ {\n  height: 36px;\n  font: 300 14px/20px Meiryo, Arial, system-ui, sans-serif;\n  color: #262b38;\n  padding-left: 24px;\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n  border: 1px solid #949cb0;\n  border-radius: 4px;\n  outline: none;\n  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);\n  padding: 4px 40px 4px 16px;\n  cursor: pointer;\n  width: 100%;\n  background-repeat: no-repeat;\n  background-position: right 18.25px bottom 50%;\n  position: relative;\n}\n\n.baseSelect-module_select__sT7F_:focus {\n  border-color: #353ebd;\n  box-shadow: drop-shadow(0px 0px 4px rgba(57, 68, 179, 0.6));\n}\n\n.baseSelect-module_select__sT7F_:focus:hover {\n  background-color: #ffffff;\n  border-color: #7780d9;\n}\n\n.baseSelect-module_placeholder__2Uu_Q {\n  color: #949cb0;\n}\n\n.baseSelect-module_default__rUmmh:not(:disabled):hover {\n  border-color: #5f636d;\n}\n\n.baseSelect-module_default__rUmmh:not(:disabled):focus {\n  border-color: #353ebd;\n  box-shadow: 0px 0px 5px rgba(53, 62, 189, 1);\n}\n\n.baseSelect-module_success__2IzQA {\n  color: #262b38;\n}\n\n.baseSelect-module_fail__3sir2 {\n  color: #262b38;\n}\n\n.baseSelect-module_success__2IzQA {\n  border-color: #3aa393;\n}\n\n.baseSelect-module_success__2IzQA:not(:disabled):hover {\n  border-color: #258675;\n}\n\n.baseSelect-module_success__2IzQA:not(:disabled):focus {\n  border-color: #258675;\n  box-shadow: 0px 0px 5px #3aa393;\n}\n\n.baseSelect-module_fail__3sir2 {\n  border-color: #de3226;\n}\n\n.baseSelect-module_fail__3sir2 {\n  background-color: #fff5f6;\n  border-color: #de3226;\n}\n\n.baseSelect-module_select__sT7F_:focus.baseSelect-module_fail__3sir2 {\n  background-color: #fff5f6;\n  border-color: #de3226;\n}\n\n.baseSelect-module_fail__3sir2:not(:disabled):hover {\n  border-color: #b1110c;\n}\n\n.baseSelect-module_fail__3sir2:not(:disabled):focus {\n  border-color: #b1110c;\n  filter: drop-shadow(0px 0px 5px rgba(222, 50, 38, 0.7));\n}\n\n.baseSelect-module_select__sT7F_:disabled {\n  background-color: #f1f2f7;\n  border-color: #f1f2f7;\n  color: #949cb0;\n  box-shadow: none;\n  cursor: not-allowed;\n}\n\n.baseSelect-module_indicator__1cmee {\n  position: absolute;\n  right: 16px;\n  top: 8px;\n}\n";
var styles$o = {"wrapper":"baseSelect-module_wrapper__2vQ0F","select":"baseSelect-module_select__sT7F_ image-encode_down-arrow-background-image__guKgg","placeholder":"baseSelect-module_placeholder__2Uu_Q","default":"baseSelect-module_default__rUmmh","success":"baseSelect-module_success__2IzQA","fail":"baseSelect-module_fail__3sir2","indicator":"baseSelect-module_indicator__1cmee"};
styleInject(css_248z$p);

/**
 * GCDK内部で使用するセレクトボックスです。
 * 外部公開は禁止します。
 * @param param0
 * @returns
 */
var BaseSelect = function BaseSelect(_ref) {
  var options = _ref.options,
    value = _ref.value,
    disabled = _ref.disabled,
    id = _ref.id,
    name = _ref.name,
    _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? "選択してください" : _ref$placeholder,
    onFocus = _ref.onFocus,
    onChange = _ref.onChange,
    onBlur = _ref.onBlur,
    formState = _ref.formState;
  return /*#__PURE__*/React__namespace.default.createElement("div", {
    className: styles$o.wrapper
  }, /*#__PURE__*/React__namespace.default.createElement("select", {
    id: id,
    name: name,
    className: classnames__default.default(styles$o.select, formState.matchType({
      "default": styles$o["default"],
      success: styles$o.success,
      fail: styles$o.fail,
      disabled: ""
    })),
    value: value,
    onChange: onChange,
    onBlur: onBlur,
    onFocus: onFocus,
    disabled: disabled,
    "aria-invalid": formState.matchType({
      "default": false,
      disabled: false,
      success: false,
      fail: true
    })
  }, /*#__PURE__*/React__namespace.default.createElement("option", {
    className: styles$o.placeholder,
    hidden: true
  }, placeholder), options.map(function (o) {
    return /*#__PURE__*/React__namespace.default.createElement("option", {
      key: o.value,
      value: o.value
    }, o.name);
  })));
};

function useSelectRender(_ref) {
  var options = _ref.options,
    value = _ref.value,
    disabled = _ref.disabled,
    name = _ref.name,
    _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? "選択してください" : _ref$placeholder,
    onFocus = _ref.onFocus,
    onChange = _ref.onChange,
    onBlur = _ref.onBlur;
  return React.useCallback(function (_ref2) {
    var id = _ref2.id,
      onTouch = _ref2.onTouch,
      formState = _ref2.formState;
    var handleChange = function handleChange(e) {
      onTouch();
      onChange(e.currentTarget.value);
    };
    var handleBlur = function handleBlur(e) {
      onTouch();
      onBlur && onBlur(e);
    };
    return /*#__PURE__*/React__namespace.default.createElement(BaseSelect, {
      id: id,
      name: name,
      value: value,
      onChange: handleChange,
      onBlur: handleBlur,
      onFocus: onFocus,
      disabled: disabled,
      "aria-invalid": formState.matchType({
        "default": false,
        disabled: false,
        success: false,
        fail: true
      }),
      placeholder: placeholder,
      options: options,
      formState: formState,
      onTouch: onTouch
    });
  }, [disabled, name, onBlur, onChange, onFocus, options, placeholder, value]);
}

var Select = function Select(_ref) {
  var options = _ref.options,
    value = _ref.value,
    disabled = _ref.disabled,
    label = _ref.label,
    required = _ref.required,
    id = _ref.id,
    description = _ref.description,
    errorMessages = _ref.errorMessages,
    _ref$shouldDisplayErr = _ref.shouldDisplayError,
    shouldDisplayError = _ref$shouldDisplayErr === void 0 ? false : _ref$shouldDisplayErr,
    name = _ref.name,
    _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? "選択してください" : _ref$placeholder,
    helperText = _ref.helperText,
    onFocus = _ref.onFocus,
    onChange = _ref.onChange,
    onBlur = _ref.onBlur;
  var render = useSelectRender({
    options: options,
    value: value,
    disabled: disabled,
    name: name,
    placeholder: placeholder,
    onFocus: onFocus,
    onChange: onChange,
    onBlur: onBlur
  });
  return /*#__PURE__*/React__namespace.default.createElement(FormController, {
    label: label,
    description: description,
    required: required,
    disabled: disabled,
    id: id,
    shouldDisplayError: shouldDisplayError,
    validator: undefined,
    onError: undefined,
    errorMessages: errorMessages,
    noValidate: false,
    render: render,
    helperText: helperText
  });
};

var css_248z$o = ":root {\n  /* Color styles */\n\n  /* Text-size styles */\n\n  /* Effect styles */\n  /* border-radius */\n}\n\n.baseReactSelect-module_selectWrapper__Ya-cN .baseReactSelect-module_control__3UxSG {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  font: 300 14px/20px Meiryo, Arial, system-ui, sans-serif;\n  color: #262b38;\n  padding-left: 24px;\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n  border-radius: 4px;\n  outline: none;\n  width: 100%;\n  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);\n  padding: 4px 16px;\n  cursor: pointer;\n  background-repeat: no-repeat;\n  background-position: right 18.25px bottom 50%;\n  border: 1px solid #949cb0;\n}\n\n.baseReactSelect-module_selectWrapper__Ya-cN .baseReactSelect-module_controlFocus__1W4g8 {\n  border: 1px solid #353ebd;\n  box-shadow: drop-shadow(0px 0px 4px rgba(57, 68, 179, 0.6));\n}\n\n.baseReactSelect-module_selectWrapper__Ya-cN .baseReactSelect-module_controlFocus__1W4g8:hover {\n  border: 1px solid #ffffff;\n  border-color: #7780d9;\n}\n\n.baseReactSelect-module_selectWrapper__Ya-cN .baseReactSelect-module_placeholder__2DMy0 {\n  color: #262b38;\n}\n\n.baseReactSelect-module_selectWrapper__Ya-cN .baseReactSelect-module_valueContainer__KFePK {\n  height: auto;\n}\n\n.baseReactSelect-module_selectWrapper__Ya-cN.baseReactSelect-module_default__1cNSA:not(:disabled):hover {\n  border-color: #5f636d;\n}\n\n.baseReactSelect-module_selectWrapper__Ya-cN.baseReactSelect-module_default__1cNSA:not(:disabled) .baseReactSelect-module_controlFocus__1W4g8 {\n  border-color: #353ebd;\n  box-shadow: 0px 0px 5px rgba(53, 62, 189, 1);\n}\n\n.baseReactSelect-module_selectWrapper__Ya-cN.baseReactSelect-module_success__3HEK8 .baseReactSelect-module_control__3UxSG {\n  color: #262b38;\n}\n\n.baseReactSelect-module_selectWrapper__Ya-cN.baseReactSelect-module_fail__3O1XU .baseReactSelect-module_control__3UxSG {\n  color: #262b38;\n}\n\n.baseReactSelect-module_selectWrapper__Ya-cN.baseReactSelect-module_success__3HEK8 .baseReactSelect-module_control__3UxSG {\n  border-color: #3aa393;\n}\n\n.baseReactSelect-module_selectWrapper__Ya-cN.baseReactSelect-module_success__3HEK8 .baseReactSelect-module_control__3UxSG:not(:disabled):hover {\n  border-color: #258675;\n}\n\n.baseReactSelect-module_selectWrapper__Ya-cN.baseReactSelect-module_success__3HEK8 .baseReactSelect-module_control__3UxSG:not(:disabled).baseReactSelect-module_controlFocus__1W4g8 {\n  border-color: #258675;\n  box-shadow: 0px 0px 5px #3aa393;\n}\n\n.baseReactSelect-module_selectWrapper__Ya-cN.baseReactSelect-module_fail__3O1XU .baseReactSelect-module_control__3UxSG {\n  border-color: #de3226;\n}\n\n.baseReactSelect-module_selectWrapper__Ya-cN.baseReactSelect-module_fail__3O1XU .baseReactSelect-module_control__3UxSG {\n  background-color: #fff5f6;\n  border-color: #de3226;\n}\n\n.baseReactSelect-module_selectWrapper__Ya-cN.baseReactSelect-module_fail__3O1XU .baseReactSelect-module_control__3UxSG.baseReactSelect-module_controlFocus__1W4g8 {\n  background-color: #fff5f6;\n  border-color: #de3226;\n}\n\n.baseReactSelect-module_selectWrapper__Ya-cN.baseReactSelect-module_fail__3O1XU:not(:disabled):hover {\n  border-color: #b1110c;\n}\n\n.baseReactSelect-module_selectWrapper__Ya-cN .baseReactSelect-module_menu__T7vBe {\n  z-index: 100;\n}\n\n.baseReactSelect-module_selectWrapper__Ya-cN .baseReactSelect-module_option__vFl7W {\n  cursor: pointer;\n  background-color: #ffffff;\n}\n\n.baseReactSelect-module_selectWrapper__Ya-cN .baseReactSelect-module_option__vFl7W:hover {\n  background-color: #f1f2f7;\n}\n\n.baseReactSelect-module_selectWrapper__Ya-cN .baseReactSelect-module_optionSelected__2kmW9 {\n  background-color: #f1f2f7;\n  color: #262b38;\n}\n\n.baseReactSelect-module_selectWrapper__Ya-cN.baseReactSelect-module_fail__3O1XU .baseReactSelect-module_control__3UxSG:not(:disabled).baseReactSelect-module_controlFocus__1W4g8 {\n  border-color: #b1110c;\n  filter: drop-shadow(0px 0px 5px rgba(222, 50, 38, 0.7));\n}\n\n.baseReactSelect-module_selectWrapper__Ya-cN .baseReactSelect-module_control__3UxSG.baseReactSelect-module_select__32Eag:disabled {\n  background-color: #f1f2f7;\n  border-color: #f1f2f7;\n  color: #949cb0;\n  box-shadow: none;\n  cursor: not-allowed;\n}\n\n.baseReactSelect-module_indicatorSeparator__3eaxR {\n  display: none;\n}\n";
var styles$n = {"selectWrapper":"baseReactSelect-module_selectWrapper__Ya-cN","control":"baseReactSelect-module_control__3UxSG","controlFocus":"baseReactSelect-module_controlFocus__1W4g8","placeholder":"baseReactSelect-module_placeholder__2DMy0","valueContainer":"baseReactSelect-module_valueContainer__KFePK","default":"baseReactSelect-module_default__1cNSA","success":"baseReactSelect-module_success__3HEK8","fail":"baseReactSelect-module_fail__3O1XU","menu":"baseReactSelect-module_menu__T7vBe","option":"baseReactSelect-module_option__vFl7W","optionSelected":"baseReactSelect-module_optionSelected__2kmW9","select":"baseReactSelect-module_select__32Eag","indicatorSeparator":"baseReactSelect-module_indicatorSeparator__3eaxR"};
styleInject(css_248z$o);

var _excluded$5 = ["disabled", "id", "name", "placeholder", "formState", "isMulti", "width", "onTouch", "onChange", "onBlur"];
var DropdownIndicator = function DropdownIndicator() {
  return /*#__PURE__*/React__namespace.default.createElement(ArrowDownIcon, {
    size: 24
  });
};
var BaseReactSelect = function BaseReactSelect(_ref) {
  var disabled = _ref.disabled,
    id = _ref.id,
    name = _ref.name,
    _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? "選択してください" : _ref$placeholder,
    formState = _ref.formState,
    _ref$isMulti = _ref.isMulti,
    isMulti = _ref$isMulti === void 0 ? false : _ref$isMulti,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? "100%" : _ref$width,
    onTouch = _ref.onTouch,
    onChange = _ref.onChange,
    onBlur = _ref.onBlur,
    props = _objectWithoutProperties(_ref, _excluded$5);
  var handleChange = React.useCallback(function (newValue, actionMeta) {
    onTouch();
    onChange && onChange(newValue, actionMeta);
  }, [onChange, onTouch]);
  var handleBlur = React.useCallback(function (e) {
    onTouch();
    onBlur && onBlur(e);
  }, [onBlur, onTouch]);
  return /*#__PURE__*/React__namespace.default.createElement(Select__default.default, _objectSpread2(_objectSpread2({}, props), {}, {
    id: id,
    name: name,
    className: classnames__default.default(styles$n.selectWrapper, formState.matchType({
      "default": styles$n["default"],
      success: styles$n.success,
      fail: styles$n.fail,
      disabled: ""
    })),
    components: _objectSpread2(_objectSpread2({}, props.components), {}, {
      DropdownIndicator: DropdownIndicator
    }),
    classNamePrefix: "react-select",
    styles: {
      container: function container(styles) {
        return _objectSpread2(_objectSpread2({}, styles), {}, {
          width: width,
          minWidth: width === "auto" ? "300px" : undefined,
          minHeight: "36px"
        });
      },
      valueContainer: function valueContainer(styles) {
        return _objectSpread2(_objectSpread2({}, styles), {}, {
          padding: "0px"
        });
      },
      input: function input(styles) {
        return _objectSpread2(_objectSpread2({}, styles), {}, {
          margin: "0px"
        });
      },
      indicatorsContainer: function indicatorsContainer(styles) {
        return _objectSpread2(_objectSpread2({}, styles), {}, {
          paddingLeft: "32px"
        });
      },
      dropdownIndicator: function dropdownIndicator(styles) {
        return _objectSpread2(_objectSpread2({}, styles), {}, {
          paddingTop: 7,
          paddingBottom: 7
        });
      },
      clearIndicator: function clearIndicator(styles) {
        return _objectSpread2(_objectSpread2({}, styles), {}, {
          paddingTop: 7,
          paddingBottom: 7
        });
      }
    },
    classNames: {
      control: function control(state) {
        return classnames__default.default(styles$n.control, state.isFocused && styles$n.controlFocus);
      },
      placeholder: function placeholder() {
        return styles$n.placeholder;
      },
      valueContainer: function valueContainer() {
        return styles$n.valueContainer;
      },
      indicatorsContainer: function indicatorsContainer() {
        return styles$n.indicatorsContainer;
      },
      indicatorSeparator: function indicatorSeparator() {
        return styles$n.indicatorSeparator;
      },
      menu: function menu() {
        return styles$n.menu;
      },
      option: function option(state) {
        return classnames__default.default(styles$n.option, state.isSelected && styles$n.optionSelected, state.isFocused && styles$n.optionSelected);
      }
    },
    placeholder: placeholder,
    onChange: handleChange,
    onBlur: handleBlur,
    isDisabled: disabled,
    "aria-invalid": formState.matchType({
      "default": false,
      disabled: false,
      success: false,
      fail: true
    }),
    isMulti: isMulti
  }));
};

function useReactSelectRender(props) {
  return React.useCallback(function (_ref) {
    var id = _ref.id,
      onTouch = _ref.onTouch,
      formState = _ref.formState;
    return /*#__PURE__*/React__namespace.default.createElement(BaseReactSelect, _objectSpread2(_objectSpread2({}, props), {}, {
      id: id,
      onTouch: onTouch,
      formState: formState
    }));
  }, [props]);
}

var _excluded$4 = ["disabled", "label", "required", "id", "description", "errorMessages", "shouldDisplayError", "name", "placeholder", "isMulti", "onChange", "onBlur", "helperText"];
var ReactSelect = function ReactSelect(_ref) {
  var disabled = _ref.disabled,
    label = _ref.label,
    required = _ref.required,
    id = _ref.id,
    description = _ref.description,
    errorMessages = _ref.errorMessages,
    _ref$shouldDisplayErr = _ref.shouldDisplayError,
    shouldDisplayError = _ref$shouldDisplayErr === void 0 ? false : _ref$shouldDisplayErr,
    name = _ref.name,
    _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? "選択してください" : _ref$placeholder,
    _ref$isMulti = _ref.isMulti,
    isMulti = _ref$isMulti === void 0 ? false : _ref$isMulti,
    onChange = _ref.onChange,
    onBlur = _ref.onBlur,
    helperText = _ref.helperText,
    props = _objectWithoutProperties(_ref, _excluded$4);
  var render = useReactSelectRender(_objectSpread2({
    disabled: disabled,
    name: name,
    placeholder: placeholder,
    isMulti: isMulti,
    onChange: onChange,
    onBlur: onBlur
  }, props));
  return /*#__PURE__*/React__namespace.default.createElement(FormController, {
    label: label,
    description: description,
    required: required,
    disabled: disabled,
    id: id,
    shouldDisplayError: shouldDisplayError,
    validator: undefined,
    onError: undefined,
    errorMessages: errorMessages,
    noValidate: false,
    render: render,
    helperText: helperText
  });
};

var css_248z$n = ":root {\n  /* Color styles */\n\n  /* Text-size styles */\n\n  /* Effect styles */\n  /* border-radius */\n}\n\n.tab-panel-group-module_tabPanelWrapper__17rRA {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.tab-panel-group-module_tabs__38Mrz {\n  -webkit-overflow-scrolling: touch;\n  align-items: stretch;\n  display: flex;\n  font-size: 1rem;\n  justify-content: space-between;\n  overflow: hidden;\n  overflow-x: auto;\n  white-space: nowrap;\n}\n\n.tab-panel-group-module_tablist__XuQ7i {\n  align-items: center;\n  border-bottom-color: #dbdbdb;\n  border-bottom-style: solid;\n  border-bottom-width: 1px;\n  display: flex;\n  flex-grow: 1;\n  flex-shrink: 0;\n  justify-content: flex-start;\n}\n\n.tab-panel-group-module_tabItem__xz1kv {\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  margin: 0px 20px;\n  vertical-align: top;\n  padding-bottom: 8px;\n}\n\n.tab-panel-group-module_baseline__UZ4pq {\n  border-bottom-color: #b2b8c8;\n}\n\n.tab-panel-group-module_active__3e2X2 {\n  border-bottom: 2px solid #353ebd;\n  margin-bottom: -1px;\n}\n\n.tab-panel-group-module_tabItem__xz1kv[aria-selected=\"true\"] {\n  font: 600 16px/24px Meiryo, Arial, system-ui, sans-serif;\n  color: #353ebd;\n  /* 選択中タブの場合はブルーの下線分で上にボタンが少しずれるので、下線分を引いた値を設定 */\n  padding-bottom: 7px;\n}\n\n.tab-panel-group-module_tabItem__xz1kv[aria-selected=\"false\"] {\n  font: 600 16px/24px Meiryo, Arial, system-ui, sans-serif;\n  color: #4c505c;\n}\n\n.tab-panel-group-module_tabRing__3VE3q {\n  padding: 4px 8px;\n  border-radius: 4px;\n}\n\n.tab-panel-group-module_tabItem__xz1kv:hover span.tab-panel-group-module_tabRing__3VE3q {\n  background-color: #f1f2f7;\n}\n\n.tab-panel-group-module_tabItem__xz1kv:active span.tab-panel-group-module_tabRing__3VE3q {\n  background-color: #e5e6ea;\n}\n\n.tab-panel-group-module_tabItem__xz1kv:focus-visible span.tab-panel-group-module_tabRing__3VE3q {\n  outline-offset: -2px;\n  outline: 2px solid #353ebd;\n}\n";
var styles$m = {"tabPanelWrapper":"tab-panel-group-module_tabPanelWrapper__17rRA","tabs":"tab-panel-group-module_tabs__38Mrz","tablist":"tab-panel-group-module_tablist__XuQ7i","tabItem":"tab-panel-group-module_tabItem__xz1kv","baseline":"tab-panel-group-module_baseline__UZ4pq","active":"tab-panel-group-module_active__3e2X2","tabRing":"tab-panel-group-module_tabRing__3VE3q"};
styleInject(css_248z$n);

var TabPanelGroup = function TabPanelGroup(_ref) {
  var tabItems = _ref.tabItems;
  // 【アクセシビリティ対応】TabPanelGroupコンポーネントでは、各idを生成し、tab（button）部分とtabPanel部分の関連付けをしております。
  // (参考) https://developer.mozilla.org/ja/docs/Web/Accessibility/ARIA/Roles/tab_role
  var id = React__namespace.useId();
  var tabItemsWithIds = React__namespace.useMemo(function () {
    return tabItems.map(function (item, index) {
      return _objectSpread2(_objectSpread2({}, item), {}, {
        // tabpanelの「id」属性と、tab（button）の「aria-control」属性に設定する値です。
        tabPanelId: "tab-panel-".concat(id, "-").concat(index, "-").concat(item.label),
        // tab（button）の「id」属性と、 tabpanelの「aria-labelledby」属性に設定する値です。
        tabId: "tab-".concat(id, "-").concat(index, "-").concat(item.label)
      });
    });
  }, [id, tabItems]);
  return /*#__PURE__*/React__namespace.createElement("div", {
    className: styles$m.tabPanelWrapper
  }, /*#__PURE__*/React__namespace.createElement("div", {
    className: styles$m.tabs
  }, /*#__PURE__*/React__namespace.createElement("div", {
    role: "tablist",
    className: "".concat(styles$m.tablist, " ").concat(styles$m.baseline)
  }, tabItemsWithIds.map(function (i, index) {
    return !i.hidden && (/*#__PURE__*/React__namespace.createElement("button", {
      id: i.tabId,
      type: "button",
      role: "tab",
      "aria-selected": i.isActive,
      "aria-controls": i.tabPanelId,
      onClick: i.onClick,
      className: "".concat(styles$m.tabItem, " ").concat(i.isActive ? styles$m.active : ""),
      key: "".concat(i.tabId, "-").concat(index)
    }, /*#__PURE__*/React__namespace.createElement("span", {
      className: styles$m.tabRing
    }, i.label)));
  }))), tabItemsWithIds.map(function (i, index) {
    return /*#__PURE__*/React__namespace.createElement("div", {
      role: "tabpanel",
      id: i.tabPanelId,
      "aria-labelledby": i.tabId,
      tabIndex: 0,
      hidden: !i.isActive,
      key: "".concat(i.tabPanelId, "-").concat(index)
    }, i.panelNode);
  }));
};

/**
 * 全角数字とハイフンを半角数字に変換する
 * @param value
 * @returns
 */
var convertFullToHalfWidth = function convertFullToHalfWidth(value) {
  if (!value) return "";
  return value.replace(/[０-９ー]/g, function (s) {
    if (s === "ー") return "-";
    return String.fromCharCode(s.charCodeAt(0) - 0xfee0);
  });
};
/**
 * ハイフンを取り除く
 * @param value
 * @returns
 */
var excludeHyphen = function excludeHyphen(value) {
  if (!value) return "";
  return value.replace(new RegExp("-", "g"), "");
};

var css_248z$m = ":root {\n  /* Color styles */\n\n  /* Text-size styles */\n\n  /* Effect styles */\n  /* border-radius */\n}\n\n.telTextField-module_icon__2ICWW {\n  fill: #949cb0;\n  position: absolute;\n  top: 6px;\n  left: 16px;\n}\n";
var styles$l = {"icon":"telTextField-module_icon__2ICWW"};
styleInject(css_248z$m);

var TelTextFieldValidator = /*#__PURE__*/function () {
  function TelTextFieldValidator(_ref) {
    var value = _ref.value;
    _classCallCheck(this, TelTextFieldValidator);
    this.value = value;
  }
  return _createClass(TelTextFieldValidator, [{
    key: "validateTelString",
    value: function validateTelString() {
      if (!this.value) return true;
      if (!this.value.match(/^[0-9-]+$/)) {
        return false;
      }
      return true;
    }
  }, {
    key: "validate",
    value: function validate() {
      if (!this.validateTelString()) return "\u6570\u5B57\u4EE5\u5916\u306E\u6587\u5B57\u304C\u542B\u307E\u308C\u3066\u3044\u307E\u3059\u3002";
      return undefined;
    }
  }], [{
    key: "create",
    value: function create(props) {
      return new TelTextFieldValidator(props);
    }
  }]);
}();

var _excluded$3 = ["description", "placeholder", "value", "disabled", "setValue", "onBlur", "id", "shouldDisplayError", "required", "label", "errorMessages", "maxLength", "helperText", "onError"];
var TelTextField = function TelTextField(_ref) {
  var description = _ref.description,
    placeholder = _ref.placeholder,
    value = _ref.value,
    disabled = _ref.disabled,
    setValue = _ref.setValue,
    onBlur = _ref.onBlur,
    id = _ref.id,
    shouldDisplayError = _ref.shouldDisplayError,
    required = _ref.required,
    label = _ref.label,
    errorMessages = _ref.errorMessages,
    maxLength = _ref.maxLength,
    helperText = _ref.helperText,
    onError = _ref.onError,
    props = _objectWithoutProperties(_ref, _excluded$3);
  var handleOnBlur = React.useCallback(function (e) {
    var value = excludeHyphen(e.target.value);
    setValue(value);
    onBlur && onBlur(e);
  }, [onBlur, setValue]);
  var handleOnChange = React.useCallback(function (e) {
    var value = convertFullToHalfWidth(e.target.value);
    setValue(value);
  }, [setValue]);
  var generatedID = id !== null && id !== void 0 ? id : generateID("telTextbox");
  var validator = TelTextFieldValidator.create({
    value: value
  });
  var render = React.useCallback(function (_ref2) {
    var formState = _ref2.formState,
      onTouch = _ref2.onTouch;
    return /*#__PURE__*/React__namespace.default.createElement(BaseFormInput, _objectSpread2(_objectSpread2({}, props), {}, {
      type: "tel",
      inputMode: "tel",
      placeholder: placeholder,
      onChange: handleOnChange,
      onBlur: handleOnBlur,
      formState: formState,
      onTouch: onTouch,
      disabled: disabled,
      value: value,
      maxLength: maxLength,
      fullWidth: false,
      icon: /*#__PURE__*/React__namespace.default.createElement(PhoneIcon, {
        className: styles$l.icon,
        size: 24
      })
    }));
  }, [disabled, handleOnBlur, handleOnChange, maxLength, placeholder, props, value]);
  return /*#__PURE__*/React__namespace.default.createElement(FormController, {
    label: label,
    helperText: helperText,
    description: description,
    required: required,
    disabled: disabled,
    id: generatedID,
    shouldDisplayError: shouldDisplayError,
    validator: validator,
    onError: onError,
    errorMessages: errorMessages,
    noValidate: false,
    render: render
  });
};

var css_248z$l = ":root {\n  /* Color styles */\n\n  /* Text-size styles */\n\n  /* Effect styles */\n  /* border-radius */\n}\n\n.copyTextbox-module_wrapper__1Kude {\n  display: flex;\n  align-items: center;\n}\n\n.copyTextbox-module_wrapper__1Kude button {\n  border-top-left-radius: 0px;\n  border-bottom-left-radius: 0px;\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n  height: 36px;\n  width: 82px !important;\n  min-width: 82px !important;\n}\n\n/* iconの位置がズレるため調整 */\n\n.copyTextbox-module_wrapper__1Kude button svg {\n  margin-top: 4px;\n}\n\n.copyTextbox-module_wrapper__1Kude .copyTextbox-module_inputWrap__2zDLA {\n  border: 1px solid #949cb0 !important;\n  border-top-right-radius: 0px;\n  border-bottom-right-radius: 0px;\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n  border-right: none !important;\n  color: #949cb0 !important;\n  background-color: #ffffff !important;\n}\n\n.copyTextbox-module_wrapper__1Kude .copyTextbox-module_icon__3e_3B {\n  fill: #949cb0;\n  position: absolute;\n  top: 10px;\n  left: 16px;\n}\n\n@media screen and (max-width: 800px) {\n  .copyTextbox-module_wrapper__1Kude button {\n    width: 82px !important;\n  }\n}\n";
var styles$k = {"wrapper":"copyTextbox-module_wrapper__1Kude","inputWrap":"copyTextbox-module_inputWrap__2zDLA","icon":"copyTextbox-module_icon__3e_3B"};
styleInject(css_248z$l);

function useCopyToClipboard(_ref) {
  var _ref$resetInterval = _ref.resetInterval,
    resetInterval = _ref$resetInterval === void 0 ? 2000 : _ref$resetInterval,
    value = _ref.value;
  var _useState = React.useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isCopied = _useState2[0],
    setIsCopied = _useState2[1];
  var handleCopy = React__namespace.default.useCallback(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!(typeof value === "string" || typeof value === "number")) {
            _context.next = 5;
            break;
          }
          navigator.clipboard.writeText(value.toString());
          setIsCopied(true);
          _context.next = 7;
          break;
        case 5:
          setIsCopied(false);
          throw new Error("Cannot copy typeof ".concat(_typeof(value), " to clipboard, must be a string or number."));
        case 7:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })), [value]);
  React.useEffect(function () {
    if (!isCopied || !resetInterval) return;
    var timeout = setTimeout(function () {
      return setIsCopied(false);
    }, resetInterval);
    return function () {
      clearTimeout(timeout);
    };
  }, [isCopied, resetInterval]);
  return {
    isCopied: isCopied,
    handleCopy: handleCopy
  };
}

// 基本的に入力しないコンポーネントのため、空のonChangeを渡す
// eslint-disable-next-line @typescript-eslint/no-empty-function
var onChange = function onChange() {};
var CopyTextBox = /*#__PURE__*/React__namespace.default.memo(function (_ref) {
  var value = _ref.value;
  var _useCopyToClipboard = useCopyToClipboard({
      value: value
    }),
    isCopied = _useCopyToClipboard.isCopied,
    handleCopy = _useCopyToClipboard.handleCopy;
  return /*#__PURE__*/React__namespace.default.createElement("div", {
    className: styles$k.wrapper
  }, /*#__PURE__*/React__namespace.default.createElement(BaseInputOuterWrap, {
    className: styles$k.outerWrap
  }, /*#__PURE__*/React__namespace.default.createElement(BaseInputWrap, {
    className: styles$k.inputWrap,
    icon: /*#__PURE__*/React__namespace.default.createElement(LinkIcon$1, {
      className: styles$k.icon,
      size: 16
    })
  }, /*#__PURE__*/React__namespace.default.createElement(BaseInput, {
    placeholder: value,
    onChange: onChange,
    value: value,
    disabled: true
  }))), isCopied ? (/*#__PURE__*/React__namespace.default.createElement(SecondaryButton, {
    icon: "CheckCircleSolidIcon",
    iconPosition: "left",
    text: "",
    "aria-label": "コピーしました。",
    onClick: handleCopy
  })) : (/*#__PURE__*/React__namespace.default.createElement(SecondaryButton, {
    text: "コピー",
    onClick: handleCopy
  })));
});
CopyTextBox.displayName = "CopyTextBox";

var css_248z$k = ":root {\n  /* Color styles */\n\n  /* Text-size styles */\n\n  /* Effect styles */\n  /* border-radius */\n}\n\n.searchTextbox-module_wrapper__2ZN-4 {\n  display: flex;\n  align-items: center;\n}\n\n.searchTextbox-module_wrapper__2ZN-4:focus-within {\n  gap: 1px;\n}\n\n.searchTextbox-module_wrapper__2ZN-4 button {\n  border-top-left-radius: 0px;\n  border-bottom-left-radius: 0px;\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n  height: 36px;\n  margin-left: -1px;\n}\n\n/* iconの位置がズレるため調整 */\n\n.searchTextbox-module_wrapper__2ZN-4 button svg {\n  margin-top: 4px;\n}\n\n.searchTextbox-module_wrapper__2ZN-4 .searchTextbox-module_inputWrap__2vGFJ {\n  border-radius: 4px;\n}\n\n.searchTextbox-module_wrapper__2ZN-4 .searchTextbox-module_inputWrap__2vGFJ.searchTextbox-module_disabled__2g0z8:hover {\n  border: 1px solid #b2b8c8;\n}\n\n.searchTextbox-module_wrapper__2ZN-4 .searchTextbox-module_icon__2QNiA {\n  color: #949cb0;\n  position: absolute;\n  top: 10px;\n  left: 16px;\n}\n\n.searchTextbox-module_wrapper__2ZN-4 .searchTextbox-module_inputWrap__2vGFJ.searchTextbox-module_disabled__2g0z8 {\n  color: #949cb0;\n  border: none !important;\n  cursor: not-allowed;\n}\n\n.searchTextbox-module_wrapper__2ZN-4 .searchTextbox-module_inputWrap__2vGFJ.searchTextbox-module_disabled__2g0z8 .searchTextbox-module_input__MW7ei:disabled {\n  color: #949cb0;\n  border: none !important;\n  cursor: not-allowed;\n}\n\n.searchTextbox-module_wrapper__2ZN-4 .searchTextbox-module_inputWrap__2vGFJ.searchTextbox-module_disabled__2g0z8 {\n  background-color: #e5e6ea;\n}\n\n.searchTextbox-module_wrapper__2ZN-4.searchTextbox-module_withButton__3Bty1 .searchTextbox-module_inputWrap__2vGFJ {\n  border-top-right-radius: 0px;\n  border-bottom-right-radius: 0px;\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n}\n\n.searchTextbox-module_input__MW7ei:disabled::-moz-placeholder {\n  color: #949cb0;\n}\n\n.searchTextbox-module_input__MW7ei:disabled::placeholder {\n  color: #949cb0;\n}\n\n@media screen and (max-width: 800px) {\n  .searchTextbox-module_wrapper__2ZN-4 button {\n    width: auto;\n  }\n}\n";
var styles$j = {"wrapper":"searchTextbox-module_wrapper__2ZN-4","inputWrap":"searchTextbox-module_inputWrap__2vGFJ","disabled":"searchTextbox-module_disabled__2g0z8","icon":"searchTextbox-module_icon__2QNiA","input":"searchTextbox-module_input__MW7ei","withButton":"searchTextbox-module_withButton__3Bty1"};
styleInject(css_248z$k);

var Button = function Button(_ref) {
  var _ref$buttonType = _ref.buttonType,
    buttonType = _ref$buttonType === void 0 ? "Secondary" : _ref$buttonType,
    onSearch = _ref.onSearch,
    disabled = _ref.disabled;
  if (buttonType === "Primary") return /*#__PURE__*/React__namespace.default.createElement(PrimaryButton, {
    disabled: disabled,
    text: "検索",
    onClick: onSearch
  });
  if (buttonType === "Secondary") return /*#__PURE__*/React__namespace.default.createElement(SecondaryButton, {
    disabled: disabled,
    text: "検索",
    onClick: onSearch
  });
  return /*#__PURE__*/React__namespace.default.createElement(React__namespace.default.Fragment, null);
};
var SearchTextBox = /*#__PURE__*/React__namespace.default.memo(function (_ref2) {
  var placeholder = _ref2.placeholder,
    _ref2$buttonType = _ref2.buttonType,
    buttonType = _ref2$buttonType === void 0 ? "Secondary" : _ref2$buttonType,
    id = _ref2.id,
    disabled = _ref2.disabled,
    errorMessages = _ref2.errorMessages,
    shouldDisplayError = _ref2.shouldDisplayError,
    onError = _ref2.onError,
    value = _ref2.value,
    onSearch = _ref2.onSearch,
    onChange = _ref2.onChange;
  var render = React.useCallback(function () {
    return /*#__PURE__*/React__namespace.default.createElement("div", {
      className: classnames__default.default(styles$j.wrapper, buttonType !== "None" && styles$j.withButton)
    }, /*#__PURE__*/React__namespace.default.createElement(BaseInputOuterWrap, {
      className: styles$j.outerWrap
    }, /*#__PURE__*/React__namespace.default.createElement(BaseInputWrap, {
      className: classnames__default.default(styles$j.inputWrap, !!disabled && styles$j.disabled),
      icon: /*#__PURE__*/React__namespace.default.createElement(SearchIcon, {
        className: styles$j.icon,
        size: 16
      })
    }, /*#__PURE__*/React__namespace.default.createElement(BaseInput, {
      id: id,
      placeholder: placeholder,
      onChange: onChange,
      value: value,
      disabled: disabled,
      className: classnames__default.default(styles$j.input, disabled && styles$j.disabled)
    }))), buttonType === "None" ? (/*#__PURE__*/React__namespace.default.createElement(React__namespace.default.Fragment, null)) : (/*#__PURE__*/React__namespace.default.createElement(Button, {
      disabled: disabled,
      buttonType: buttonType,
      onSearch: onSearch
    })));
  }, [buttonType, disabled, id, onChange, onSearch, placeholder, value]);
  var _useFormController = useFormController({
      id: id,
      disabled: disabled,
      errorMessages: errorMessages,
      shouldDisplayError: shouldDisplayError,
      noValidate: false,
      validator: undefined,
      helperText: undefined,
      onError: onError,
      render: render
    }),
    component = _useFormController.component;
  return component;
});
SearchTextBox.displayName = "CopyTextBox";

var css_248z$j = ":root {\n  /* Color styles */\n\n  /* Text-size styles */\n\n  /* Effect styles */\n  /* border-radius */\n}\n\n.textboxWithButton-module_wrapper__2P3eo {\n  display: flex;\n  align-items: center;\n}\n\n.textboxWithButton-module_wrapper__2P3eo:focus-within {\n  gap: 1px;\n}\n\n.textboxWithButton-module_wrapper__2P3eo button {\n  border-top-left-radius: 0px;\n  border-bottom-left-radius: 0px;\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n  height: 36px;\n  margin-left: -1px;\n}\n\n/* iconの位置がズレるため調整 */\n\n.textboxWithButton-module_wrapper__2P3eo button svg {\n  margin-top: 4px;\n}\n\n.textboxWithButton-module_wrapper__2P3eo .textboxWithButton-module_inputWrap__24XU0 {\n  border-top-right-radius: 0px;\n  border-bottom-right-radius: 0px;\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n}\n\n.textboxWithButton-module_wrapper__2P3eo .textboxWithButton-module_inputWrap__24XU0.textboxWithButton-module_disabled__MEvKq {\n  color: #949cb0;\n  border: none !important;\n  cursor: not-allowed;\n}\n\n.textboxWithButton-module_wrapper__2P3eo .textboxWithButton-module_inputWrap__24XU0.textboxWithButton-module_disabled__MEvKq .textboxWithButton-module_input__RjFyn:disabled {\n  color: #949cb0;\n  border: none !important;\n  cursor: not-allowed;\n}\n\n.textboxWithButton-module_wrapper__2P3eo .textboxWithButton-module_inputWrap__24XU0.textboxWithButton-module_disabled__MEvKq {\n  background-color: #e5e6ea;\n}\n\n.textboxWithButton-module_wrapper__2P3eo .textboxWithButton-module_icon__L4rxX {\n  fill: #949cb0;\n}\n\n@media screen and (max-width: 800px) {\n  .textboxWithButton-module_wrapper__2P3eo button {\n    width: auto;\n  }\n}\n";
var styles$i = {"wrapper":"textboxWithButton-module_wrapper__2P3eo","inputWrap":"textboxWithButton-module_inputWrap__24XU0","disabled":"textboxWithButton-module_disabled__MEvKq","input":"textboxWithButton-module_input__RjFyn","icon":"textboxWithButton-module_icon__L4rxX"};
styleInject(css_248z$j);

var TextBoxWithButton = /*#__PURE__*/React__namespace.default.memo(function (_ref) {
  var placeholder = _ref.placeholder,
    id = _ref.id,
    disabled = _ref.disabled,
    errorMessages = _ref.errorMessages,
    shouldDisplayError = _ref.shouldDisplayError,
    onError = _ref.onError,
    value = _ref.value,
    text = _ref.text,
    onSubmit = _ref.onSubmit,
    onChange = _ref.onChange;
  var render = React.useCallback(function () {
    return /*#__PURE__*/React__namespace.default.createElement("div", {
      className: styles$i.wrapper
    }, /*#__PURE__*/React__namespace.default.createElement(BaseInputOuterWrap, {
      className: styles$i.outerWrap
    }, /*#__PURE__*/React__namespace.default.createElement(BaseInputWrap, {
      className: classnames__default.default(styles$i.inputWrap, !!disabled && styles$i.disabled)
    }, /*#__PURE__*/React__namespace.default.createElement(BaseInput, {
      id: id,
      placeholder: placeholder,
      onChange: onChange,
      value: value,
      disabled: disabled,
      className: classnames__default.default(styles$i.input, disabled && styles$i.disabled)
    }))), /*#__PURE__*/React__namespace.default.createElement(SecondaryButton, {
      disabled: disabled,
      text: text,
      onClick: onSubmit
    }));
  }, [id, disabled, onChange, onSubmit, placeholder, text, value]);
  var _useFormController = useFormController({
      id: id,
      disabled: disabled,
      errorMessages: errorMessages,
      shouldDisplayError: shouldDisplayError,
      noValidate: false,
      validator: undefined,
      helperText: undefined,
      onError: onError,
      render: render
    }),
    component = _useFormController.component;
  return component;
});
TextBoxWithButton.displayName = "CopyTextBox";

/**
 * FilterContainer内で使用可能なコンポーネントです。
 * Formでは使用できません。
 * Formで使用する場合は、Selectを使用してください。
 */
var InlineSelect = function InlineSelect(_ref) {
  var id = _ref.id,
    options = _ref.options,
    value = _ref.value,
    disabled = _ref.disabled,
    label = _ref.label,
    name = _ref.name,
    _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? "選択してください" : _ref$placeholder,
    onFocus = _ref.onFocus,
    onChange = _ref.onChange,
    onBlur = _ref.onBlur;
  var render = useSelectRender({
    options: options,
    value: value,
    disabled: disabled,
    name: name,
    placeholder: placeholder,
    onFocus: onFocus,
    onChange: onChange,
    onBlur: onBlur
  });
  return /*#__PURE__*/React__namespace.createElement(InlineController, {
    render: render,
    disabled: disabled,
    label: label,
    id: id
  });
};

var _excluded$2 = ["disabled", "label", "id", "name", "placeholder", "isMulti", "onChange", "onBlur"];
/**
 * FilterContainer内で使用可能なコンポーネントです。
 * Formでは使用できません。
 * Formで使用する場合は、ReactSelectを使用してください。
 */
var InlineReactSelect = function InlineReactSelect(_ref) {
  var disabled = _ref.disabled,
    label = _ref.label,
    id = _ref.id,
    name = _ref.name,
    _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? "選択してください" : _ref$placeholder,
    _ref$isMulti = _ref.isMulti,
    isMulti = _ref$isMulti === void 0 ? false : _ref$isMulti,
    onChange = _ref.onChange,
    onBlur = _ref.onBlur,
    props = _objectWithoutProperties(_ref, _excluded$2);
  var render = useReactSelectRender(_objectSpread2({
    disabled: disabled,
    name: name,
    placeholder: placeholder,
    isMulti: isMulti,
    onChange: onChange,
    onBlur: onBlur
  }, props));
  return /*#__PURE__*/React__namespace.createElement(InlineController, {
    render: render,
    disabled: disabled,
    label: label,
    id: id
  });
};

/**
 * FilterContainer内で使用可能なコンポーネントです。
 * Formでは使用できません。
 * Formで使用する場合は、RadioButtonを使用してください。
 */
var InlineRadioButton = /*#__PURE__*/React__namespace.memo(function (_ref) {
  var id = _ref.id,
    options = _ref.options,
    value = _ref.value,
    disabled = _ref.disabled,
    label = _ref.label,
    _ref$direction = _ref.direction,
    direction = _ref$direction === void 0 ? "row" : _ref$direction,
    onChange = _ref.onChange,
    onBlur = _ref.onBlur;
  var render = useRadioButtonRender({
    options: options,
    value: value,
    disabled: disabled,
    onChange: onChange,
    onBlur: onBlur,
    direction: direction
  });
  return /*#__PURE__*/React__namespace.createElement(InlineController, {
    render: render,
    disabled: disabled,
    label: label,
    id: id
  });
});
InlineRadioButton.displayName = "InlineRadioButton";

/**
 * FilterContainer内で使用可能なコンポーネントです。
 * Formでは使用できません。
 * Formで使用する場合は、CheckBoxを使用してください。
 */
var InlineCheckBox = /*#__PURE__*/React__namespace.memo(function (_ref) {
  var id = _ref.id,
    options = _ref.options,
    values = _ref.values,
    disabled = _ref.disabled,
    label = _ref.label,
    _ref$direction = _ref.direction,
    direction = _ref$direction === void 0 ? "row" : _ref$direction,
    onChange = _ref.onChange,
    onBlur = _ref.onBlur;
  var render = useCheckboxListRender({
    options: options,
    values: values,
    disabled: disabled,
    onChange: onChange,
    onBlur: onBlur,
    direction: direction
  });
  return /*#__PURE__*/React__namespace.createElement(InlineController, {
    render: render,
    disabled: disabled,
    label: label,
    id: id
  });
});
InlineCheckBox.displayName = "InlineCheckBox";

/**
 * FilterContainer内で使用可能なコンポーネントです。
 * Formでは使用できません。
 * Formで使用する場合は、Toggleを使用してください。
 */
var InlineToggle = function InlineToggle(_ref) {
  var id = _ref.id,
    checked = _ref.checked,
    disabled = _ref.disabled,
    label = _ref.label,
    onChange = _ref.onChange;
  var render = useToggleRender({
    checked: checked,
    disabled: disabled,
    onChange: onChange
  });
  return /*#__PURE__*/React__namespace.default.createElement(InlineController, {
    render: render,
    disabled: disabled,
    label: label,
    id: id
  });
};

var css_248z$i = ":root {\n  /* Color styles */\n\n  /* Text-size styles */\n\n  /* Effect styles */\n  /* border-radius */\n}\n\n.kebabMenu-module_wrapper__1BLO- {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n}\n\n.kebabMenu-module_popup__zq-8E {\n  display: inline-flex;\n  position: relative;\n  vertical-align: top;\n  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);\n  border-radius: 4px;\n}\n\n.kebabMenu-module_popup__zq-8E .kebabMenu-module_menu__3o2Jx {\n  display: none;\n}\n\n.kebabMenu-module_popup__zq-8E.kebabMenu-module_isActive__9vM5B .kebabMenu-module_menu__3o2Jx {\n  display: grid;\n  grid-column-gap: 16px;\n  grid-row-gap: 8px;\n  grid-template-columns: repeat(auto-fill, minmax(12rem, 1fr));\n  padding-top: calc(8px / 2);\n  position: absolute;\n  top: calc(100% + 12px);\n  width: 330px;\n  z-index: 20;\n  right: 0;\n}\n\n.kebabMenu-module_popup__zq-8E .kebabMenu-module_contentWrapper__Uhnvb {\n  background-color: white;\n  border-radius: calc(8px / 2);\n  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);\n  padding-bottom: 8px;\n  padding-top: 8px;\n}\n\n.kebabMenu-module_popup__zq-8E .kebabMenu-module_content__3z_Md {\n  white-space: nowrap;\n  width: 100%;\n  display: inline-flex;\n  align-items: center;\n  padding: 8px 16px;\n  color: #353ebd;\n}\n\n.kebabMenu-module_popup__zq-8E .kebabMenu-module_title__ayY54 {\n  font: 600 16px/24px Meiryo, Arial, system-ui, sans-serif;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  padding: 16px 16px 8px;\n  gap: 10px;\n  border-top: 0.5px solid #949cb0;\n}\n\n.kebabMenu-module_popup__zq-8E .kebabMenu-module_menuLink__2kFBg {\n  font: 300 14px/20px Meiryo, Arial, system-ui, sans-serif;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 10px;\n}\n\n.kebabMenu-module_popup__zq-8E .kebabMenu-module_menuLink__2kFBg > * {\n  font: 300 14px/20px Meiryo, Arial, system-ui, sans-serif;\n  border: none;\n  color: #353ebd;\n  text-align: left;\n  padding: initial;\n  border-radius: initial;\n  padding: 8px 24px;\n  width: 100%;\n}\n\n.kebabMenu-module_popup__zq-8E .kebabMenu-module_menuLink__2kFBg *:focus {\n  color: #353ebd;\n  box-shadow: 0px 0px 5px rgba(53, 62, 189, 1);\n  outline: 1px #353ebd solid;\n  background-color: initial;\n}\n\n@media (hover: hover) {\n  .kebabMenu-module_popup__zq-8E .kebabMenu-module_menuLink__2kFBg:hover {\n    background-color: #f1f2f7;\n    cursor: pointer;\n  }\n\n  .kebabMenu-module_popup__zq-8E .kebabMenu-module_menuLink__2kFBg:hover * {\n    color: #0f1192;\n  }\n}\n\n@media screen and (max-width: 768px) {\n  .kebabMenu-module_popup__zq-8E .kebabMenu-module_contentWrapper__Uhnvb {\n    max-height: 360px;\n    overflow-y: scroll;\n  }\n}\n";
var styles$h = {"wrapper":"kebabMenu-module_wrapper__1BLO-","popup":"kebabMenu-module_popup__zq-8E","menu":"kebabMenu-module_menu__3o2Jx","isActive":"kebabMenu-module_isActive__9vM5B","contentWrapper":"kebabMenu-module_contentWrapper__Uhnvb","content":"kebabMenu-module_content__3z_Md","title":"kebabMenu-module_title__ayY54","menuLink":"kebabMenu-module_menuLink__2kFBg"};
styleInject(css_248z$i);

var MenuItem = function MenuItem(_ref) {
  var text = _ref.text,
    _ref$active = _ref.active,
    active = _ref$active === void 0 ? false : _ref$active,
    anchor = _ref.anchor;
  var Anchor = anchor !== null && anchor !== void 0 ? anchor : function (_ref2) {
    var children = _ref2.children;
    return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, children);
  };
  return /*#__PURE__*/React__namespace.createElement("div", {
    className: classnames__default.default(styles$h.menuLink, !!active && styles$h.active),
    role: "menuitem"
  }, /*#__PURE__*/React__namespace.createElement(Anchor, null, /*#__PURE__*/React__namespace.createElement("span", {
    className: classnames__default.default(styles$h.menuText)
  }, text)));
};
var Popup$1 = function Popup(_ref3) {
  var name = _ref3.name,
    onOutsideClick = _ref3.onOutsideClick,
    isActive = _ref3.isActive,
    items = _ref3.items,
    target = _ref3.target,
    className = _ref3.className;
  return /*#__PURE__*/React__namespace.createElement(OutsideClickHandler__default.default, {
    onOutsideClick: onOutsideClick
  }, /*#__PURE__*/React__namespace.createElement("div", {
    className: classnames__default.default(styles$h.popup, _defineProperty({}, styles$h.isActive, isActive), className)
  }, target, /*#__PURE__*/React__namespace.createElement("div", {
    className: classnames__default.default(styles$h.menu),
    role: "menu"
  }, /*#__PURE__*/React__namespace.createElement("div", {
    className: styles$h.contentWrapper
  }, items.map(function (item, index) {
    return /*#__PURE__*/React__namespace.createElement("div", {
      key: "".concat(name, "-").concat(index),
      className: styles$h.menuWrapper
    }, /*#__PURE__*/React__namespace.createElement("div", {
      className: styles$h.title
    }, item.title), item.menuItems.map(function (menuItem, index) {
      return /*#__PURE__*/React__namespace.createElement(MenuItem, {
        key: "".concat(name, "-menu-").concat(index),
        text: menuItem.text,
        active: menuItem.active,
        anchor: menuItem.anchor
      });
    }));
  })))));
};
var KebabMenu = function KebabMenu(_ref4) {
  var items = _ref4.items;
  var _React$useState = React__namespace.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isOpen = _React$useState2[0],
    setIsOpen = _React$useState2[1];
  return /*#__PURE__*/React__namespace.createElement(Popup$1, {
    target: /*#__PURE__*/React__namespace.createElement(KebabButton, {
      onClick: function onClick() {
        return setIsOpen(!isOpen);
      }
    }),
    name: "kebab-menu",
    onOutsideClick: function onOutsideClick() {
      return setIsOpen(false);
    },
    isActive: isOpen,
    items: items
  });
};

var CopyButton = function CopyButton(_ref) {
  var text = _ref.text,
    value = _ref.value;
  var _useCopyToClipboard = useCopyToClipboard({
      value: value
    }),
    isCopied = _useCopyToClipboard.isCopied,
    handleCopy = _useCopyToClipboard.handleCopy;
  return /*#__PURE__*/React__namespace.createElement(TextButton, {
    icon: isCopied ? "CheckCircleSolidIcon" : "CopyIcon",
    type: "button",
    onClick: handleCopy,
    text: text
  });
};

var css_248z$h = ":root {\n  /* Color styles */\n\n  /* Text-size styles */\n\n  /* Effect styles */\n  /* border-radius */\n}\n\n.inlineSpinner-module_spinnerContainer__3a-Cj {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.inlineSpinner-module_spinner__88Q0O {\n  width: 24px;\n  height: 24px;\n  border: 2px solid #e8e9f9;\n  border-top-color: #353ebd;\n  border-right-color: #353ebd;\n  border-bottom-color: #353ebd;\n  border-radius: 50%;\n  animation: inlineSpinner-module_spin__-Peoa 1s linear infinite;\n}\n\n.inlineSpinner-module_spinnerText__1lcaK {\n  font-size: 14px;\n  color: #262b38;\n}\n\n@keyframes inlineSpinner-module_spin__-Peoa {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(-360deg);\n  }\n}\n";
var styles$g = {"spinnerContainer":"inlineSpinner-module_spinnerContainer__3a-Cj","spinner":"inlineSpinner-module_spinner__88Q0O","spin":"inlineSpinner-module_spin__-Peoa","spinnerText":"inlineSpinner-module_spinnerText__1lcaK"};
styleInject(css_248z$h);

var InlineSpinner = function InlineSpinner() {
  return /*#__PURE__*/React__namespace.default.createElement("div", {
    className: styles$g.spinnerContainer
  }, /*#__PURE__*/React__namespace.default.createElement("div", {
    className: styles$g.spinner
  }), /*#__PURE__*/React__namespace.default.createElement("span", {
    className: styles$g.spinnerText
  }, "\u901A\u4FE1\u4E2D..."));
};

var LinkCopyButton = function LinkCopyButton(_ref) {
  var text = _ref.text,
    value = _ref.value;
  var _useCopyToClipboard = useCopyToClipboard({
      value: value
    }),
    isCopied = _useCopyToClipboard.isCopied,
    handleCopy = _useCopyToClipboard.handleCopy;
  return /*#__PURE__*/React__namespace.createElement(TextButton, {
    icon: isCopied ? "CheckCircleSolidIcon" : "LinkIcon",
    type: "button",
    onClick: handleCopy,
    text: text
  });
};

var css_248z$g = ":root {\n  /* Color styles */\n\n  /* Text-size styles */\n\n  /* Effect styles */\n  /* border-radius */\n}\n\n.header-module_header__17XbN {\n  background-color: #ffffff;\n  color: #353ebd;\n  border-bottom: 1px solid #b2b8c8;\n  display: flex;\n  justify-content: space-between;\n  grid-area: header;\n  flex-wrap: wrap;\n}\n\n.header-module_navBar__5c8gF {\n  opacity: 1;\n  pointer-events: auto;\n  transform: translateY(0);\n}\n\n.header-module_navStart__-rKln {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  padding: 8px 0px;\n}\n\n.header-module_navEnd__1xbTi {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  padding: 8px 0px;\n}\n\n.header-module_dropDown__2k073 {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n}\n\n.header-module_dropdownItem__16pOi {\n  margin-left: 16px;\n}\n\n.header-module_tenantName__1au4u {\n  color: #262b38;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.header-module_tenantInfo__3jA39 {\n  color: #353ebd;\n  background-color: transparent !important;\n}\n\n.header-module_tenantInfo__3jA39:hover {\n  color: #353ebd;\n  background-color: transparent !important;\n}\n\n.header-module_sideMenuIcon__3X9wY {\n  color: #353ebd;\n  background-color: transparent !important;\n  padding-left: 0.75rem;\n}\n\n.header-module_sideMenuIcon__3X9wY:hover {\n  color: #353ebd;\n  background-color: transparent !important;\n  padding-left: 0.75rem;\n}\n\n.header-module_sideMenuIcon__3X9wY:active {\n  color: #353ebd;\n  background-color: transparent !important;\n  padding-left: 0.75rem;\n}\n\n.header-module_logoWrapper__2daXO {\n  background-color: transparent;\n  padding-right: 0;\n  color: #353ebd;\n  position: relative;\n  padding-left: 0px;\n}\n\n.header-module_logo__3CgVw {\n  font: 600 16px/24px Meiryo, Arial, system-ui, sans-serif;\n  color: #353ebd;\n  border: 0.5px solid #7780d9;\n  border-radius: 30px;\n  display: inline-flex;\n  align-items: center;\n  padding: 6px 8px;\n  line-height: 24px;\n  white-space: nowrap;\n}\n\n.header-module_grafferLogo__2qyGO {\n  margin-right: 8px;\n}\n\n.header-module_name__2SMkn {\n  color: #353ebd;\n}\n\n.header-module_dropdownItem__16pOi {\n  position: relative;\n  display: inline-flex;\n}\n\n.header-module_iconWrapper__1iNGC {\n  display: inline-flex;\n  align-items: center;\n  padding: 4px;\n  white-space: nowrap;\n  font: 300 13px/18px Meiryo, Arial, system-ui, sans-serif;\n}\n\n.header-module_questionLink__2XUcn {\n  gap: 8px;\n  margin-right: 8px;\n}\n\n.header-module_badge__bUm2C {\n  display: inline-block;\n  background-color: #ec3d26;\n  border: 1px solid #ec3d26;\n  border-radius: 50%;\n  width: 10px;\n  height: 10px;\n}\n\n.header-module_badge__bUm2C.header-module_withIcon__3Akpx {\n  position: absolute;\n  top: 5px;\n  left: 22px;\n}\n\n.header-module_badge__bUm2C.header-module_withText__LK402 {\n  margin-left: 8px;\n}\n\n.header-module_icon__1Xi4p {\n  color: #353ebd;\n  display: inline-flex;\n  align-items: center;\n}\n\n.header-module_question__1v89S {\n  margin-right: 8px;\n}\n\n.header-module_dropAllow__1RRcR {\n  border-radius: 50%;\n  background-color: #e8e9f9;\n  width: 24px;\n  height: 24px;\n  margin-left: 4px;\n}\n\n.header-module_logout__2l-g3 {\n  color: #5963d1;\n}\n\n.header-module_fullWidth__16jZ9 {\n  width: 100%;\n}\n\n.header-module_menuIcon__xctZh {\n  transition: transform 0.2s ease-in-out;\n  opacity: 0.6;\n}\n\n.header-module_sideMenuNavDropDown__G7eu8 {\n  border-radius: 6px;\n  border-top: none;\n  display: block;\n  top: calc(100% + (-4px));\n  transition-duration: 86ms;\n  transition-property: opacity, transform;\n  opacity: 1;\n  transform: translateY(0);\n  pointer-events: auto;\n  z-index: 20;\n  min-width: 10%;\n}\n\n.header-module_dropDownContent__33fvb {\n  background-color: white;\n  border-radius: 4px;\n  box-shadow: 0 0.5em 1em -0.125em rgba(10, 10, 10, 0.1),\n    0 0px 0 1px rgba(10, 10, 10, 0.02);\n  padding-bottom: 0.5rem;\n  padding-top: 0.5rem;\n}\n\n.header-module_notificationWrapper__1XHT5 {\n  display: flex;\n  align-items: center;\n}\n\n.header-module_slash__1gDVr {\n  margin: 0px 8px;\n}\n\n.header-module_popup__28h3a {\n  display: inline-flex;\n  position: relative;\n  vertical-align: top;\n}\n\n.header-module_popup__28h3a .header-module_menu__2QSKN {\n  display: none;\n}\n\n.header-module_popup__28h3a.header-module_isActive__2OVTD .header-module_menu__2QSKN {\n  display: grid;\n  grid-column-gap: 16px;\n  grid-row-gap: 8px;\n  grid-template-columns: repeat(auto-fill, minmax(12rem, 1fr));\n  padding-top: calc(8px / 2);\n  position: absolute;\n  top: 100%;\n  z-index: 20;\n  right: 0;\n}\n\n.header-module_popup__28h3a.header-module_isActive__2OVTD.header-module_notificationMenu__1x0Ot .header-module_menu__2QSKN {\n  grid-template-columns: repeat(auto-fill, minmax(330px, 1fr));\n}\n\n.header-module_popup__28h3a .header-module_contentWrapper__3Rvlo {\n  background-color: white;\n  border-radius: calc(8px / 2);\n  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);\n  padding-bottom: 8px;\n  padding-top: 8px;\n}\n\n.header-module_popup__28h3a .header-module_content__1ObHN {\n  white-space: nowrap;\n  width: 100%;\n  display: inline-flex;\n  align-items: center;\n  padding: 8px 16px;\n  color: #353ebd;\n  text-align: left;\n  font: 300 14px/20px Meiryo, Arial, system-ui, sans-serif;\n}\n\n.header-module_popup__28h3a.header-module_isActive__2OVTD.header-module_notificationMenu__1x0Ot .header-module_menuWrapper__2xhCa > .header-module_content__1ObHN {\n  display: inline-flex;\n  align-items: center;\n}\n\n.header-module_popup__28h3a.header-module_isActive__2OVTD.header-module_notificationMenu__1x0Ot .header-module_menuWrapper__2xhCa > .header-module_content__1ObHN {\n  height: 65px;\n}\n\n.header-module_popup__28h3a.header-module_isActive__2OVTD.header-module_notificationMenu__1x0Ot .header-module_menuWrapper__2xhCa > .header-module_content__1ObHN:first-child {\n  border-top: 1px solid #f1f2f7;\n  border-bottom: 1px solid #f1f2f7;\n}\n\n.header-module_popup__28h3a.header-module_isActive__2OVTD.header-module_notificationMenu__1x0Ot .header-module_menuWrapper__2xhCa > .header-module_content__1ObHN:not(:first-child) {\n  border-bottom: 1px solid #f1f2f7;\n}\n\n.header-module_popup__28h3a.header-module_isActive__2OVTD.header-module_notificationMenu__1x0Ot .header-module_left__1wuig {\n  display: inline-flex;\n  flex-direction: column;\n  width: 90%;\n}\n\n.header-module_popup__28h3a.header-module_isActive__2OVTD.header-module_notificationMenu__1x0Ot .header-module_right__1hUSC {\n  display: inline-flex;\n  width: 10%;\n}\n\n.header-module_notificationItemText__3iz3X {\n  width: 100%;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.header-module_notificationList__29GHl {\n  width: 100%;\n  text-align: right;\n}\n\n.header-module_closeButtonWrapper__15MVa {\n  display: flex;\n  padding: 8px 16px;\n  justify-content: flex-end;\n  align-items: center;\n}\n\n.header-module_closeButtonWrapper__15MVa .header-module_cancel__3ldQM {\n  height: 28px;\n  width: 28px;\n  border-radius: 50%;\n}\n\n.header-module_logo__3CgVw:hover {\n  box-shadow: 0px 0px 5px #7780d9;\n}\n\n.header-module_logo__3CgVw:focus {\n  box-shadow: 0px 0px 5px #7780d9;\n}\n\n.header-module_logo__3CgVw:hover .header-module_dropAllow__1RRcR {\n  background-color: #c5c7ef;\n}\n\n.header-module_logo__3CgVw:focus .header-module_dropAllow__1RRcR {\n  background-color: #c5c7ef;\n}\n\n.header-module_iconWrapper__1iNGC:hover .header-module_dropAllow__1RRcR {\n  background-color: #c5c7ef;\n}\n\n.header-module_iconWrapper__1iNGC:focus .header-module_dropAllow__1RRcR {\n  background-color: #c5c7ef;\n}\n\n.header-module_grafferLogo__2qyGO:hover {\n  background-color: #f1f2f7;\n  border-radius: 4px;\n}\n\n.header-module_grafferLogo__2qyGO:focus {\n  background-color: #f1f2f7;\n  border-radius: 4px;\n}\n\n.header-module_iconWrapper__1iNGC:hover {\n  background-color: #f1f2f7;\n  border-radius: 4px;\n}\n\na.header-module_iconWrapper__1iNGC:hover {\n  background-color: #f1f2f7;\n  border-radius: 4px;\n}\n\n.header-module_iconWrapper__1iNGC:focus {\n  background-color: #f1f2f7;\n  border-radius: 4px;\n}\n\na.header-module_iconWrapper__1iNGC:focus {\n  background-color: #f1f2f7;\n  border-radius: 4px;\n}\n\n.header-module_popup__28h3a .header-module_contentWrapper__3Rvlo .header-module_content__1ObHN:hover {\n  color: #0f1192;\n  background-color: #f1f2f7;\n}\n\n.header-module_popup__28h3a .header-module_contentWrapper__3Rvlo .header-module_content__1ObHN:focus {\n  color: #0f1192;\n  background-color: #f1f2f7;\n}\n\n.header-module_closeButtonWrapper__15MVa .header-module_cancel__3ldQM:hover {\n  color: #0f1192;\n  background-color: #f1f2f7;\n}\n\n.header-module_closeButtonWrapper__15MVa .header-module_cancel__3ldQM:focus {\n  color: #0f1192;\n  background-color: #f1f2f7;\n}\n\n.header-module_wrapped__2mmY4 .header-module_popup__28h3a.header-module_isActive__2OVTD .header-module_menu__2QSKN {\n  left: 0;\n}\n\na.header-module_link__1VUPu {\n  color: #353ebd;\n  fill: #353ebd;\n}\n";
var styles$f = {"header":"header-module_header__17XbN","navBar":"header-module_navBar__5c8gF","navStart":"header-module_navStart__-rKln","navEnd":"header-module_navEnd__1xbTi","dropDown":"header-module_dropDown__2k073","dropdownItem":"header-module_dropdownItem__16pOi","tenantName":"header-module_tenantName__1au4u","tenantInfo":"header-module_tenantInfo__3jA39","sideMenuIcon":"header-module_sideMenuIcon__3X9wY","logoWrapper":"header-module_logoWrapper__2daXO","logo":"header-module_logo__3CgVw","grafferLogo":"header-module_grafferLogo__2qyGO","name":"header-module_name__2SMkn","iconWrapper":"header-module_iconWrapper__1iNGC","questionLink":"header-module_questionLink__2XUcn","badge":"header-module_badge__bUm2C","withIcon":"header-module_withIcon__3Akpx","withText":"header-module_withText__LK402","icon":"header-module_icon__1Xi4p","question":"header-module_question__1v89S","dropAllow":"header-module_dropAllow__1RRcR","logout":"header-module_logout__2l-g3","fullWidth":"header-module_fullWidth__16jZ9","menuIcon":"header-module_menuIcon__xctZh","sideMenuNavDropDown":"header-module_sideMenuNavDropDown__G7eu8","dropDownContent":"header-module_dropDownContent__33fvb","notificationWrapper":"header-module_notificationWrapper__1XHT5","slash":"header-module_slash__1gDVr","popup":"header-module_popup__28h3a","menu":"header-module_menu__2QSKN","isActive":"header-module_isActive__2OVTD","notificationMenu":"header-module_notificationMenu__1x0Ot","contentWrapper":"header-module_contentWrapper__3Rvlo","content":"header-module_content__1ObHN","menuWrapper":"header-module_menuWrapper__2xhCa","left":"header-module_left__1wuig","right":"header-module_right__1hUSC","notificationItemText":"header-module_notificationItemText__3iz3X","notificationList":"header-module_notificationList__29GHl","closeButtonWrapper":"header-module_closeButtonWrapper__15MVa","cancel":"header-module_cancel__3ldQM","wrapped":"header-module_wrapped__2mmY4","link":"header-module_link__1VUPu"};
styleInject(css_248z$g);

var EnvConfig = /*#__PURE__*/function () {
  function EnvConfig(env) {
    _classCallCheck(this, EnvConfig);
    if (!env) {
      throw new Error("required env variable not provided");
    }
    if (env === "production" || env === "production_sandbox" || env === "staging" || env === "staging_sandbox" || env === "dev" || env === "local") {
      this.environment = env;
      return;
    }
    throw new Error("invalid env ".concat(env));
  }
  return _createClass(EnvConfig, [{
    key: "matchEnv",
    value: function matchEnv(matcher) {
      return matcher[this.environment]();
    }
  }, {
    key: "matchEnvValue",
    value: function matchEnvValue(matcher) {
      return matcher[this.environment];
    }
  }]);
}();

var css_248z$f = ":root {\n  /* font */\n  /* color */\n  /* shadow */\n  /* 余白 */\n  /* border-radius */\n}\n\n.env-tag-module_tagWrapper__aK4wp {\n  margin-left: 16px;\n  display: flex;\n  align-items: center;\n}\n\n.env-tag-module_tag__Cv5MN {\n  padding: 0px 16px;\n  height: 32px;\n  border-radius: 4px;\n  text-align: center;\n  line-height: 20px;\n  font-weight: 300;\n  display: flex;\n  align-items: center;\n  white-space: nowrap;\n}\n\n.env-tag-module_isSuccess__2E-Vu {\n  background-color: #3dac9a;\n  color: #fff;\n}\n\n.env-tag-module_isLight__2qBJO {\n  background-color: #f1f2f7;\n  color: #353ebd;\n}\n\n.env-tag-module_isInfo__1Awfw {\n  background-color: #353ebd;\n  color: #fff;\n}\n";
var styles$e = {"tagWrapper":"env-tag-module_tagWrapper__aK4wp","tag":"env-tag-module_tag__Cv5MN","isSuccess":"env-tag-module_isSuccess__2E-Vu","isLight":"env-tag-module_isLight__2qBJO","isInfo":"env-tag-module_isInfo__1Awfw"};
styleInject(css_248z$f);

var EnvTag = function EnvTag(_ref) {
  var envConfig = _ref.envConfig;
  var envInfo = envTagValue(envConfig);
  return envInfo ? (/*#__PURE__*/React__namespace.createElement("div", {
    className: styles$e.tagWrapper
  }, /*#__PURE__*/React__namespace.createElement("span", {
    className: classnames__default.default(envInfo === null || envInfo === void 0 ? void 0 : envInfo.color, "is-large", styles$e.tag)
  }, envInfo === null || envInfo === void 0 ? void 0 : envInfo.status))) : null;
};
var envTagValue = function envTagValue(envConfig) {
  return envConfig.matchEnvValue({
    dev: {
      status: "Dev environment",
      color: styles$e.isInfo
    },
    local: {
      status: "Local",
      color: styles$e.isLight
    },
    production: undefined,
    production_sandbox: {
      status: "サンドボックス",
      color: styles$e.isInfo
    },
    staging: {
      status: "Staging environment",
      color: styles$e.isSuccess
    },
    staging_sandbox: {
      status: "Staging (サンドボックス)",
      color: styles$e.isSuccess
    }
  });
};

var GrafferLogo = function GrafferLogo() {
  return /*#__PURE__*/React__namespace.default.createElement("svg", {
    width: "107",
    height: "34",
    viewBox: "0 0 107 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": "\u682A\u5F0F\u4F1A\u793E\u30B0\u30E9\u30D5\u30A1\u30FC\u306E\u30ED\u30B4"
  }, /*#__PURE__*/React__namespace.default.createElement("g", {
    clipPath: "url(#clip0_4225_55734)"
  }, /*#__PURE__*/React__namespace.default.createElement("title", null, "\u682A\u5F0F\u4F1A\u793E\u30B0\u30E9\u30D5\u30A1\u30FC\u306E\u30ED\u30B4"), /*#__PURE__*/React__namespace.default.createElement("desc", null, "\u682A\u5F0F\u4F1A\u793E\u30B0\u30E9\u30D5\u30A1\u30FC\u306E\u30ED\u30B4\u3067\u3059"), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M44.9516 22.1043C45.6539 22.1154 46.3488 21.9597 46.9783 21.6501V17.267H49.1564V23.0718C47.8932 23.8796 46.421 24.3049 44.9189 24.2958C41.4916 24.2958 38.5063 21.7444 38.5063 17.7684C38.5063 13.7923 41.4738 11.2262 44.9367 11.2262C46.2574 11.2107 47.5597 11.5348 48.7172 12.1671V14.5268C47.6787 13.8198 46.4477 13.4452 45.189 13.4531C42.7082 13.4531 40.9189 15.2819 40.9189 17.7979C40.9189 20.3139 42.6756 22.1043 44.9516 22.1043Z",
    fill: "#0D0422"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M51.1357 14.7834H52.9933L53.2278 16.1933H53.2634C53.5127 15.7341 53.883 15.3509 54.3346 15.0848C54.7863 14.8188 55.3022 14.6799 55.8272 14.6831C56.0548 14.6766 56.2822 14.6994 56.5038 14.751V16.913C56.2594 16.8666 56.0108 16.8448 55.762 16.8481C54.5958 16.8481 53.4652 17.5 53.4652 19.2638V24.0097H51.1357V14.7834Z",
    fill: "#0D0422"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M57.4652 19.4142C57.4652 16.4646 59.5068 14.5651 61.6196 14.5651C62.2496 14.5532 62.8716 14.7068 63.4229 15.0103C63.9741 15.3137 64.435 15.7564 64.7591 16.2936L64.9965 14.7834H66.955V24.0097H64.9876L64.7502 22.4995C64.4272 23.0389 63.967 23.4843 63.4159 23.7908C62.8648 24.0974 62.2422 24.2542 61.6107 24.2457C59.5068 24.2457 57.4652 22.3166 57.4652 19.4142ZM64.6553 19.3965C64.6553 17.7861 63.6256 16.6623 62.2576 16.6623C60.8896 16.6623 59.8124 17.8038 59.8124 19.3965C59.8124 20.9893 60.857 22.1308 62.2576 22.1308C63.6582 22.1308 64.6553 21.007 64.6553 19.3965Z",
    fill: "#0D0422"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M70.0321 16.7124H68.7502V14.7834H70.0321V13.7097C70.0321 11.94 71.2992 10.4209 73.5099 10.4209C74.0881 10.4237 74.6625 10.5143 75.2132 10.6893V12.6862C74.79 12.5424 74.3459 12.4687 73.8987 12.4679C72.869 12.4679 72.3289 12.9045 72.3289 13.9427V14.7981H74.8423V16.7272H72.3437V24.0097H70.0321V16.7124Z",
    fill: "#0D0422"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M76.958 16.7124H75.6701V14.7834H76.9698V13.7097C76.9698 11.94 78.234 10.4209 80.4447 10.4209C81.0238 10.424 81.5992 10.5145 82.151 10.6893V12.6862C81.7267 12.5424 81.2816 12.4687 80.8334 12.4679C79.8037 12.4679 79.2637 12.9045 79.2637 13.9427V14.7981H81.78V16.7272H79.2815V24.0097H76.952L76.958 16.7124Z",
    fill: "#0D0422"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M91.4744 20.0691H84.9461C85.2665 21.5439 86.4654 22.3668 88.0025 22.3668C89.0676 22.3429 90.0991 21.9915 90.9551 21.361V23.3402C89.9884 23.9383 88.8711 24.2522 87.7325 24.2457C84.5929 24.2457 82.7175 22.2488 82.7175 19.432C82.7175 16.4824 84.7947 14.5651 87.3259 14.5651C89.6376 14.5651 91.5278 16.1756 91.5278 19.2284C91.5288 19.5095 91.5109 19.7904 91.4744 20.0691ZM89.3141 18.5943C89.2785 17.1667 88.4001 16.4116 87.32 16.4116C86.1746 16.4116 85.1953 17.2522 84.9461 18.5943H89.3141Z",
    fill: "#0D0422"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M93.4302 14.7834H95.2878L95.5222 16.2051H95.5519C95.8014 15.7454 96.1722 15.3619 96.6244 15.0959C97.0766 14.8298 97.5932 14.6912 98.1187 14.6949C98.3452 14.6887 98.5716 14.7115 98.7923 14.7627V16.913C98.5469 16.8664 98.2973 16.8447 98.0475 16.8481C96.8843 16.8481 95.7537 17.5 95.7537 19.2638V24.0097H93.4243L93.4302 14.7834Z",
    fill: "#0D0422"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M14.4819 25.517V16.1726C14.4827 15.6975 14.6731 15.2421 15.0114 14.9065C15.3496 14.5708 15.8081 14.3822 16.2861 14.3822H25.3367C25.6374 14.3822 25.9257 14.2635 26.1383 14.0522C26.3508 13.8409 26.4703 13.5543 26.4703 13.2555V8.48009C26.4695 8.18177 26.3497 7.89593 26.1372 7.68527C25.9247 7.4746 25.6368 7.35629 25.3367 7.35629H9.07525C8.6361 7.35629 8.21494 7.5297 7.90441 7.83836C7.59389 8.14702 7.41943 8.56566 7.41943 9.00217V25.5199C7.42022 25.8177 7.53958 26.1031 7.75144 26.3137C7.9633 26.5243 8.25041 26.6429 8.55002 26.6437H13.3543C13.6539 26.6422 13.9407 26.5228 14.152 26.3116C14.3633 26.1005 14.4819 25.8148 14.4819 25.517V25.517Z",
    fill: "#4716B8"
  }), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M25.3397 19.2845H20.1942C19.5714 19.2845 19.0666 19.7863 19.0666 20.4053V25.5199C19.0666 26.1389 19.5714 26.6408 20.1942 26.6408H25.3397C25.9625 26.6408 26.4673 26.1389 26.4673 25.5199V20.4053C26.4673 19.7863 25.9625 19.2845 25.3397 19.2845Z",
    fill: "#4716B8"
  })), /*#__PURE__*/React__namespace.default.createElement("defs", null, /*#__PURE__*/React__namespace.default.createElement("clipPath", {
    id: "clip0_4225_55734"
  }, /*#__PURE__*/React__namespace.default.createElement("rect", {
    width: "91.3787",
    height: "19.2845",
    fill: "white",
    transform: "translate(7.41943 7.35629)"
  }))));
};

var css_248z$e = ":root {\n  /* Color styles */\n\n  /* Text-size styles */\n\n  /* Effect styles */\n  /* border-radius */\n}\n\n.side-menu-module_menuIcon__3TA-P {\n  margin-top: 10px;\n}\n\n.side-menu-module_menuList__3ia1K {\n  min-width: 172px;\n  max-width: 320px;\n  display: flex;\n  flex-direction: column;\n}\n\n.side-menu-module_icon__BdjL_ {\n  display: inline-flex;\n  align-items: center;\n  width: 100%;\n}\n\n.side-menu-module_icon__BdjL_::before {\n  content: \"\";\n  display: inline-block;\n  width: 16px;\n  height: 16px;\n  border-radius: 3px;\n  margin-right: 4px;\n}\n\n.side-menu-module_item__E1pQO:hover {\n  background: #f1f2f7;\n}\n\n.side-menu-module_item__E1pQO:hover a {\n  color: #0f1192;\n}\n\n.side-menu-module_sideMenuNavDropDown__2eQ3K {\n  border-radius: 6px;\n  border-top: none;\n  display: block;\n  transition-duration: 86ms;\n  transition-property: opacity, transform;\n  opacity: 1;\n  transform: translateY(0);\n  pointer-events: auto;\n  z-index: 20;\n  position: absolute;\n  min-width: 100%;\n  position: absolute;\n  top: 100%;\n  left: 0;\n  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);\n  top: 100%;\n  background-color: #ffffff;\n}\n\n.side-menu-module_sideMenuNavDropDown__2eQ3K .side-menu-module_item__E1pQO {\n  padding-top: 8px;\n  padding-bottom: 8px;\n  padding-left: 16px;\n  padding-right: 16px;\n  white-space: nowrap;\n  align-items: center;\n  display: flex;\n}\n\n.side-menu-module_smartApply__kYoZ9::before {\n  background: #3aa393;\n}\n\n.side-menu-module_survey__1KLby::before {\n  background: #6f3a9a;\n}\n\n.side-menu-module_boothReserve__xyR4l::before {\n  background: #7780d9;\n}\n\n.side-menu-module_madoguchiEditor__2blvO::before {\n  background: #b1110c;\n}\n\n.side-menu-module_ttzkPortal__1zCGH::before {\n  background: #f0a30c;\n}\n\n.side-menu-module_aiStudio__m_hIX::before {\n  background: #eaa6e3;\n}\n\n.side-menu-module_call__2yPiy::before {\n  background: #f1a6a1;\n}\n\n.side-menu-module_dataSight__38qgJ::before {\n  background: #84d4e5;\n}\n\n.side-menu-module_ttzkGuide__VEtcc::before {\n  background: #9e5bb8;\n}\n\n.side-menu-module_setting__8UZeh::before {\n  background: #5f636d;\n}\n\n.side-menu-module_kintoneExport__1sOeL::before {\n  background: #f2d323;\n}\n\n.side-menu-module_ninteiShoukai__juC8X::before {\n  background: #c6e79d;\n}\n";
var styles$d = {"menuIcon":"side-menu-module_menuIcon__3TA-P","menuList":"side-menu-module_menuList__3ia1K","icon":"side-menu-module_icon__BdjL_","item":"side-menu-module_item__E1pQO","sideMenuNavDropDown":"side-menu-module_sideMenuNavDropDown__2eQ3K","smartApply":"side-menu-module_smartApply__kYoZ9","survey":"side-menu-module_survey__1KLby","boothReserve":"side-menu-module_boothReserve__xyR4l","madoguchiEditor":"side-menu-module_madoguchiEditor__2blvO","ttzkPortal":"side-menu-module_ttzkPortal__1zCGH","aiStudio":"side-menu-module_aiStudio__m_hIX","call":"side-menu-module_call__2yPiy","dataSight":"side-menu-module_dataSight__38qgJ","ttzkGuide":"side-menu-module_ttzkGuide__VEtcc","setting":"side-menu-module_setting__8UZeh","kintoneExport":"side-menu-module_kintoneExport__1sOeL","ninteiShoukai":"side-menu-module_ninteiShoukai__juC8X"};
styleInject(css_248z$e);

var SideMenuList = function SideMenuList(_ref) {
  var onClick = _ref.onClick,
    settingPath = _ref.settingPath,
    product = _ref.product;
  return /*#__PURE__*/React__namespace.createElement("div", {
    className: classnames__default.default(styles$d.sideMenuNavDropDown)
  }, product.smartApply && (/*#__PURE__*/React__namespace.createElement("div", {
    className: classnames__default.default(styles$d.item)
  }, /*#__PURE__*/React__namespace.createElement("a", {
    href: product.smartApply.urlPath,
    onClick: onClick,
    className: classnames__default.default(styles$d.smartApply, styles$d.icon)
  }, "\u30B9\u30DE\u30FC\u30C8\u7533\u8ACB"))), product.survey && (/*#__PURE__*/React__namespace.createElement("div", {
    className: classnames__default.default(styles$d.item)
  }, /*#__PURE__*/React__namespace.createElement("a", {
    href: product.survey.urlPath,
    onClick: onClick,
    className: classnames__default.default(styles$d.survey, styles$d.icon)
  }, "\u30A2\u30F3\u30B1\u30FC\u30C8"))), product.kintoneExport && (/*#__PURE__*/React__namespace.createElement("div", {
    className: classnames__default.default(styles$d.item)
  }, /*#__PURE__*/React__namespace.createElement("a", {
    href: product.kintoneExport.urlPath,
    onClick: onClick,
    className: classnames__default.default(styles$d.kintoneExport, styles$d.icon)
  }, "kintone\u9023\u643A"))), product.boothReserve && (/*#__PURE__*/React__namespace.createElement("div", {
    className: classnames__default.default(styles$d.item)
  }, /*#__PURE__*/React__namespace.createElement("a", {
    href: product.boothReserve.urlPath,
    onClick: onClick,
    className: classnames__default.default(styles$d.boothReserve, styles$d.icon)
  }, "\u7A93\u53E3\u4E88\u7D04"))), product.madoguchiEditor && (/*#__PURE__*/React__namespace.createElement("div", {
    className: classnames__default.default(styles$d.item)
  }, /*#__PURE__*/React__namespace.createElement("a", {
    href: product.madoguchiEditor.urlPath,
    onClick: onClick,
    className: classnames__default.default(styles$d.madoguchiEditor, styles$d.icon)
  }, "\u7A93\u53E3\u66F8\u985E\u4F5C\u6210(\u03B2)"))), product.ttzkPortal && (/*#__PURE__*/React__namespace.createElement("div", {
    className: classnames__default.default(styles$d.item)
  }, /*#__PURE__*/React__namespace.createElement("a", {
    href: product.ttzkPortal.urlPath,
    onClick: onClick,
    className: classnames__default.default(styles$d.ttzkPortal, styles$d.icon)
  }, "\u30DD\u30FC\u30BF\u30EB"))), product.aiStudio && (/*#__PURE__*/React__namespace.createElement("div", {
    className: classnames__default.default(styles$d.item)
  }, /*#__PURE__*/React__namespace.createElement("a", {
    href: product.aiStudio.urlPath,
    onClick: onClick,
    className: classnames__default.default(styles$d.aiStudio, styles$d.icon)
  }, "AI Studio"))), product.call && (/*#__PURE__*/React__namespace.createElement("div", {
    className: classnames__default.default(styles$d.item)
  }, /*#__PURE__*/React__namespace.createElement("a", {
    href: product.call.urlPath,
    onClick: onClick,
    className: classnames__default.default(styles$d.call, styles$d.icon)
  }, "\u30B3\u30FC\u30EB"))), product.dataSight && (/*#__PURE__*/React__namespace.createElement("div", {
    className: classnames__default.default(styles$d.item)
  }, /*#__PURE__*/React__namespace.createElement("a", {
    href: product.dataSight.urlPath,
    onClick: onClick,
    className: classnames__default.default(styles$d.dataSight, styles$d.icon)
  }, "\u96C6\u8A08(\u03B2)"))), product.ttzkGuide && (/*#__PURE__*/React__namespace.createElement("div", {
    className: classnames__default.default(styles$d.item)
  }, /*#__PURE__*/React__namespace.createElement("a", {
    href: product.ttzkGuide.urlPath,
    onClick: onClick,
    className: classnames__default.default(styles$d.ttzkGuide, styles$d.icon)
  }, "\u624B\u7D9A\u304D\u30AC\u30A4\u30C9"))), product.ninteiShoukai && (/*#__PURE__*/React__namespace.createElement("div", {
    className: classnames__default.default(styles$d.item)
  }, /*#__PURE__*/React__namespace.createElement("a", {
    href: product.ninteiShoukai.urlPath,
    onClick: onClick,
    className: classnames__default.default(styles$d.ninteiShoukai, styles$d.icon)
  }, "\u8A8D\u5B9A\u7167\u4F1A"))), /*#__PURE__*/React__namespace.createElement("div", {
    className: classnames__default.default(styles$d.item)
  }, /*#__PURE__*/React__namespace.createElement("a", {
    href: settingPath,
    onClick: onClick,
    className: classnames__default.default(styles$d.setting, styles$d.icon)
  }, "\u8A2D\u5B9A\u30FB\u30B5\u30DD\u30FC\u30C8")));
};

dayjs__default.default.locale(ja__default.default);
var isLastDayOfMonth = function isLastDayOfMonth(date) {
  return date.getDate() === dayjs__default.default(date).daysInMonth();
};
/**
 * 日付で使用できない文字を弾く
 * @param value
 * @returns
 */
var removeInvalidDateString = function removeInvalidDateString(value) {
  if (!value) return "";
  var v = value.trim();
  if (v && v.length === 1 && v.match(/[０0]/g)) return "";
  if (!v.match(/[０-９-0-9]/g)) return "";
  return value;
};
var getSeparator = function getSeparator(format) {
  switch (format) {
    case "YYYY/MM/DD":
      return "/";
    case "YYYY-MM-DD":
      return "-";
  }
  throw new Error("Invalid date format");
};
var isValidDateString = function isValidDateString(value, format) {
  if (!value) return true;
  if (typeof value === "string") {
    return value === dayjs__default.default(value, undefined).format(format);
  }
  return true;
};
var formatValue = function formatValue(value, format) {
  var v = value.replace(/\D/g, "").match(/^(\d{0,4})(\d{1,2})?(\d{1,2})?$/);
  var ymd = v || [];
  ymd.shift();
  return ymd.filter(function (_) {
    return _;
  }).join(getSeparator(format));
};
/**
 * 範囲チェック
 * @param start
 * @param end
 * @returns
 */
var isValidDayRange = function isValidDayRange(start, end, isSame) {
  if (!start || !end) return true;
  {
    // 同じ日を許可するためにdayオプションを追加（dayオプションがない場合、時間まで一致している必要があるため）
    return dayjs__default.default(end).diff(dayjs__default.default(start), "day") >= 0;
  }
};

var useNotification = function useNotification(_ref) {
  var notifications = _ref.notifications,
    showNewNotification = _ref.showNewNotification,
    onCloseNotification = _ref.onCloseNotification;
  var _useState = React.useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showNotification = _useState2[0],
    setNotification = _useState2[1];
  var handleOnToggleNotification = function handleOnToggleNotification() {
    setNotification(function (prev) {
      if (prev) {
        onCloseNotification && onCloseNotification();
      }
      return !prev;
    });
  };
  var handleOnCloseNotification = function handleOnCloseNotification() {
    setNotification(false);
    onCloseNotification && onCloseNotification();
  };
  var notificationItems = React__namespace.default.useMemo(function () {
    var _a;
    if (!notifications) {
      return [];
    }
    var newContents = (_a = notifications.recentContents) === null || _a === void 0 ? void 0 : _a.map(function (content) {
      return {
        content: (/*#__PURE__*/React__namespace.default.createElement(React__namespace.default.Fragment, null, /*#__PURE__*/React__namespace.default.createElement("p", {
          className: styles$f.left
        }, /*#__PURE__*/React__namespace.default.createElement("span", {
          className: styles$f.notificationItemText
        }, dayjs__default.default(content.publishedAt).format("YYYY年MM月DD日")), /*#__PURE__*/React__namespace.default.createElement("span", {
          className: styles$f.notificationItemText
        }, content.title)), /*#__PURE__*/React__namespace.default.createElement("p", {
          className: styles$f.right
        }, /*#__PURE__*/React__namespace.default.createElement(Icons.ArrowRightIcon, {
          size: 24
        })))),
        onClick: function onClick() {
          content.onClickForTracking && content.onClickForTracking();
          window.location.assign(content.url);
        }
      };
    });
    return [].concat(_toConsumableArray(newContents !== null && newContents !== void 0 ? newContents : []), [{
      content: (/*#__PURE__*/React__namespace.default.createElement(React__namespace.default.Fragment, null, /*#__PURE__*/React__namespace.default.createElement("p", {
        className: styles$f.notificationList
      }, "\u304A\u77E5\u3089\u305B\u4E00\u89A7\u306F\u3053\u3061\u3089"), /*#__PURE__*/React__namespace.default.createElement("p", {
        className: styles$f.right
      }, /*#__PURE__*/React__namespace.default.createElement(Icons.ArrowRightIcon, {
        size: 24
      })))),
      onClick: function onClick() {
        notifications.onClickForTracking && notifications.onClickForTracking();
        window.location.assign(notifications.path);
      }
    }]);
  }, [notifications]);
  React__namespace.default.useEffect(function () {
    // 新着のお知らせがある場合、Popupを表示した状態にする
    // Popupを表示するしない、しないはプロダクト側で制御する
    if (showNewNotification) {
      setNotification(true);
    }
  }, [showNewNotification]);
  return {
    notificationItems: notificationItems,
    handleOnCloseNotification: handleOnCloseNotification,
    handleOnToggleNotification: handleOnToggleNotification,
    showNotification: showNotification
  };
};

function useWrapped(maxHeight) {
  var _React$useState = React__namespace.default.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isWrapped = _React$useState2[0],
    setIsWrapped = _React$useState2[1];
  var ref = React__namespace.default.useRef(null);
  React__namespace.default.useEffect(function () {
    var handleResize = function handleResize() {
      var menuElement = ref.current;
      if (menuElement) {
        var _isWrapped = menuElement.clientHeight > maxHeight;
        setIsWrapped(_isWrapped);
      }
    };
    window.addEventListener("resize", handleResize);
    handleResize();
    return function () {
      window.removeEventListener("resize", handleResize);
    };
  }, [maxHeight]);
  return {
    ref: ref,
    isWrapped: isWrapped
  };
}

var _excluded$1 = ["envText", "onLogout", "tenantName", "tenantUserName", "logoName", "onLogoClick", "notifications", "helpPath", "showNewNotification", "settingPath", "verified", "isDisplayNotification", "onCloseNotification"];
var Popup = function Popup(_ref) {
  var name = _ref.name,
    onOutsideClick = _ref.onOutsideClick,
    isActive = _ref.isActive,
    target = _ref.target,
    items = _ref.items,
    _ref$hasCloseButton = _ref.hasCloseButton,
    hasCloseButton = _ref$hasCloseButton === void 0 ? false : _ref$hasCloseButton,
    className = _ref.className;
  return /*#__PURE__*/React__namespace.createElement(OutsideClickHandler__default.default, {
    onOutsideClick: onOutsideClick
  }, /*#__PURE__*/React__namespace.createElement("div", {
    className: classnames__default.default(styles$f.popup, _defineProperty({}, styles$f.isActive, isActive), className)
  }, target, /*#__PURE__*/React__namespace.createElement("div", {
    className: styles$f.menu,
    role: "menu"
  }, /*#__PURE__*/React__namespace.createElement("div", {
    className: styles$f.contentWrapper
  }, /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, hasCloseButton && (/*#__PURE__*/React__namespace.createElement("div", {
    className: styles$f.closeButtonWrapper,
    role: "menuitem"
  }, /*#__PURE__*/React__namespace.createElement(CloseButton, {
    onClose: onOutsideClick
  }))), /*#__PURE__*/React__namespace.createElement("div", {
    className: styles$f.menuWrapper
  }, items.map(function (item, index) {
    return /*#__PURE__*/React__namespace.createElement("button", {
      key: "".concat(name, "-").concat(index),
      className: styles$f.content,
      onClick: item.onClick,
      role: "menuitem",
      type: "button"
    }, item.content);
  })))))));
};
var Header = function Header(_ref2) {
  var _ref2$envText = _ref2.envText,
    envText = _ref2$envText === void 0 ? "local" : _ref2$envText,
    onLogout = _ref2.onLogout,
    tenantName = _ref2.tenantName,
    tenantUserName = _ref2.tenantUserName,
    logoName = _ref2.logoName,
    onLogoClick = _ref2.onLogoClick,
    notifications = _ref2.notifications,
    helpPath = _ref2.helpPath,
    showNewNotification = _ref2.showNewNotification,
    settingPath = _ref2.settingPath,
    verified = _ref2.verified,
    _ref2$isDisplayNotifi = _ref2.isDisplayNotification,
    isDisplayNotification = _ref2$isDisplayNotifi === void 0 ? true : _ref2$isDisplayNotifi,
    onCloseNotification = _ref2.onCloseNotification,
    props = _objectWithoutProperties(_ref2, _excluded$1);
  var _useState = React.useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showMenu = _useState2[0],
    setShowMenu = _useState2[1];
  var _useState3 = React.useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showUserMenu = _useState4[0],
    setShowUserMenu = _useState4[1];
  var _useNotification = useNotification({
      notifications: notifications,
      showNewNotification: showNewNotification,
      onCloseNotification: onCloseNotification
    }),
    handleOnCloseNotification = _useNotification.handleOnCloseNotification,
    handleOnToggleNotification = _useNotification.handleOnToggleNotification,
    notificationItems = _useNotification.notificationItems,
    showNotification = _useNotification.showNotification;
  var _useWrapped = useWrapped(54),
    ref = _useWrapped.ref,
    isWrapped = _useWrapped.isWrapped;
  var headerId = "header-".concat(React__namespace.useId());
  return /*#__PURE__*/React__namespace.createElement("header", {
    id: headerId,
    className: classnames__default.default(styles$f.header, isWrapped && styles$f.wrapped),
    "aria-label": "dropdown navigation",
    ref: ref
  }, /*#__PURE__*/React__namespace.createElement("div", {
    className: styles$f.navStart
  }, /*#__PURE__*/React__namespace.createElement("button", {
    className: classnames__default.default(styles$f.icon, styles$f.grafferLogo),
    onClick: onLogoClick
  }, /*#__PURE__*/React__namespace.createElement(GrafferLogo, null)), /*#__PURE__*/React__namespace.createElement("div", {
    className: classnames__default.default(styles$f.dropDown, styles$f.navItem)
  }, /*#__PURE__*/React__namespace.createElement("p", {
    className: styles$f.tenantName
  }, tenantName), /*#__PURE__*/React__namespace.createElement("div", {
    className: styles$f.dropdownItem
  }, /*#__PURE__*/React__namespace.createElement("button", {
    className: classnames__default.default(styles$f.logo),
    onClick: function onClick() {
      return setShowMenu(!showMenu);
    }
  }, logoName, /*#__PURE__*/React__namespace.createElement("span", {
    className: classnames__default.default(styles$f.dropAllow, styles$f.icon)
  }, /*#__PURE__*/React__namespace.createElement(ArrowDownIcon, {
    size: 24
  }))), showMenu && (/*#__PURE__*/React__namespace.createElement(OutsideClickHandler__default.default, {
    onOutsideClick: function onOutsideClick() {
      setShowMenu(false);
    }
  }, /*#__PURE__*/React__namespace.createElement(SideMenuList, _objectSpread2({
    onClick: function onClick() {
      return setShowMenu(function (showMenu) {
        return !showMenu;
      });
    },
    settingPath: settingPath
  }, props))))), /*#__PURE__*/React__namespace.createElement(EnvTag, {
    envConfig: new EnvConfig(envText)
  }))), /*#__PURE__*/React__namespace.createElement("div", {
    className: classnames__default.default(styles$f.navEnd, styles$f.dropDown, styles$f.navItem)
  }, helpPath && (/*#__PURE__*/React__namespace.createElement("a", {
    className: classnames__default.default(styles$f.link, styles$f.iconWrapper, styles$f.questionLink),
    target: "_blank",
    rel: "noreferrer noopener",
    href: helpPath
  }, /*#__PURE__*/React__namespace.createElement("span", {
    className: classnames__default.default(styles$f.icon)
  }, /*#__PURE__*/React__namespace.createElement(Icons.QuestionCircleIcon, {
    size: 24
  })), "\u30D8\u30EB\u30D7", /*#__PURE__*/React__namespace.createElement(Icons.OpenInNewIcon, {
    size: 24
  }))), isDisplayNotification && (/*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, /*#__PURE__*/React__namespace.createElement(Popup, {
    onOutsideClick: function onOutsideClick() {
      handleOnCloseNotification();
    },
    target: /*#__PURE__*/React__namespace.createElement("button", {
      className: classnames__default.default(styles$f.iconWrapper),
      onClick: handleOnToggleNotification,
      type: "button"
    }, /*#__PURE__*/React__namespace.createElement("span", {
      className: classnames__default.default(styles$f.icon, styles$f.question)
    }, /*#__PURE__*/React__namespace.createElement(Icons.AttentionCircleIcon, {
      size: 24
    })), showNewNotification && (
    /*#__PURE__*/
    // 新着のお知らせがある場合、バッジを表示する
    React__namespace.createElement("span", {
      className: classnames__default.default(styles$f.badge, styles$f.withIcon)
    })), /*#__PURE__*/React__namespace.createElement("span", {
      className: classnames__default.default(styles$f.name)
    }, "\u304A\u77E5\u3089\u305B")),
    isActive: showNotification,
    name: "notificationMenu",
    items: notificationItems,
    hasCloseButton: true,
    className: styles$f.notificationMenu
  }), /*#__PURE__*/React__namespace.createElement("p", {
    className: classnames__default.default(styles$f.name, styles$f.slash)
  }, "|"))), verified && (/*#__PURE__*/React__namespace.createElement(Popup, {
    name: "userMenu",
    isActive: showUserMenu,
    target: /*#__PURE__*/React__namespace.createElement("button", {
      className: classnames__default.default(styles$f.name, styles$f.iconWrapper),
      onClick: function onClick() {
        return setShowUserMenu(true);
      },
      type: "button"
    }, /*#__PURE__*/React__namespace.createElement("span", {
      className: classnames__default.default(styles$f.name)
    }, tenantUserName), /*#__PURE__*/React__namespace.createElement("span", {
      className: classnames__default.default(styles$f.dropAllow, styles$f.icon)
    }, /*#__PURE__*/React__namespace.createElement(ArrowDownIcon, {
      size: 24
    }))),
    onOutsideClick: function onOutsideClick() {
      setShowUserMenu(false);
    },
    items: [{
      content: "ログアウト",
      onClick: onLogout
    }]
  }))));
};

var css_248z$d = ":root {\n  /* font */\n  /* color */\n  /* shadow */\n  /* 余白 */\n  /* border-radius */\n}\n\n.menuList-module_menuContainer__3O32u {\n  color: #353ebd;\n  grid-area: sidemenu;\n  white-space: nowrap;\n}\n\n.menuList-module_menuContainer__3O32u.menuList-module_withMargin__1MO3z {\n  margin: 2em 16px 0 16px;\n}\n\n.menuList-module_menuContainer__3O32u.menuList-module_open__kMyMt {\n  width: 254px;\n}\n\n.menuList-module_menuContainer__3O32u.menuList-module_close__11T8X {\n  width: 34px;\n}\n\n.menuList-module_closeSideBar__21H_l {\n  width: 100%;\n  background: #f1f2f7;\n  border-radius: 14px;\n  padding: 5px 40px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  font-weight: 300;\n  font-size: 13px;\n  line-height: 18px;\n  margin-bottom: 10px;\n}\n\n.menuList-module_closeSideBar__21H_l:hover {\n  background: #c5c7ef;\n  color: #3739a2;\n}\n\n.menuList-module_closeSideBar__21H_l .menuList-module_icon__2piKx {\n  margin-right: 8px;\n  line-height: 8px;\n}\n\n.menuList-module_openSideBar__1kWhP {\n  width: 34px;\n  height: 28px;\n  border-radius: 40px;\n  background: #f1f2f7;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 10px;\n  cursor: pointer;\n}\n\n.menuList-module_openSideBar__1kWhP:hover {\n  background: #c5c7ef;\n}\n\n.menuList-module_menuListWrapper__14lZN {\n  margin-top: 4px;\n}\n\n.menuList-module_h2__3dlQv {\n  margin-left: 24px;\n  color: #1d1c1a;\n  font-weight: 300;\n  font-size: 14px;\n  padding-top: 2px;\n  padding-bottom: 2px;\n}\n\n.menuList-module_menuLink__3YGAG.menuList-module_isActive__26ZlS a {\n  width: 100%;\n}\n\n.menuList-module_menuLink__3YGAG:not(.menuList-module_isActive__26ZlS) a::before {\n  content: \"･\";\n  display: inline-block;\n  margin: 0px 2px;\n  font-weight: 600;\n  width: 16px;\n  text-align: center;\n}\n\n.menuList-module_menuLink__3YGAG.menuList-module_isActive__26ZlS a::before {\n  content: \"|\";\n  display: inline-block;\n  margin: 0px 2px;\n  font-weight: 600;\n  width: 16px;\n  text-align: center;\n  vertical-align: text-bottom;\n}\n\n.menuList-module_menuLinkWrapper__1qYb5:not(:first-of-type) {\n  margin-top: 4px;\n}\n\n.menuList-module_menuLink__3YGAG a {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: 4px 32px;\n  border-top-right-radius: 14px;\n  border-bottom-right-radius: 14px;\n  line-height: 20px;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n}\n\n.menuList-module_menuLink__3YGAG a:hover {\n  background: #f1f2f7;\n}\n\n.menuList-module_menuLink__3YGAG.menuList-module_isActive__26ZlS a {\n  background: #f1f2f7;\n}\n\n.menuList-module_menuLink__3YGAG a:hover {\n  color: #3739a2;\n  font-weight: 600;\n}\n\n.menuList-module_menuLink__3YGAG.menuList-module_isActive__26ZlS a {\n  color: #3739a2;\n  font-weight: 600;\n}\n";
var styles$c = {"menuContainer":"menuList-module_menuContainer__3O32u","withMargin":"menuList-module_withMargin__1MO3z","open":"menuList-module_open__kMyMt","close":"menuList-module_close__11T8X","closeSideBar":"menuList-module_closeSideBar__21H_l","icon":"menuList-module_icon__2piKx","openSideBar":"menuList-module_openSideBar__1kWhP","menuListWrapper":"menuList-module_menuListWrapper__14lZN","h2":"menuList-module_h2__3dlQv","menuLink":"menuList-module_menuLink__3YGAG","isActive":"menuList-module_isActive__26ZlS","menuLinkWrapper":"menuList-module_menuLinkWrapper__1qYb5"};
styleInject(css_248z$d);

var DEFAULT_SHOW_MENU_STATE$1 = true;
var MenuLink$1 = function MenuLink(_ref) {
  var title = _ref.title,
    hidden = _ref.hidden,
    isActive = _ref.active,
    anchor = _ref.anchor;
  return hidden ? (/*#__PURE__*/React__namespace.default.createElement(React__namespace.default.Fragment, null)) : (/*#__PURE__*/React__namespace.default.createElement("li", {
    className: classnames__default.default(styles$c.menuLink, isActive && styles$c.isActive)
  }, /*#__PURE__*/React__namespace.default.createElement(Anchor, {
    "data-for-rpa-id": "side-menu-".concat(title),
    anchor: anchor
  }, title)));
};
var MenuSection = function MenuSection(_ref2) {
  var item = _ref2.item;
  var hidden = React.useMemo(function () {
    return item.navItems.every(function (_) {
      return _.hidden;
    });
  }, [item]);
  return /*#__PURE__*/React__namespace.default.createElement(React__namespace.default.Fragment, null, hidden ? (/*#__PURE__*/React__namespace.default.createElement(React__namespace.default.Fragment, null)) : (/*#__PURE__*/React__namespace.default.createElement("div", {
    className: styles$c.menuListWrapper
  }, /*#__PURE__*/React__namespace.default.createElement("p", {
    "data-testid": "test-sidemenu-header",
    className: styles$c.h2
  }, item.header), /*#__PURE__*/React__namespace.default.createElement("ul", {
    className: classnames__default.default(styles$c.menuListWrapper)
  }, item.navItems.map(function (l) {
    return /*#__PURE__*/React__namespace.default.createElement(MenuLink$1, {
      key: l.title,
      title: l.title,
      hidden: l.hidden,
      active: l.active,
      anchor: l.anchor
    });
  })))));
};
var MenuList$1 = function MenuList(_ref3) {
  var persistKey = _ref3.persistKey,
    items = _ref3.items,
    _ref3$withMargin = _ref3.withMargin,
    withMargin = _ref3$withMargin === void 0 ? true : _ref3$withMargin,
    onError = _ref3.onError;
  var initialShowMenuState = React__namespace.default.useMemo(function () {
    if (!persistKey) {
      return DEFAULT_SHOW_MENU_STATE$1;
    }
    try {
      var persistedValue = localStorage.getItem(persistKey);
      if (typeof persistedValue !== "string") {
        return DEFAULT_SHOW_MENU_STATE$1;
      }
      return persistedValue === "true";
    } catch (error) {
      // localStorage API の意図しないエラーをonErrorが渡されている時はハンドルし、そうではない場合はthrowする
      if (onError) {
        onError(error);
      } else {
        throw error;
      }
      return true;
    }
  }, [onError, persistKey]);
  var _React$useState = React__namespace.default.useState(initialShowMenuState),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    showMenu = _React$useState2[0],
    setShowMenu = _React$useState2[1];
  React__namespace.default.useEffect(function () {
    if (!persistKey) {
      return;
    }
    localStorage.setItem(persistKey, String(showMenu));
  }, [persistKey, showMenu]);
  return /*#__PURE__*/React__namespace.default.createElement("div", {
    className: classnames__default.default(styles$c.menuContainer, withMargin ? styles$c.withMargin : "", showMenu ? styles$c.open : styles$c.close)
  }, /*#__PURE__*/React__namespace.default.createElement("aside", {
    className: classnames__default.default(styles$c.menuListToggle, showMenu ? "" : "is-hidden")
  }, /*#__PURE__*/React__namespace.default.createElement("div", {
    onClick: function onClick() {
      setShowMenu(false);
    },
    className: styles$c.closeSideBar
  }, /*#__PURE__*/React__namespace.default.createElement("span", {
    className: styles$c.icon
  }, /*#__PURE__*/React__namespace.default.createElement(CloseMenuIcon, {
    size: 16
  })), "\u30B5\u30A4\u30C9\u30D0\u30FC\u3092\u9589\u3058\u308B"), /*#__PURE__*/React__namespace.default.createElement("nav", {
    className: styles$c.menuListWrapper
  }, items.map(function (item, index) {
    return /*#__PURE__*/React__namespace.default.createElement(MenuSection, {
      key: "menu-section-".concat(index),
      item: item
    });
  }))), /*#__PURE__*/React__namespace.default.createElement("aside", {
    className: classnames__default.default(styles$c.menuListToggle, showMenu ? "is-hidden" : ""),
    onClick: function onClick() {
      setShowMenu(true);
    }
  }, /*#__PURE__*/React__namespace.default.createElement("div", {
    className: styles$c.openSideBar
  }, /*#__PURE__*/React__namespace.default.createElement(OpenMenuIcon, {
    size: 16
  }))));
};

var css_248z$c = ":root {\n  /* Color styles */\n\n  /* Text-size styles */\n\n  /* Effect styles */\n  /* border-radius */\n}\n\n.menuList-module_menuContainer__3clNb {\n  color: #353ebd;\n  grid-area: sidemenu;\n  white-space: nowrap;\n  border-right: 1px solid #b2b8c8;\n  width: -moz-max-content;\n  width: max-content;\n  min-height: calc(100vh - 56px);\n}\n\n.menuList-module_menuContainer__3clNb.menuList-module_open__U8gWK {\n  width: 200px;\n}\n\n.menuList-module_openMenuListWrapper__2TaH0,\n.menuList-module_closeMenuListWrapper__1RHae {\n  display: inline-flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n.menuList-module_buttonWrapper__w9UZE {\n  padding: 16px;\n}\n\n.menuList-module_closeSideBar__38nKa {\n  background: #ffffff;\n  border-radius: 14px;\n  padding: 6px 12px;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  font-weight: 300;\n  font-size: 13px;\n  line-height: 18px;\n  color: #353ebd;\n  border: 1px solid #353ebd;\n  width: 100%;\n  justify-content: center;\n}\n\n.menuList-module_openSideBar__JAsCN {\n  background: #ffffff;\n  border-radius: 14px;\n  padding: 6px 12px;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  font-weight: 300;\n  font-size: 13px;\n  line-height: 18px;\n  color: #353ebd;\n  border: 1px solid #353ebd;\n  width: 100%;\n  justify-content: center;\n}\n\n.menuList-module_closeSideBar__38nKa:focus-visible {\n  outline: none;\n  border: 1px solid #353ebd;\n  box-shadow: 0px 0px 5px rgba(53, 62, 189, 1);\n}\n\n.menuList-module_openSideBar__JAsCN:focus-visible {\n  outline: none;\n  border: 1px solid #353ebd;\n  box-shadow: 0px 0px 5px rgba(53, 62, 189, 1);\n}\n\n.menuList-module_openMenuLink__29rYa *:not(svg):focus-visible {\n  outline: none;\n  border: 1px solid #353ebd;\n  box-shadow: 0px 0px 5px rgba(53, 62, 189, 1);\n}\n\n.menuList-module_closeMenuLink__2xTfk .menuList-module_anchor__3d2Fb *:not(svg):focus-visible {\n  outline: none;\n  border: 1px solid #353ebd;\n  box-shadow: 0px 0px 5px rgba(53, 62, 189, 1);\n}\n\n.menuList-module_h2__xzlo6 {\n  padding: 16px;\n}\n\n.menuList-module_closeMenuLink__2xTfk .menuList-module_anchor__3d2Fb *:not(svg):focus-visible {\n  background: #353ebd;\n}\n\n.menuList-module_closeSideBar__38nKa svg {\n  margin-right: 8px;\n  line-height: 8px;\n}\n\n.menuList-module_h2__xzlo6 {\n  color: #262b38;\n  font-weight: 300;\n  font-size: 14px;\n  padding-top: 2px;\n  padding-bottom: 2px;\n}\n\n.menuList-module_openMenuLink__29rYa.menuList-module_active__28aIU * {\n  width: 100%;\n}\n\n.menuList-module_openMenuLink__29rYa:not(.menuList-module_active__28aIU) *::before {\n  content: \"･\";\n  display: inline-block;\n  font-weight: 600;\n  text-align: center;\n}\n\n.menuList-module_openMenuLink__29rYa.menuList-module_active__28aIU *::before {\n  content: \"|\";\n  display: inline-block;\n  margin: 0px 2px;\n  font-weight: 600;\n  text-align: center;\n  vertical-align: text-bottom;\n}\n\n.menuList-module_openMenuLink__29rYa *:not(svg) {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: 4px 16px;\n  border-top-right-radius: 16px;\n  border-bottom-right-radius: 16px;\n  line-height: 20px;\n  gap: 4px;\n  font: 16px/28px Meiryo, Arial, system-ui, sans-serif;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n}\n\n.menuList-module_closeMenuSection__3bS3S {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  align-items: center;\n}\n\n.menuList-module_menuWrapper__1kGza {\n  width: 40px;\n  height: 56px;\n}\n\n.menuList-module_closeMenuLink__2xTfk {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  font: 300 8px/12px Meiryo, Arial, system-ui, sans-serif;\n}\n\n.menuList-module_closeMenuLink__2xTfk .menuList-module_anchor__3d2Fb *:not(svg) {\n  color: #ffffff;\n  width: 40px;\n  display: flex;\n  padding: 6px 12px;\n  justify-content: center;\n  align-items: center;\n  border-radius: 14px;\n  flex-shrink: 0;\n  background-color: #c5c7ef;\n  border: 1px solid #c5c7ef;\n}\n\n.menuList-module_closeMenuLink__2xTfk.menuList-module_active__28aIU .menuList-module_anchor__3d2Fb *:not(svg) {\n  color: #ffffff;\n  background-color: #353ebd;\n  border: 1px solid #353ebd;\n}\n\n.menuList-module_closeMenuLink__2xTfk .menuList-module_title___tdjC {\n  width: 40px;\n  color: #262b38;\n  white-space: normal;\n  font: 300 10px/10px Meiryo, Arial, system-ui, sans-serif;\n  text-align: center;\n}\n\n.menuList-module_hidden__2eoJp {\n  display: none;\n}\n\n@media (hover: hover) {\n  .menuList-module_closeSideBar__38nKa:hover {\n    color: #0f1192;\n  }\n  .menuList-module_openSideBar__JAsCN:hover {\n    color: #0f1192;\n  }\n\n  .menuList-module_openMenuLink__29rYa a:hover {\n    background: #f1f2f7;\n  }\n\n  .menuList-module_openMenuLink__29rYa *:hover {\n    color: #0f1192;\n  }\n\n  .menuList-module_openMenuLink__29rYa.menuList-module_active__28aIU * {\n    font-weight: 600;\n  }\n\n  .menuList-module_closeMenuLink__2xTfk *:hover,\n  .menuList-module_closeMenuLink__2xTfk .menuList-module_openMenuSection__fW3lm,\n  .menuList-module_menuWrapper__1kGza {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n  }\n\n  .menuList-module_closeMenuLink__2xTfk .menuList-module_anchor__3d2Fb *:not(svg):hover {\n    color: #ffffff;\n    background-color: #353ebd;\n    border: 1px solid #353ebd;\n  }\n}\n\n@media screen and (max-width: 768px) {\n  .menuList-module_menuContainer__3clNb,\n  .menuList-module_menuContainer__3clNb.menuList-module_open__U8gWK {\n    min-height: auto;\n    width: 100%;\n    border-right: none;\n  }\n\n  .menuList-module_openMenuListWrapper__2TaH0 {\n    display: inline-flex;\n  }\n\n  .menuList-module_closeSideBar__38nKa {\n    display: none;\n  }\n\n  .menuList-module_closeMenuListWrapper__1RHae {\n    display: none;\n  }\n}\n";
var styles$b = {"menuContainer":"menuList-module_menuContainer__3clNb","open":"menuList-module_open__U8gWK","openMenuListWrapper":"menuList-module_openMenuListWrapper__2TaH0","closeMenuListWrapper":"menuList-module_closeMenuListWrapper__1RHae","buttonWrapper":"menuList-module_buttonWrapper__w9UZE","closeSideBar":"menuList-module_closeSideBar__38nKa","openSideBar":"menuList-module_openSideBar__JAsCN","openMenuLink":"menuList-module_openMenuLink__29rYa","closeMenuLink":"menuList-module_closeMenuLink__2xTfk","anchor":"menuList-module_anchor__3d2Fb","h2":"menuList-module_h2__xzlo6","active":"menuList-module_active__28aIU","closeMenuSection":"menuList-module_closeMenuSection__3bS3S","menuWrapper":"menuList-module_menuWrapper__1kGza","title":"menuList-module_title___tdjC","hidden":"menuList-module_hidden__2eoJp","openMenuSection":"menuList-module_openMenuSection__fW3lm"};
styleInject(css_248z$c);

var DEFAULT_SHOW_MENU_STATE = true;
function useShowState(_ref) {
  var persistKey = _ref.persistKey,
    onError = _ref.onError;
  var initialShowMenuState = React__namespace.default.useMemo(function () {
    if (!persistKey) {
      return DEFAULT_SHOW_MENU_STATE;
    }
    try {
      var persistedValue = localStorage.getItem(persistKey);
      if (typeof persistedValue !== "string") {
        return DEFAULT_SHOW_MENU_STATE;
      }
      return persistedValue === "true";
    } catch (error) {
      // localStorage API の意図しないエラーをonErrorが渡されている時はハンドルし、そうではない場合はthrowする
      if (onError) {
        onError(error);
      } else {
        throw error;
      }
      return true;
    }
  }, [onError, persistKey]);
  return {
    initialShowMenuState: initialShowMenuState
  };
}

function useSetLocalStorage(_ref) {
  var showMenu = _ref.showMenu,
    persistKey = _ref.persistKey;
  React__namespace.default.useEffect(function () {
    if (!persistKey) {
      return;
    }
    localStorage.setItem(persistKey, String(showMenu));
  }, [persistKey, showMenu]);
}

var CloseMenuLink = function CloseMenuLink(_ref) {
  var title = _ref.title,
    hidden = _ref.hidden,
    active = _ref.active,
    _ref$icon = _ref.icon,
    icon = _ref$icon === void 0 ? "PaperIcon" : _ref$icon,
    anchor = _ref.anchor;
  var Icon = Icons[icon];
  return hidden ? (/*#__PURE__*/React__namespace.default.createElement(React__namespace.default.Fragment, null)) : (/*#__PURE__*/React__namespace.default.createElement("li", {
    className: classnames__default.default(styles$b.closeMenuLink, !!active && styles$b.active)
  }, /*#__PURE__*/React__namespace.default.createElement("span", {
    className: styles$b.anchor
  }, /*#__PURE__*/React__namespace.default.createElement(Anchor, {
    anchor: anchor,
    "data-for-rpa-id": "side-menu-".concat(title)
  }, /*#__PURE__*/React__namespace.default.createElement(Icon, {
    size: 16
  }))), /*#__PURE__*/React__namespace.default.createElement("span", {
    className: styles$b.title
  }, title)));
};
var OpenMenuLink = function OpenMenuLink(_ref2) {
  var title = _ref2.title,
    hidden = _ref2.hidden,
    active = _ref2.active,
    anchor = _ref2.anchor;
  return hidden ? (/*#__PURE__*/React__namespace.default.createElement(React__namespace.default.Fragment, null)) : (/*#__PURE__*/React__namespace.default.createElement("li", {
    className: classnames__default.default(styles$b.openMenuLink, !!active && styles$b.active)
  }, /*#__PURE__*/React__namespace.default.createElement(Anchor, {
    anchor: anchor,
    "data-for-rpa-id": "side-menu-".concat(title)
  }, title)));
};
var OpenMenuSection = function OpenMenuSection(_ref3) {
  var item = _ref3.item;
  var hidden = React.useMemo(function () {
    return item.navItems.every(function (_) {
      return _.hidden;
    });
  }, [item]);
  return /*#__PURE__*/React__namespace.default.createElement(React__namespace.default.Fragment, null, hidden ? (/*#__PURE__*/React__namespace.default.createElement(React__namespace.default.Fragment, null)) : (/*#__PURE__*/React__namespace.default.createElement(React__namespace.default.Fragment, null, /*#__PURE__*/React__namespace.default.createElement("p", {
    "data-testid": "test-sidemenu-header",
    className: classnames__default.default(styles$b.h2)
  }, item.header), /*#__PURE__*/React__namespace.default.createElement("ul", null, item.navItems.map(function (l) {
    return /*#__PURE__*/React__namespace.default.createElement(OpenMenuLink, {
      key: l.title,
      title: l.title,
      hidden: l.hidden,
      active: l.active,
      anchor: l.anchor
    });
  })))));
};
var CloseMenuSection = function CloseMenuSection(_ref4) {
  var item = _ref4.item;
  return /*#__PURE__*/React__namespace.default.createElement(CloseMenuLink, {
    key: item.title,
    title: item.title,
    hidden: item.hidden,
    active: item.active,
    anchor: item.anchor,
    icon: item.icon
  });
};
var OpenMenuList$1 = function OpenMenuList(_ref5) {
  var items = _ref5.items,
    className = _ref5.className,
    onClose = _ref5.onClose;
  return /*#__PURE__*/React__namespace.default.createElement("div", {
    className: classnames__default.default(className, styles$b.openMenuListWrapper)
  }, /*#__PURE__*/React__namespace.default.createElement("div", {
    className: styles$b.buttonWrapper
  }, /*#__PURE__*/React__namespace.default.createElement("button", {
    onClick: onClose,
    className: classnames__default.default(styles$b.closeSideBar)
  }, /*#__PURE__*/React__namespace.default.createElement(CloseMenuIcon, {
    size: 16
  }), "\u9589\u3058\u308B")), /*#__PURE__*/React__namespace.default.createElement("div", {
    className: styles$b.openMenuSection
  }, items.map(function (item) {
    return /*#__PURE__*/React__namespace.default.createElement(OpenMenuSection, {
      key: item.header,
      item: item
    });
  })));
};
var CloseMenuList$1 = function CloseMenuList(_ref6) {
  var items = _ref6.items,
    className = _ref6.className,
    onOpen = _ref6.onOpen;
  var iconMenuItems = React.useMemo(function () {
    var navItems = items.flatMap(function (item) {
      return item.navItems;
    });
    return _toConsumableArray(navItems);
  }, [items]);
  return /*#__PURE__*/React__namespace.default.createElement("div", {
    className: classnames__default.default(className, styles$b.closeMenuListWrapper)
  }, /*#__PURE__*/React__namespace.default.createElement("div", {
    className: styles$b.buttonWrapper
  }, /*#__PURE__*/React__namespace.default.createElement("button", {
    className: classnames__default.default(className, styles$b.openSideBar),
    onClick: onOpen
  }, /*#__PURE__*/React__namespace.default.createElement(OpenMenuIcon, {
    size: 16
  }))), /*#__PURE__*/React__namespace.default.createElement("div", {
    className: styles$b.closeMenuSection
  }, iconMenuItems.map(function (item) {
    return /*#__PURE__*/React__namespace.default.createElement(CloseMenuSection, {
      key: item.title,
      item: item
    });
  })));
};
var MenuList = function MenuList(_ref7) {
  var persistKey = _ref7.persistKey,
    items = _ref7.items,
    onError = _ref7.onError;
  var _useShowState = useShowState({
      persistKey: persistKey,
      onError: onError
    }),
    initialShowMenuState = _useShowState.initialShowMenuState;
  var _React$useState = React__namespace.default.useState(initialShowMenuState),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    showMenu = _React$useState2[0],
    setShowMenu = _React$useState2[1];
  useSetLocalStorage({
    showMenu: showMenu,
    persistKey: persistKey
  });
  return /*#__PURE__*/React__namespace.default.createElement("div", {
    className: classnames__default.default(styles$b.menuContainer, showMenu ? styles$b.open : styles$b.close)
  }, /*#__PURE__*/React__namespace.default.createElement("aside", {
    className: classnames__default.default(styles$b.menuListToggle, !showMenu && styles$b.close)
  }, /*#__PURE__*/React__namespace.default.createElement(OpenMenuList$1, {
    className: !showMenu ? styles$b.hidden : "",
    items: items,
    onClose: function onClose() {
      return setShowMenu(false);
    }
  }), /*#__PURE__*/React__namespace.default.createElement(CloseMenuList$1, {
    className: showMenu ? styles$b.hidden : "",
    items: items,
    onOpen: function onOpen() {
      return setShowMenu(true);
    }
  })));
};

var menuList = /*#__PURE__*/Object.freeze({
  __proto__: null,
  MenuList: MenuList
});

var css_248z$b = ":root {\n  /* Color styles */\n\n  /* Text-size styles */\n\n  /* Effect styles */\n  /* border-radius */\n}\n\n.secondaryMenuList-module_menuContainer__2wEj2 {\n  color: #353ebd;\n  grid-area: sidemenu;\n  white-space: nowrap;\n  border-right: 1px solid #b2b8c8;\n  width: -moz-max-content;\n  width: max-content;\n  background: #f1f2f7;\n  min-height: calc(100vh - 56px);\n}\n\n.secondaryMenuList-module_parentButton__2I0-p {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 16px;\n  background: #ffffff;\n  svg {\n    flex-shrink: 0;\n  }\n}\n\n.secondaryMenuList-module_parentButton__2I0-p *:not(svg, p) {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 5px 12px;\n  border-radius: 14px;\n  width: 100%;\n  background: #f1f2f7;\n  font: 300 13px/18px Meiryo, Arial, system-ui, sans-serif;\n  color: #353ebd;\n}\n\n.secondaryMenuList-module_sideBarButton__25dHH {\n  display: flex;\n  justify-content: right;\n  padding: 16px;\n  svg {\n    flex-shrink: 0;\n  }\n}\n\n.secondaryMenuList-module_sideBarButton__25dHH.secondaryMenuList-module_open__2CKgT {\n  justify-content: center;\n}\n\n.secondaryMenuList-module_menuContainer__2wEj2.secondaryMenuList-module_open__2CKgT {\n  width: 200px;\n}\n\n.secondaryMenuList-module_menuListToggle__26eqQ {\n  display: inline-flex;\n  flex-direction: column;\n  padding: 0px 0px 16px 0px;\n  width: 100%;\n}\n\n.secondaryMenuList-module_closeSideBar__3mtFq {\n  width: -moz-fit-content;\n  width: fit-content;\n  background: #ffffff;\n  border-radius: 14px;\n  padding: 6px 12px;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  font-weight: 300;\n  font-size: 13px;\n  line-height: 18px;\n  color: #353ebd;\n  border: 1px solid #353ebd;\n}\n\n.secondaryMenuList-module_openSideBar__17XDB {\n  width: -moz-fit-content;\n  width: fit-content;\n  background: #ffffff;\n  border-radius: 14px;\n  padding: 6px 12px;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  font-weight: 300;\n  font-size: 13px;\n  line-height: 18px;\n  color: #353ebd;\n  border: 1px solid #353ebd;\n}\n\n.secondaryMenuList-module_closeSideBar__3mtFq:focus-visible {\n  outline: none;\n  border: 1px solid #353ebd;\n  box-shadow: 0px 0px 5px rgba(53, 62, 189, 1);\n}\n\n.secondaryMenuList-module_openSideBar__17XDB:focus-visible {\n  outline: none;\n  border: 1px solid #353ebd;\n  box-shadow: 0px 0px 5px rgba(53, 62, 189, 1);\n}\n\n.secondaryMenuList-module_menuLink__Sgdyu *:not(svg):focus-visible {\n  outline: none;\n  border: 1px solid #353ebd;\n  box-shadow: 0px 0px 5px rgba(53, 62, 189, 1);\n}\n\n.secondaryMenuList-module_parentButton__2I0-p *:not(svg, p):focus-visible {\n  outline: none;\n  border: 1px solid #353ebd;\n  box-shadow: 0px 0px 5px rgba(53, 62, 189, 1);\n}\n\n.secondaryMenuList-module_closeSideBar__3mtFq svg {\n  line-height: 8px;\n}\n\n.secondaryMenuList-module_h2__1imfx {\n  color: #262b38;\n  font-weight: 300;\n  font-size: 14px;\n  padding-top: 2px;\n  padding-bottom: 2px;\n}\n\n.secondaryMenuList-module_menuLink__Sgdyu * {\n  padding-left: 16px;\n}\n\n.secondaryMenuList-module_menuLink__Sgdyu.secondaryMenuList-module_active__2TPiz * {\n  width: 100%;\n}\n\n.secondaryMenuList-module_menuLink__Sgdyu:not(.secondaryMenuList-module_active__2TPiz) *::before {\n  content: \"･\";\n  display: inline-block;\n  font-weight: 600;\n  text-align: center;\n}\n\n.secondaryMenuList-module_menuLink__Sgdyu.secondaryMenuList-module_active__2TPiz *::before {\n  content: \"|\";\n  display: inline-block;\n  margin: 0px 2px;\n  font-weight: 600;\n  text-align: center;\n  vertical-align: text-bottom;\n}\n\n.secondaryMenuList-module_menuLink__Sgdyu *:not(svg) {\n  color: #353ebd;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: 4px 16px;\n  border-top-right-radius: 14px;\n  border-bottom-right-radius: 14px;\n  line-height: 20px;\n  gap: 4px;\n  font: 16px/28px Meiryo, Arial, system-ui, sans-serif;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  text-align: left;\n}\n\n.secondaryMenuList-module_menuLink__Sgdyu.secondaryMenuList-module_active__2TPiz * {\n  color: #0f1192;\n  font-weight: 600;\n  background: #ffffff;\n}\n\n.secondaryMenuList-module_closeMenuLink__4W2Wm .secondaryMenuList-module_openMenuSection__2n8Qx,\n.secondaryMenuList-module_menuWrapper__3TiDW {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.secondaryMenuList-module_closeMenuSection__UsE1e {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  align-items: center;\n}\n\n.secondaryMenuList-module_menuWrapper__3TiDW {\n  width: 40px;\n  height: 56px;\n}\n\n.secondaryMenuList-module_closeMenuLink__4W2Wm {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  font: 300 8px/12px Meiryo, Arial, system-ui, sans-serif;\n}\n\n.secondaryMenuList-module_closeMenuLink__4W2Wm .secondaryMenuList-module_anchor__6RR9L *:not(svg) {\n  color: #353ebd;\n  width: 40px;\n  display: flex;\n  padding: 6px 12px;\n  justify-content: center;\n  align-items: center;\n  border-radius: 14px;\n  flex-shrink: 0;\n  background-color: #ffffff;\n  border: 1px solid #c5c7ef;\n}\n\n.secondaryMenuList-module_closeMenuLink__4W2Wm.secondaryMenuList-module_active__2TPiz .secondaryMenuList-module_anchor__6RR9L *:not(svg) {\n  color: #353ebd;\n  background-color: #ffffff;\n  border: 1px solid #ffffff;\n}\n\n.secondaryMenuList-module_closeMenuLink__4W2Wm .secondaryMenuList-module_title__1L967 {\n  width: 40px;\n  color: #262b38;\n  white-space: normal;\n}\n\n.secondaryMenuList-module_hidden__wRHKS {\n  display: none;\n}\n\n@media (hover: hover) {\n  .secondaryMenuList-module_parentButton__2I0-p *:not(svg, p):hover {\n    background: #e5e6ea;\n    color: #353ebd;\n  }\n  .secondaryMenuList-module_closeSideBar__3mtFq:hover {\n    color: #0f1192;\n    border: 1px solid #0f1192;\n  }\n  .secondaryMenuList-module_openSideBar__17XDB:hover {\n    color: #0f1192;\n    border: 1px solid #0f1192;\n  }\n  .secondaryMenuList-module_menuLink__Sgdyu *:not(svg):hover {\n    color: #0f1192;\n    background: #ffffff;\n  }\n\n  .secondaryMenuList-module_closeMenuLink__4W2Wm .secondaryMenuList-module_anchor__6RR9L *:not(svg):hover {\n    color: #ffffff;\n    background-color: #353ebd;\n    border: 1px solid #353ebd;\n  }\n}\n\n@media screen and (max-width: 768px) {\n  .secondaryMenuList-module_menuContainer__2wEj2 {\n    min-height: auto;\n    border-right: none;\n    width: 100%;\n  }\n\n  .secondaryMenuList-module_parentButton__2I0-p {\n    align-items: flex-start;\n  }\n\n  .secondaryMenuList-module_sideBarButton__25dHH.secondaryMenuList-module_close__3HE3l {\n    display: none;\n  }\n\n  .secondaryMenuList-module_menuContainer__2wEj2.secondaryMenuList-module_open__2CKgT {\n    border-right: none;\n    width: 100%;\n  }\n\n  .secondaryMenuList-module_parentButtonTitle__2g0iD {\n    display: inline;\n  }\n\n  .secondaryMenuList-module_sideBarButton__25dHH.secondaryMenuList-module_open__2CKgT {\n    display: none;\n  }\n\n  .secondaryMenuList-module_openSideBarWrapper__3uziN {\n    display: block;\n  }\n}\n";
var styles$a = {"menuContainer":"secondaryMenuList-module_menuContainer__2wEj2","parentButton":"secondaryMenuList-module_parentButton__2I0-p","sideBarButton":"secondaryMenuList-module_sideBarButton__25dHH","open":"secondaryMenuList-module_open__2CKgT","menuListToggle":"secondaryMenuList-module_menuListToggle__26eqQ","closeSideBar":"secondaryMenuList-module_closeSideBar__3mtFq","openSideBar":"secondaryMenuList-module_openSideBar__17XDB","menuLink":"secondaryMenuList-module_menuLink__Sgdyu","h2":"secondaryMenuList-module_h2__1imfx","active":"secondaryMenuList-module_active__2TPiz","closeMenuLink":"secondaryMenuList-module_closeMenuLink__4W2Wm","openMenuSection":"secondaryMenuList-module_openMenuSection__2n8Qx","menuWrapper":"secondaryMenuList-module_menuWrapper__3TiDW","closeMenuSection":"secondaryMenuList-module_closeMenuSection__UsE1e","anchor":"secondaryMenuList-module_anchor__6RR9L","title":"secondaryMenuList-module_title__1L967","hidden":"secondaryMenuList-module_hidden__wRHKS","close":"secondaryMenuList-module_close__3HE3l","parentButtonTitle":"secondaryMenuList-module_parentButtonTitle__2g0iD","openSideBarWrapper":"secondaryMenuList-module_openSideBarWrapper__3uziN"};
styleInject(css_248z$b);

var MenuLink = function MenuLink(_ref) {
  var title = _ref.title,
    hidden = _ref.hidden,
    active = _ref.active,
    anchor = _ref.anchor;
  return hidden ? (/*#__PURE__*/React__namespace.default.createElement(React__namespace.default.Fragment, null)) : (/*#__PURE__*/React__namespace.default.createElement("li", {
    className: classnames__default.default(styles$a.menuLink, !!active && styles$a.active)
  }, /*#__PURE__*/React__namespace.default.createElement(Anchor, {
    anchor: anchor,
    "data-for-rpa-id": "side-menu-".concat(title)
  }, title)));
};
var OpenMenuList = function OpenMenuList(_ref2) {
  var items = _ref2.items,
    onClose = _ref2.onClose,
    className = _ref2.className;
  return /*#__PURE__*/React__namespace.default.createElement("div", {
    className: classnames__default.default(className, styles$a.openSideBarWrapper)
  }, /*#__PURE__*/React__namespace.default.createElement("div", {
    className: classnames__default.default(styles$a.sideBarButton, styles$a.close)
  }, /*#__PURE__*/React__namespace.default.createElement("button", {
    onClick: onClose,
    className: classnames__default.default(styles$a.closeSideBar)
  }, /*#__PURE__*/React__namespace.default.createElement(CloseMenuIcon, {
    size: 16
  }))), /*#__PURE__*/React__namespace.default.createElement("div", {
    className: styles$a.openMenuSection
  }, items.map(function (item) {
    return /*#__PURE__*/React__namespace.default.createElement(React__namespace.default.Fragment, {
      key: item.title
    }, item.hidden ? (/*#__PURE__*/React__namespace.default.createElement(React__namespace.default.Fragment, null)) : (/*#__PURE__*/React__namespace.default.createElement("ul", null, /*#__PURE__*/React__namespace.default.createElement(MenuLink, {
      title: item.title,
      hidden: item.hidden,
      active: item.active,
      anchor: item.anchor
    }))));
  })));
};
var CloseMenuList = function CloseMenuList(_ref3) {
  var onOpen = _ref3.onOpen,
    className = _ref3.className;
  return /*#__PURE__*/React__namespace.default.createElement("div", {
    className: classnames__default.default(className, styles$a.sideBarButton, styles$a.open)
  }, /*#__PURE__*/React__namespace.default.createElement("button", {
    className: classnames__default.default(styles$a.openSideBar),
    onClick: onOpen
  }, /*#__PURE__*/React__namespace.default.createElement(OpenMenuIcon, {
    size: 16
  })));
};
var SecondaryMenuList = function SecondaryMenuList(_ref4) {
  var persistKey = _ref4.persistKey,
    items = _ref4.items,
    parent = _ref4.parent,
    onError = _ref4.onError;
  var _useShowState = useShowState({
      persistKey: persistKey,
      onError: onError
    }),
    initialShowMenuState = _useShowState.initialShowMenuState;
  var _React$useState = React__namespace.default.useState(initialShowMenuState),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    showMenu = _React$useState2[0],
    setShowMenu = _React$useState2[1];
  useSetLocalStorage({
    showMenu: showMenu,
    persistKey: persistKey
  });
  return /*#__PURE__*/React__namespace.default.createElement("div", {
    className: classnames__default.default(styles$a.menuContainer, showMenu ? styles$a.open : styles$a.close)
  }, /*#__PURE__*/React__namespace.default.createElement("div", {
    className: styles$a.parentButton
  }, /*#__PURE__*/React__namespace.default.createElement(Anchor, {
    anchor: parent.anchor,
    "data-for-rpa-id": "side-menu-".concat(parent.title)
  }, /*#__PURE__*/React__namespace.default.createElement(React__namespace.default.Fragment, null, /*#__PURE__*/React__namespace.default.createElement(ArrowLeftIcon, {
    size: 16
  }), /*#__PURE__*/React__namespace.default.createElement("p", {
    className: classnames__default.default(!showMenu && styles$a.hidden, styles$a.parentButtonTitle)
  }, parent.title)))), /*#__PURE__*/React__namespace.default.createElement("aside", {
    className: classnames__default.default(styles$a.menuListToggle, !showMenu && styles$a.close)
  }, /*#__PURE__*/React__namespace.default.createElement(OpenMenuList, {
    className: !showMenu ? styles$a.hidden : "",
    items: items,
    onClose: function onClose() {
      return setShowMenu(false);
    }
  }), /*#__PURE__*/React__namespace.default.createElement(CloseMenuList, {
    className: showMenu ? styles$a.hidden : "",
    onOpen: function onOpen() {
      return setShowMenu(true);
    }
  })));
};

var css_248z$a = ":root {\n  /* Color styles */\n\n  /* Text-size styles */\n\n  /* Effect styles */\n  /* border-radius */\n}\n\n.date-range-module_iconInputWrapper__SOY0I svg:not(.date-range-module_clearIcon__3-yZa) {\n  fill: #262b38;\n  position: absolute;\n  left: 8px;\n}\n\n.date-range-module_iconInputWrapper__SOY0I .date-range-module_iconInputWrapper__SOY0I {\n  color: #0f1192;\n  background-color: #f1f2f7;\n}\n\n.date-range-module_iconInputWrapper__SOY0I .date-range-module_input__38-rm:focus {\n  background-color: #f1f2f7;\n  color: #353ebd;\n}\n\n.date-range-module_iconInputWrapper__SOY0I .date-range-module_input__38-rm:focus + svg {\n  fill: #353ebd;\n}\n\n.date-range-module_iconInputWrapper__SOY0I.date-range-module_fail__PXcat .date-range-module_input__38-rm {\n  color: #b1110c;\n}\n\n.date-range-module_iconInputWrapper__SOY0I.date-range-module_fail__PXcat svg {\n  color: #b1110c;\n}\n\n.date-range-module_iconInputWrapper__SOY0I.date-range-module_fail__PXcat .date-range-module_input__38-rm {\n  color: #b1110c;\n}\n\n.date-range-module_iconInputWrapper__SOY0I.date-range-module_fail__PXcat .date-range-module_input__38-rm:focus {\n  background-color: #fff5f6;\n  color: #b1110c;\n}\n\n.date-range-module_iconInputWrapper__SOY0I.date-range-module_fail__PXcat .date-range-module_input__38-rm:focus ~ .date-range-module_clearIcon__3-yZa.date-range-module_fail__PXcat {\n  background-color: #fff5f6;\n  color: #920400;\n}\n\n.date-range-module_iconInputWrapper__SOY0I.date-range-module_fail__PXcat .date-range-module_input__38-rm:focus + svg {\n  fill: #b1110c;\n}\n\n.date-range-module_iconInputWrapper__SOY0I {\n  position: relative;\n  width: calc(calc(100vw - 260px) / 2);\n  min-width: calc(440px / 2);\n  max-width: calc(555px / 2);\n}\n\n.date-range-module_divider__cxWs9 {\n  border-left: 1px solid #949cb0;\n  margin-left: 8px;\n  margin-right: 8px;\n  height: 100%;\n  position: relative;\n}\n\n.date-range-module_clearIconWrapper__3o_ru {\n  display: flex;\n  position: absolute;\n  right: 0px;\n  margin-right: 8px;\n}\n\n.date-range-module_clearIconWrapper__3o_ru .date-range-module_clearIcon__3-yZa.date-range-module_default__2KOgO {\n  color: #5f636d;\n}\n\n.date-range-module_input__38-rm:focus ~ .date-range-module_clearIconWrapper__3o_ru .date-range-module_clearIcon__3-yZa.date-range-module_default__2KOgO {\n  color: #353ebd;\n  background-color: #f1f2f7;\n}\n\n.date-range-module_clearIconWrapper__3o_ru:focus .date-range-module_clearIcon__3-yZa.date-range-module_default__2KOgO {\n  color: #353ebd;\n}\n\n.date-range-module_clearIconWrapper__3o_ru .date-range-module_clearIcon__3-yZa.date-range-module_fail__PXcat {\n  color: #b1110c;\n}\n\n.date-range-module_clearIconWrapper__3o_ru:focus .date-range-module_clearIcon__3-yZa.date-range-module_fail__PXcat {\n  color: #920400;\n}\n\n.date-range-module_wrapper__2bKRa {\n  width: -moz-fit-content;\n  width: fit-content;\n  display: flex;\n  flex-wrap: nowrap;\n  position: relative;\n  font: 300 16px/24px Meiryo, Arial, system-ui, sans-serif;\n  flex-direction: column;\n}\n\n.date-range-module_errorWrapper__26GSp {\n  display: flex;\n  font-family: \"Hiragino Sans\";\n  font-style: normal;\n  font-weight: 300;\n  font-size: 13px;\n  line-height: 18px;\n}\n\n.date-range-module_error__1UAZ1 {\n  width: 50%;\n  margin-left: 40px;\n  font: 300 12px/18px Meiryo, Arial, system-ui, sans-serif;\n}\n\n.date-range-module_inputWrapper__PVqlp {\n  display: flex;\n  align-items: center;\n  position: relative;\n  padding: 8px;\n  height: 36px;\n  background: #ffffff;\n  border: 1px solid #949cb0;\n  border-radius: 4px;\n  width: -moz-fit-content;\n  width: fit-content;\n}\n\n.date-range-module_input__38-rm {\n  border: none;\n  height: 24px;\n  font-family: \"Hiragino Sans\";\n  font-style: normal;\n  font-weight: 300;\n  font-size: 16px;\n  line-height: 20px;\n  outline: none;\n  padding-left: 40px;\n  width: 100%;\n}\n\n.date-range-module_calender__2rKrh {\n  width: 100%;\n  position: absolute;\n  top: 70px;\n  left: 0px;\n  z-index: 100;\n}\n\n@media (hover: hover) {\n  .date-range-module_iconInputWrapper__SOY0I .date-range-module_input__38-rm:hover {\n    background-color: #f1f2f7;\n    color: #353ebd;\n  }\n\n  .date-range-module_iconInputWrapper__SOY0I .date-range-module_input__38-rm:hover + svg {\n    fill: #353ebd;\n  }\n\n  .date-range-module_iconInputWrapper__SOY0I.date-range-module_fail__PXcat .date-range-module_input__38-rm:hover {\n    background-color: #fff5f6;\n    color: #b1110c;\n  }\n\n  .date-range-module_iconInputWrapper__SOY0I.date-range-module_fail__PXcat .date-range-module_input__38-rm:hover + svg {\n    fill: #b1110c;\n  }\n\n  .date-range-module_clearIconWrapper__3o_ru:hover .date-range-module_clearIcon__3-yZa {\n    cursor: pointer;\n  }\n\n  .date-range-module_iconInputWrapper__SOY0I .date-range-module_input__38-rm:hover ~ .date-range-module_clearIcon__3-yZa.date-range-module_default__2KOgO {\n    color: #353ebd;\n    background-color: #f1f2f7;\n  }\n\n  .date-range-module_clearIconWrapper__3o_ru:hover .date-range-module_clearIcon__3-yZa.date-range-module_default__2KOgO {\n    color: #353ebd;\n  }\n\n  .date-range-module_iconInputWrapper__SOY0I .date-range-module_input__38-rm:hover ~ .date-range-module_clearIcon__3-yZa.date-range-module_fail__PXcat {\n    background-color: #fff5f6;\n    color: #920400;\n  }\n\n  .date-range-module_clearIconWrapper__3o_ru:hover .date-range-module_clearIcon__3-yZa.date-range-module_fail__PXcat {\n    color: #920400;\n  }\n}\n\n.date-range-module_inputWrapper__PVqlp.date-range-module_small__75x6Y {\n  padding: 4px 2px;\n\n  .date-range-module_iconInputWrapper__SOY0I {\n    min-width: calc(342px / 2);\n    max-width: calc(342px / 2);\n  }\n\n  .date-range-module_divider__cxWs9 {\n    margin-left: 0;\n    margin-right: 0;\n  }\n\n  .date-range-module_calender__2rKrh {\n    width: auto;\n  }\n\n  .date-range-module_clearIconWrapper__3o_ru {\n    margin-right: 4px;\n  }\n\n  .date-range-module_calender__2rKrh {\n    left: 50%;\n    transform: translateX(-50%);\n  }\n}\n";
var styles$9 = {"iconInputWrapper":"date-range-module_iconInputWrapper__SOY0I","clearIcon":"date-range-module_clearIcon__3-yZa","input":"date-range-module_input__38-rm","fail":"date-range-module_fail__PXcat","divider":"date-range-module_divider__cxWs9","clearIconWrapper":"date-range-module_clearIconWrapper__3o_ru","default":"date-range-module_default__2KOgO","wrapper":"date-range-module_wrapper__2bKRa","errorWrapper":"date-range-module_errorWrapper__26GSp","error":"date-range-module_error__1UAZ1","inputWrapper":"date-range-module_inputWrapper__PVqlp","calender":"date-range-module_calender__2rKrh","small":"date-range-module_small__75x6Y"};
styleInject(css_248z$a);

var css_248z$9 = ":root {\n  /* font */\n  /* color */\n  /* shadow */\n  /* 余白 */\n  /* border-radius */\n}\n\n.date-picker-range-module_box__1ZFf2 {\n  display: flex;\n  position: relative;\n  background: #fff;\n  border: 1px solid #949cb0;\n  border-radius: 4px;\n  padding: 16px;\n  z-index: 1000;\n  box-shadow: 0px 3px 6px rgba(38, 43, 56, 0.35);\n}\n\n.date-picker-range-module_box__1ZFf2:after,\n.date-picker-range-module_box__1ZFf2:before {\n  bottom: 100%;\n  left: 50%;\n  border: solid transparent;\n  content: \"\";\n  height: 0;\n  width: 0;\n  position: absolute;\n  pointer-events: none;\n}\n\n.date-picker-range-module_box__1ZFf2:after {\n  border-color: rgba(255, 255, 255, 0);\n  border-bottom-color: #fff;\n  border-width: 11px;\n  margin-left: -11px;\n}\n\n.date-picker-range-module_box__1ZFf2:before {\n  border-color: rgba(148, 156, 176, 0);\n  border-bottom-color: #949cb0;\n  border-width: 12px;\n  margin-left: -12px;\n}\n\n.date-picker-range-module_calenderIcon__2NanV {\n  width: 32px;\n  height: 32px;\n  cursor: pointer;\n}\n\n.date-picker-range-module_calenderIcon__2NanV:hover path {\n  fill: #7b82ce;\n}\n\n.date-picker-range-module_container__3ThXv {\n  width: 400px;\n  background-color: #fff;\n  border: 1px solid #949cb0;\n  box-sizing: border-box;\n  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);\n  border-radius: 6px;\n  padding: 27px 31px 31px;\n}\n\n.date-picker-range-module_header__EW81e {\n  border: none;\n  font: bold 18px/31px Hiragino Sans, Arial, Meiryo, system-ui, sans-serif;\n  height: 32px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n}\n\n@media screen and (max-width: 800px) {\n\n  .date-picker-range-module_header__EW81e {\n  font: bold 16px/28px Hiragino Sans, Arial, Meiryo, system-ui,\n      sans-serif;\n  }\n}\n\n.date-picker-range-module_transitionContainer__12IwE {\n  font-family: \"Hiragino Sans\";\n  font-style: normal;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 18px;\n}\n\n.date-picker-range-module_previous__1H8OA {\n  position: absolute;\n  left: 0;\n}\n\n.date-picker-range-module_next__Wbq8Z {\n  position: absolute;\n  right: 0;\n}\n\n.date-picker-range-module_changeMonthButton__p_iXO {\n  width: 32px;\n  height: 32px;\n  box-sizing: border-box;\n  outline: none;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 60px;\n  padding: 2px;\n}\n\n.date-picker-range-module_changeMonthButton__p_iXO path {\n  fill: #706d6c;\n}\n\n.date-picker-range-module_changeMonthButton__p_iXO:focus {\n  background-color: #f1f2f7;\n}\n\n.date-picker-range-module_changeMonthButton__p_iXO:focus path {\n  fill: #353ebd;\n}\n\n.date-picker-range-module_spaceLeft__3JY7d {\n  margin-left: 1rem;\n}\n\n.date-picker-range-module_day__kRYfb {\n  width: 36px;\n  height: 36px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: #1d1c1a;\n  cursor: pointer;\n  font-family: \"Hiragino Sans\";\n  font-style: normal;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 10px;\n}\n\n.date-picker-range-module_day__kRYfb:focus {\n  outline: none;\n}\n\n.date-picker-range-module_mobileLabel__2zYsb {\n  font: bold 18px/31px Hiragino Sans, Arial, Meiryo, system-ui, sans-serif;\n  background-color: #f4f2f0;\n  border-bottom: 1px solid #949cb0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: calc(100% + 28px);\n  height: 60px;\n  transform: translateX(-14px);\n}\n\n@media screen and (max-width: 800px) {\n\n  .date-picker-range-module_mobileLabel__2zYsb {\n  font: bold 16px/28px Hiragino Sans, Arial, Meiryo, system-ui,\n      sans-serif;\n  }\n}\n\n.date-picker-range-module_footer__2F8OE {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 11px;\n}\n\n@media screen and (max-width: 800px) {\n  .date-picker-range-module_wrapper__E36Jz {\n    margin-bottom: 1px;\n  }\n  .date-picker-range-module_calenderIcon__2NanV,\n  .date-picker-range-module_calenderIcon__2NanV svg {\n    width: 24px;\n    height: 24px;\n  }\n  .date-picker-range-module_container__3ThXv {\n    width: calc(100vw - 32px);\n    padding: 0 14px 15px;\n  }\n  .date-picker-range-module_header__EW81e {\n    margin-top: 16px;\n  }\n\n  .date-picker-range-module_day__kRYfb {\n    width: 24px;\n    height: 24px;\n  }\n}\n\n@media (hover: hover) {\n  .date-picker-range-module_changeMonthButton__p_iXO:hover {\n    background-color: #f1f2f7;\n  }\n\n  .date-picker-range-module_changeMonthButton__p_iXO:hover path {\n    fill: #353ebd;\n  }\n}\n";
var styles$8 = {"box":"date-picker-range-module_box__1ZFf2","calenderIcon":"date-picker-range-module_calenderIcon__2NanV","container":"date-picker-range-module_container__3ThXv","header":"date-picker-range-module_header__EW81e","transitionContainer":"date-picker-range-module_transitionContainer__12IwE","previous":"date-picker-range-module_previous__1H8OA","next":"date-picker-range-module_next__Wbq8Z","changeMonthButton":"date-picker-range-module_changeMonthButton__p_iXO","spaceLeft":"date-picker-range-module_spaceLeft__3JY7d","day":"date-picker-range-module_day__kRYfb","mobileLabel":"date-picker-range-module_mobileLabel__2zYsb","footer":"date-picker-range-module_footer__2F8OE","wrapper":"date-picker-range-module_wrapper__E36Jz"};
styleInject(css_248z$9);

var css_248z$8 = ":root {\n  /* font */\n  /* color */\n  /* shadow */\n  /* 余白 */\n  /* border-radius */\n}\n\n.gcdk-date-range-picker .react-datepicker__month-container {\n  width: 50%;\n  float: none;\n}\n\n.gcdk-date-range-picker .react-datepicker__month-container:first-of-type {\n  padding-right: 16px;\n}\n\n.gcdk-date-range-picker .react-datepicker__month-container:last-of-type {\n  padding-left: 16px;\n  border-left: 1px solid #949cb0;\n}\n\n.gcdk-date-range-picker .react-datepicker__header--custom {\n  background-color: #fff;\n  border: none;\n  padding: 0;\n}\n\n.gcdk-date-range-picker\n  .react-datepicker__header--custom\n  .react-datepicker__day-names {\n  display: flex;\n  margin-top: 24px;\n  justify-content: space-around;\n}\n\n.gcdk-date-range-picker\n  .react-datepicker__header--custom\n  .react-datepicker__day-name {\n  font-family: \"Hiragino Sans\";\n  font-style: normal;\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 10px;\n  text-align: center;\n  margin: 0;\n}\n\n.gcdk-date-range-picker\n  .react-datepicker__month-container:first-of-type\n  .react-datepicker__month,\n.gcdk-date-range-picker\n  .react-datepicker__month-container:first-of-type\n  .react-datepicker__day-names {\n  padding-left: 20px;\n}\n\n.gcdk-date-range-picker\n  .react-datepicker__month-container:last-of-type\n  .react-datepicker__month,\n.gcdk-date-range-picker\n  .react-datepicker__month-container:last-of-type\n  .react-datepicker__day-names {\n  padding-right: 20px;\n}\n\n.gcdk-date-range-picker .react-datepicker__day-names {\n  margin: 0;\n}\n\n.gcdk-date-range-picker .react-datepicker__day {\n  margin: 0;\n}\n\n.gcdk-date-range-picker .react-datepicker__month {\n  margin: 8px 0 0;\n}\n\n.gcdk-date-range-picker .react-datepicker__week:not(:first-child) {\n  margin-top: 2px;\n}\n\n.gcdk-date-range-picker .react-datepicker__week {\n  margin: 0;\n  display: flex;\n  justify-content: space-around;\n}\n\n.gcdk-date-range-picker .react-datepicker__day--outside-month {\n  pointer-events: none;\n  color: #949cb0;\n}\n\n.gcdk-date-range-picker .react-datepicker__day--disabled {\n  pointer-events: none;\n  color: #949cb0;\n}\n\n.gcdk-date-range-picker .react-datepicker__day--keyboard-selected {\n  background-color: transparent;\n  border-radius: 0;\n  color: #1d1c1a;\n}\n\n.gcdk-date-range-picker .react-datepicker__day .cell {\n  transition: background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n  -webkit-transition: background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n  -moz-transition: background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n  -ms-transition: background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n  -o-transition: background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n}\n\n.gcdk-date-range-picker .react-datepicker__day:hover .cell {\n  background-color: #f7f3f0;\n}\n\n.gcdk-date-range-picker\n  .react-datepicker__day.react-datepicker__day--selected:hover\n  .cell {\n  background-color: #353ebd;\n}\n\n.gcdk-date-range-picker .react-datepicker__day--selected,\n.gcdk-date-range-picker .react-datepicker__day:hover {\n  background-color: transparent;\n}\n\n.gcdk-date-range-picker .react-datepicker__day--in-range,\n.gcdk-date-range-picker .react-datepicker__day--in-selecting-range {\n  border-radius: 0;\n}\n\n.gcdk-date-range-picker .lastDayOfMonth.react-datepicker__day--outside-month,\n.gcdk-date-range-picker .lastDayOfMonth.react-datepicker__day--in-range {\n  border-radius: 0;\n}\n\n.gcdk-date-range-picker\n  :not(\n    .react-datepicker__day--disabled\n  ).react-datepicker__day--in-selecting-range {\n  background-color: #e8e9f7;\n  color: #1d1c1a;\n}\n\n.gcdk-date-range-picker\n  :not(\n    .react-datepicker__day--disabled\n  ).react-datepicker__day--in-selecting-range:hover {\n  background-color: #e8e9f7;\n  color: #1d1c1a;\n}\n\n.gcdk-date-range-picker\n  :not(.react-datepicker__day--disabled).react-datepicker__day--in-range {\n  background-color: #e8e9f7;\n  color: #1d1c1a;\n}\n\n.gcdk-date-range-picker\n  :not(.react-datepicker__day--disabled).react-datepicker__day--in-range:hover {\n  background-color: #e8e9f7;\n  color: #1d1c1a;\n}\n\n.gcdk-date-range-picker .react-datepicker__day--selected {\n  border-top-left-radius: 50%;\n  border-bottom-left-radius: 50%;\n}\n\n.gcdk-date-range-picker\n  .react-datepicker__day--range-end.react-datepicker__day--in-range {\n  border-top-right-radius: 50%;\n  border-bottom-right-radius: 50%;\n}\n\n/* TODO:正式な色を決める */\n\n.react-datepicker__day--disabled.gcdk-date-range-picker\n  .react-datepicker__day--in-range\n  .cell:hover,\n.gcdk-date-range-picker .react-datepicker__day--in-range .cell:hover {\n  background-color: #bec3ff;\n}\n\n.gcdk-date-range-picker .react-datepicker__day--in-selecting-range:hover .cell {\n  background: transparent;\n}\n\n.gcdk-date-range-picker\n  :not(\n    .react-datepicker__day--disabled\n  ).react-datepicker__day--range-end.react-datepicker__day--in-range\n  .cell {\n  background-color: #353ebd;\n  color: #fff;\n}\n\n.gcdk-date-range-picker\n  :not(\n    .react-datepicker__day--disabled\n  ).react-datepicker__day--range-end.react-datepicker__day--outside-month\n  .cell {\n  background-color: #353ebd;\n  color: #fff;\n}\n\n.gcdk-date-range-picker .cell {\n  flex: 1 1 auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  width: 100%;\n  height: 100%;\n}\n\n.gcdk-date-range-picker\n  :not(\n    .react-datepicker__day--disabled\n  ).react-datepicker__day--in-selecting-range.react-datepicker__day--selecting-range-start\n  .cell {\n  background-color: #353ebd;\n  color: #fff;\n}\n\n.gcdk-date-range-picker\n  :not(\n    .react-datepicker__day--disabled\n  ).react-datepicker__day--range-start.react-datepicker__day--selected\n  .cell {\n  background-color: #353ebd;\n  color: #fff;\n}\n\n@media screen and (max-width: 800px) {\n  .gcdk-date-range-picker\n    .react-datepicker__header--custom\n    .react-datepicker__day-names {\n    margin-top: 16px;\n  }\n  .gcdk-date-range-picker .react-datepicker__week {\n    display: flex;\n    justify-content: space-around;\n  }\n  .gcdk-date-range-picker .react-datepicker__day {\n    height: auto;\n    flex: 1 1 auto;\n    position: relative;\n  }\n\n  .gcdk-date-range-picker .react-datepicker__day:before {\n    content: \"\";\n    display: block;\n    padding-top: 100%;\n  }\n\n  .gcdk-date-range-picker .customDay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    display: flex;\n    align-items: center;\n    height: 100%;\n    justify-content: center;\n  }\n}\n";
styleInject(css_248z$8);

var LeftArrowIcon = function LeftArrowIcon(_ref) {
  var title = _ref.title,
    desc = _ref.desc,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? 24 : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 24 : _ref$height;
  return /*#__PURE__*/React__namespace.default.createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__namespace.default.createElement("g", null, title && /*#__PURE__*/React__namespace.default.createElement("title", null, title), desc && /*#__PURE__*/React__namespace.default.createElement("desc", null, desc), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M5.17505 12.1463L14.5075 2.02499L15.675 3.00519L7.24547 12.1463L15.675 21.2874L14.5075 22.275L5.17505 12.1463Z",
    fill: "#3944B3"
  })));
};
var RightArrowIcon = function RightArrowIcon(_ref2) {
  var title = _ref2.title,
    desc = _ref2.desc,
    _ref2$width = _ref2.width,
    width = _ref2$width === void 0 ? 24 : _ref2$width,
    _ref2$height = _ref2.height,
    height = _ref2$height === void 0 ? 24 : _ref2$height;
  return /*#__PURE__*/React__namespace.default.createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__namespace.default.createElement("g", null, title && /*#__PURE__*/React__namespace.default.createElement("title", null, title), desc && /*#__PURE__*/React__namespace.default.createElement("desc", null, desc), /*#__PURE__*/React__namespace.default.createElement("path", {
    d: "M19.2749 12.1537L9.94243 22.275L8.7749 21.2948L17.2045 12.1537L8.7749 3.01262L9.94243 2.02499L19.2749 12.1537Z",
    fill: "#3944B3"
  })));
};

var _excluded = ["className"];
ReactDatePicker.registerLocale("ja", ja__default$1.default);
var CalendarContainer = function CalendarContainer(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React__namespace.default.createElement("div", {
    className: classnames__default.default("gcdk-date-range-picker", styles$8.wrapper)
  }, /*#__PURE__*/React__namespace.default.createElement("div", {
    className: styles$8.box
  }, children));
};
var dayClassName = function dayClassName(date) {
  return "".concat(styles$8.day, " ").concat(isLastDayOfMonth(date) ? "lastDayOfMonth" : "");
};
/** DatePickerに渡すpropsの1つ。カレンダーのヘッダーをカスタムした要素を返す関数*/
var RenderCustomHeader = function RenderCustomHeader(_ref2) {
  var date = _ref2.date,
    monthDate = _ref2.monthDate,
    customHeaderCount = _ref2.customHeaderCount,
    decreaseMonth = _ref2.decreaseMonth,
    increaseMonth = _ref2.increaseMonth;
  return /*#__PURE__*/React__namespace.default.createElement("div", {
    className: styles$8.header
  }, customHeaderCount === 0 && (/*#__PURE__*/React__namespace.default.createElement("button", {
    className: "".concat(styles$8.changeMonthButton, " ").concat(styles$8.previous),
    onClick: decreaseMonth,
    title: "\u524D\u306E\u6708\u3092\u8868\u793A\u3059\u308B"
  }, /*#__PURE__*/React__namespace.default.createElement(LeftArrowIcon, {
    title: "\u524D\u306E\u6708\u3092\u8868\u793A\u3059\u308B",
    desc: "\u524D\u306E\u6708\u306B\u8868\u793A\u3059\u308B\u30A2\u30A4\u30B3\u30F3",
    width: 32,
    height: 32
  }))), /*#__PURE__*/React__namespace.default.createElement("div", {
    className: styles$8.transitionContainer
  }, "".concat(date.getFullYear(), "\u5E74"), /*#__PURE__*/React__namespace.default.createElement("span", {
    className: styles$8.spaceLeft
  }, "".concat(monthDate.getMonth() + 1, "\u6708"))), customHeaderCount === 1 && (/*#__PURE__*/React__namespace.default.createElement("button", {
    className: "".concat(styles$8.changeMonthButton, " ").concat(styles$8.next),
    onClick: increaseMonth,
    title: "\u6B21\u306E\u6708\u3092\u8868\u793A\u3059\u308B"
  }, /*#__PURE__*/React__namespace.default.createElement(RightArrowIcon, {
    title: "\u6B21\u306E\u6708\u306B\u8868\u793A\u3059\u308B",
    desc: "\u6B21\u306E\u6708\u306B\u8868\u793A\u3059\u308B\u30A2\u30A4\u30B3\u30F3",
    width: 32,
    height: 32
  }))));
};
var RenderDayOfMonth = function RenderDayOfMonth(dayOfMonth) {
  return /*#__PURE__*/React__namespace.default.createElement("div", {
    className: "cell"
  }, /*#__PURE__*/React__namespace.default.createElement("span", {
    className: "customDay"
  }, dayOfMonth));
};
var DateRangePicker = /*#__PURE__*/React__namespace.default.forwardRef(function (_ref3, ref) {
  var className = _ref3.className,
    props = _objectWithoutProperties(_ref3, _excluded);
  return /*#__PURE__*/React__namespace.default.createElement("div", {
    className: className
  }, /*#__PURE__*/React__namespace.default.createElement(ReactDatePicker__default.default, _objectSpread2(_objectSpread2({}, props), {}, {
    locale: "ja",
    ref: ref,
    selectsRange: true,
    monthsShown: 2,
    calendarContainer: CalendarContainer,
    renderCustomHeader: RenderCustomHeader,
    inline: true,
    dayClassName: dayClassName,
    disabledKeyboardNavigation: false,
    renderDayContents: RenderDayOfMonth
  })));
});
DateRangePicker.displayName = "DateRangePicker";

var DateRangeValidator = /*#__PURE__*/function () {
  function DateRangeValidator(_ref) {
    var minDate = _ref.minDate,
      maxDate = _ref.maxDate,
      value = _ref.value,
      format = _ref.format,
      index = _ref.index;
    _classCallCheck(this, DateRangeValidator);
    this.minDate = minDate;
    this.maxDate = maxDate;
    this.format = format;
    this.value = value;
    this.index = index;
  }
  return _createClass(DateRangeValidator, [{
    key: "validateRange",
    value: function validateRange() {
      if (!this.value[0].stringValue || !this.value[1].stringValue) return true;
      if (!!this.minDate && !!this.value[0] && !isValidDayRange(this.minDate, this.value[0].stringValue)) {
        return false;
      }
      if (!!this.maxDate && !!this.value[1] && !isValidDayRange(this.value[1].stringValue, this.maxDate)) {
        return false;
      }
      return isValidDayRange(this.value[0].stringValue, this.value[1].stringValue);
    }
  }, {
    key: "validate",
    value: function validate() {
      if (!isValidDateString(this.value[this.index].stringValue, this.format)) return "日付を入力し直してください。";
      if (!this.validateRange()) return "日付を選択し直してください。";
      return undefined;
    }
  }], [{
    key: "create",
    value: function create(props) {
      return new DateRangeValidator(props);
    }
  }]);
}();

var useDateRangeState = function useDateRangeState(_ref) {
  var disabled = _ref.disabled,
    errorState = _ref.errorState,
    touch = _ref.touch;
  var formState = React.useMemo(function () {
    return _toConsumableArray(Array(2)).map(function (_, index) {
      var _a;
      return FormState.create(touch[index], !errorState[index].hasError, false, disabled, (_a = errorState[index]) === null || _a === void 0 ? void 0 : _a.errorMessages);
    });
  }, [disabled, errorState, touch]);
  var hasError = React.useMemo(function () {
    return formState.some(function (state) {
      return state.isFail();
    });
  }, [formState]);
  return {
    formState: formState,
    hasError: hasError
  };
};
var useDateRangeErrorState = function useDateRangeErrorState(_ref2) {
  var generatedID = _ref2.generatedID,
    minDate = _ref2.minDate,
    maxDate = _ref2.maxDate,
    innerValue = _ref2.innerValue,
    format = _ref2.format;
  return React.useMemo(function () {
    return _toConsumableArray(Array(2)).map(function (_, index) {
      return ErrorState.create({
        id: generatedID,
        validator: DateRangeValidator.create({
          minDate: minDate,
          maxDate: maxDate,
          value: innerValue !== null && innerValue !== void 0 ? innerValue : [{
            stringValue: "",
            selected: null
          }, {
            stringValue: "",
            selected: null
          }],
          index: index,
          format: format
        })
      });
    });
  }, [generatedID, minDate, maxDate, innerValue, format]);
};

var DEFAULT_VALUE = [{
  stringValue: "",
  selected: null
}, {
  stringValue: "",
  selected: null
}];
var DateInput = function DateInput(_ref) {
  var index = _ref.index,
    formState = _ref.formState,
    value = _ref.value,
    format = _ref.format,
    onChange = _ref.onChange,
    onTouch = _ref.onTouch,
    onOpen = _ref.onOpen;
  var handleOnTouch = React.useCallback(function () {
    return onTouch(function (oldValues) {
      if (index > oldValues.length) return oldValues;
      var touch = _toConsumableArray(oldValues);
      touch[index] = true;
      return touch;
    });
  }, [onTouch, index]);
  var handleOnChange = React.useCallback(function (e) {
    var value = formatValue(convertFullToHalfWidth(removeInvalidDateString(e.target.value)), format);
    onChange(function () {
      var oldValues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_VALUE;
      var change = _toConsumableArray(oldValues);
      change[index].stringValue = value;
      if (!value) {
        change[index].selected = null;
      } else if (isValidDateString(value, format)) {
        change[index].selected = new Date(value);
      }
      return change;
    });
  }, [format, onChange, index]);
  var handleFocus = React.useCallback(function () {
    onOpen(true);
  }, [onOpen]);
  var handleBlur = React.useCallback(function () {
    handleOnTouch();
  }, [handleOnTouch]);
  return /*#__PURE__*/React__namespace.default.createElement("div", {
    className: classnames__default.default(styles$9.iconInputWrapper, formState[index].matchType({
      "default": styles$9["default"],
      fail: styles$9.fail,
      success: styles$9.success,
      disabled: styles$9.disabled
    })),
    "data-testid": index === 0 ? "test-date-range-start-date" : "test-date-range-end-date"
  }, /*#__PURE__*/React__namespace.default.createElement("input", {
    value: value === null || value === void 0 ? void 0 : value[index].stringValue,
    className: styles$9.input,
    onChange: handleOnChange,
    onFocus: handleFocus,
    onBlur: handleBlur
  }), formState[index].matchComponents({
    "default": /*#__PURE__*/React__namespace.default.createElement(CalenderIcon, {
      size: 24
    }),
    fail: /*#__PURE__*/React__namespace.default.createElement(WarningIcon$1, {
      size: 24
    }),
    success: /*#__PURE__*/React__namespace.default.createElement(CalenderIcon, {
      size: 24
    }),
    disabled: /*#__PURE__*/React__namespace.default.createElement(CalenderIcon, {
      size: 24
    })
  }));
};
var DateRangeInput = function DateRangeInput(_ref2) {
  var id = _ref2.id,
    _ref2$disabled = _ref2.disabled,
    disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
    _ref2$format = _ref2.format,
    format = _ref2$format === void 0 ? "YYYY/MM/DD" : _ref2$format,
    startDate = _ref2.startDate,
    endDate = _ref2.endDate,
    setValue = _ref2.setValue,
    onError = _ref2.onError,
    minDate = _ref2.minDate,
    maxDate = _ref2.maxDate,
    _ref2$isSmall = _ref2.isSmall,
    isSmall = _ref2$isSmall === void 0 ? false : _ref2$isSmall;
  var _a, _b, _c, _d, _e;
  var calendar = React.useRef(null);
  var generatedID = React.useMemo(function () {
    return id !== null && id !== void 0 ? id : generateID();
  }, [id]);
  var _useState = React.useState([{
      stringValue: startDate ? dayjs__default.default(startDate).format(format) : "",
      selected: startDate || null
    }, {
      stringValue: endDate ? dayjs__default.default(endDate).format(format) : "",
      selected: endDate || null
    }]),
    _useState2 = _slicedToArray(_useState, 2),
    innerValue = _useState2[0],
    setInnerValue = _useState2[1];
  var _useState3 = React.useState([false, false]),
    _useState4 = _slicedToArray(_useState3, 2),
    touch = _useState4[0],
    setTouch = _useState4[1];
  var _useState5 = React.useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isOpen = _useState6[0],
    setIsOpen = _useState6[1];
  var showClearIcon = React.useMemo(function () {
    return innerValue === null || innerValue === void 0 ? void 0 : innerValue.some(function (v) {
      return !!v.stringValue;
    });
  }, [innerValue]);
  var errorState = useDateRangeErrorState({
    minDate: minDate,
    maxDate: maxDate,
    format: format,
    innerValue: innerValue,
    generatedID: generatedID
  });
  var _useDateRangeState = useDateRangeState({
      errorState: errorState,
      touch: touch,
      disabled: disabled
    }),
    formState = _useDateRangeState.formState,
    hasError = _useDateRangeState.hasError;
  var closeCalendar = React.useCallback(function () {
    if (!hasError) {
      setIsOpen(false);
    }
  }, [hasError]);
  var handleOnClear = React.useCallback(function () {
    setInnerValue([{
      stringValue: "",
      selected: null
    }, {
      stringValue: "",
      selected: null
    }]);
  }, []);
  React.useEffect(function () {
    var _a, _b;
    setValue({
      startDate: (_a = innerValue === null || innerValue === void 0 ? void 0 : innerValue[0].selected) !== null && _a !== void 0 ? _a : null,
      endDate: (_b = innerValue === null || innerValue === void 0 ? void 0 : innerValue[1].selected) !== null && _b !== void 0 ? _b : null
    });
  }, [innerValue, setValue]);
  React.useEffect(function () {
    onError && errorState && onError(errorState);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [(_a = errorState === null || errorState === void 0 ? void 0 : errorState[0]) === null || _a === void 0 ? void 0 : _a.errorMessages, (_b = errorState === null || errorState === void 0 ? void 0 : errorState[1]) === null || _b === void 0 ? void 0 : _b.errorMessages]);
  return /*#__PURE__*/React__namespace.default.createElement(OutsideClickHandler__default.default, {
    onOutsideClick: closeCalendar
  }, /*#__PURE__*/React__namespace.default.createElement("div", {
    className: styles$9.wrapper,
    id: generatedID
  }, /*#__PURE__*/React__namespace.default.createElement("div", {
    className: classnames__default.default(styles$9.inputWrapper, _defineProperty({}, styles$9.small, isSmall))
  }, _toConsumableArray(Array(2)).map(function (_, index) {
    return /*#__PURE__*/React__namespace.default.createElement(React__namespace.default.Fragment, {
      key: "date-range-input-".concat(index)
    }, /*#__PURE__*/React__namespace.default.createElement(DateInput, {
      onOpen: setIsOpen,
      index: index,
      formState: formState,
      value: innerValue !== null && innerValue !== void 0 ? innerValue : DEFAULT_VALUE,
      onTouch: setTouch,
      onChange: setInnerValue,
      format: format
    }), index === 0 && (/*#__PURE__*/React__namespace.default.createElement(React__namespace.default.Fragment, null, /*#__PURE__*/React__namespace.default.createElement("div", {
      className: styles$9.divider
    }))), index === 1 && showClearIcon && (/*#__PURE__*/React__namespace.default.createElement("button", {
      className: styles$9.clearIconWrapper,
      onClick: handleOnClear
    }, /*#__PURE__*/React__namespace.default.createElement(CloseCircleIcon, {
      className: classnames__default.default(styles$9.clearIcon, formState[index].matchType({
        "default": styles$9["default"],
        fail: styles$9.fail,
        success: styles$9["default"],
        disabled: styles$9.disabled
      })),
      size: 24
    }))));
  }), isOpen && (/*#__PURE__*/React__namespace.default.createElement(DateRangePicker, {
    id: "".concat(generatedID, "-picker"),
    ref: calendar,
    className: styles$9.calender,
    onChange: function onChange(value) {
      if (!Array.isArray(value)) return;
      setInnerValue(function () {
        return value.map(function (v) {
          return {
            stringValue: v ? dayjs__default.default(v).format(format) : "",
            selected: v
          };
        });
      });
      if (value.every(function (v) {
        return v !== null;
      })) {
        closeCalendar();
      }
    },
    startDate: (_c = innerValue === null || innerValue === void 0 ? void 0 : innerValue[0].selected) !== null && _c !== void 0 ? _c : null,
    endDate: (_d = innerValue === null || innerValue === void 0 ? void 0 : innerValue[1].selected) !== null && _d !== void 0 ? _d : null,
    selected: (_e = innerValue === null || innerValue === void 0 ? void 0 : innerValue[0].selected) !== null && _e !== void 0 ? _e : null,
    minDate: minDate,
    maxDate: maxDate
  }))), /*#__PURE__*/React__namespace.default.createElement("div", {
    className: styles$9.errorWrapper
  }, formState.map(function (state, index) {
    return /*#__PURE__*/React__namespace.default.createElement("div", {
      key: "date-range-error-".concat(index),
      className: styles$9.error
    }, /*#__PURE__*/React__namespace.default.createElement(ErrorMessages, {
      messages: state.isFail() ? state.errorMessage : ""
    }));
  }))));
};

var css_248z$7 = ".horizontal-template-module_container__79akG {\n  display: grid;\n  grid-template-rows: auto 1fr auto;\n  grid-template-columns: 50% 50%;\n}\n";
var styles$7 = {"container":"horizontal-template-module_container__79akG"};
styleInject(css_248z$7);

var HorizontalTemplate = function HorizontalTemplate(_ref) {
  var editMenuBar = _ref.editMenuBar,
    editArea = _ref.editArea,
    previewMenuBar = _ref.previewMenuBar,
    previewArea = _ref.previewArea,
    charCounter = _ref.charCounter;
  return /*#__PURE__*/React__namespace.createElement("div", {
    className: styles$7.container
  }, editMenuBar, previewMenuBar, editArea, previewArea, charCounter);
};

var css_248z$6 = ".standalone-template-module_container__3Yx4G {\n  display: flex;\n  flex-direction: column;\n}\n";
var styles$6 = {"container":"standalone-template-module_container__3Yx4G"};
styleInject(css_248z$6);

var StandaloneTemplate = function StandaloneTemplate(_ref) {
  var editMenuBar = _ref.editMenuBar,
    editArea = _ref.editArea,
    charCounter = _ref.charCounter;
  return /*#__PURE__*/React__namespace.createElement("div", {
    className: styles$6.container
  }, editMenuBar, editArea, charCounter);
};

var css_248z$5 = ":root {\n  /* Color styles */\n\n  /* Text-size styles */\n\n  /* Effect styles */\n  /* border-radius */\n}\n\n.index-module_editMenuBar__3vyy9 {\n  border: 1px solid #949cb0;\n  background-color: #f1f2f7;\n  border-bottom: 0px;\n  ul {\n    list-style: none;\n    margin: 0;\n    padding: 8px;\n    display: inline-flex;\n    align-items: center;\n    flex-grow: 1;\n    width: 100%;\n    flex-wrap: wrap;\n    gap: 8px;\n\n    li {\n      font: 600 12px/12px Meiryo, Arial, system-ui, sans-serif;\n      white-space: nowrap;\n      flex-grow: 0;\n      white-space: nowrap;\n    }\n  }\n}\n\n.index-module_editMenuBarHorizontal__eZje8 {\n  border-top-right-radius: 0px;\n  border-top-left-radius: 4px;\n  border-bottom-right-radius: 0px;\n  border-bottom-left-radius: 0px;\n}\n\n.index-module_editMenuBarStandalone__KOgnd {\n  border-top-right-radius: 4px;\n  border-top-left-radius: 4px;\n  border-bottom-right-radius: 0px;\n  border-bottom-left-radius: 0px;\n}\n";
var styles$5 = {"editMenuBar":"index-module_editMenuBar__3vyy9","editMenuBarHorizontal":"index-module_editMenuBarHorizontal__eZje8","editMenuBarStandalone":"index-module_editMenuBarStandalone__KOgnd"};
styleInject(css_248z$5);

var allHeadings = ["h1", "h2", "h3", "h4", "h5", "h6"];
var wrapButtonKeys = ["bold", "link"];
var setHeadButtonKeys = [].concat(allHeadings, ["bulletList", "orderedList"]);
[].concat(wrapButtonKeys, _toConsumableArray(setHeadButtonKeys));
var buttonTagMap = {
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  h5: "h5",
  h6: "h6",
  bold: "strong",
  bulletList: "ul",
  orderedList: "ol",
  link: "a"
};
var wrapSymbolList = {
  bold: {
    prefix: "**",
    suffix: "**"
  },
  link: {
    prefix: "[",
    suffix: "](url)"
  }
};
var setHeadSymbolList = {
  h1: {
    marker: "#",
    markerSuffix: " "
  },
  h2: {
    marker: "##",
    markerSuffix: " "
  },
  h3: {
    marker: "###",
    markerSuffix: " "
  },
  h4: {
    marker: "####",
    markerSuffix: " "
  },
  h5: {
    marker: "#####",
    markerSuffix: " "
  },
  h6: {
    marker: "######",
    markerSuffix: " "
  },
  bulletList: {
    marker: "-",
    markerSuffix: " "
  },
  orderedList: {
    marker: "1",
    markerSuffix: ". "
  }
};

var allTagNames = ["h1", "h2", "h3", "h4", "h5", "h6", "a", "ul", "ol", "li", "p", "strong"];

var css_248z$4 = ":root {\n  /* Color styles */\n\n  /* Text-size styles */\n\n  /* Effect styles */\n  /* border-radius */\n}\n\n.base-module_baseEditMenuButton__q5rRX {\n  border-radius: 4px;\n  border: 1px solid #949cb0;\n  background: #ffffff;\n  padding: 8px;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  height: 36px;\n\n  &:focus:not(:disabled) {\n    border-radius: 4px;\n    border: 1px solid #353ebd;\n    background: #ffffff;\n    box-shadow: 0px 0px 5px rgba(53, 62, 189, 1);\n  }\n\n  &:hover:not(:disabled) {\n    border-radius: 4px;\n    border: 1px solid #5f636d !important;\n    background: #ffffff;\n  }\n\n  &.base-module_active__2CA7d:not(:disabled) {\n    border-radius: 4px;\n    border: 1px solid #353ebd;\n    background: #e8e9f9;\n  }\n\n  &:disabled {\n    border-radius: 4px;\n    border: 1px solid #949cb0;\n    background: #f1f2f7;\n  }\n\n  span {\n    font: 600 12px/12px Meiryo, Arial, system-ui, sans-serif;\n  }\n}\n";
var styles$4 = {"baseEditMenuButton":"base-module_baseEditMenuButton__q5rRX","active":"base-module_active__2CA7d"};
styleInject(css_248z$4);

var BaseEditMenuButton = function BaseEditMenuButton(_ref) {
  var onClick = _ref.onClick,
    icon = _ref.icon,
    label = _ref.label;
  return /*#__PURE__*/React__namespace.createElement("button", {
    className: styles$4.baseEditMenuButton,
    onClick: onClick
  }, icon, /*#__PURE__*/React__namespace.createElement("span", null, label));
};

/**
 * 行の開始位置と終了位置を取得する（LF, CR, CR+LFに対応）
 * @param editor テキストエリア
 * @returns 行の開始位置と終了位置
 */
var getLineBoundaries = function getLineBoundaries(editor) {
  var start = editor.selectionStart;
  var text = editor.value;
  var beforeCursor = text.slice(0, start);
  var lastLF = beforeCursor.lastIndexOf("\n");
  var lastCR = beforeCursor.lastIndexOf("\r");
  var lineStart = Math.max(lastLF, lastCR) + 1;
  var afterCursor = text.slice(start);
  var nextLF = afterCursor.indexOf("\n");
  var nextCR = afterCursor.indexOf("\r");
  var lineEnd;
  var hasNextLF = nextLF !== -1;
  var hasNextCR = nextCR !== -1;
  switch (true) {
    // カーソル位置以降に改行が存在しない場合は、テキストの末尾を採用
    case !hasNextLF && !hasNextCR:
      lineEnd = text.length;
      break;
    // カーソル位置以降にCRのみが存在する場合は、CRの位置を採用
    case !hasNextLF:
      lineEnd = start + nextCR;
      break;
    // カーソル位置以降にLFのみが存在する場合は、LFの位置を採用
    case !hasNextCR:
      lineEnd = start + nextLF;
      break;
    // カーソル位置以降にCRとLFの両方が存在する場合は、近い方の位置を採用
    default:
      lineEnd = start + Math.min(nextLF, nextCR);
  }
  return {
    lineStart: lineStart,
    lineEnd: lineEnd
  };
};

/**
 * 選択範囲の開始位置と終了位置を取得する
 * @param editor テキストエリア
 * @returns 選択範囲の開始位置と終了位置、選択範囲のテキスト
 */
var getSelection = function getSelection(editor) {
  var start = editor.selectionStart;
  var end = editor.selectionEnd;
  var text = editor.value.slice(start, end);
  return {
    from: start,
    to: end,
    text: text
  };
};

/**
 * 選択範囲の前後のテキストを取得する
 * @param editor テキストエリア
 * @param from 選択範囲の開始位置
 * @param to 選択範囲の終了位置
 * @returns 選択範囲の前後のテキスト
 */
var getTextBeforeAfter = function getTextBeforeAfter(editor, from, to) {
  var before = editor.value.slice(0, from);
  var after = editor.value.slice(to);
  var between = editor.value.slice(from, to);
  return {
    before: before,
    after: after,
    between: between
  };
};

/**
 * スクロール位置を保持するためのユーティリティ関数
 * @param editor テキストエリア
 * @param callback テキストエリアの操作を行うコールバック関数
 */
var preserveScrollPosition = function preserveScrollPosition(editor, callback) {
  // スクロール位置を保存
  var scrollTop = editor.scrollTop;
  var scrollLeft = editor.scrollLeft;
  try {
    // コールバック関数を実行
    var result = callback();
    return result;
  } finally {
    // エラーが発生しても、スクロール位置を復元
    editor.scrollTop = scrollTop;
    editor.scrollLeft = scrollLeft;
  }
};

/**
 * 単行の先頭にテキストを挿入する
 * @param editor テキストエリア
 * @param marker 挿入するテキスト
 * @param options.markerSuffix 挿入するテキストの後ろに追加するテキスト
 * @param options.surroundingNewlines 前後に改行を追加するかどうか
 */
var setHeadSingleLine = function setHeadSingleLine(editor, marker) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return preserveScrollPosition(editor, function () {
    var _a, _b;
    var _getSelection = getSelection(editor),
      from = _getSelection.from,
      to = _getSelection.to;
    var _getLineBoundaries = getLineBoundaries(editor),
      lineStart = _getLineBoundaries.lineStart,
      lineEnd = _getLineBoundaries.lineEnd;
    var _getTextBeforeAfter = getTextBeforeAfter(editor, lineStart, lineEnd),
      before = _getTextBeforeAfter.before,
      after = _getTextBeforeAfter.after,
      currentLineText = _getTextBeforeAfter.between;
    // 前後の改行を処理
    var leadingNewlines = "";
    var trailingNewlines = "";
    if (options.surroundingNewlines) {
      if (before.length > 0) {
        if (before.endsWith("\n\n")) {
          leadingNewlines = "";
        } else if (before.endsWith("\n")) {
          leadingNewlines = "\n";
        } else {
          leadingNewlines = "\n\n";
        }
      }
      if (after.length > 0) {
        if (after.startsWith("\n\n")) {
          trailingNewlines = "";
        } else if (after.startsWith("\n")) {
          trailingNewlines = "\n";
        } else {
          trailingNewlines = "\n\n";
        }
      }
    }
    // 新しい文字列を作成
    var newText = before + leadingNewlines + marker + ((_a = options.markerSuffix) !== null && _a !== void 0 ? _a : "") + currentLineText + trailingNewlines + after;
    // テキストエリアの値を直接更新
    editor.value = newText;
    // カーソル位置を更新
    editor.focus();
    var offset = marker.length + ((_b = options.markerSuffix) !== null && _b !== void 0 ? _b : "").length;
    editor.setSelectionRange(from + leadingNewlines.length + offset, to + leadingNewlines.length + offset);
  });
};

var HeadingButton = function HeadingButton(_ref) {
  var editorRef = _ref.editorRef,
    level = _ref.level,
    onChange = _ref.onChange,
    label = _ref.label,
    icon = _ref.icon;
  var onClick = function onClick() {
    var editor = editorRef.current;
    if (!editor) return;
    setHeadSingleLine(editor, setHeadSymbolList["h".concat(level)].marker, {
      markerSuffix: setHeadSymbolList["h".concat(level)].markerSuffix
    });
    onChange(editor.value);
  };
  var defaultIcon = function () {
    switch (level) {
      case 1:
        return /*#__PURE__*/React__namespace.createElement(Heading1Icon, {
          size: IconSizes.small
        });
      case 2:
        return /*#__PURE__*/React__namespace.createElement(Heading2Icon, {
          size: IconSizes.small
        });
      default:
        return;
    }
  }();
  return /*#__PURE__*/React__namespace.createElement(BaseEditMenuButton, {
    onClick: onClick,
    icon: icon !== null && icon !== void 0 ? icon : defaultIcon,
    label: label !== null && label !== void 0 ? label : "\u898B\u51FA\u3057".concat(level)
  });
};

/**
 * 選択範囲をテキストで囲む
 * @param editor テキストエリア
 * @param prefix 前に挿入するテキスト
 * @param suffix 後ろに挿入するテキスト（指定しない場合はprefixと同じ）
 */
var wrap = function wrap(editor, prefix) {
  var suffix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : prefix;
  return preserveScrollPosition(editor, function () {
    var _getSelection = getSelection(editor),
      from = _getSelection.from,
      to = _getSelection.to,
      selectedText = _getSelection.text;
    var _getTextBeforeAfter = getTextBeforeAfter(editor, from, to),
      before = _getTextBeforeAfter.before,
      after = _getTextBeforeAfter.after;
    // 新しい文字列を作成
    var newText = before + prefix + selectedText + suffix + after;
    // テキストエリアの値を直接更新
    editor.value = newText;
    // カーソル位置を更新（選択範囲を維持）
    editor.focus();
    editor.setSelectionRange(from + prefix.length, to + prefix.length);
  });
};

var BoldButton = function BoldButton(_ref) {
  var editorRef = _ref.editorRef,
    onChange = _ref.onChange,
    label = _ref.label,
    icon = _ref.icon;
  var onClick = function onClick() {
    var editor = editorRef.current;
    if (!editor) return;
    wrap(editor, wrapSymbolList.bold.prefix, wrapSymbolList.bold.suffix);
    onChange(editor.value);
  };
  return /*#__PURE__*/React__namespace.createElement(BaseEditMenuButton, {
    onClick: onClick,
    icon: icon !== null && icon !== void 0 ? icon : /*#__PURE__*/React__namespace.createElement(BoldIcon, {
      size: IconSizes.small
    }),
    label: label !== null && label !== void 0 ? label : "太字"
  });
};

/**
 * 複数行の先頭にテキストを挿入する
 * @param editor テキストエリア
 * @param marker 各行の先頭に挿入するテキスト
 * @param options.markerSuffix 各行の先頭に挿入するテキストの後ろに追加するテキスト
 * @param options.surroundingNewlines 選択範囲の前後に改行を追加するかどうか
 * @param options.increment マーカーをインクリメントするかどうか（マーカーが数値の場合のみ）
 */
var setHeadMultiLines = function setHeadMultiLines(editor, marker) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return preserveScrollPosition(editor, function () {
    var _getSelection = getSelection(editor),
      from = _getSelection.from,
      to = _getSelection.to,
      selectedText = _getSelection.text;
    var _getTextBeforeAfter = getTextBeforeAfter(editor, from, to),
      before = _getTextBeforeAfter.before,
      after = _getTextBeforeAfter.after;
    // 選択範囲の各行にプレフィックスを追加
    var newLines = selectedText.split(/\r\n|\r|\n/).map(function (line, index) {
      var _a, _b;
      if (typeof marker === "number" && options.increment) {
        return "".concat(marker + index).concat((_a = options.markerSuffix) !== null && _a !== void 0 ? _a : "").concat(line);
      }
      return "".concat(marker).concat((_b = options.markerSuffix) !== null && _b !== void 0 ? _b : "").concat(line);
    }).join("\n");
    // 前後の改行を処理
    var leadingNewlines = "";
    var trailingNewlines = "";
    if (options.surroundingNewlines) {
      if (before.length > 0) {
        if (before.endsWith("\n\n")) {
          leadingNewlines = "";
        } else if (before.endsWith("\n")) {
          leadingNewlines = "\n";
        } else {
          leadingNewlines = "\n\n";
        }
      }
      if (after.length > 0) {
        if (after.startsWith("\n\n")) {
          trailingNewlines = "";
        } else if (after.startsWith("\n")) {
          trailingNewlines = "\n";
        } else {
          trailingNewlines = "\n\n";
        }
      }
    }
    // 新しい文字列を作成
    var newText = before + leadingNewlines + newLines + trailingNewlines + after;
    // テキストエリアの値を直接更新
    editor.value = newText;
    // カーソル位置を更新（選択範囲を維持）
    editor.focus();
    var leadingOffset = leadingNewlines.length;
    var contentOffset = newLines.length - selectedText.length;
    editor.setSelectionRange(from + leadingOffset, to + leadingOffset + contentOffset);
  });
};

var BulletListButton = function BulletListButton(_ref) {
  var editorRef = _ref.editorRef,
    onChange = _ref.onChange,
    label = _ref.label,
    icon = _ref.icon;
  var onClick = function onClick() {
    var editor = editorRef.current;
    if (!editor) return;
    var _getSelection = getSelection(editor),
      from = _getSelection.from,
      to = _getSelection.to;
    if (from === to) {
      // 選択範囲がない場合はカーソルのある行全体をリスト化する
      setHeadSingleLine(editor, setHeadSymbolList.bulletList.marker, {
        markerSuffix: setHeadSymbolList.bulletList.markerSuffix,
        surroundingNewlines: true
      });
    } else {
      // 選択範囲がある場合は選択範囲をリスト化する
      setHeadMultiLines(editor, setHeadSymbolList.bulletList.marker, {
        markerSuffix: setHeadSymbolList.bulletList.markerSuffix,
        surroundingNewlines: true
      });
    }
    onChange(editor.value);
  };
  return /*#__PURE__*/React__namespace.createElement(BaseEditMenuButton, {
    onClick: onClick,
    icon: icon !== null && icon !== void 0 ? icon : /*#__PURE__*/React__namespace.createElement(ListUnorderedIcon, {
      size: IconSizes.small
    }),
    label: label !== null && label !== void 0 ? label : "リスト"
  });
};

var OrderedListButton = function OrderedListButton(_ref) {
  var editorRef = _ref.editorRef,
    onChange = _ref.onChange,
    label = _ref.label,
    icon = _ref.icon;
  var onClick = function onClick() {
    var editor = editorRef.current;
    if (!editor) return;
    var _getSelection = getSelection(editor),
      from = _getSelection.from,
      to = _getSelection.to;
    if (from === to) {
      // 選択範囲がない場合はカーソルのある行全体をリスト化する
      setHeadSingleLine(editor, setHeadSymbolList.orderedList.marker, {
        markerSuffix: setHeadSymbolList.orderedList.markerSuffix,
        surroundingNewlines: true
      });
    } else {
      // 選択範囲がある場合は選択範囲をリスト化する
      setHeadMultiLines(editor, Number(setHeadSymbolList.orderedList.marker), {
        markerSuffix: setHeadSymbolList.orderedList.markerSuffix,
        surroundingNewlines: true,
        increment: true
      });
    }
    onChange(editor.value);
  };
  return /*#__PURE__*/React__namespace.createElement(BaseEditMenuButton, {
    onClick: onClick,
    icon: icon !== null && icon !== void 0 ? icon : /*#__PURE__*/React__namespace.createElement(ListOrderedIcon, {
      size: IconSizes.small
    }),
    label: label !== null && label !== void 0 ? label : "順序リスト"
  });
};

var LinkButton = function LinkButton(_ref) {
  var editorRef = _ref.editorRef,
    onChange = _ref.onChange,
    label = _ref.label,
    icon = _ref.icon;
  var onClick = function onClick() {
    var editor = editorRef.current;
    if (!editor) return;
    wrap(editor, wrapSymbolList.link.prefix, wrapSymbolList.link.suffix);
    onChange(editor.value);
  };
  return /*#__PURE__*/React__namespace.createElement(BaseEditMenuButton, {
    onClick: onClick,
    icon: icon !== null && icon !== void 0 ? icon : /*#__PURE__*/React__namespace.createElement(LinkIcon$1, {
      size: IconSizes.small
    }),
    label: label !== null && label !== void 0 ? label : "リンク"
  });
};

var EditMenuBar = function EditMenuBar(_ref) {
  var editorRef = _ref.editorRef,
    _ref$allowedTagNames = _ref.allowedTagNames,
    allowedTagNames = _ref$allowedTagNames === void 0 ? allTagNames : _ref$allowedTagNames,
    layout = _ref.layout,
    menuButtonOptions = _ref.menuButtonOptions,
    onChange = _ref.onChange;
  var _a, _b, _c, _d, _e, _f, _g, _h;
  var buttons = [].concat(_toConsumableArray(allHeadings.map(function (heading) {
    var _a, _b;
    return /*#__PURE__*/React__namespace.createElement(HeadingButton, {
      key: heading,
      editorRef: editorRef,
      level: Number(heading.slice(1)),
      label: (_a = menuButtonOptions === null || menuButtonOptions === void 0 ? void 0 : menuButtonOptions[heading]) === null || _a === void 0 ? void 0 : _a.label,
      icon: (_b = menuButtonOptions === null || menuButtonOptions === void 0 ? void 0 : menuButtonOptions[heading]) === null || _b === void 0 ? void 0 : _b.icon,
      onChange: onChange
    });
  })), [/*#__PURE__*/React__namespace.createElement(BoldButton, {
    key: "bold",
    editorRef: editorRef,
    label: (_a = menuButtonOptions === null || menuButtonOptions === void 0 ? void 0 : menuButtonOptions.bold) === null || _a === void 0 ? void 0 : _a.label,
    icon: (_b = menuButtonOptions === null || menuButtonOptions === void 0 ? void 0 : menuButtonOptions.bold) === null || _b === void 0 ? void 0 : _b.icon,
    onChange: onChange
  }), /*#__PURE__*/React__namespace.createElement(BulletListButton, {
    key: "bulletList",
    editorRef: editorRef,
    label: (_c = menuButtonOptions === null || menuButtonOptions === void 0 ? void 0 : menuButtonOptions.bulletList) === null || _c === void 0 ? void 0 : _c.label,
    icon: (_d = menuButtonOptions === null || menuButtonOptions === void 0 ? void 0 : menuButtonOptions.bulletList) === null || _d === void 0 ? void 0 : _d.icon,
    onChange: onChange
  }), /*#__PURE__*/React__namespace.createElement(OrderedListButton, {
    key: "orderedList",
    editorRef: editorRef,
    label: (_e = menuButtonOptions === null || menuButtonOptions === void 0 ? void 0 : menuButtonOptions.orderedList) === null || _e === void 0 ? void 0 : _e.label,
    icon: (_f = menuButtonOptions === null || menuButtonOptions === void 0 ? void 0 : menuButtonOptions.orderedList) === null || _f === void 0 ? void 0 : _f.icon,
    onChange: onChange
  }), /*#__PURE__*/React__namespace.createElement(LinkButton, {
    key: "link",
    editorRef: editorRef,
    label: (_g = menuButtonOptions === null || menuButtonOptions === void 0 ? void 0 : menuButtonOptions.link) === null || _g === void 0 ? void 0 : _g.label,
    icon: (_h = menuButtonOptions === null || menuButtonOptions === void 0 ? void 0 : menuButtonOptions.link) === null || _h === void 0 ? void 0 : _h.icon,
    onChange: onChange
  })]).filter(function (button) {
    return allowedTagNames.includes(buttonTagMap[button.key]);
  });
  return /*#__PURE__*/React__namespace.createElement("div", {
    className: classnames__default.default(styles$5.editMenuBar, layout === "horizontal" && styles$5.editMenuBarHorizontal, layout === "standalone" && styles$5.editMenuBarStandalone)
  }, /*#__PURE__*/React__namespace.createElement("ul", null, buttons.map(function (button, index) {
    return /*#__PURE__*/React__namespace.createElement("li", {
      key: index
    }, button);
  })));
};

var css_248z$3 = ":root {\n  /* Color styles */\n\n  /* Text-size styles */\n\n  /* Effect styles */\n  /* border-radius */\n}\n\n.index-module_editArea__1ZQcc {\n  flex-shrink: 0;\n  resize: none;\n  flex-grow: 1;\n  background: #ffffff;\n  border: 1px solid #949cb0;\n  padding: 8px;\n  font: 300 14px/20px Meiryo, Arial, system-ui, sans-serif;\n  color: #262b38;\n  max-width: 100%;\n  width: 100%;\n  box-sizing: border-box;\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n\n  &:hover {\n    border: 1px solid #5f636d;\n  }\n\n  &:focus {\n    border: 1px solid #353ebd;\n    outline: unset;\n    box-shadow: 0px 0px 5px rgba(53, 62, 189, 1);\n  }\n\n  &:focus-visible {\n    border: 1px solid #353ebd;\n    outline: unset;\n    box-shadow: 0px 0px 5px rgba(53, 62, 189, 1);\n  }\n\n  &.index-module_disabled__1IjlK {\n    background: #f1f2f7;\n    border-color: #f1f2f7;\n    cursor: not-allowed;\n  }\n\n  @media (max-width: 768px) {\n    border-bottom-right-radius: 4px;\n  }\n}\n\n.index-module_editAreaHorizontal__3jkds {\n  border-top-right-radius: 0px;\n  border-top-left-radius: 0px;\n  border-bottom-right-radius: 0px;\n  border-bottom-left-radius: 4px;\n  max-height: 300px;\n}\n\n.index-module_editAreaStandalone__1L8zs {\n  border-top-right-radius: 0px;\n  border-top-left-radius: 0px;\n  border-bottom-right-radius: 4px;\n  border-bottom-left-radius: 4px;\n  max-height: 200px;\n}\n\ntextarea[aria-invalid=\"true\"].index-module_editAreaError__jfyHv {\n  border: 1px solid #de3226;\n  background: #fff5f6;\n\n  &:hover {\n    border: 1px solid #b1110c;\n    background: #fff5f6;\n  }\n\n  &:focus {\n    border: 1px solid #de3226;\n    box-shadow: 0px 0px 5px rgba(222, 50, 38, 0.7);\n  }\n}\n";
var styles$3 = {"editArea":"index-module_editArea__1ZQcc","disabled":"index-module_disabled__1IjlK","editAreaHorizontal":"index-module_editAreaHorizontal__3jkds","editAreaStandalone":"index-module_editAreaStandalone__1L8zs","editAreaError":"index-module_editAreaError__jfyHv"};
styleInject(css_248z$3);

var EditArea = function EditArea(_ref) {
  var editorRef = _ref.editorRef,
    value = _ref.value,
    _onChange = _ref.onChange,
    onScroll = _ref.onScroll,
    layout = _ref.layout,
    isError = _ref.isError,
    attributes = _ref.attributes;
  return /*#__PURE__*/React__namespace.createElement("textarea", _objectSpread2({
    className: classnames__default.default(styles$3.editArea, layout === "horizontal" && styles$3.editAreaHorizontal, layout === "standalone" && styles$3.editAreaStandalone, isError && styles$3.editAreaError),
    ref: editorRef,
    value: value,
    onChange: function onChange(e) {
      return _onChange(e.target.value);
    },
    onScroll: onScroll,
    "aria-invalid": isError
  }, attributes));
};

var css_248z$2 = ":root {\n  /* Color styles */\n\n  /* Text-size styles */\n\n  /* Effect styles */\n  /* border-radius */\n}\n\n.index-module_previewMenuBar__B7OpQ {\n  border: 1px solid #949cb0;\n  margin-bottom: -1px;\n  padding: 8px;\n  width: 100%;\n  display: flex;\n  align-items: center;\n\n  span {\n    font: 600 14px/18px Meiryo, Arial, system-ui, sans-serif;\n    display: inline-block;\n  }\n\n  span:not(:last-child) {\n    margin-right: 8px;\n  }\n}\n\n.index-module_previewMenuBarHorizontal__3K6uS {\n  background-color: #ffffff;\n  border-top-right-radius: 4px;\n  border-top-left-radius: 0px;\n  border-bottom-right-radius: 0px;\n  border-bottom-left-radius: 0px;\n  border-top: 1px solid #949cb0;\n  border-left: 0px;\n  border-right: 1px solid #949cb0;\n  border-bottom: 0px;\n}\n";
var styles$2 = {"previewMenuBar":"index-module_previewMenuBar__B7OpQ","previewMenuBarHorizontal":"index-module_previewMenuBarHorizontal__3K6uS"};
styleInject(css_248z$2);

var PreviewMenuBar = function PreviewMenuBar(_ref) {
  var title = _ref.title,
    description = _ref.description,
    layout = _ref.layout;
  return /*#__PURE__*/React__namespace.createElement("div", {
    className: classnames__default.default(styles$2.previewMenuBar, layout === "horizontal" && styles$2.previewMenuBarHorizontal)
  }, /*#__PURE__*/React__namespace.createElement("span", null, title !== null && title !== void 0 ? title : "プレビュー"), !!description && /*#__PURE__*/React__namespace.createElement("span", null, description));
};

var css_248z$1 = ":root {\n  /* Color styles */\n\n  /* Text-size styles */\n\n  /* Effect styles */\n  /* border-radius */\n}\n\n.index-module_markdownPreviewContainerHorizontal__1GsYX {\n  overflow: auto;\n  padding: 8px;\n  border: 1px solid #949cb0;\n  border-top-left-radius: 0px;\n  border-top-right-radius: 0px;\n  border-bottom-left-radius: 0px;\n  border-bottom-right-radius: 4px;\n  border-left: 0px;\n  max-height: 300px;\n  min-height: 60px;\n}\n\n.index-module_errorContent__1UTF7 {\n  color: #de3226;\n  font: 300 12px/18px Meiryo, Arial, system-ui, sans-serif;\n}\n";
var styles$1 = {"markdownPreviewContainerHorizontal":"index-module_markdownPreviewContainerHorizontal__1GsYX","errorContent":"index-module_errorContent__1UTF7"};
styleInject(css_248z$1);

var PreviewArea = function PreviewArea(_ref) {
  var previewRef = _ref.previewRef,
    content = _ref.content,
    layout = _ref.layout,
    onScroll = _ref.onScroll;
  return /*#__PURE__*/React__namespace.createElement("div", {
    ref: previewRef,
    className: classnames__default.default(styles$1.markdownPreviewContainer, layout === "horizontal" && styles$1.markdownPreviewContainerHorizontal),
    onScroll: onScroll
  }, content);
};

var css_248z = ":root {\n  /* Color styles */\n\n  /* Text-size styles */\n\n  /* Effect styles */\n  /* border-radius */\n}\n\n.index-module_charCounter__3h6rq {\n  font: 300 13px/18px Meiryo, Arial, system-ui, sans-serif;\n  text-align: right;\n  letter-spacing: 1px;\n  color: #262b38;\n  width: 100%;\n}\n";
var styles = {"charCounter":"index-module_charCounter__3h6rq"};
styleInject(css_248z);

var CharCounter = function CharCounter(_ref) {
  var content = _ref.content,
    maxLength = _ref.maxLength;
  return /*#__PURE__*/React__namespace.createElement("div", {
    className: styles.charCounter
  }, maxLength ? "".concat(content.length, "/").concat(maxLength) : content.length);
};

var useScrollHook = function useScrollHook(_ref) {
  var textareaRef = _ref.textareaRef,
    previewRef = _ref.previewRef;
  var previewActive = React.useRef(false);
  var textAreaActive = React.useRef(false);
  var handleOnScroll = React.useCallback(function (targetHeight, targetScrollTop, targetScrollHeight, ref) {
    if (!ref || !ref.current) return;
    var refHeight = ref.current.offsetHeight;
    var refScrollHeight = ref.current.scrollHeight;
    var targetScrollRatio = targetScrollTop / (targetScrollHeight - targetHeight);
    ref.current.scrollTop = (refScrollHeight - refHeight) * targetScrollRatio;
  }, []);
  var handleOnScrollTextArea = React.useCallback(function (event) {
    if (previewActive.current) return;
    var _event$currentTarget = event.currentTarget,
      offsetHeight = _event$currentTarget.offsetHeight,
      scrollTop = _event$currentTarget.scrollTop,
      scrollHeight = _event$currentTarget.scrollHeight;
    handleOnScroll(offsetHeight, scrollTop, scrollHeight, previewRef);
  }, [handleOnScroll, previewRef]);
  var handleOnScrollPreview = React.useCallback(function (event) {
    if (textAreaActive.current) return;
    var _event$currentTarget2 = event.currentTarget,
      offsetHeight = _event$currentTarget2.offsetHeight,
      scrollTop = _event$currentTarget2.scrollTop,
      scrollHeight = _event$currentTarget2.scrollHeight;
    handleOnScroll(offsetHeight, scrollTop, scrollHeight, textareaRef);
  }, [handleOnScroll, textareaRef]);
  var handleMouseEnterTextArea = React.useCallback(function () {
    textAreaActive.current = true;
  }, []);
  var handleMouseEnterPreview = React.useCallback(function () {
    previewActive.current = true;
  }, []);
  var handleMouseLeaveTextArea = React.useCallback(function () {
    textAreaActive.current = false;
  }, []);
  var handleMouseLeavePreview = React.useCallback(function () {
    previewActive.current = false;
  }, []);
  React.useEffect(function () {
    if (!previewRef || !textareaRef) return;
    var textarea = textareaRef.current;
    if (textarea == null) {
      return;
    }
    var preview = previewRef.current;
    if (preview == null) {
      return;
    }
    textarea.addEventListener("mouseenter", handleMouseEnterTextArea);
    textarea.addEventListener("mouseleave", handleMouseLeaveTextArea);
    preview.addEventListener("mouseenter", handleMouseEnterPreview);
    preview.addEventListener("mouseleave", handleMouseLeavePreview);
    return function () {
      textarea.removeEventListener("mouseenter", handleMouseEnterTextArea);
      textarea.removeEventListener("mouseleave", handleMouseLeaveTextArea);
      preview.removeEventListener("mouseenter", handleMouseEnterPreview);
      preview.removeEventListener("mouseleave", handleMouseLeavePreview);
    };
  }, [handleMouseEnterPreview, handleMouseEnterTextArea, handleMouseLeavePreview, handleMouseLeaveTextArea, previewRef, textareaRef]);
  return {
    handleOnScrollTextArea: handleOnScrollTextArea,
    handleOnScrollPreview: handleOnScrollPreview
  };
};

/**
 * MarkdownEditor。
 * プレビューへスタイルの当たったコンテンツを表示するには、previewAreaOptionsのcontentにスタイルの当たったReactElementを渡してください。
 * @param props MarkdownEditorProps
 * @returns MarkdownEditorコンポーネント
 */
var MarkdownEditor = function MarkdownEditor(_ref) {
  var value = _ref.value,
    onChange = _ref.onChange,
    _ref$layout = _ref.layout,
    layout = _ref$layout === void 0 ? "horizontal" : _ref$layout,
    _ref$isError = _ref.isError,
    isError = _ref$isError === void 0 ? false : _ref$isError,
    allowedTagNames = _ref.allowedTagNames,
    editMenuBarOptions = _ref.editMenuBarOptions,
    editAreaOptions = _ref.editAreaOptions,
    previewMenuBarOptions = _ref.previewMenuBarOptions,
    previewAreaOptions = _ref.previewAreaOptions,
    charCounterOptions = _ref.charCounterOptions;
  var _a;
  var editorRef = React__namespace.useRef(null);
  var previewRef = React__namespace.useRef(null);
  var _useScrollHook = useScrollHook({
      textareaRef: editorRef,
      previewRef: previewRef
    }),
    handleOnScrollPreview = _useScrollHook.handleOnScrollPreview,
    handleOnScrollTextArea = _useScrollHook.handleOnScrollTextArea;
  var TemplateComponent = React__namespace.useMemo(function () {
    switch (layout) {
      case "horizontal":
        return HorizontalTemplate;
      case "standalone":
        return StandaloneTemplate;
      default:
        throw new Error("Invalid layout: ".concat(layout));
    }
  }, [layout]);
  return /*#__PURE__*/React__namespace.createElement(TemplateComponent, {
    editMenuBar: /*#__PURE__*/React__namespace.createElement(EditMenuBar, {
      editorRef: editorRef,
      layout: layout,
      menuButtonOptions: editMenuBarOptions === null || editMenuBarOptions === void 0 ? void 0 : editMenuBarOptions.menuButton,
      allowedTagNames: allowedTagNames,
      onChange: onChange
    }),
    editArea: /*#__PURE__*/React__namespace.createElement(EditArea, {
      editorRef: editorRef,
      value: value,
      layout: layout,
      isError: isError,
      onChange: onChange,
      onScroll: handleOnScrollTextArea,
      attributes: editAreaOptions === null || editAreaOptions === void 0 ? void 0 : editAreaOptions.attributes
    }),
    previewMenuBar: layout !== "standalone" && (/*#__PURE__*/React__namespace.createElement(PreviewMenuBar, {
      layout: layout,
      title: previewMenuBarOptions === null || previewMenuBarOptions === void 0 ? void 0 : previewMenuBarOptions.title,
      description: previewMenuBarOptions === null || previewMenuBarOptions === void 0 ? void 0 : previewMenuBarOptions.description
    })),
    previewArea: layout !== "standalone" && (/*#__PURE__*/React__namespace.createElement(PreviewArea, {
      previewRef: previewRef,
      layout: layout,
      content: (_a = previewAreaOptions === null || previewAreaOptions === void 0 ? void 0 : previewAreaOptions.content) !== null && _a !== void 0 ? _a : /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null),
      onScroll: handleOnScrollPreview
    })),
    charCounter: (charCounterOptions === null || charCounterOptions === void 0 ? void 0 : charCounterOptions.show) && (/*#__PURE__*/React__namespace.createElement(CharCounter, {
      content: value,
      maxLength: charCounterOptions.maxLength
    }))
  });
};

var COLOR_TARGET = "COLOR_TARGET";
// https://www.figma.com/file/yqSs9KgmTCRPrS4lsL95Jm/favicon?type=design&node-id=1242-172&t=d01pDE8rcE80p5Eu-0
var originalFavicon = "<svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><rect width=\"16\" height=\"16\" fill=\"".concat(COLOR_TARGET, "\"/><g clip-path=\"url(#clip0_1242_208)\"><mask id=\"mask0_1242_208\" style=\"mask-type:luminance\" maskUnits=\"userSpaceOnUse\" x=\"2\" y=\"2\" width=\"12\" height=\"12\"><path d=\"M13.8169 2H2.00439V14H13.8169V2Z\" fill=\"white\"/></mask><g mask=\"url(#mask0_1242_208)\"><mask id=\"mask1_1242_208\" style=\"mask-type:luminance\" maskUnits=\"userSpaceOnUse\" x=\"2\" y=\"2\" width=\"12\" height=\"12\"><path d=\"M13.8169 2H2.00439V14H13.8169V2Z\" fill=\"white\"/></mask><g mask=\"url(#mask1_1242_208)\"><path d=\"M6.3697 13.2995V7.48466C6.3697 7.1878 6.48788 6.9031 6.69824 6.69318C6.9086 6.48327 7.19391 6.36534 7.49141 6.36534H13.1187C13.2108 6.36546 13.302 6.34746 13.3872 6.31236C13.4724 6.27726 13.5498 6.22575 13.615 6.16078C13.6801 6.0958 13.7319 6.01863 13.7672 5.9337C13.8025 5.84877 13.8207 5.75772 13.8207 5.66577V2.70052C13.8207 2.60821 13.8024 2.51681 13.7668 2.43158C13.7313 2.34635 13.6793 2.26896 13.6137 2.20386C13.5481 2.13876 13.4703 2.08724 13.3847 2.05226C13.2991 2.01727 13.2074 1.99952 13.1149 2.00001H3.11301C2.96761 1.99952 2.82353 2.02767 2.68905 2.08286C2.55456 2.13805 2.43232 2.21918 2.32933 2.32161C2.22633 2.42404 2.14461 2.54575 2.08885 2.67975C2.0331 2.81376 2.00439 2.95743 2.00439 3.10254V13.2995C2.00439 13.4853 2.07836 13.6634 2.21001 13.7948C2.34166 13.9262 2.52021 14 2.7064 14H5.6677C5.75989 14 5.85117 13.9819 5.93634 13.9467C6.02151 13.9115 6.09891 13.8599 6.16409 13.7948C6.22927 13.7298 6.28099 13.6526 6.31626 13.5675C6.35154 13.4826 6.3697 13.3915 6.3697 13.2995Z\" fill=\"white\"/><path d=\"M12.881 9.4209H10.1637C9.64695 9.4209 9.22803 9.83893 9.22803 10.3546V13.0662C9.22803 13.5818 9.64695 13.9998 10.1637 13.9998H12.881C13.3978 13.9998 13.8168 13.5818 13.8168 13.0662V10.3546C13.8168 9.83893 13.3978 9.4209 12.881 9.4209Z\" fill=\"white\"/></g></g></g><defs><clipPath id=\"clip0_1242_208\"><rect width=\"11.9062\" height=\"12\" fill=\"white\" transform=\"translate(2 2)\"/></clipPath></defs></svg>");
var colorMap = {
  production: null,
  production_sandbox: null,
  staging: "#DB6A2F",
  staging_sandbox: "#83C7EF",
  dev: "#D8CE46",
  local: "#4EAC7F"
};
var getFavicon = function getFavicon(env) {
  var color = colorMap[env];
  if (!color) return null;
  return originalFavicon.replace(COLOR_TARGET, color);
};
var replaceFavicon = function replaceFavicon(linkElement, env) {
  var favicon = getFavicon(env);
  if (!favicon) return;
  linkElement.setAttribute("href", "data:image/svg+xml,".concat(encodeURIComponent(favicon)));
};

exports.Breadcrumbs = Breadcrumbs$1;
exports.BreadcrumbsV2 = breadcrumbs;
exports.Checkbox = Checkbox;
exports.ClusterWrap = ClusterWrap;
exports.Contents = Contents;
exports.ContentsContainer = ContentsContainer;
exports.ContentsHeader = ContentsHeader;
exports.CopyButton = CopyButton;
exports.CopyTextBox = CopyTextBox;
exports.DangerButton = DangerButton;
exports.DangerSecondaryButton = DangerSecondaryButton;
exports.DateRangeInput = DateRangeInput;
exports.DefaultDialog = DefaultDialog;
exports.ErrorDialog = ErrorDialog;
exports.ExternalLink = ExternalLink;
exports.FilterContainer = FilterContainer;
exports.FilterRow = FilterRow;
exports.ForTestSpinnerInner = ForTestSpinnerInner;
exports.FormContainer = FormContainer;
exports.FormContainerItem = FormContainerItem;
exports.Header = Header;
exports.IconSizes = IconSizes;
exports.InformationBanner = InformationBanner;
exports.InlineCheckBox = InlineCheckBox;
exports.InlineRadioButton = InlineRadioButton;
exports.InlineReactSelect = InlineReactSelect;
exports.InlineSelect = InlineSelect;
exports.InlineSpinner = InlineSpinner;
exports.InlineTextField = InlineTextField;
exports.InlineToggle = InlineToggle;
exports.KebabMenu = KebabMenu;
exports.Link = Link;
exports.LinkCopyButton = LinkCopyButton;
exports.MarkdownEditor = MarkdownEditor;
exports.MenuList = MenuList$1;
exports.MenuListV2 = menuList;
exports.MessageDialog = MessageDialog;
exports.MultipleFileUploader = MultipleFileUploader;
exports.Navigation = Navigation;
exports.Pagination = Pagination;
exports.PrimaryButton = PrimaryButton;
exports.RadioButton = RadioButton;
exports.ReactSelect = ReactSelect;
exports.SearchTextBox = SearchTextBox;
exports.SecondaryButton = SecondaryButton;
exports.SecondaryMenuList = SecondaryMenuList;
exports.SecondaryStatusTag = SecondaryStatusTag;
exports.Select = Select;
exports.SingleFileUploader = SingleFileUploader;
exports.Spinner = Spinner;
exports.StatusTag = StatusTag;
exports.SuccessBanner = SuccessBanner;
exports.TabPanelGroup = TabPanelGroup;
exports.Table = Table;
exports.TableBody = TableBody;
exports.TableCheckBoxTd = TableCheckBoxTd;
exports.TableCheckBoxTh = TableCheckBoxTh;
exports.TableGroupContext = TableGroupContext;
exports.TableHeader = TableHeader;
exports.TableRow = TableRow;
exports.Tabs = Tabs;
exports.Td = Td;
exports.TelTextField = TelTextField;
exports.TextArea = TextArea;
exports.TextBoxWithButton = TextBoxWithButton;
exports.TextButton = TextButton;
exports.TextField = TextField;
exports.Th = Th;
exports.TitleWrap = TitleWrap;
exports.Toggle = Toggle;
exports.WarningBanner = WarningBanner;
exports.WarningDialog = WarningDialog;
exports.allTagNames = allTagNames;
exports.replaceFavicon = replaceFavicon;
